var Lu = Object.defineProperty;
var Uu = (e, t, n) => t in e ? Lu(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var y = (e, t, n) => Uu(e, typeof t != "symbol" ? t + "" : t, n);
import { CanvasTexture as Nu, LinearFilter as Pu, RepeatWrapping as Ii, Color as O, BoxGeometry as Gu, Matrix4 as yt, EdgesGeometry as vu, LineSegments as Hu, LineBasicMaterial as Ju, Vector3 as Tt, Frustum as ku, Group as qn, PlaneGeometry as Vu, MeshBasicMaterial as Es, DoubleSide as pa, Mesh as Cs, ArrowHelper as ju, Vector2 as ga, ShaderMaterial as Ws, NormalBlending as Qs, WebGLRenderTarget as Ku, NearestFilter as xi, RGBAFormat as zu, FloatType as Wu, Scene as Qu, WebGLRenderer as $u, Euler as Nr, BufferGeometry as Aa, Float32BufferAttribute as ir, BufferAttribute as ya, Quaternion as Xu, Uint8BufferAttribute as Mi, Points as qu } from "three";
import * as Yu from "three/examples/jsm/utils/BufferGeometryUtils";
import { GLTFLoader as Zu } from "three/examples/jsm/loaders/GLTFLoader.js";
import { DRACOLoader as th } from "three/examples/jsm/loaders/DRACOLoader.js";
import { KTX2Loader as eh } from "three/examples/jsm/loaders/KTX2Loader.js";
function nh(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var s = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, s.get ? s : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), n;
}
var st = {}, Ba = {}, Cr = {};
Cr.byteLength = ih;
Cr.toByteArray = ah;
Cr.fromByteArray = hh;
var ee = [], Gt = [], rh = typeof Uint8Array < "u" ? Uint8Array : Array, Pr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var Ue = 0, sh = Pr.length; Ue < sh; ++Ue)
  ee[Ue] = Pr[Ue], Gt[Pr.charCodeAt(Ue)] = Ue;
Gt[45] = 62;
Gt[95] = 63;
function Ea(e) {
  var t = e.length;
  if (t % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var n = e.indexOf("=");
  n === -1 && (n = t);
  var r = n === t ? 0 : 4 - n % 4;
  return [n, r];
}
function ih(e) {
  var t = Ea(e), n = t[0], r = t[1];
  return (n + r) * 3 / 4 - r;
}
function oh(e, t, n) {
  return (t + n) * 3 / 4 - n;
}
function ah(e) {
  var t, n = Ea(e), r = n[0], s = n[1], i = new rh(oh(e, r, s)), o = 0, a = s > 0 ? r - 4 : r, c;
  for (c = 0; c < a; c += 4)
    t = Gt[e.charCodeAt(c)] << 18 | Gt[e.charCodeAt(c + 1)] << 12 | Gt[e.charCodeAt(c + 2)] << 6 | Gt[e.charCodeAt(c + 3)], i[o++] = t >> 16 & 255, i[o++] = t >> 8 & 255, i[o++] = t & 255;
  return s === 2 && (t = Gt[e.charCodeAt(c)] << 2 | Gt[e.charCodeAt(c + 1)] >> 4, i[o++] = t & 255), s === 1 && (t = Gt[e.charCodeAt(c)] << 10 | Gt[e.charCodeAt(c + 1)] << 4 | Gt[e.charCodeAt(c + 2)] >> 2, i[o++] = t >> 8 & 255, i[o++] = t & 255), i;
}
function ch(e) {
  return ee[e >> 18 & 63] + ee[e >> 12 & 63] + ee[e >> 6 & 63] + ee[e & 63];
}
function uh(e, t, n) {
  for (var r, s = [], i = t; i < n; i += 3)
    r = (e[i] << 16 & 16711680) + (e[i + 1] << 8 & 65280) + (e[i + 2] & 255), s.push(ch(r));
  return s.join("");
}
function hh(e) {
  for (var t, n = e.length, r = n % 3, s = [], i = 16383, o = 0, a = n - r; o < a; o += i)
    s.push(uh(e, o, o + i > a ? a : o + i));
  return r === 1 ? (t = e[n - 1], s.push(
    ee[t >> 2] + ee[t << 4 & 63] + "=="
  )) : r === 2 && (t = (e[n - 2] << 8) + e[n - 1], s.push(
    ee[t >> 10] + ee[t >> 4 & 63] + ee[t << 2 & 63] + "="
  )), s.join("");
}
var $s = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
$s.read = function(e, t, n, r, s) {
  var i, o, a = s * 8 - r - 1, c = (1 << a) - 1, h = c >> 1, f = -7, d = n ? s - 1 : 0, p = n ? -1 : 1, g = e[t + d];
  for (d += p, i = g & (1 << -f) - 1, g >>= -f, f += a; f > 0; i = i * 256 + e[t + d], d += p, f -= 8)
    ;
  for (o = i & (1 << -f) - 1, i >>= -f, f += r; f > 0; o = o * 256 + e[t + d], d += p, f -= 8)
    ;
  if (i === 0)
    i = 1 - h;
  else {
    if (i === c)
      return o ? NaN : (g ? -1 : 1) * (1 / 0);
    o = o + Math.pow(2, r), i = i - h;
  }
  return (g ? -1 : 1) * o * Math.pow(2, i - r);
};
$s.write = function(e, t, n, r, s, i) {
  var o, a, c, h = i * 8 - s - 1, f = (1 << h) - 1, d = f >> 1, p = s === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, g = r ? 0 : i - 1, B = r ? 1 : -1, C = t < 0 || t === 0 && 1 / t < 0 ? 1 : 0;
  for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (a = isNaN(t) ? 1 : 0, o = f) : (o = Math.floor(Math.log(t) / Math.LN2), t * (c = Math.pow(2, -o)) < 1 && (o--, c *= 2), o + d >= 1 ? t += p / c : t += p * Math.pow(2, 1 - d), t * c >= 2 && (o++, c /= 2), o + d >= f ? (a = 0, o = f) : o + d >= 1 ? (a = (t * c - 1) * Math.pow(2, s), o = o + d) : (a = t * Math.pow(2, d - 1) * Math.pow(2, s), o = 0)); s >= 8; e[n + g] = a & 255, g += B, a /= 256, s -= 8)
    ;
  for (o = o << s | a, h += s; h > 0; e[n + g] = o & 255, g += B, o /= 256, h -= 8)
    ;
  e[n + g - B] |= C * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(e) {
  const t = Cr, n = $s, r = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  e.Buffer = a, e.SlowBuffer = D, e.INSPECT_MAX_BYTES = 50;
  const s = 2147483647;
  e.kMaxLength = s, a.TYPED_ARRAY_SUPPORT = i(), !a.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function i() {
    try {
      const m = new Uint8Array(1), u = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(u, Uint8Array.prototype), Object.setPrototypeOf(m, u), m.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(a.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (a.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(a.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (a.isBuffer(this))
        return this.byteOffset;
    }
  });
  function o(m) {
    if (m > s)
      throw new RangeError('The value "' + m + '" is invalid for option "size"');
    const u = new Uint8Array(m);
    return Object.setPrototypeOf(u, a.prototype), u;
  }
  function a(m, u, l) {
    if (typeof m == "number") {
      if (typeof u == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return d(m);
    }
    return c(m, u, l);
  }
  a.poolSize = 8192;
  function c(m, u, l) {
    if (typeof m == "string")
      return p(m, u);
    if (ArrayBuffer.isView(m))
      return B(m);
    if (m == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof m
      );
    if (qt(m, ArrayBuffer) || m && qt(m.buffer, ArrayBuffer) || typeof SharedArrayBuffer < "u" && (qt(m, SharedArrayBuffer) || m && qt(m.buffer, SharedArrayBuffer)))
      return C(m, u, l);
    if (typeof m == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    const A = m.valueOf && m.valueOf();
    if (A != null && A !== m)
      return a.from(A, u, l);
    const E = b(m);
    if (E) return E;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof m[Symbol.toPrimitive] == "function")
      return a.from(m[Symbol.toPrimitive]("string"), u, l);
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof m
    );
  }
  a.from = function(m, u, l) {
    return c(m, u, l);
  }, Object.setPrototypeOf(a.prototype, Uint8Array.prototype), Object.setPrototypeOf(a, Uint8Array);
  function h(m) {
    if (typeof m != "number")
      throw new TypeError('"size" argument must be of type number');
    if (m < 0)
      throw new RangeError('The value "' + m + '" is invalid for option "size"');
  }
  function f(m, u, l) {
    return h(m), m <= 0 ? o(m) : u !== void 0 ? typeof l == "string" ? o(m).fill(u, l) : o(m).fill(u) : o(m);
  }
  a.alloc = function(m, u, l) {
    return f(m, u, l);
  };
  function d(m) {
    return h(m), o(m < 0 ? 0 : M(m) | 0);
  }
  a.allocUnsafe = function(m) {
    return d(m);
  }, a.allocUnsafeSlow = function(m) {
    return d(m);
  };
  function p(m, u) {
    if ((typeof u != "string" || u === "") && (u = "utf8"), !a.isEncoding(u))
      throw new TypeError("Unknown encoding: " + u);
    const l = _(m, u) | 0;
    let A = o(l);
    const E = A.write(m, u);
    return E !== l && (A = A.slice(0, E)), A;
  }
  function g(m) {
    const u = m.length < 0 ? 0 : M(m.length) | 0, l = o(u);
    for (let A = 0; A < u; A += 1)
      l[A] = m[A] & 255;
    return l;
  }
  function B(m) {
    if (qt(m, Uint8Array)) {
      const u = new Uint8Array(m);
      return C(u.buffer, u.byteOffset, u.byteLength);
    }
    return g(m);
  }
  function C(m, u, l) {
    if (u < 0 || m.byteLength < u)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (m.byteLength < u + (l || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    let A;
    return u === void 0 && l === void 0 ? A = new Uint8Array(m) : l === void 0 ? A = new Uint8Array(m, u) : A = new Uint8Array(m, u, l), Object.setPrototypeOf(A, a.prototype), A;
  }
  function b(m) {
    if (a.isBuffer(m)) {
      const u = M(m.length) | 0, l = o(u);
      return l.length === 0 || m.copy(l, 0, 0, u), l;
    }
    if (m.length !== void 0)
      return typeof m.length != "number" || Ur(m.length) ? o(0) : g(m);
    if (m.type === "Buffer" && Array.isArray(m.data))
      return g(m.data);
  }
  function M(m) {
    if (m >= s)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + s.toString(16) + " bytes");
    return m | 0;
  }
  function D(m) {
    return +m != m && (m = 0), a.alloc(+m);
  }
  a.isBuffer = function(u) {
    return u != null && u._isBuffer === !0 && u !== a.prototype;
  }, a.compare = function(u, l) {
    if (qt(u, Uint8Array) && (u = a.from(u, u.offset, u.byteLength)), qt(l, Uint8Array) && (l = a.from(l, l.offset, l.byteLength)), !a.isBuffer(u) || !a.isBuffer(l))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (u === l) return 0;
    let A = u.length, E = l.length;
    for (let w = 0, I = Math.min(A, E); w < I; ++w)
      if (u[w] !== l[w]) {
        A = u[w], E = l[w];
        break;
      }
    return A < E ? -1 : E < A ? 1 : 0;
  }, a.isEncoding = function(u) {
    switch (String(u).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, a.concat = function(u, l) {
    if (!Array.isArray(u))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (u.length === 0)
      return a.alloc(0);
    let A;
    if (l === void 0)
      for (l = 0, A = 0; A < u.length; ++A)
        l += u[A].length;
    const E = a.allocUnsafe(l);
    let w = 0;
    for (A = 0; A < u.length; ++A) {
      let I = u[A];
      if (qt(I, Uint8Array))
        w + I.length > E.length ? (a.isBuffer(I) || (I = a.from(I)), I.copy(E, w)) : Uint8Array.prototype.set.call(
          E,
          I,
          w
        );
      else if (a.isBuffer(I))
        I.copy(E, w);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      w += I.length;
    }
    return E;
  };
  function _(m, u) {
    if (a.isBuffer(m))
      return m.length;
    if (ArrayBuffer.isView(m) || qt(m, ArrayBuffer))
      return m.byteLength;
    if (typeof m != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof m
      );
    const l = m.length, A = arguments.length > 2 && arguments[2] === !0;
    if (!A && l === 0) return 0;
    let E = !1;
    for (; ; )
      switch (u) {
        case "ascii":
        case "latin1":
        case "binary":
          return l;
        case "utf8":
        case "utf-8":
          return Lr(m).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return l * 2;
        case "hex":
          return l >>> 1;
        case "base64":
          return _i(m).length;
        default:
          if (E)
            return A ? -1 : Lr(m).length;
          u = ("" + u).toLowerCase(), E = !0;
      }
  }
  a.byteLength = _;
  function x(m, u, l) {
    let A = !1;
    if ((u === void 0 || u < 0) && (u = 0), u > this.length || ((l === void 0 || l > this.length) && (l = this.length), l <= 0) || (l >>>= 0, u >>>= 0, l <= u))
      return "";
    for (m || (m = "utf8"); ; )
      switch (m) {
        case "hex":
          return Xt(this, u, l);
        case "utf8":
        case "utf-8":
          return k(this, u, l);
        case "ascii":
          return Pt(this, u, l);
        case "latin1":
        case "binary":
          return Oe(this, u, l);
        case "base64":
          return ft(this, u, l);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return dt(this, u, l);
        default:
          if (A) throw new TypeError("Unknown encoding: " + m);
          m = (m + "").toLowerCase(), A = !0;
      }
  }
  a.prototype._isBuffer = !0;
  function L(m, u, l) {
    const A = m[u];
    m[u] = m[l], m[l] = A;
  }
  a.prototype.swap16 = function() {
    const u = this.length;
    if (u % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (let l = 0; l < u; l += 2)
      L(this, l, l + 1);
    return this;
  }, a.prototype.swap32 = function() {
    const u = this.length;
    if (u % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (let l = 0; l < u; l += 4)
      L(this, l, l + 3), L(this, l + 1, l + 2);
    return this;
  }, a.prototype.swap64 = function() {
    const u = this.length;
    if (u % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (let l = 0; l < u; l += 8)
      L(this, l, l + 7), L(this, l + 1, l + 6), L(this, l + 2, l + 5), L(this, l + 3, l + 4);
    return this;
  }, a.prototype.toString = function() {
    const u = this.length;
    return u === 0 ? "" : arguments.length === 0 ? k(this, 0, u) : x.apply(this, arguments);
  }, a.prototype.toLocaleString = a.prototype.toString, a.prototype.equals = function(u) {
    if (!a.isBuffer(u)) throw new TypeError("Argument must be a Buffer");
    return this === u ? !0 : a.compare(this, u) === 0;
  }, a.prototype.inspect = function() {
    let u = "";
    const l = e.INSPECT_MAX_BYTES;
    return u = this.toString("hex", 0, l).replace(/(.{2})/g, "$1 ").trim(), this.length > l && (u += " ... "), "<Buffer " + u + ">";
  }, r && (a.prototype[r] = a.prototype.inspect), a.prototype.compare = function(u, l, A, E, w) {
    if (qt(u, Uint8Array) && (u = a.from(u, u.offset, u.byteLength)), !a.isBuffer(u))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof u
      );
    if (l === void 0 && (l = 0), A === void 0 && (A = u ? u.length : 0), E === void 0 && (E = 0), w === void 0 && (w = this.length), l < 0 || A > u.length || E < 0 || w > this.length)
      throw new RangeError("out of range index");
    if (E >= w && l >= A)
      return 0;
    if (E >= w)
      return -1;
    if (l >= A)
      return 1;
    if (l >>>= 0, A >>>= 0, E >>>= 0, w >>>= 0, this === u) return 0;
    let I = w - E, j = A - l;
    const ut = Math.min(I, j), rt = this.slice(E, w), ht = u.slice(l, A);
    for (let Y = 0; Y < ut; ++Y)
      if (rt[Y] !== ht[Y]) {
        I = rt[Y], j = ht[Y];
        break;
      }
    return I < j ? -1 : j < I ? 1 : 0;
  };
  function S(m, u, l, A, E) {
    if (m.length === 0) return -1;
    if (typeof l == "string" ? (A = l, l = 0) : l > 2147483647 ? l = 2147483647 : l < -2147483648 && (l = -2147483648), l = +l, Ur(l) && (l = E ? 0 : m.length - 1), l < 0 && (l = m.length + l), l >= m.length) {
      if (E) return -1;
      l = m.length - 1;
    } else if (l < 0)
      if (E) l = 0;
      else return -1;
    if (typeof u == "string" && (u = a.from(u, A)), a.isBuffer(u))
      return u.length === 0 ? -1 : G(m, u, l, A, E);
    if (typeof u == "number")
      return u = u & 255, typeof Uint8Array.prototype.indexOf == "function" ? E ? Uint8Array.prototype.indexOf.call(m, u, l) : Uint8Array.prototype.lastIndexOf.call(m, u, l) : G(m, [u], l, A, E);
    throw new TypeError("val must be string, number or Buffer");
  }
  function G(m, u, l, A, E) {
    let w = 1, I = m.length, j = u.length;
    if (A !== void 0 && (A = String(A).toLowerCase(), A === "ucs2" || A === "ucs-2" || A === "utf16le" || A === "utf-16le")) {
      if (m.length < 2 || u.length < 2)
        return -1;
      w = 2, I /= 2, j /= 2, l /= 2;
    }
    function ut(ht, Y) {
      return w === 1 ? ht[Y] : ht.readUInt16BE(Y * w);
    }
    let rt;
    if (E) {
      let ht = -1;
      for (rt = l; rt < I; rt++)
        if (ut(m, rt) === ut(u, ht === -1 ? 0 : rt - ht)) {
          if (ht === -1 && (ht = rt), rt - ht + 1 === j) return ht * w;
        } else
          ht !== -1 && (rt -= rt - ht), ht = -1;
    } else
      for (l + j > I && (l = I - j), rt = l; rt >= 0; rt--) {
        let ht = !0;
        for (let Y = 0; Y < j; Y++)
          if (ut(m, rt + Y) !== ut(u, Y)) {
            ht = !1;
            break;
          }
        if (ht) return rt;
      }
    return -1;
  }
  a.prototype.includes = function(u, l, A) {
    return this.indexOf(u, l, A) !== -1;
  }, a.prototype.indexOf = function(u, l, A) {
    return S(this, u, l, A, !0);
  }, a.prototype.lastIndexOf = function(u, l, A) {
    return S(this, u, l, A, !1);
  };
  function v(m, u, l, A) {
    l = Number(l) || 0;
    const E = m.length - l;
    A ? (A = Number(A), A > E && (A = E)) : A = E;
    const w = u.length;
    A > w / 2 && (A = w / 2);
    let I;
    for (I = 0; I < A; ++I) {
      const j = parseInt(u.substr(I * 2, 2), 16);
      if (Ur(j)) return I;
      m[l + I] = j;
    }
    return I;
  }
  function P(m, u, l, A) {
    return Sn(Lr(u, m.length - l), m, l, A);
  }
  function J(m, u, l, A) {
    return Sn(Su(u), m, l, A);
  }
  function tt(m, u, l, A) {
    return Sn(_i(u), m, l, A);
  }
  function it(m, u, l, A) {
    return Sn(Fu(u, m.length - l), m, l, A);
  }
  a.prototype.write = function(u, l, A, E) {
    if (l === void 0)
      E = "utf8", A = this.length, l = 0;
    else if (A === void 0 && typeof l == "string")
      E = l, A = this.length, l = 0;
    else if (isFinite(l))
      l = l >>> 0, isFinite(A) ? (A = A >>> 0, E === void 0 && (E = "utf8")) : (E = A, A = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    const w = this.length - l;
    if ((A === void 0 || A > w) && (A = w), u.length > 0 && (A < 0 || l < 0) || l > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    E || (E = "utf8");
    let I = !1;
    for (; ; )
      switch (E) {
        case "hex":
          return v(this, u, l, A);
        case "utf8":
        case "utf-8":
          return P(this, u, l, A);
        case "ascii":
        case "latin1":
        case "binary":
          return J(this, u, l, A);
        case "base64":
          return tt(this, u, l, A);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return it(this, u, l, A);
        default:
          if (I) throw new TypeError("Unknown encoding: " + E);
          E = ("" + E).toLowerCase(), I = !0;
      }
  }, a.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function ft(m, u, l) {
    return u === 0 && l === m.length ? t.fromByteArray(m) : t.fromByteArray(m.slice(u, l));
  }
  function k(m, u, l) {
    l = Math.min(m.length, l);
    const A = [];
    let E = u;
    for (; E < l; ) {
      const w = m[E];
      let I = null, j = w > 239 ? 4 : w > 223 ? 3 : w > 191 ? 2 : 1;
      if (E + j <= l) {
        let ut, rt, ht, Y;
        switch (j) {
          case 1:
            w < 128 && (I = w);
            break;
          case 2:
            ut = m[E + 1], (ut & 192) === 128 && (Y = (w & 31) << 6 | ut & 63, Y > 127 && (I = Y));
            break;
          case 3:
            ut = m[E + 1], rt = m[E + 2], (ut & 192) === 128 && (rt & 192) === 128 && (Y = (w & 15) << 12 | (ut & 63) << 6 | rt & 63, Y > 2047 && (Y < 55296 || Y > 57343) && (I = Y));
            break;
          case 4:
            ut = m[E + 1], rt = m[E + 2], ht = m[E + 3], (ut & 192) === 128 && (rt & 192) === 128 && (ht & 192) === 128 && (Y = (w & 15) << 18 | (ut & 63) << 12 | (rt & 63) << 6 | ht & 63, Y > 65535 && Y < 1114112 && (I = Y));
        }
      }
      I === null ? (I = 65533, j = 1) : I > 65535 && (I -= 65536, A.push(I >>> 10 & 1023 | 55296), I = 56320 | I & 1023), A.push(I), E += j;
    }
    return Nt(A);
  }
  const gt = 4096;
  function Nt(m) {
    const u = m.length;
    if (u <= gt)
      return String.fromCharCode.apply(String, m);
    let l = "", A = 0;
    for (; A < u; )
      l += String.fromCharCode.apply(
        String,
        m.slice(A, A += gt)
      );
    return l;
  }
  function Pt(m, u, l) {
    let A = "";
    l = Math.min(m.length, l);
    for (let E = u; E < l; ++E)
      A += String.fromCharCode(m[E] & 127);
    return A;
  }
  function Oe(m, u, l) {
    let A = "";
    l = Math.min(m.length, l);
    for (let E = u; E < l; ++E)
      A += String.fromCharCode(m[E]);
    return A;
  }
  function Xt(m, u, l) {
    const A = m.length;
    (!u || u < 0) && (u = 0), (!l || l < 0 || l > A) && (l = A);
    let E = "";
    for (let w = u; w < l; ++w)
      E += Ou[m[w]];
    return E;
  }
  function dt(m, u, l) {
    const A = m.slice(u, l);
    let E = "";
    for (let w = 0; w < A.length - 1; w += 2)
      E += String.fromCharCode(A[w] + A[w + 1] * 256);
    return E;
  }
  a.prototype.slice = function(u, l) {
    const A = this.length;
    u = ~~u, l = l === void 0 ? A : ~~l, u < 0 ? (u += A, u < 0 && (u = 0)) : u > A && (u = A), l < 0 ? (l += A, l < 0 && (l = 0)) : l > A && (l = A), l < u && (l = u);
    const E = this.subarray(u, l);
    return Object.setPrototypeOf(E, a.prototype), E;
  };
  function X(m, u, l) {
    if (m % 1 !== 0 || m < 0) throw new RangeError("offset is not uint");
    if (m + u > l) throw new RangeError("Trying to access beyond buffer length");
  }
  a.prototype.readUintLE = a.prototype.readUIntLE = function(u, l, A) {
    u = u >>> 0, l = l >>> 0, A || X(u, l, this.length);
    let E = this[u], w = 1, I = 0;
    for (; ++I < l && (w *= 256); )
      E += this[u + I] * w;
    return E;
  }, a.prototype.readUintBE = a.prototype.readUIntBE = function(u, l, A) {
    u = u >>> 0, l = l >>> 0, A || X(u, l, this.length);
    let E = this[u + --l], w = 1;
    for (; l > 0 && (w *= 256); )
      E += this[u + --l] * w;
    return E;
  }, a.prototype.readUint8 = a.prototype.readUInt8 = function(u, l) {
    return u = u >>> 0, l || X(u, 1, this.length), this[u];
  }, a.prototype.readUint16LE = a.prototype.readUInt16LE = function(u, l) {
    return u = u >>> 0, l || X(u, 2, this.length), this[u] | this[u + 1] << 8;
  }, a.prototype.readUint16BE = a.prototype.readUInt16BE = function(u, l) {
    return u = u >>> 0, l || X(u, 2, this.length), this[u] << 8 | this[u + 1];
  }, a.prototype.readUint32LE = a.prototype.readUInt32LE = function(u, l) {
    return u = u >>> 0, l || X(u, 4, this.length), (this[u] | this[u + 1] << 8 | this[u + 2] << 16) + this[u + 3] * 16777216;
  }, a.prototype.readUint32BE = a.prototype.readUInt32BE = function(u, l) {
    return u = u >>> 0, l || X(u, 4, this.length), this[u] * 16777216 + (this[u + 1] << 16 | this[u + 2] << 8 | this[u + 3]);
  }, a.prototype.readBigUInt64LE = de(function(u) {
    u = u >>> 0, ie(u, "offset");
    const l = this[u], A = this[u + 7];
    (l === void 0 || A === void 0) && oe(u, this.length - 8);
    const E = l + this[++u] * 2 ** 8 + this[++u] * 2 ** 16 + this[++u] * 2 ** 24, w = this[++u] + this[++u] * 2 ** 8 + this[++u] * 2 ** 16 + A * 2 ** 24;
    return BigInt(E) + (BigInt(w) << BigInt(32));
  }), a.prototype.readBigUInt64BE = de(function(u) {
    u = u >>> 0, ie(u, "offset");
    const l = this[u], A = this[u + 7];
    (l === void 0 || A === void 0) && oe(u, this.length - 8);
    const E = l * 2 ** 24 + this[++u] * 2 ** 16 + this[++u] * 2 ** 8 + this[++u], w = this[++u] * 2 ** 24 + this[++u] * 2 ** 16 + this[++u] * 2 ** 8 + A;
    return (BigInt(E) << BigInt(32)) + BigInt(w);
  }), a.prototype.readIntLE = function(u, l, A) {
    u = u >>> 0, l = l >>> 0, A || X(u, l, this.length);
    let E = this[u], w = 1, I = 0;
    for (; ++I < l && (w *= 256); )
      E += this[u + I] * w;
    return w *= 128, E >= w && (E -= Math.pow(2, 8 * l)), E;
  }, a.prototype.readIntBE = function(u, l, A) {
    u = u >>> 0, l = l >>> 0, A || X(u, l, this.length);
    let E = l, w = 1, I = this[u + --E];
    for (; E > 0 && (w *= 256); )
      I += this[u + --E] * w;
    return w *= 128, I >= w && (I -= Math.pow(2, 8 * l)), I;
  }, a.prototype.readInt8 = function(u, l) {
    return u = u >>> 0, l || X(u, 1, this.length), this[u] & 128 ? (255 - this[u] + 1) * -1 : this[u];
  }, a.prototype.readInt16LE = function(u, l) {
    u = u >>> 0, l || X(u, 2, this.length);
    const A = this[u] | this[u + 1] << 8;
    return A & 32768 ? A | 4294901760 : A;
  }, a.prototype.readInt16BE = function(u, l) {
    u = u >>> 0, l || X(u, 2, this.length);
    const A = this[u + 1] | this[u] << 8;
    return A & 32768 ? A | 4294901760 : A;
  }, a.prototype.readInt32LE = function(u, l) {
    return u = u >>> 0, l || X(u, 4, this.length), this[u] | this[u + 1] << 8 | this[u + 2] << 16 | this[u + 3] << 24;
  }, a.prototype.readInt32BE = function(u, l) {
    return u = u >>> 0, l || X(u, 4, this.length), this[u] << 24 | this[u + 1] << 16 | this[u + 2] << 8 | this[u + 3];
  }, a.prototype.readBigInt64LE = de(function(u) {
    u = u >>> 0, ie(u, "offset");
    const l = this[u], A = this[u + 7];
    (l === void 0 || A === void 0) && oe(u, this.length - 8);
    const E = this[u + 4] + this[u + 5] * 2 ** 8 + this[u + 6] * 2 ** 16 + (A << 24);
    return (BigInt(E) << BigInt(32)) + BigInt(l + this[++u] * 2 ** 8 + this[++u] * 2 ** 16 + this[++u] * 2 ** 24);
  }), a.prototype.readBigInt64BE = de(function(u) {
    u = u >>> 0, ie(u, "offset");
    const l = this[u], A = this[u + 7];
    (l === void 0 || A === void 0) && oe(u, this.length - 8);
    const E = (l << 24) + // Overflow
    this[++u] * 2 ** 16 + this[++u] * 2 ** 8 + this[++u];
    return (BigInt(E) << BigInt(32)) + BigInt(this[++u] * 2 ** 24 + this[++u] * 2 ** 16 + this[++u] * 2 ** 8 + A);
  }), a.prototype.readFloatLE = function(u, l) {
    return u = u >>> 0, l || X(u, 4, this.length), n.read(this, u, !0, 23, 4);
  }, a.prototype.readFloatBE = function(u, l) {
    return u = u >>> 0, l || X(u, 4, this.length), n.read(this, u, !1, 23, 4);
  }, a.prototype.readDoubleLE = function(u, l) {
    return u = u >>> 0, l || X(u, 8, this.length), n.read(this, u, !0, 52, 8);
  }, a.prototype.readDoubleBE = function(u, l) {
    return u = u >>> 0, l || X(u, 8, this.length), n.read(this, u, !1, 52, 8);
  };
  function at(m, u, l, A, E, w) {
    if (!a.isBuffer(m)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (u > E || u < w) throw new RangeError('"value" argument is out of bounds');
    if (l + A > m.length) throw new RangeError("Index out of range");
  }
  a.prototype.writeUintLE = a.prototype.writeUIntLE = function(u, l, A, E) {
    if (u = +u, l = l >>> 0, A = A >>> 0, !E) {
      const j = Math.pow(2, 8 * A) - 1;
      at(this, u, l, A, j, 0);
    }
    let w = 1, I = 0;
    for (this[l] = u & 255; ++I < A && (w *= 256); )
      this[l + I] = u / w & 255;
    return l + A;
  }, a.prototype.writeUintBE = a.prototype.writeUIntBE = function(u, l, A, E) {
    if (u = +u, l = l >>> 0, A = A >>> 0, !E) {
      const j = Math.pow(2, 8 * A) - 1;
      at(this, u, l, A, j, 0);
    }
    let w = A - 1, I = 1;
    for (this[l + w] = u & 255; --w >= 0 && (I *= 256); )
      this[l + w] = u / I & 255;
    return l + A;
  }, a.prototype.writeUint8 = a.prototype.writeUInt8 = function(u, l, A) {
    return u = +u, l = l >>> 0, A || at(this, u, l, 1, 255, 0), this[l] = u & 255, l + 1;
  }, a.prototype.writeUint16LE = a.prototype.writeUInt16LE = function(u, l, A) {
    return u = +u, l = l >>> 0, A || at(this, u, l, 2, 65535, 0), this[l] = u & 255, this[l + 1] = u >>> 8, l + 2;
  }, a.prototype.writeUint16BE = a.prototype.writeUInt16BE = function(u, l, A) {
    return u = +u, l = l >>> 0, A || at(this, u, l, 2, 65535, 0), this[l] = u >>> 8, this[l + 1] = u & 255, l + 2;
  }, a.prototype.writeUint32LE = a.prototype.writeUInt32LE = function(u, l, A) {
    return u = +u, l = l >>> 0, A || at(this, u, l, 4, 4294967295, 0), this[l + 3] = u >>> 24, this[l + 2] = u >>> 16, this[l + 1] = u >>> 8, this[l] = u & 255, l + 4;
  }, a.prototype.writeUint32BE = a.prototype.writeUInt32BE = function(u, l, A) {
    return u = +u, l = l >>> 0, A || at(this, u, l, 4, 4294967295, 0), this[l] = u >>> 24, this[l + 1] = u >>> 16, this[l + 2] = u >>> 8, this[l + 3] = u & 255, l + 4;
  };
  function De(m, u, l, A, E) {
    Mn(u, A, E, m, l, 7);
    let w = Number(u & BigInt(4294967295));
    m[l++] = w, w = w >> 8, m[l++] = w, w = w >> 8, m[l++] = w, w = w >> 8, m[l++] = w;
    let I = Number(u >> BigInt(32) & BigInt(4294967295));
    return m[l++] = I, I = I >> 8, m[l++] = I, I = I >> 8, m[l++] = I, I = I >> 8, m[l++] = I, l;
  }
  function Le(m, u, l, A, E) {
    Mn(u, A, E, m, l, 7);
    let w = Number(u & BigInt(4294967295));
    m[l + 7] = w, w = w >> 8, m[l + 6] = w, w = w >> 8, m[l + 5] = w, w = w >> 8, m[l + 4] = w;
    let I = Number(u >> BigInt(32) & BigInt(4294967295));
    return m[l + 3] = I, I = I >> 8, m[l + 2] = I, I = I >> 8, m[l + 1] = I, I = I >> 8, m[l] = I, l + 8;
  }
  a.prototype.writeBigUInt64LE = de(function(u, l = 0) {
    return De(this, u, l, BigInt(0), BigInt("0xffffffffffffffff"));
  }), a.prototype.writeBigUInt64BE = de(function(u, l = 0) {
    return Le(this, u, l, BigInt(0), BigInt("0xffffffffffffffff"));
  }), a.prototype.writeIntLE = function(u, l, A, E) {
    if (u = +u, l = l >>> 0, !E) {
      const ut = Math.pow(2, 8 * A - 1);
      at(this, u, l, A, ut - 1, -ut);
    }
    let w = 0, I = 1, j = 0;
    for (this[l] = u & 255; ++w < A && (I *= 256); )
      u < 0 && j === 0 && this[l + w - 1] !== 0 && (j = 1), this[l + w] = (u / I >> 0) - j & 255;
    return l + A;
  }, a.prototype.writeIntBE = function(u, l, A, E) {
    if (u = +u, l = l >>> 0, !E) {
      const ut = Math.pow(2, 8 * A - 1);
      at(this, u, l, A, ut - 1, -ut);
    }
    let w = A - 1, I = 1, j = 0;
    for (this[l + w] = u & 255; --w >= 0 && (I *= 256); )
      u < 0 && j === 0 && this[l + w + 1] !== 0 && (j = 1), this[l + w] = (u / I >> 0) - j & 255;
    return l + A;
  }, a.prototype.writeInt8 = function(u, l, A) {
    return u = +u, l = l >>> 0, A || at(this, u, l, 1, 127, -128), u < 0 && (u = 255 + u + 1), this[l] = u & 255, l + 1;
  }, a.prototype.writeInt16LE = function(u, l, A) {
    return u = +u, l = l >>> 0, A || at(this, u, l, 2, 32767, -32768), this[l] = u & 255, this[l + 1] = u >>> 8, l + 2;
  }, a.prototype.writeInt16BE = function(u, l, A) {
    return u = +u, l = l >>> 0, A || at(this, u, l, 2, 32767, -32768), this[l] = u >>> 8, this[l + 1] = u & 255, l + 2;
  }, a.prototype.writeInt32LE = function(u, l, A) {
    return u = +u, l = l >>> 0, A || at(this, u, l, 4, 2147483647, -2147483648), this[l] = u & 255, this[l + 1] = u >>> 8, this[l + 2] = u >>> 16, this[l + 3] = u >>> 24, l + 4;
  }, a.prototype.writeInt32BE = function(u, l, A) {
    return u = +u, l = l >>> 0, A || at(this, u, l, 4, 2147483647, -2147483648), u < 0 && (u = 4294967295 + u + 1), this[l] = u >>> 24, this[l + 1] = u >>> 16, this[l + 2] = u >>> 8, this[l + 3] = u & 255, l + 4;
  }, a.prototype.writeBigInt64LE = de(function(u, l = 0) {
    return De(this, u, l, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  }), a.prototype.writeBigInt64BE = de(function(u, l = 0) {
    return Le(this, u, l, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function xn(m, u, l, A, E, w) {
    if (l + A > m.length) throw new RangeError("Index out of range");
    if (l < 0) throw new RangeError("Index out of range");
  }
  function R(m, u, l, A, E) {
    return u = +u, l = l >>> 0, E || xn(m, u, l, 4), n.write(m, u, l, A, 23, 4), l + 4;
  }
  a.prototype.writeFloatLE = function(u, l, A) {
    return R(this, u, l, !0, A);
  }, a.prototype.writeFloatBE = function(u, l, A) {
    return R(this, u, l, !1, A);
  };
  function H(m, u, l, A, E) {
    return u = +u, l = l >>> 0, E || xn(m, u, l, 8), n.write(m, u, l, A, 52, 8), l + 8;
  }
  a.prototype.writeDoubleLE = function(u, l, A) {
    return H(this, u, l, !0, A);
  }, a.prototype.writeDoubleBE = function(u, l, A) {
    return H(this, u, l, !1, A);
  }, a.prototype.copy = function(u, l, A, E) {
    if (!a.isBuffer(u)) throw new TypeError("argument should be a Buffer");
    if (A || (A = 0), !E && E !== 0 && (E = this.length), l >= u.length && (l = u.length), l || (l = 0), E > 0 && E < A && (E = A), E === A || u.length === 0 || this.length === 0) return 0;
    if (l < 0)
      throw new RangeError("targetStart out of bounds");
    if (A < 0 || A >= this.length) throw new RangeError("Index out of range");
    if (E < 0) throw new RangeError("sourceEnd out of bounds");
    E > this.length && (E = this.length), u.length - l < E - A && (E = u.length - l + A);
    const w = E - A;
    return this === u && typeof Uint8Array.prototype.copyWithin == "function" ? this.copyWithin(l, A, E) : Uint8Array.prototype.set.call(
      u,
      this.subarray(A, E),
      l
    ), w;
  }, a.prototype.fill = function(u, l, A, E) {
    if (typeof u == "string") {
      if (typeof l == "string" ? (E = l, l = 0, A = this.length) : typeof A == "string" && (E = A, A = this.length), E !== void 0 && typeof E != "string")
        throw new TypeError("encoding must be a string");
      if (typeof E == "string" && !a.isEncoding(E))
        throw new TypeError("Unknown encoding: " + E);
      if (u.length === 1) {
        const I = u.charCodeAt(0);
        (E === "utf8" && I < 128 || E === "latin1") && (u = I);
      }
    } else typeof u == "number" ? u = u & 255 : typeof u == "boolean" && (u = Number(u));
    if (l < 0 || this.length < l || this.length < A)
      throw new RangeError("Out of range index");
    if (A <= l)
      return this;
    l = l >>> 0, A = A === void 0 ? this.length : A >>> 0, u || (u = 0);
    let w;
    if (typeof u == "number")
      for (w = l; w < A; ++w)
        this[w] = u;
    else {
      const I = a.isBuffer(u) ? u : a.from(u, E), j = I.length;
      if (j === 0)
        throw new TypeError('The value "' + u + '" is invalid for argument "value"');
      for (w = 0; w < A - l; ++w)
        this[w + l] = I[w % j];
    }
    return this;
  };
  const nt = {};
  function At(m, u, l) {
    nt[m] = class extends l {
      constructor() {
        super(), Object.defineProperty(this, "message", {
          value: u.apply(this, arguments),
          writable: !0,
          configurable: !0
        }), this.name = `${this.name} [${m}]`, this.stack, delete this.name;
      }
      get code() {
        return m;
      }
      set code(E) {
        Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          value: E,
          writable: !0
        });
      }
      toString() {
        return `${this.name} [${m}]: ${this.message}`;
      }
    };
  }
  At(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function(m) {
      return m ? `${m} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    },
    RangeError
  ), At(
    "ERR_INVALID_ARG_TYPE",
    function(m, u) {
      return `The "${m}" argument must be of type number. Received type ${typeof u}`;
    },
    TypeError
  ), At(
    "ERR_OUT_OF_RANGE",
    function(m, u, l) {
      let A = `The value of "${m}" is out of range.`, E = l;
      return Number.isInteger(l) && Math.abs(l) > 2 ** 32 ? E = _t(String(l)) : typeof l == "bigint" && (E = String(l), (l > BigInt(2) ** BigInt(32) || l < -(BigInt(2) ** BigInt(32))) && (E = _t(E)), E += "n"), A += ` It must be ${u}. Received ${E}`, A;
    },
    RangeError
  );
  function _t(m) {
    let u = "", l = m.length;
    const A = m[0] === "-" ? 1 : 0;
    for (; l >= A + 4; l -= 3)
      u = `_${m.slice(l - 3, l)}${u}`;
    return `${m.slice(0, l)}${u}`;
  }
  function Ze(m, u, l) {
    ie(u, "offset"), (m[u] === void 0 || m[u + l] === void 0) && oe(u, m.length - (l + 1));
  }
  function Mn(m, u, l, A, E, w) {
    if (m > l || m < u) {
      const I = typeof u == "bigint" ? "n" : "";
      let j;
      throw u === 0 || u === BigInt(0) ? j = `>= 0${I} and < 2${I} ** ${(w + 1) * 8}${I}` : j = `>= -(2${I} ** ${(w + 1) * 8 - 1}${I}) and < 2 ** ${(w + 1) * 8 - 1}${I}`, new nt.ERR_OUT_OF_RANGE("value", j, m);
    }
    Ze(A, E, w);
  }
  function ie(m, u) {
    if (typeof m != "number")
      throw new nt.ERR_INVALID_ARG_TYPE(u, "number", m);
  }
  function oe(m, u, l) {
    throw Math.floor(m) !== m ? (ie(m, l), new nt.ERR_OUT_OF_RANGE("offset", "an integer", m)) : u < 0 ? new nt.ERR_BUFFER_OUT_OF_BOUNDS() : new nt.ERR_OUT_OF_RANGE(
      "offset",
      `>= 0 and <= ${u}`,
      m
    );
  }
  const Rn = /[^+/0-9A-Za-z-_]/g;
  function ct(m) {
    if (m = m.split("=")[0], m = m.trim().replace(Rn, ""), m.length < 2) return "";
    for (; m.length % 4 !== 0; )
      m = m + "=";
    return m;
  }
  function Lr(m, u) {
    u = u || 1 / 0;
    let l;
    const A = m.length;
    let E = null;
    const w = [];
    for (let I = 0; I < A; ++I) {
      if (l = m.charCodeAt(I), l > 55295 && l < 57344) {
        if (!E) {
          if (l > 56319) {
            (u -= 3) > -1 && w.push(239, 191, 189);
            continue;
          } else if (I + 1 === A) {
            (u -= 3) > -1 && w.push(239, 191, 189);
            continue;
          }
          E = l;
          continue;
        }
        if (l < 56320) {
          (u -= 3) > -1 && w.push(239, 191, 189), E = l;
          continue;
        }
        l = (E - 55296 << 10 | l - 56320) + 65536;
      } else E && (u -= 3) > -1 && w.push(239, 191, 189);
      if (E = null, l < 128) {
        if ((u -= 1) < 0) break;
        w.push(l);
      } else if (l < 2048) {
        if ((u -= 2) < 0) break;
        w.push(
          l >> 6 | 192,
          l & 63 | 128
        );
      } else if (l < 65536) {
        if ((u -= 3) < 0) break;
        w.push(
          l >> 12 | 224,
          l >> 6 & 63 | 128,
          l & 63 | 128
        );
      } else if (l < 1114112) {
        if ((u -= 4) < 0) break;
        w.push(
          l >> 18 | 240,
          l >> 12 & 63 | 128,
          l >> 6 & 63 | 128,
          l & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return w;
  }
  function Su(m) {
    const u = [];
    for (let l = 0; l < m.length; ++l)
      u.push(m.charCodeAt(l) & 255);
    return u;
  }
  function Fu(m, u) {
    let l, A, E;
    const w = [];
    for (let I = 0; I < m.length && !((u -= 2) < 0); ++I)
      l = m.charCodeAt(I), A = l >> 8, E = l % 256, w.push(E), w.push(A);
    return w;
  }
  function _i(m) {
    return t.toByteArray(ct(m));
  }
  function Sn(m, u, l, A) {
    let E;
    for (E = 0; E < A && !(E + l >= u.length || E >= m.length); ++E)
      u[E + l] = m[E];
    return E;
  }
  function qt(m, u) {
    return m instanceof u || m != null && m.constructor != null && m.constructor.name != null && m.constructor.name === u.name;
  }
  function Ur(m) {
    return m !== m;
  }
  const Ou = function() {
    const m = "0123456789abcdef", u = new Array(256);
    for (let l = 0; l < 16; ++l) {
      const A = l * 16;
      for (let E = 0; E < 16; ++E)
        u[A + E] = m[l] + m[E];
    }
    return u;
  }();
  function de(m) {
    return typeof BigInt > "u" ? Du : m;
  }
  function Du() {
    throw new Error("BigInt not supported");
  }
})(Ba);
var V = { exports: {} }, mt = V.exports = {}, Zt, te;
function Ts() {
  throw new Error("setTimeout has not been defined");
}
function ws() {
  throw new Error("clearTimeout has not been defined");
}
(function() {
  try {
    typeof setTimeout == "function" ? Zt = setTimeout : Zt = Ts;
  } catch {
    Zt = Ts;
  }
  try {
    typeof clearTimeout == "function" ? te = clearTimeout : te = ws;
  } catch {
    te = ws;
  }
})();
function Ca(e) {
  if (Zt === setTimeout)
    return setTimeout(e, 0);
  if ((Zt === Ts || !Zt) && setTimeout)
    return Zt = setTimeout, setTimeout(e, 0);
  try {
    return Zt(e, 0);
  } catch {
    try {
      return Zt.call(null, e, 0);
    } catch {
      return Zt.call(this, e, 0);
    }
  }
}
function lh(e) {
  if (te === clearTimeout)
    return clearTimeout(e);
  if ((te === ws || !te) && clearTimeout)
    return te = clearTimeout, clearTimeout(e);
  try {
    return te(e);
  } catch {
    try {
      return te.call(null, e);
    } catch {
      return te.call(this, e);
    }
  }
}
var ce = [], ze = !1, Te, Yn = -1;
function fh() {
  !ze || !Te || (ze = !1, Te.length ? ce = Te.concat(ce) : Yn = -1, ce.length && Ta());
}
function Ta() {
  if (!ze) {
    var e = Ca(fh);
    ze = !0;
    for (var t = ce.length; t; ) {
      for (Te = ce, ce = []; ++Yn < t; )
        Te && Te[Yn].run();
      Yn = -1, t = ce.length;
    }
    Te = null, ze = !1, lh(e);
  }
}
mt.nextTick = function(e) {
  var t = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var n = 1; n < arguments.length; n++)
      t[n - 1] = arguments[n];
  ce.push(new wa(e, t)), ce.length === 1 && !ze && Ca(Ta);
};
function wa(e, t) {
  this.fun = e, this.array = t;
}
wa.prototype.run = function() {
  this.fun.apply(null, this.array);
};
mt.title = "browser";
mt.browser = !0;
mt.env = {};
mt.argv = [];
mt.version = "";
mt.versions = {};
function fe() {
}
mt.on = fe;
mt.addListener = fe;
mt.once = fe;
mt.off = fe;
mt.removeListener = fe;
mt.removeAllListeners = fe;
mt.emit = fe;
mt.prependListener = fe;
mt.prependOnceListener = fe;
mt.listeners = function(e) {
  return [];
};
mt.binding = function(e) {
  throw new Error("process.binding is not supported");
};
mt.cwd = function() {
  return "/";
};
mt.chdir = function(e) {
  throw new Error("process.chdir is not supported");
};
mt.umask = function() {
  return 0;
};
function Me() {
}
var ba = (
  /** @type {boolean} */
  V.exports.browser
), _a = Me, Ia = (
  /** @type {Function} */
  V.exports.binding
), xa = Me, Ma = 1, Ra = {}, Sa = Me, Fa = Me, Oa = Me, Da = Me, La = Me, Ua = "browser", Na = "browser", Pa = "browser", Ga = (
  /** @type {string[]} */
  []
), dh = {
  nextTick: V.exports.nextTick,
  title: V.exports.title,
  browser: ba,
  env: V.exports.env,
  argv: V.exports.argv,
  version: V.exports.version,
  versions: V.exports.versions,
  on: V.exports.on,
  addListener: V.exports.addListener,
  once: V.exports.once,
  off: V.exports.off,
  removeListener: V.exports.removeListener,
  removeAllListeners: V.exports.removeAllListeners,
  emit: V.exports.emit,
  emitWarning: _a,
  prependListener: V.exports.prependListener,
  prependOnceListener: V.exports.prependOnceListener,
  listeners: V.exports.listeners,
  binding: Ia,
  cwd: V.exports.cwd,
  chdir: V.exports.chdir,
  umask: V.exports.umask,
  exit: xa,
  pid: Ma,
  features: Ra,
  kill: Sa,
  dlopen: Fa,
  uptime: Oa,
  memoryUsage: Da,
  uvCounters: La,
  platform: Ua,
  arch: Na,
  execPath: Pa,
  execArgv: Ga
}, mh = V.exports.addListener, ph = V.exports.argv, gh = V.exports.chdir, Ah = V.exports.cwd, yh = V.exports.emit, Bh = V.exports.env, Eh = V.exports.listeners, Ch = V.exports.nextTick, Th = V.exports.off, wh = V.exports.on, bh = V.exports.once, _h = V.exports.prependListener, Ih = V.exports.prependOnceListener, xh = V.exports.removeAllListeners, Mh = V.exports.removeListener, Rh = V.exports.title, Sh = V.exports.umask, Fh = V.exports.version, Oh = V.exports.versions;
const Dh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  addListener: mh,
  arch: Na,
  argv: ph,
  binding: Ia,
  browser: ba,
  chdir: gh,
  cwd: Ah,
  default: dh,
  dlopen: Fa,
  emit: yh,
  emitWarning: _a,
  env: Bh,
  execArgv: Ga,
  execPath: Pa,
  exit: xa,
  features: Ra,
  kill: Sa,
  listeners: Eh,
  memoryUsage: Da,
  nextTick: Ch,
  off: Th,
  on: wh,
  once: bh,
  pid: Ma,
  platform: Ua,
  prependListener: _h,
  prependOnceListener: Ih,
  removeAllListeners: xh,
  removeListener: Mh,
  title: Rh,
  umask: Sh,
  uptime: Oa,
  uvCounters: La,
  version: Fh,
  versions: Oh
}, Symbol.toStringTag, { value: "Module" })), Lh = /* @__PURE__ */ nh(Dh);
(function(e) {
  Object.defineProperty(e, Symbol.toStringTag, { value: "Module" });
  const t = Ba, n = Lh, r = (o) => o && o.__esModule ? o : { default: o }, s = r(n), i = globalThis || void 0 || self;
  Object.defineProperty(e, "Buffer", { enumerable: !0, get: () => t.Buffer }), Object.defineProperty(e, "process", { enumerable: !0, get: () => s.default }), e.global = i;
})(st);
async function Cn(e, t, n, r) {
  return r._parse(e, t, n, r);
}
function $(e, t) {
  if (!e)
    throw new Error(t || "loader assertion failed.");
}
const Tr = (
  // @ts-ignore process does not exist on browser
  !!(typeof st.process != "object" || String(st.process) !== "[object process]" || st.process.browser)
), Ri = typeof st.process < "u" && st.process.version && /v([0-9]*)/.exec(st.process.version);
Ri && parseFloat(Ri[1]);
const Fn = globalThis, Ne = globalThis.process || {};
function Uh(e) {
  var r, s;
  if (typeof window < "u" && ((r = window.process) == null ? void 0 : r.type) === "renderer" || typeof st.process < "u" && ((s = st.process.versions) != null && s.electron))
    return !0;
  const n = typeof navigator < "u" && navigator.userAgent;
  return !!(n && n.indexOf("Electron") >= 0);
}
function Xs() {
  var t;
  return !// @ts-expect-error
  (typeof st.process == "object" && String(st.process) === "[object process]" && !((t = st.process) != null && t.browser)) || Uh();
}
const va = "4.1.1";
function qs(e, t) {
  if (!e)
    throw new Error("Assertion failed");
}
function Ha(e) {
  if (!e)
    return 0;
  let t;
  switch (typeof e) {
    case "number":
      t = e;
      break;
    case "object":
      t = e.logLevel || e.priority || 0;
      break;
    default:
      return 0;
  }
  return qs(Number.isFinite(t) && t >= 0), t;
}
function Nh(e) {
  const { logLevel: t, message: n } = e;
  e.logLevel = Ha(t);
  const r = e.args ? Array.from(e.args) : [];
  for (; r.length && r.shift() !== n; )
    ;
  switch (typeof t) {
    case "string":
    case "function":
      n !== void 0 && r.unshift(n), e.message = t;
      break;
    case "object":
      Object.assign(e, t);
      break;
  }
  typeof e.message == "function" && (e.message = e.message());
  const s = typeof e.message;
  return qs(s === "string" || s === "object"), Object.assign(e, { args: r }, e.opts);
}
const ke = () => {
};
class Ph {
  constructor({ level: t = 0 } = {}) {
    this.userData = {}, this._onceCache = /* @__PURE__ */ new Set(), this._level = t;
  }
  set level(t) {
    this.setLevel(t);
  }
  get level() {
    return this.getLevel();
  }
  setLevel(t) {
    return this._level = t, this;
  }
  getLevel() {
    return this._level;
  }
  // Unconditional logging
  warn(t, ...n) {
    return this._log("warn", 0, t, n, { once: !0 });
  }
  error(t, ...n) {
    return this._log("error", 0, t, n);
  }
  // Conditional logging
  log(t, n, ...r) {
    return this._log("log", t, n, r);
  }
  info(t, n, ...r) {
    return this._log("info", t, n, r);
  }
  once(t, n, ...r) {
    return this._log("once", t, n, r, { once: !0 });
  }
  _log(t, n, r, s, i = {}) {
    const o = Nh({
      logLevel: n,
      message: r,
      args: this._buildArgs(n, r, s),
      opts: i
    });
    return this._createLogFunction(t, o, i);
  }
  _buildArgs(t, n, r) {
    return [t, n, ...r];
  }
  _createLogFunction(t, n, r) {
    if (!this._shouldLog(n.logLevel))
      return ke;
    const s = this._getOnceTag(r.tag ?? n.tag ?? n.message);
    if ((r.once || n.once) && s !== void 0) {
      if (this._onceCache.has(s))
        return ke;
      this._onceCache.add(s);
    }
    return this._emit(t, n);
  }
  _shouldLog(t) {
    return this.getLevel() >= Ha(t);
  }
  _getOnceTag(t) {
    if (t !== void 0)
      try {
        return typeof t == "string" ? t : String(t);
      } catch {
        return;
      }
  }
}
function Gh(e) {
  try {
    const t = window[e], n = "__storage_test__";
    return t.setItem(n, n), t.removeItem(n), t;
  } catch {
    return null;
  }
}
class vh {
  constructor(t, n, r = "sessionStorage") {
    this.storage = Gh(r), this.id = t, this.config = n, this._loadConfiguration();
  }
  getConfiguration() {
    return this.config;
  }
  setConfiguration(t) {
    if (Object.assign(this.config, t), this.storage) {
      const n = JSON.stringify(this.config);
      this.storage.setItem(this.id, n);
    }
  }
  // Get config from persistent store, if available
  _loadConfiguration() {
    let t = {};
    if (this.storage) {
      const n = this.storage.getItem(this.id);
      t = n ? JSON.parse(n) : {};
    }
    return Object.assign(this.config, t), this;
  }
}
function Hh(e) {
  let t;
  return e < 10 ? t = `${e.toFixed(2)}ms` : e < 100 ? t = `${e.toFixed(1)}ms` : e < 1e3 ? t = `${e.toFixed(0)}ms` : t = `${(e / 1e3).toFixed(2)}s`, t;
}
function Jh(e, t = 8) {
  const n = Math.max(t - e.length, 0);
  return `${" ".repeat(n)}${e}`;
}
var or;
(function(e) {
  e[e.BLACK = 30] = "BLACK", e[e.RED = 31] = "RED", e[e.GREEN = 32] = "GREEN", e[e.YELLOW = 33] = "YELLOW", e[e.BLUE = 34] = "BLUE", e[e.MAGENTA = 35] = "MAGENTA", e[e.CYAN = 36] = "CYAN", e[e.WHITE = 37] = "WHITE", e[e.BRIGHT_BLACK = 90] = "BRIGHT_BLACK", e[e.BRIGHT_RED = 91] = "BRIGHT_RED", e[e.BRIGHT_GREEN = 92] = "BRIGHT_GREEN", e[e.BRIGHT_YELLOW = 93] = "BRIGHT_YELLOW", e[e.BRIGHT_BLUE = 94] = "BRIGHT_BLUE", e[e.BRIGHT_MAGENTA = 95] = "BRIGHT_MAGENTA", e[e.BRIGHT_CYAN = 96] = "BRIGHT_CYAN", e[e.BRIGHT_WHITE = 97] = "BRIGHT_WHITE";
})(or || (or = {}));
const kh = 10;
function Si(e) {
  return typeof e != "string" ? e : (e = e.toUpperCase(), or[e] || or.WHITE);
}
function Vh(e, t, n) {
  return !Xs && typeof e == "string" && (t && (e = `\x1B[${Si(t)}m${e}\x1B[39m`), n && (e = `\x1B[${Si(n) + kh}m${e}\x1B[49m`)), e;
}
function jh(e, t = ["constructor"]) {
  const n = Object.getPrototypeOf(e), r = Object.getOwnPropertyNames(n), s = e;
  for (const i of r) {
    const o = s[i];
    typeof o == "function" && (t.find((a) => i === a) || (s[i] = o.bind(e)));
  }
}
function tn() {
  var t, n, r;
  let e;
  if (Xs() && Fn.performance)
    e = (n = (t = Fn == null ? void 0 : Fn.performance) == null ? void 0 : t.now) == null ? void 0 : n.call(t);
  else if ("hrtime" in Ne) {
    const s = (r = Ne == null ? void 0 : Ne.hrtime) == null ? void 0 : r.call(Ne);
    e = s[0] * 1e3 + s[1] / 1e6;
  } else
    e = Date.now();
  return e;
}
const Pe = {
  debug: Xs() && console.debug || console.log,
  log: console.log,
  info: console.info,
  warn: console.warn,
  error: console.error
}, Gr = {
  enabled: !0,
  level: 0
};
class wr extends Ph {
  constructor({ id: t } = { id: "" }) {
    super({ level: 0 }), this.VERSION = va, this._startTs = tn(), this._deltaTs = tn(), this.userData = {}, this.LOG_THROTTLE_TIMEOUT = 0, this.id = t, this.userData = {}, this._storage = new vh(`__probe-${this.id}__`, { [this.id]: Gr }), this.timeStamp(`${this.id} started`), jh(this), Object.seal(this);
  }
  isEnabled() {
    return this._getConfiguration().enabled;
  }
  getLevel() {
    return this._getConfiguration().level;
  }
  /** @return milliseconds, with fractions */
  getTotal() {
    return Number((tn() - this._startTs).toPrecision(10));
  }
  /** @return milliseconds, with fractions */
  getDelta() {
    return Number((tn() - this._deltaTs).toPrecision(10));
  }
  /** @deprecated use logLevel */
  set priority(t) {
    this.level = t;
  }
  /** @deprecated use logLevel */
  get priority() {
    return this.level;
  }
  /** @deprecated use logLevel */
  getPriority() {
    return this.level;
  }
  // Configure
  enable(t = !0) {
    return this._updateConfiguration({ enabled: t }), this;
  }
  setLevel(t) {
    return this._updateConfiguration({ level: t }), this;
  }
  /** return the current status of the setting */
  get(t) {
    return this._getConfiguration()[t];
  }
  // update the status of the setting
  set(t, n) {
    this._updateConfiguration({ [t]: n });
  }
  /** Logs the current settings as a table */
  settings() {
    console.table ? console.table(this._storage.config) : console.log(this._storage.config);
  }
  // Unconditional logging
  assert(t, n) {
    if (!t)
      throw new Error(n || "Assertion failed");
  }
  warn(t, ...n) {
    return this._log("warn", 0, t, n, {
      method: Pe.warn,
      once: !0
    });
  }
  error(t, ...n) {
    return this._log("error", 0, t, n, {
      method: Pe.error
    });
  }
  /** Print a deprecation warning */
  deprecated(t, n) {
    return this.warn(`\`${t}\` is deprecated and will be removed in a later version. Use \`${n}\` instead`);
  }
  /** Print a removal warning */
  removed(t, n) {
    return this.error(`\`${t}\` has been removed. Use \`${n}\` instead`);
  }
  probe(t, n, ...r) {
    return this._log("log", t, n, r, {
      method: Pe.log,
      time: !0,
      once: !0
    });
  }
  log(t, n, ...r) {
    return this._log("log", t, n, r, {
      method: Pe.debug
    });
  }
  info(t, n, ...r) {
    return this._log("info", t, n, r, { method: console.info });
  }
  once(t, n, ...r) {
    return this._log("once", t, n, r, {
      method: Pe.debug || Pe.info,
      once: !0
    });
  }
  /** Logs an object as a table */
  table(t, n, r) {
    return n ? this._log("table", t, n, r && [r] || [], {
      method: console.table || ke,
      tag: zh(n)
    }) : ke;
  }
  time(t, n) {
    return this._log("time", t, n, [], {
      method: console.time ? console.time : console.info
    });
  }
  timeEnd(t, n) {
    return this._log("time", t, n, [], {
      method: console.timeEnd ? console.timeEnd : console.info
    });
  }
  timeStamp(t, n) {
    return this._log("time", t, n, [], {
      method: console.timeStamp || ke
    });
  }
  group(t, n, r = { collapsed: !1 }) {
    const s = (r.collapsed ? console.groupCollapsed : console.group) || console.info;
    return this._log("group", t, n, [], { method: s });
  }
  groupCollapsed(t, n, r = {}) {
    return this.group(t, n, Object.assign({}, r, { collapsed: !0 }));
  }
  groupEnd(t) {
    return this._log("groupEnd", t, "", [], {
      method: console.groupEnd || ke
    });
  }
  // EXPERIMENTAL
  withGroup(t, n, r) {
    this.group(t, n)();
    try {
      r();
    } finally {
      this.groupEnd(t)();
    }
  }
  trace() {
    console.trace && console.trace();
  }
  _shouldLog(t) {
    return this.isEnabled() && super._shouldLog(t);
  }
  _emit(t, n) {
    const r = n.method;
    qs(r), n.total = this.getTotal(), n.delta = this.getDelta(), this._deltaTs = tn();
    const s = Kh(this.id, n.message, n);
    return r.bind(console, s, ...n.args);
  }
  _getConfiguration() {
    return this._storage.config[this.id] || this._updateConfiguration(Gr), this._storage.config[this.id];
  }
  _updateConfiguration(t) {
    const n = this._storage.config[this.id] || {
      ...Gr
    };
    this._storage.setConfiguration({
      [this.id]: { ...n, ...t }
    });
  }
}
wr.VERSION = va;
function Kh(e, t, n) {
  if (typeof t == "string") {
    const r = n.time ? Jh(Hh(n.total)) : "";
    t = n.time ? `${e}: ${r}  ${t}` : `${e}: ${t}`, t = Vh(t, n.color, n.background);
  }
  return t;
}
function zh(e) {
  for (const t in e)
    for (const n in e[t])
      return n || "untitled";
  return "empty";
}
globalThis.probe = {};
const Ja = new wr({ id: "@probe.gl/log" }), vr = "4.3.3", Wh = vr[0] >= "0" && vr[0] <= "9" ? `v${vr}` : "";
function Qh() {
  const e = new wr({ id: "loaders.gl" });
  return globalThis.loaders = globalThis.loaders || {}, globalThis.loaders.log = e, globalThis.loaders.version = Wh, globalThis.probe = globalThis.probe || {}, globalThis.probe.loaders = e, e;
}
const $h = Qh();
function Xh(e, t) {
  return ka(e || {}, t);
}
function ka(e, t, n = 0) {
  if (n > 3)
    return t;
  const r = { ...e };
  for (const [s, i] of Object.entries(t))
    i && typeof i == "object" && !Array.isArray(i) ? r[s] = ka(r[s] || {}, t[s], n + 1) : r[s] = t[s];
  return r;
}
function qh(e) {
  var t;
  globalThis.loaders || (globalThis.loaders = {}), (t = globalThis.loaders).modules || (t.modules = {}), Object.assign(globalThis.loaders.modules, e);
}
function Yh(e) {
  var n, r;
  return ((r = (n = globalThis.loaders) == null ? void 0 : n.modules) == null ? void 0 : r[e]) || null;
}
const Zh = "latest";
function tl() {
  var e;
  return (e = globalThis._loadersgl_) != null && e.version || (globalThis._loadersgl_ = globalThis._loadersgl_ || {}, globalThis._loadersgl_.version = "4.3.3"), globalThis._loadersgl_.version;
}
const Va = tl();
function le(e, t) {
  if (!e)
    throw new Error(t || "loaders.gl assertion failed.");
}
const kt = (
  // @ts-ignore process.browser
  typeof st.process != "object" || String(st.process) !== "[object process]" || st.process.browser
), Ys = typeof importScripts == "function", el = typeof window < "u" && typeof window.orientation < "u", Fi = typeof st.process < "u" && st.process.version && /v([0-9]*)/.exec(st.process.version);
Fi && parseFloat(Fi[1]);
class nl {
  constructor(t, n) {
    y(this, "name");
    y(this, "workerThread");
    y(this, "isRunning", !0);
    /** Promise that resolves when Job is done */
    y(this, "result");
    y(this, "_resolve", () => {
    });
    y(this, "_reject", () => {
    });
    this.name = t, this.workerThread = n, this.result = new Promise((r, s) => {
      this._resolve = r, this._reject = s;
    });
  }
  /**
   * Send a message to the job's worker thread
   * @param data any data structure, ideally consisting mostly of transferrable objects
   */
  postMessage(t, n) {
    this.workerThread.postMessage({
      source: "loaders.gl",
      // Lets worker ignore unrelated messages
      type: t,
      payload: n
    });
  }
  /**
   * Call to resolve the `result` Promise with the supplied value
   */
  done(t) {
    le(this.isRunning), this.isRunning = !1, this._resolve(t);
  }
  /**
   * Call to reject the `result` Promise with the supplied error
   */
  error(t) {
    le(this.isRunning), this.isRunning = !1, this._reject(t);
  }
}
class Hr {
  terminate() {
  }
}
const Jr = /* @__PURE__ */ new Map();
function rl(e) {
  le(e.source && !e.url || !e.source && e.url);
  let t = Jr.get(e.source || e.url);
  return t || (e.url && (t = sl(e.url), Jr.set(e.url, t)), e.source && (t = ja(e.source), Jr.set(e.source, t))), le(t), t;
}
function sl(e) {
  if (!e.startsWith("http"))
    return e;
  const t = il(e);
  return ja(t);
}
function ja(e) {
  const t = new Blob([e], { type: "application/javascript" });
  return URL.createObjectURL(t);
}
function il(e) {
  return `try {
  importScripts('${e}');
} catch (error) {
  console.error(error);
  throw error;
}`;
}
function Ka(e, t = !0, n) {
  const r = n || /* @__PURE__ */ new Set();
  if (e) {
    if (Oi(e))
      r.add(e);
    else if (Oi(e.buffer))
      r.add(e.buffer);
    else if (!ArrayBuffer.isView(e)) {
      if (t && typeof e == "object")
        for (const s in e)
          Ka(e[s], t, r);
    }
  }
  return n === void 0 ? Array.from(r) : [];
}
function Oi(e) {
  return e ? e instanceof ArrayBuffer || typeof MessagePort < "u" && e instanceof MessagePort || typeof ImageBitmap < "u" && e instanceof ImageBitmap || typeof OffscreenCanvas < "u" && e instanceof OffscreenCanvas : !1;
}
const kr = () => {
};
class bs {
  constructor(t) {
    y(this, "name");
    y(this, "source");
    y(this, "url");
    y(this, "terminated", !1);
    y(this, "worker");
    y(this, "onMessage");
    y(this, "onError");
    y(this, "_loadableURL", "");
    const { name: n, source: r, url: s } = t;
    le(r || s), this.name = n, this.source = r, this.url = s, this.onMessage = kr, this.onError = (i) => console.log(i), this.worker = kt ? this._createBrowserWorker() : this._createNodeWorker();
  }
  /** Checks if workers are supported on this platform */
  static isSupported() {
    return typeof Worker < "u" && kt || typeof Hr < "u" && !kt;
  }
  /**
   * Terminate this worker thread
   * @note Can free up significant memory
   */
  destroy() {
    this.onMessage = kr, this.onError = kr, this.worker.terminate(), this.terminated = !0;
  }
  get isRunning() {
    return !!this.onMessage;
  }
  /**
   * Send a message to this worker thread
   * @param data any data structure, ideally consisting mostly of transferrable objects
   * @param transferList If not supplied, calculated automatically by traversing data
   */
  postMessage(t, n) {
    n = n || Ka(t), this.worker.postMessage(t, n);
  }
  // PRIVATE
  /**
   * Generate a standard Error from an ErrorEvent
   * @param event
   */
  _getErrorFromErrorEvent(t) {
    let n = "Failed to load ";
    return n += `worker ${this.name} from ${this.url}. `, t.message && (n += `${t.message} in `), t.lineno && (n += `:${t.lineno}:${t.colno}`), new Error(n);
  }
  /**
   * Creates a worker thread on the browser
   */
  _createBrowserWorker() {
    this._loadableURL = rl({ source: this.source, url: this.url });
    const t = new Worker(this._loadableURL, { name: this.name });
    return t.onmessage = (n) => {
      n.data ? this.onMessage(n.data) : this.onError(new Error("No data received"));
    }, t.onerror = (n) => {
      this.onError(this._getErrorFromErrorEvent(n)), this.terminated = !0;
    }, t.onmessageerror = (n) => console.error(n), t;
  }
  /**
   * Creates a worker thread in node.js
   * @todo https://nodejs.org/api/async_hooks.html#async-resource-worker-pool
   */
  _createNodeWorker() {
    let t;
    if (this.url) {
      const r = this.url.includes(":/") || this.url.startsWith("/") ? this.url : `./${this.url}`;
      t = new Hr(r, { eval: !1 });
    } else if (this.source)
      t = new Hr(this.source, { eval: !0 });
    else
      throw new Error("no worker");
    return t.on("message", (n) => {
      this.onMessage(n);
    }), t.on("error", (n) => {
      this.onError(n);
    }), t.on("exit", (n) => {
    }), t;
  }
}
class ol {
  /**
   * @param processor - worker function
   * @param maxConcurrency - max count of workers
   */
  constructor(t) {
    y(this, "name", "unnamed");
    y(this, "source");
    // | Function;
    y(this, "url");
    y(this, "maxConcurrency", 1);
    y(this, "maxMobileConcurrency", 1);
    y(this, "onDebug", () => {
    });
    y(this, "reuseWorkers", !0);
    y(this, "props", {});
    y(this, "jobQueue", []);
    y(this, "idleQueue", []);
    y(this, "count", 0);
    y(this, "isDestroyed", !1);
    this.source = t.source, this.url = t.url, this.setProps(t);
  }
  /** Checks if workers are supported on this platform */
  static isSupported() {
    return bs.isSupported();
  }
  /**
   * Terminates all workers in the pool
   * @note Can free up significant memory
   */
  destroy() {
    this.idleQueue.forEach((t) => t.destroy()), this.isDestroyed = !0;
  }
  setProps(t) {
    this.props = { ...this.props, ...t }, t.name !== void 0 && (this.name = t.name), t.maxConcurrency !== void 0 && (this.maxConcurrency = t.maxConcurrency), t.maxMobileConcurrency !== void 0 && (this.maxMobileConcurrency = t.maxMobileConcurrency), t.reuseWorkers !== void 0 && (this.reuseWorkers = t.reuseWorkers), t.onDebug !== void 0 && (this.onDebug = t.onDebug);
  }
  async startJob(t, n = (s, i, o) => s.done(o), r = (s, i) => s.error(i)) {
    const s = new Promise((i) => (this.jobQueue.push({ name: t, onMessage: n, onError: r, onStart: i }), this));
    return this._startQueuedJob(), await s;
  }
  // PRIVATE
  /**
   * Starts first queued job if worker is available or can be created
   * Called when job is started and whenever a worker returns to the idleQueue
   */
  async _startQueuedJob() {
    if (!this.jobQueue.length)
      return;
    const t = this._getAvailableWorker();
    if (!t)
      return;
    const n = this.jobQueue.shift();
    if (n) {
      this.onDebug({
        message: "Starting job",
        name: n.name,
        workerThread: t,
        backlog: this.jobQueue.length
      });
      const r = new nl(n.name, t);
      t.onMessage = (s) => n.onMessage(r, s.type, s.payload), t.onError = (s) => n.onError(r, s), n.onStart(r);
      try {
        await r.result;
      } catch (s) {
        console.error(`Worker exception: ${s}`);
      } finally {
        this.returnWorkerToQueue(t);
      }
    }
  }
  /**
   * Returns a worker to the idle queue
   * Destroys the worker if
   *  - pool is destroyed
   *  - if this pool doesn't reuse workers
   *  - if maxConcurrency has been lowered
   * @param worker
   */
  returnWorkerToQueue(t) {
    // Workers on Node.js prevent the process from exiting.
    // Until we figure out how to close them before exit, we always destroy them
    !kt || // If the pool is destroyed, there is no reason to keep the worker around
    this.isDestroyed || // If the app has disabled worker reuse, any completed workers should be destroyed
    !this.reuseWorkers || // If concurrency has been lowered, this worker might be surplus to requirements
    this.count > this._getMaxConcurrency() ? (t.destroy(), this.count--) : this.idleQueue.push(t), this.isDestroyed || this._startQueuedJob();
  }
  /**
   * Returns idle worker or creates new worker if maxConcurrency has not been reached
   */
  _getAvailableWorker() {
    if (this.idleQueue.length > 0)
      return this.idleQueue.shift() || null;
    if (this.count < this._getMaxConcurrency()) {
      this.count++;
      const t = `${this.name.toLowerCase()} (#${this.count} of ${this.maxConcurrency})`;
      return new bs({ name: t, source: this.source, url: this.url });
    }
    return null;
  }
  _getMaxConcurrency() {
    return el ? this.maxMobileConcurrency : this.maxConcurrency;
  }
}
const al = {
  maxConcurrency: 3,
  maxMobileConcurrency: 1,
  reuseWorkers: !0,
  onDebug: () => {
  }
}, Ae = class Ae {
  /** get global instance with WorkerFarm.getWorkerFarm() */
  constructor(t) {
    y(this, "props");
    y(this, "workerPools", /* @__PURE__ */ new Map());
    this.props = { ...al }, this.setProps(t), this.workerPools = /* @__PURE__ */ new Map();
  }
  /** Checks if workers are supported on this platform */
  static isSupported() {
    return bs.isSupported();
  }
  /** Get the singleton instance of the global worker farm */
  static getWorkerFarm(t = {}) {
    return Ae._workerFarm = Ae._workerFarm || new Ae({}), Ae._workerFarm.setProps(t), Ae._workerFarm;
  }
  /**
   * Terminate all workers in the farm
   * @note Can free up significant memory
   */
  destroy() {
    for (const t of this.workerPools.values())
      t.destroy();
    this.workerPools = /* @__PURE__ */ new Map();
  }
  /**
   * Set props used when initializing worker pools
   * @param props
   */
  setProps(t) {
    this.props = { ...this.props, ...t };
    for (const n of this.workerPools.values())
      n.setProps(this._getWorkerPoolProps());
  }
  /**
   * Returns a worker pool for the specified worker
   * @param options - only used first time for a specific worker name
   * @param options.name - the name of the worker - used to identify worker pool
   * @param options.url -
   * @param options.source -
   * @example
   *   const job = WorkerFarm.getWorkerFarm().getWorkerPool({name, url}).startJob(...);
   */
  getWorkerPool(t) {
    const { name: n, source: r, url: s } = t;
    let i = this.workerPools.get(n);
    return i || (i = new ol({
      name: n,
      source: r,
      url: s
    }), i.setProps(this._getWorkerPoolProps()), this.workerPools.set(n, i)), i;
  }
  _getWorkerPoolProps() {
    return {
      maxConcurrency: this.props.maxConcurrency,
      maxMobileConcurrency: this.props.maxMobileConcurrency,
      reuseWorkers: this.props.reuseWorkers,
      onDebug: this.props.onDebug
    };
  }
};
// singleton
y(Ae, "_workerFarm");
let ar = Ae;
function cl(e, t = {}) {
  const n = t[e.id] || {}, r = kt ? `${e.id}-worker.js` : `${e.id}-worker-node.js`;
  let s = n.workerUrl;
  if (!s && e.id === "compression" && (s = t.workerUrl), t._workerType === "test" && (kt ? s = `modules/${e.module}/dist/${r}` : s = `modules/${e.module}/src/workers/${e.id}-worker-node.ts`), !s) {
    let i = e.version;
    i === "latest" && (i = Zh);
    const o = i ? `@${i}` : "";
    s = `https://unpkg.com/@loaders.gl/${e.module}${o}/dist/${r}`;
  }
  return le(s), s;
}
function ul(e, t = Va) {
  le(e, "no worker provided");
  const n = e.version;
  return !(!t || !n);
}
const Vr = {};
async function be(e, t = null, n = {}, r = null) {
  return t && (e = hl(e, t, n, r)), Vr[e] = // eslint-disable-next-line @typescript-eslint/no-misused-promises
  Vr[e] || ll(e), await Vr[e];
}
function hl(e, t, n = {}, r = null) {
  if (!n.useLocalLibraries && e.startsWith("http"))
    return e;
  r = r || e;
  const s = n.modules || {};
  return s[r] ? s[r] : kt ? n.CDN ? (le(n.CDN.startsWith("http")), `${n.CDN}/${t}@${Va}/dist/libs/${r}`) : Ys ? `../src/libs/${r}` : `modules/${t}/src/libs/${r}` : `modules/${t}/dist/libs/${r}`;
}
async function ll(e) {
  if (e.endsWith("wasm"))
    return await dl(e);
  if (!kt)
    try {
      const { requireFromFile: n } = globalThis.loaders || {};
      return await (n == null ? void 0 : n(e));
    } catch (n) {
      return console.error(n), null;
    }
  if (Ys)
    return importScripts(e);
  const t = await ml(e);
  return fl(t, e);
}
function fl(e, t) {
  if (!kt) {
    const { requireFromString: r } = globalThis.loaders || {};
    return r == null ? void 0 : r(e, t);
  }
  if (Ys)
    return eval.call(globalThis, e), null;
  const n = document.createElement("script");
  n.id = t;
  try {
    n.appendChild(document.createTextNode(e));
  } catch {
    n.text = e;
  }
  return document.body.appendChild(n), null;
}
async function dl(e) {
  const { readFileAsArrayBuffer: t } = globalThis.loaders || {};
  return kt || !t || e.startsWith("http") ? await (await fetch(e)).arrayBuffer() : await t(e);
}
async function ml(e) {
  const { readFileAsText: t } = globalThis.loaders || {};
  return kt || !t || e.startsWith("http") ? await (await fetch(e)).text() : await t(e);
}
function pl(e, t) {
  return !ar.isSupported() || !kt && !(t != null && t._nodeWorkers) ? !1 : e.worker && (t == null ? void 0 : t.worker);
}
async function gl(e, t, n, r, s) {
  const i = e.id, o = cl(e, n), c = ar.getWorkerFarm(n).getWorkerPool({ name: i, url: o });
  n = JSON.parse(JSON.stringify(n)), r = JSON.parse(JSON.stringify(r || {}));
  const h = await c.startJob(
    "process-on-worker",
    // @ts-expect-error
    Al.bind(null, s)
    // eslint-disable-line @typescript-eslint/no-misused-promises
  );
  return h.postMessage("process", {
    // @ts-ignore
    input: t,
    options: n,
    context: r
  }), await (await h.result).result;
}
async function Al(e, t, n, r) {
  switch (n) {
    case "done":
      t.done(r);
      break;
    case "error":
      t.error(new Error(r.error));
      break;
    case "process":
      const { id: s, input: i, options: o } = r;
      try {
        const a = await e(i, o);
        t.postMessage("done", { id: s, result: a });
      } catch (a) {
        const c = a instanceof Error ? a.message : "unknown error";
        t.postMessage("error", { id: s, error: c });
      }
      break;
    default:
      console.warn(`parse-with-worker unknown message ${n}`);
  }
}
function yl(e, t = 5) {
  return typeof e == "string" ? e.slice(0, t) : ArrayBuffer.isView(e) ? Di(e.buffer, e.byteOffset, t) : e instanceof ArrayBuffer ? Di(e, 0, t) : "";
}
function Di(e, t, n) {
  if (e.byteLength <= t + n)
    return "";
  const r = new DataView(e);
  let s = "";
  for (let i = 0; i < n; i++)
    s += String.fromCharCode(r.getUint8(t + i));
  return s;
}
function Bl(e) {
  try {
    return JSON.parse(e);
  } catch {
    throw new Error(`Failed to parse JSON from data starting with "${yl(e)}"`);
  }
}
function El(e, t, n) {
  if (n = n || e.byteLength, e.byteLength < n || t.byteLength < n)
    return !1;
  const r = new Uint8Array(e), s = new Uint8Array(t);
  for (let i = 0; i < r.length; ++i)
    if (r[i] !== s[i])
      return !1;
  return !0;
}
function Cl(...e) {
  return Tl(e);
}
function Tl(e) {
  const t = e.map((i) => i instanceof ArrayBuffer ? new Uint8Array(i) : i), n = t.reduce((i, o) => i + o.byteLength, 0), r = new Uint8Array(n);
  let s = 0;
  for (const i of t)
    r.set(i, s), s += i.byteLength;
  return r.buffer;
}
function Zs(e, t, n) {
  const r = n !== void 0 ? new Uint8Array(e).subarray(t, t + n) : new Uint8Array(e).subarray(t);
  return new Uint8Array(r).buffer;
}
function Tn(e, t) {
  return $(e >= 0), $(t > 0), e + (t - 1) & -4;
}
function wl(e, t, n) {
  let r;
  if (e instanceof ArrayBuffer)
    r = new Uint8Array(e);
  else {
    const s = e.byteOffset, i = e.byteLength;
    r = new Uint8Array(e.buffer || e.arrayBuffer, s, i);
  }
  return t.set(r, n), n + Tn(r.byteLength, 4);
}
async function* bl(e, t = {}) {
  const n = new TextDecoder(void 0, t);
  for await (const r of e)
    yield typeof r == "string" ? r : n.decode(r, { stream: !0 });
}
async function _l(e) {
  const t = [];
  for await (const n of e)
    t.push(n);
  return Cl(...t);
}
function Li() {
  let e;
  if (typeof window < "u" && window.performance)
    e = window.performance.now();
  else if (typeof st.process < "u" && st.process.hrtime) {
    const t = st.process.hrtime();
    e = t[0] * 1e3 + t[1] / 1e6;
  } else
    e = Date.now();
  return e;
}
class Ui {
  constructor(t, n) {
    this.sampleSize = 1, this.time = 0, this.count = 0, this.samples = 0, this.lastTiming = 0, this.lastSampleTime = 0, this.lastSampleCount = 0, this._count = 0, this._time = 0, this._samples = 0, this._startTime = 0, this._timerPending = !1, this.name = t, this.type = n, this.reset();
  }
  reset() {
    return this.time = 0, this.count = 0, this.samples = 0, this.lastTiming = 0, this.lastSampleTime = 0, this.lastSampleCount = 0, this._count = 0, this._time = 0, this._samples = 0, this._startTime = 0, this._timerPending = !1, this;
  }
  setSampleSize(t) {
    return this.sampleSize = t, this;
  }
  /** Call to increment count (+1) */
  incrementCount() {
    return this.addCount(1), this;
  }
  /** Call to decrement count (-1) */
  decrementCount() {
    return this.subtractCount(1), this;
  }
  /** Increase count */
  addCount(t) {
    return this._count += t, this._samples++, this._checkSampling(), this;
  }
  /** Decrease count */
  subtractCount(t) {
    return this._count -= t, this._samples++, this._checkSampling(), this;
  }
  /** Add an arbitrary timing and bump the count */
  addTime(t) {
    return this._time += t, this.lastTiming = t, this._samples++, this._checkSampling(), this;
  }
  /** Start a timer */
  timeStart() {
    return this._startTime = Li(), this._timerPending = !0, this;
  }
  /** End a timer. Adds to time and bumps the timing count. */
  timeEnd() {
    return this._timerPending ? (this.addTime(Li() - this._startTime), this._timerPending = !1, this._checkSampling(), this) : this;
  }
  getSampleAverageCount() {
    return this.sampleSize > 0 ? this.lastSampleCount / this.sampleSize : 0;
  }
  /** Calculate average time / count for the previous window */
  getSampleAverageTime() {
    return this.sampleSize > 0 ? this.lastSampleTime / this.sampleSize : 0;
  }
  /** Calculate counts per second for the previous window */
  getSampleHz() {
    return this.lastSampleTime > 0 ? this.sampleSize / (this.lastSampleTime / 1e3) : 0;
  }
  getAverageCount() {
    return this.samples > 0 ? this.count / this.samples : 0;
  }
  /** Calculate average time / count */
  getAverageTime() {
    return this.samples > 0 ? this.time / this.samples : 0;
  }
  /** Calculate counts per second */
  getHz() {
    return this.time > 0 ? this.samples / (this.time / 1e3) : 0;
  }
  _checkSampling() {
    this._samples === this.sampleSize && (this.lastSampleTime = this._time, this.lastSampleCount = this._count, this.count += this._count, this.time += this._time, this.samples += this._samples, this._time = 0, this._count = 0, this._samples = 0);
  }
}
class za {
  constructor(t) {
    this.stats = {}, this.id = t.id, this.stats = {}, this._initializeStats(t.stats), Object.seal(this);
  }
  /** Acquire a stat. Create if it doesn't exist. */
  get(t, n = "count") {
    return this._getOrCreate({ name: t, type: n });
  }
  get size() {
    return Object.keys(this.stats).length;
  }
  /** Reset all stats */
  reset() {
    for (const t of Object.values(this.stats))
      t.reset();
    return this;
  }
  forEach(t) {
    for (const n of Object.values(this.stats))
      t(n);
  }
  getTable() {
    const t = {};
    return this.forEach((n) => {
      t[n.name] = {
        time: n.time || 0,
        count: n.count || 0,
        average: n.getAverageTime() || 0,
        hz: n.getHz() || 0
      };
    }), t;
  }
  _initializeStats(t = []) {
    t.forEach((n) => this._getOrCreate(n));
  }
  _getOrCreate(t) {
    const { name: n, type: r } = t;
    let s = this.stats[n];
    return s || (t instanceof Ui ? s = t : s = new Ui(n, r), this.stats[n] = s), s;
  }
}
const Il = "Queued Requests", xl = "Active Requests", Ml = "Cancelled Requests", Rl = "Queued Requests Ever", Sl = "Active Requests Ever", Fl = {
  id: "request-scheduler",
  /** Specifies if the request scheduler should throttle incoming requests, mainly for comparative testing. */
  throttleRequests: !0,
  /** The maximum number of simultaneous active requests. Un-throttled requests do not observe this limit. */
  maxRequests: 6,
  /**
   * Specifies a debounce time, in milliseconds. All requests are queued, until no new requests have
   * been added to the queue for this amount of time.
   */
  debounceTime: 0
};
class Ol {
  constructor(t = {}) {
    y(this, "props");
    y(this, "stats");
    y(this, "activeRequestCount", 0);
    /** Tracks the number of active requests and prioritizes/cancels queued requests. */
    y(this, "requestQueue", []);
    y(this, "requestMap", /* @__PURE__ */ new Map());
    y(this, "updateTimer", null);
    this.props = { ...Fl, ...t }, this.stats = new za({ id: this.props.id }), this.stats.get(Il), this.stats.get(xl), this.stats.get(Ml), this.stats.get(Rl), this.stats.get(Sl);
  }
  /**
   * Called by an application that wants to issue a request, without having it deeply queued by the browser
   *
   * When the returned promise resolved, it is OK for the application to issue a request.
   * The promise resolves to an object that contains a `done` method.
   * When the application's request has completed (or failed), the application must call the `done` function
   *
   * @param handle
   * @param getPriority will be called when request "slots" open up,
   *    allowing the caller to update priority or cancel the request
   *    Highest priority executes first, priority < 0 cancels the request
   * @returns a promise
   *   - resolves to a object (with a `done` field) when the request can be issued without queueing,
   *   - resolves to `null` if the request has been cancelled (by the callback return < 0).
   *     In this case the application should not issue the request
   */
  scheduleRequest(t, n = () => 0) {
    if (!this.props.throttleRequests)
      return Promise.resolve({ done: () => {
      } });
    if (this.requestMap.has(t))
      return this.requestMap.get(t);
    const r = { handle: t, priority: 0, getPriority: n }, s = new Promise((i) => (r.resolve = i, r));
    return this.requestQueue.push(r), this.requestMap.set(t, s), this._issueNewRequests(), s;
  }
  // PRIVATE
  _issueRequest(t) {
    const { handle: n, resolve: r } = t;
    let s = !1;
    const i = () => {
      s || (s = !0, this.requestMap.delete(n), this.activeRequestCount--, this._issueNewRequests());
    };
    return this.activeRequestCount++, r ? r({ done: i }) : Promise.resolve({ done: i });
  }
  /** We check requests asynchronously, to prevent multiple updates */
  _issueNewRequests() {
    this.updateTimer !== null && clearTimeout(this.updateTimer), this.updateTimer = setTimeout(() => this._issueNewRequestsAsync(), this.props.debounceTime);
  }
  /** Refresh all requests  */
  _issueNewRequestsAsync() {
    this.updateTimer !== null && clearTimeout(this.updateTimer), this.updateTimer = null;
    const t = Math.max(this.props.maxRequests - this.activeRequestCount, 0);
    if (t !== 0) {
      this._updateAllRequests();
      for (let n = 0; n < t; ++n) {
        const r = this.requestQueue.shift();
        r && this._issueRequest(r);
      }
    }
  }
  /** Ensure all requests have updated priorities, and that no longer valid requests are cancelled */
  _updateAllRequests() {
    const t = this.requestQueue;
    for (let n = 0; n < t.length; ++n) {
      const r = t[n];
      this._updateRequest(r) || (t.splice(n, 1), this.requestMap.delete(r.handle), n--);
    }
    t.sort((n, r) => n.priority - r.priority);
  }
  /** Update a single request by calling the callback */
  _updateRequest(t) {
    return t.priority = t.getPriority(t.handle), t.priority < 0 ? (t.resolve(null), !1) : !0;
  }
}
let Dl = "";
const Ni = {};
function Ll(e) {
  for (const t in Ni)
    if (e.startsWith(t)) {
      const n = Ni[t];
      e = e.replace(t, n);
    }
  return !e.startsWith("http://") && !e.startsWith("https://") && (e = `${Dl}${e}`), e;
}
function Ul(e) {
  return e && typeof e == "object" && e.isBuffer;
}
function Wa(e) {
  if (Ul(e))
    return e;
  if (e instanceof ArrayBuffer)
    return e;
  if (ArrayBuffer.isView(e))
    return e.byteOffset === 0 && e.byteLength === e.buffer.byteLength ? e.buffer : e.buffer.slice(e.byteOffset, e.byteOffset + e.byteLength);
  if (typeof e == "string") {
    const t = e;
    return new TextEncoder().encode(t).buffer;
  }
  if (e && typeof e == "object" && e._toArrayBuffer)
    return e._toArrayBuffer();
  throw new Error("toArrayBuffer");
}
function Nl() {
  var t;
  if (typeof st.process < "u" && typeof st.process.cwd < "u")
    return st.process.cwd();
  const e = (t = window.location) == null ? void 0 : t.pathname;
  return (e == null ? void 0 : e.slice(0, e.lastIndexOf("/") + 1)) || "";
}
function Qa(e) {
  const t = e ? e.lastIndexOf("/") : -1;
  return t >= 0 ? e.substr(t + 1) : "";
}
function ti(e) {
  const t = e ? e.lastIndexOf("/") : -1;
  return t >= 0 ? e.substr(0, t) : "";
}
function Pl(...e) {
  const t = [];
  for (let i = 0; i < e.length; i++)
    t[i] = e[i];
  let n = "", r = !1, s;
  for (let i = t.length - 1; i >= -1 && !r; i--) {
    let o;
    i >= 0 ? o = t[i] : (s === void 0 && (s = Nl()), o = s), o.length !== 0 && (n = `${o}/${n}`, r = o.charCodeAt(0) === an);
  }
  return n = Gl(n, !r), r ? `/${n}` : n.length > 0 ? n : ".";
}
const an = 47, jr = 46;
function Gl(e, t) {
  let n = "", r = -1, s = 0, i, o = !1;
  for (let a = 0; a <= e.length; ++a) {
    if (a < e.length)
      i = e.charCodeAt(a);
    else {
      if (i === an)
        break;
      i = an;
    }
    if (i === an) {
      if (!(r === a - 1 || s === 1)) if (r !== a - 1 && s === 2) {
        if (n.length < 2 || !o || n.charCodeAt(n.length - 1) !== jr || n.charCodeAt(n.length - 2) !== jr) {
          if (n.length > 2) {
            const c = n.length - 1;
            let h = c;
            for (; h >= 0 && n.charCodeAt(h) !== an; --h)
              ;
            if (h !== c) {
              n = h === -1 ? "" : n.slice(0, h), r = a, s = 0, o = !1;
              continue;
            }
          } else if (n.length === 2 || n.length === 1) {
            n = "", r = a, s = 0, o = !1;
            continue;
          }
        }
        t && (n.length > 0 ? n += "/.." : n = "..", o = !0);
      } else {
        const c = e.slice(r + 1, a);
        n.length > 0 ? n += `/${c}` : n = c, o = !1;
      }
      r = a, s = 0;
    } else i === jr && s !== -1 ? ++s : s = -1;
  }
  return n;
}
const vl = (e) => typeof e == "boolean", un = (e) => typeof e == "function", wn = (e) => e !== null && typeof e == "object", Pi = (e) => wn(e) && e.constructor === {}.constructor, Hl = (e) => !!e && typeof e[Symbol.iterator] == "function", Jl = (e) => e && typeof e[Symbol.asyncIterator] == "function", Re = (e) => typeof Response < "u" && e instanceof Response || e && e.arrayBuffer && e.text && e.json, Se = (e) => typeof Blob < "u" && e instanceof Blob, kl = (e) => e && typeof e == "object" && e.isBuffer, Vl = (e) => typeof ReadableStream < "u" && e instanceof ReadableStream || wn(e) && un(e.tee) && un(e.cancel) && un(e.getReader), jl = (e) => wn(e) && un(e.read) && un(e.pipe) && vl(e.readable), $a = (e) => Vl(e) || jl(e);
class Kl extends Error {
  constructor(n, r) {
    super(n);
    /** A best effort reason for why the fetch failed */
    y(this, "reason");
    /** The URL that failed to load. Empty string if not available. */
    y(this, "url");
    /** The Response object, if any. */
    y(this, "response");
    this.reason = r.reason, this.url = r.url, this.response = r.response;
  }
}
const zl = /^data:([-\w.]+\/[-\w.+]+)(;|,)/, Wl = /^([-\w.]+\/[-\w.+]+)/;
function Gi(e, t) {
  return e.toLowerCase() === t.toLowerCase();
}
function Ql(e) {
  const t = Wl.exec(e);
  return t ? t[1] : e;
}
function vi(e) {
  const t = zl.exec(e);
  return t ? t[1] : "";
}
const Xa = /\?.*/;
function $l(e) {
  const t = e.match(Xa);
  return t && t[0];
}
function ei(e) {
  return e.replace(Xa, "");
}
function Xl(e) {
  if (e.length < 50)
    return e;
  const t = e.slice(e.length - 15);
  return `${e.substr(0, 32)}...${t}`;
}
function br(e) {
  return Re(e) ? e.url : Se(e) ? e.name || "" : typeof e == "string" ? e : "";
}
function ni(e) {
  if (Re(e)) {
    const t = e, n = t.headers.get("content-type") || "", r = ei(t.url);
    return Ql(n) || vi(r);
  }
  return Se(e) ? e.type || "" : typeof e == "string" ? vi(e) : "";
}
function ql(e) {
  return Re(e) ? e.headers["content-length"] || -1 : Se(e) ? e.size : typeof e == "string" ? e.length : e instanceof ArrayBuffer || ArrayBuffer.isView(e) ? e.byteLength : -1;
}
async function qa(e) {
  if (Re(e))
    return e;
  const t = {}, n = ql(e);
  n >= 0 && (t["content-length"] = String(n));
  const r = br(e), s = ni(e);
  s && (t["content-type"] = s);
  const i = await tf(e);
  i && (t["x-first-bytes"] = i), typeof e == "string" && (e = new TextEncoder().encode(e));
  const o = new Response(e, { headers: t });
  return Object.defineProperty(o, "url", { value: r }), o;
}
async function Yl(e) {
  if (!e.ok)
    throw await Zl(e);
}
async function Zl(e) {
  const t = Xl(e.url);
  let n = `Failed to fetch resource (${e.status}) ${e.statusText}: ${t}`;
  n = n.length > 100 ? `${n.slice(0, 100)}...` : n;
  const r = {
    reason: e.statusText,
    url: e.url,
    response: e
  };
  try {
    const s = e.headers.get("Content-Type");
    r.reason = !e.bodyUsed && (s != null && s.includes("application/json")) ? await e.json() : await e.text();
  } catch {
  }
  return new Kl(n, r);
}
async function tf(e) {
  if (typeof e == "string")
    return `data:,${e.slice(0, 5)}`;
  if (e instanceof Blob) {
    const n = e.slice(0, 5);
    return await new Promise((r) => {
      const s = new FileReader();
      s.onload = (i) => {
        var o;
        return r((o = i == null ? void 0 : i.target) == null ? void 0 : o.result);
      }, s.readAsDataURL(n);
    });
  }
  if (e instanceof ArrayBuffer) {
    const n = e.slice(0, 5);
    return `data:base64,${ef(n)}`;
  }
  return null;
}
function ef(e) {
  let t = "";
  const n = new Uint8Array(e);
  for (let r = 0; r < n.byteLength; r++)
    t += String.fromCharCode(n[r]);
  return btoa(t);
}
function nf(e) {
  return !rf(e) && !sf(e);
}
function rf(e) {
  return e.startsWith("http:") || e.startsWith("https:");
}
function sf(e) {
  return e.startsWith("data:");
}
async function pn(e, t) {
  var n, r;
  if (typeof e == "string") {
    const s = Ll(e);
    return nf(s) && (n = globalThis.loaders) != null && n.fetchNode ? (r = globalThis.loaders) == null ? void 0 : r.fetchNode(s, t) : await fetch(s, t);
  }
  return await qa(e);
}
const Hi = new wr({ id: "loaders.gl" });
class of {
  log() {
    return () => {
    };
  }
  info() {
    return () => {
    };
  }
  warn() {
    return () => {
    };
  }
  error() {
    return () => {
    };
  }
}
class af {
  constructor() {
    y(this, "console");
    this.console = console;
  }
  log(...t) {
    return this.console.log.bind(this.console, ...t);
  }
  info(...t) {
    return this.console.info.bind(this.console, ...t);
  }
  warn(...t) {
    return this.console.warn.bind(this.console, ...t);
  }
  error(...t) {
    return this.console.error.bind(this.console, ...t);
  }
}
const Ya = {
  // baseUri
  fetch: null,
  mimeType: void 0,
  nothrow: !1,
  log: new af(),
  // A probe.gl compatible (`log.log()()` syntax) that just logs to console
  useLocalLibraries: !1,
  CDN: "https://unpkg.com/@loaders.gl",
  worker: !0,
  // By default, use worker if provided by loader.
  maxConcurrency: 3,
  // How many worker instances should be created for each loader.
  maxMobileConcurrency: 1,
  // How many worker instances should be created for each loader on mobile devices.
  reuseWorkers: Tr,
  // By default reuse workers in browser (Node.js refuses to terminate if browsers are running)
  _nodeWorkers: !1,
  // By default do not support node workers
  _workerType: "",
  // 'test' to use locally generated workers
  limit: 0,
  _limitMB: 0,
  batchSize: "auto",
  batchDebounceMs: 0,
  metadata: !1,
  // TODO - currently only implemented for parseInBatches, adds initial metadata batch,
  transforms: []
}, cf = {
  throws: "nothrow",
  dataType: "(no longer used)",
  uri: "baseUri",
  // Warn if fetch options are used on top-level
  method: "fetch.method",
  headers: "fetch.headers",
  body: "fetch.body",
  mode: "fetch.mode",
  credentials: "fetch.credentials",
  cache: "fetch.cache",
  redirect: "fetch.redirect",
  referrer: "fetch.referrer",
  referrerPolicy: "fetch.referrerPolicy",
  integrity: "fetch.integrity",
  keepalive: "fetch.keepalive",
  signal: "fetch.signal"
};
function Za() {
  globalThis.loaders = globalThis.loaders || {};
  const { loaders: e } = globalThis;
  return e._state || (e._state = {}), e._state;
}
function tc() {
  const e = Za();
  return e.globalOptions = e.globalOptions || { ...Ya }, e.globalOptions;
}
function uf(e, t, n, r) {
  return n = n || [], n = Array.isArray(n) ? n : [n], hf(e, n), ff(t, e, r);
}
function hf(e, t) {
  Ji(e, null, Ya, cf, t);
  for (const n of t) {
    const r = e && e[n.id] || {}, s = n.options && n.options[n.id] || {}, i = n.deprecatedOptions && n.deprecatedOptions[n.id] || {};
    Ji(r, n.id, s, i, t);
  }
}
function Ji(e, t, n, r, s) {
  const i = t || "Top level", o = t ? `${t}.` : "";
  for (const a in e) {
    const c = !t && wn(e[a]), h = a === "baseUri" && !t, f = a === "workerUrl" && t;
    if (!(a in n) && !h && !f) {
      if (a in r)
        Hi.warn(`${i} loader option '${o}${a}' no longer supported, use '${r[a]}'`)();
      else if (!c) {
        const d = lf(a, s);
        Hi.warn(`${i} loader option '${o}${a}' not recognized. ${d}`)();
      }
    }
  }
}
function lf(e, t) {
  const n = e.toLowerCase();
  let r = "";
  for (const s of t)
    for (const i in s.options) {
      if (e === i)
        return `Did you mean '${s.id}.${i}'?`;
      const o = i.toLowerCase();
      (n.startsWith(o) || o.startsWith(n)) && (r = r || `Did you mean '${s.id}.${i}'?`);
    }
  return r;
}
function ff(e, t, n) {
  const s = { ...e.options || {} };
  return df(s, n), s.log === null && (s.log = new of()), ki(s, tc()), ki(s, t), s;
}
function ki(e, t) {
  for (const n in t)
    if (n in t) {
      const r = t[n];
      Pi(r) && Pi(e[n]) ? e[n] = {
        ...e[n],
        ...t[n]
      } : e[n] = t[n];
    }
}
function df(e, t) {
  t && !("baseUri" in e) && (e.baseUri = t);
}
function ri(e) {
  return e ? (Array.isArray(e) && (e = e[0]), Array.isArray(e == null ? void 0 : e.extensions)) : !1;
}
function ec(e) {
  $(e, "null loader"), $(ri(e), "invalid loader");
  let t;
  return Array.isArray(e) && (t = e[1], e = e[0], e = {
    ...e,
    options: { ...e.options, ...t }
  }), (e != null && e.parseTextSync || e != null && e.parseText) && (e.text = !0), e.text || (e.binary = !0), e;
}
const mf = () => {
  const e = Za();
  return e.loaderRegistry = e.loaderRegistry || [], e.loaderRegistry;
};
function pf() {
  return mf();
}
const gf = /\.([^.]+)$/;
async function Af(e, t = [], n, r) {
  if (!nc(e))
    return null;
  let s = Vi(e, t, { ...n, nothrow: !0 }, r);
  if (s)
    return s;
  if (Se(e) && (e = await e.slice(0, 10).arrayBuffer(), s = Vi(e, t, n, r)), !s && !(n != null && n.nothrow))
    throw new Error(rc(e));
  return s;
}
function Vi(e, t = [], n, r) {
  if (!nc(e))
    return null;
  if (t && !Array.isArray(t))
    return ec(t);
  let s = [];
  t && (s = s.concat(t)), n != null && n.ignoreRegisteredLoaders || s.push(...pf()), Bf(s);
  const i = yf(e, s, n, r);
  if (!i && !(n != null && n.nothrow))
    throw new Error(rc(e));
  return i;
}
function yf(e, t, n, r) {
  const s = br(e), i = ni(e), o = ei(s) || (r == null ? void 0 : r.url);
  let a = null, c = "";
  return n != null && n.mimeType && (a = Kr(t, n == null ? void 0 : n.mimeType), c = `match forced by supplied MIME type ${n == null ? void 0 : n.mimeType}`), a = a || Ef(t, o), c = c || (a ? `matched url ${o}` : ""), a = a || Kr(t, i), c = c || (a ? `matched MIME type ${i}` : ""), a = a || Tf(t, e), c = c || (a ? `matched initial data ${sc(e)}` : ""), n != null && n.fallbackMimeType && (a = a || Kr(t, n == null ? void 0 : n.fallbackMimeType), c = c || (a ? `matched fallback MIME type ${i}` : "")), c && $h.log(1, `selectLoader selected ${a == null ? void 0 : a.name}: ${c}.`), a;
}
function nc(e) {
  return !(e instanceof Response && e.status === 204);
}
function rc(e) {
  const t = br(e), n = ni(e);
  let r = "No valid loader found (";
  r += t ? `${Qa(t)}, ` : "no url provided, ", r += `MIME type: ${n ? `"${n}"` : "not provided"}, `;
  const s = e ? sc(e) : "";
  return r += s ? ` first bytes: "${s}"` : "first bytes: not available", r += ")", r;
}
function Bf(e) {
  for (const t of e)
    ec(t);
}
function Ef(e, t) {
  const n = t && gf.exec(t), r = n && n[1];
  return r ? Cf(e, r) : null;
}
function Cf(e, t) {
  t = t.toLowerCase();
  for (const n of e)
    for (const r of n.extensions)
      if (r.toLowerCase() === t)
        return n;
  return null;
}
function Kr(e, t) {
  var n;
  for (const r of e)
    if ((n = r.mimeTypes) != null && n.some((s) => Gi(t, s)) || Gi(t, `application/x.${r.id}`))
      return r;
  return null;
}
function Tf(e, t) {
  if (!t)
    return null;
  for (const n of e)
    if (typeof t == "string") {
      if (wf(t, n))
        return n;
    } else if (ArrayBuffer.isView(t)) {
      if (ji(t.buffer, t.byteOffset, n))
        return n;
    } else if (t instanceof ArrayBuffer && ji(t, 0, n))
      return n;
  return null;
}
function wf(e, t) {
  return t.testText ? t.testText(e) : (Array.isArray(t.tests) ? t.tests : [t.tests]).some((r) => e.startsWith(r));
}
function ji(e, t, n) {
  return (Array.isArray(n.tests) ? n.tests : [n.tests]).some((s) => bf(e, t, n, s));
}
function bf(e, t, n, r) {
  if (r instanceof ArrayBuffer)
    return El(r, e, r.byteLength);
  switch (typeof r) {
    case "function":
      return r(e);
    case "string":
      const s = _s(e, t, r.length);
      return r === s;
    default:
      return !1;
  }
}
function sc(e, t = 5) {
  return typeof e == "string" ? e.slice(0, t) : ArrayBuffer.isView(e) ? _s(e.buffer, e.byteOffset, t) : e instanceof ArrayBuffer ? _s(e, 0, t) : "";
}
function _s(e, t, n) {
  if (e.byteLength < t + n)
    return "";
  const r = new DataView(e);
  let s = "";
  for (let i = 0; i < n; i++)
    s += String.fromCharCode(r.getUint8(t + i));
  return s;
}
const _f = 256 * 1024;
function* If(e, t) {
  const n = (t == null ? void 0 : t.chunkSize) || _f;
  let r = 0;
  const s = new TextEncoder();
  for (; r < e.length; ) {
    const i = Math.min(e.length - r, n), o = e.slice(r, r + i);
    r += i, yield s.encode(o);
  }
}
const xf = 256 * 1024;
function* Mf(e, t = {}) {
  const { chunkSize: n = xf } = t;
  let r = 0;
  for (; r < e.byteLength; ) {
    const s = Math.min(e.byteLength - r, n), i = new ArrayBuffer(s), o = new Uint8Array(e, r, s);
    new Uint8Array(i).set(o), r += s, yield i;
  }
}
const Rf = 1024 * 1024;
async function* Sf(e, t) {
  const n = (t == null ? void 0 : t.chunkSize) || Rf;
  let r = 0;
  for (; r < e.size; ) {
    const s = r + n, i = await e.slice(r, s).arrayBuffer();
    r = s, yield i;
  }
}
function Ki(e, t) {
  return Tr ? Ff(e, t) : Of(e);
}
async function* Ff(e, t) {
  const n = e.getReader();
  let r;
  try {
    for (; ; ) {
      const s = r || n.read();
      t != null && t._streamReadAhead && (r = n.read());
      const { done: i, value: o } = await s;
      if (i)
        return;
      yield Wa(o);
    }
  } catch {
    n.releaseLock();
  }
}
async function* Of(e, t) {
  for await (const n of e)
    yield Wa(n);
}
function Df(e, t) {
  if (typeof e == "string")
    return If(e, t);
  if (e instanceof ArrayBuffer)
    return Mf(e, t);
  if (Se(e))
    return Sf(e, t);
  if ($a(e))
    return Ki(e, t);
  if (Re(e))
    return Ki(e.body, t);
  throw new Error("makeIterator");
}
const ic = "Cannot convert supplied data type";
function Lf(e, t, n) {
  if (t.text && typeof e == "string")
    return e;
  if (kl(e) && (e = e.buffer), e instanceof ArrayBuffer) {
    const r = e;
    return t.text && !t.binary ? new TextDecoder("utf8").decode(r) : r;
  }
  if (ArrayBuffer.isView(e)) {
    if (t.text && !t.binary)
      return new TextDecoder("utf8").decode(e);
    let r = e.buffer;
    const s = e.byteLength || e.length;
    return (e.byteOffset !== 0 || s !== r.byteLength) && (r = r.slice(e.byteOffset, e.byteOffset + s)), r;
  }
  throw new Error(ic);
}
async function Uf(e, t, n) {
  const r = e instanceof ArrayBuffer || ArrayBuffer.isView(e);
  if (typeof e == "string" || r)
    return Lf(e, t);
  if (Se(e) && (e = await qa(e)), Re(e)) {
    const s = e;
    return await Yl(s), t.binary ? await s.arrayBuffer() : await s.text();
  }
  if ($a(e) && (e = Df(e, n)), Hl(e) || Jl(e))
    return _l(e);
  throw new Error(ic);
}
function oc(e, t) {
  const n = tc(), r = e || n;
  return typeof r.fetch == "function" ? r.fetch : wn(r.fetch) ? (s) => pn(s, r.fetch) : t != null && t.fetch ? t == null ? void 0 : t.fetch : pn;
}
function Nf(e, t, n) {
  if (n)
    return n;
  const r = {
    fetch: oc(t, e),
    ...e
  };
  if (r.url) {
    const s = ei(r.url);
    r.baseUrl = s, r.queryString = $l(r.url), r.filename = Qa(s), r.baseUrl = ti(s);
  }
  return Array.isArray(r.loaders) || (r.loaders = null), r;
}
function Pf(e, t) {
  if (e && !Array.isArray(e))
    return e;
  let n;
  if (e && (n = Array.isArray(e) ? e : [e]), t && t.loaders) {
    const r = Array.isArray(t.loaders) ? t.loaders : [t.loaders];
    n = n ? [...n, ...r] : r;
  }
  return n && n.length ? n : void 0;
}
async function cr(e, t, n, r) {
  t && !Array.isArray(t) && !ri(t) && (r = void 0, n = t, t = void 0), e = await e, n = n || {};
  const s = br(e), o = Pf(t, r), a = await Af(e, o, n);
  return a ? (n = uf(n, a, o, s), r = Nf(
    // @ts-expect-error
    { url: s, _parse: cr, loaders: o },
    n,
    r || null
  ), await Gf(a, e, n, r)) : null;
}
async function Gf(e, t, n, r) {
  if (ul(e), n = Xh(e.options, n), Re(t)) {
    const i = t, { ok: o, redirected: a, status: c, statusText: h, type: f, url: d } = i, p = Object.fromEntries(i.headers.entries());
    r.response = { headers: p, ok: o, redirected: a, status: c, statusText: h, type: f, url: d };
  }
  t = await Uf(t, e, n);
  const s = e;
  if (s.parseTextSync && typeof t == "string")
    return s.parseTextSync(t, n, r);
  if (pl(e, n))
    return await gl(e, t, n, r, cr);
  if (s.parseText && typeof t == "string")
    return await s.parseText(t, n, r);
  if (s.parse)
    return await s.parse(t, n, r);
  throw le(!s.parseSync), new Error(`${e.id} loader - no parser found and worker is disabled`);
}
function vf(e) {
  switch (e.constructor) {
    case Int8Array:
      return "int8";
    case Uint8Array:
    case Uint8ClampedArray:
      return "uint8";
    case Int16Array:
      return "int16";
    case Uint16Array:
      return "uint16";
    case Int32Array:
      return "int32";
    case Uint32Array:
      return "uint32";
    case Float32Array:
      return "float32";
    case Float64Array:
      return "float64";
    default:
      return "null";
  }
}
const zi = 100;
class Hf {
  constructor(t, n) {
    y(this, "schema");
    y(this, "options");
    y(this, "shape");
    y(this, "length", 0);
    y(this, "rows", null);
    y(this, "cursor", 0);
    y(this, "_headers", []);
    if (this.options = n, this.schema = t, !Array.isArray(t)) {
      this._headers = [];
      for (const r in t)
        this._headers[t[r].index] = t[r].name;
    }
  }
  rowCount() {
    return this.length;
  }
  addArrayRow(t, n) {
    Number.isFinite(n) && (this.cursor = n), this.shape = "array-row-table", this.rows = this.rows || new Array(zi), this.rows[this.length] = t, this.length++;
  }
  addObjectRow(t, n) {
    Number.isFinite(n) && (this.cursor = n), this.shape = "object-row-table", this.rows = this.rows || new Array(zi), this.rows[this.length] = t, this.length++;
  }
  getBatch() {
    let t = this.rows;
    return t ? (t = t.slice(0, this.length), this.rows = null, {
      shape: this.shape || "array-row-table",
      batchType: "data",
      data: t,
      length: this.length,
      schema: this.schema,
      cursor: this.cursor
    }) : null;
  }
}
function Jf(e, t) {
  if (!e)
    throw new Error("null row");
  const n = {};
  if (t)
    for (let r = 0; r < t.length; r++)
      n[t[r]] = e[r];
  else
    for (let r = 0; r < e.length; r++) {
      const s = `column-${r}`;
      n[s] = e[r];
    }
  return n;
}
function kf(e, t) {
  if (!e)
    throw new Error("null row");
  if (t) {
    const n = new Array(t.length);
    for (let r = 0; r < t.length; r++)
      n[r] = e[t[r]];
    return n;
  }
  return Object.values(e);
}
function Vf(e) {
  const t = [];
  for (let n = 0; n < e.length; n++) {
    const r = `column-${n}`;
    t.push(r);
  }
  return t;
}
function jf(e) {
  return Object.keys(e);
}
const Wi = 100;
class Kf {
  constructor(t, n) {
    y(this, "schema");
    y(this, "options");
    y(this, "length", 0);
    y(this, "objectRows", null);
    y(this, "arrayRows", null);
    y(this, "cursor", 0);
    y(this, "_headers", null);
    if (this.options = n, this.schema = t, t) {
      this._headers = [];
      for (const r in t)
        this._headers[t[r].index] = t[r].name;
    }
  }
  rowCount() {
    return this.length;
  }
  addArrayRow(t, n) {
    switch (Number.isFinite(n) && (this.cursor = n), this._headers || (this._headers = Vf(t)), this.options.shape) {
      case "object-row-table":
        const r = Jf(t, this._headers);
        this.addObjectRow(r, n);
        break;
      case "array-row-table":
        this.arrayRows = this.arrayRows || new Array(Wi), this.arrayRows[this.length] = t, this.length++;
        break;
    }
  }
  addObjectRow(t, n) {
    switch (Number.isFinite(n) && (this.cursor = n), this._headers || (this._headers = jf(t)), this.options.shape) {
      case "array-row-table":
        const r = kf(t, this._headers);
        this.addArrayRow(r, n);
        break;
      case "object-row-table":
        this.objectRows = this.objectRows || new Array(Wi), this.objectRows[this.length] = t, this.length++;
        break;
    }
  }
  getBatch() {
    let t = this.arrayRows || this.objectRows;
    return t ? (t = t.slice(0, this.length), this.arrayRows = null, this.objectRows = null, {
      shape: this.options.shape,
      batchType: "data",
      data: t,
      length: this.length,
      // @ts-expect-error we should infer a schema
      schema: this.schema,
      cursor: this.cursor
    }) : null;
  }
}
const zf = 100;
class Wf {
  constructor(t, n) {
    y(this, "schema");
    y(this, "length", 0);
    y(this, "allocated", 0);
    y(this, "columns", {});
    this.schema = t, this._reallocateColumns();
  }
  rowCount() {
    return this.length;
  }
  addArrayRow(t) {
    this._reallocateColumns();
    let n = 0;
    for (const r in this.columns)
      this.columns[r][this.length] = t[n++];
    this.length++;
  }
  addObjectRow(t) {
    this._reallocateColumns();
    for (const n in t)
      this.columns[n][this.length] = t[n];
    this.length++;
  }
  getBatch() {
    this._pruneColumns();
    const t = Array.isArray(this.schema) ? this.columns : {};
    if (!Array.isArray(this.schema))
      for (const r in this.schema) {
        const s = this.schema[r];
        t[s.name] = this.columns[s.index];
      }
    return this.columns = {}, {
      shape: "columnar-table",
      batchType: "data",
      data: t,
      schema: this.schema,
      length: this.length
    };
  }
  // HELPERS
  _reallocateColumns() {
    if (!(this.length < this.allocated)) {
      this.allocated = this.allocated > 0 ? this.allocated *= 2 : zf, this.columns = {};
      for (const t in this.schema) {
        const n = this.schema[t], r = n.type || Float32Array, s = this.columns[n.index];
        if (s && ArrayBuffer.isView(s)) {
          const i = new r(this.allocated);
          i.set(s), this.columns[n.index] = i;
        } else s ? (s.length = this.allocated, this.columns[n.index] = s) : this.columns[n.index] = new r(this.allocated);
      }
    }
  }
  _pruneColumns() {
    for (const [t, n] of Object.entries(this.columns))
      this.columns[t] = n.slice(0, this.length);
  }
}
const Qf = {
  shape: void 0,
  batchSize: "auto",
  batchDebounceMs: 0,
  limit: 0,
  _limitMB: 0
}, $f = "TableBatchBuilder", mn = class mn {
  constructor(t, n) {
    y(this, "schema");
    y(this, "options");
    y(this, "aggregator", null);
    y(this, "batchCount", 0);
    y(this, "bytesUsed", 0);
    y(this, "isChunkComplete", !1);
    y(this, "lastBatchEmittedMs", Date.now());
    y(this, "totalLength", 0);
    y(this, "totalBytes", 0);
    y(this, "rowBytes", 0);
    this.schema = t, this.options = { ...Qf, ...n };
  }
  limitReached() {
    var t, n;
    return !!((t = this.options) != null && t.limit && this.totalLength >= this.options.limit || (n = this.options) != null && n._limitMB && this.totalBytes / 1e6 >= this.options._limitMB);
  }
  /** @deprecated Use addArrayRow or addObjectRow */
  addRow(t) {
    this.limitReached() || (this.totalLength++, this.rowBytes = this.rowBytes || this._estimateRowMB(t), this.totalBytes += this.rowBytes, Array.isArray(t) ? this.addArrayRow(t) : this.addObjectRow(t));
  }
  /** Add one row to the batch */
  addArrayRow(t) {
    if (!this.aggregator) {
      const n = this._getTableBatchType();
      this.aggregator = new n(this.schema, this.options);
    }
    this.aggregator.addArrayRow(t);
  }
  /** Add one row to the batch */
  addObjectRow(t) {
    if (!this.aggregator) {
      const n = this._getTableBatchType();
      this.aggregator = new n(this.schema, this.options);
    }
    this.aggregator.addObjectRow(t);
  }
  /** Mark an incoming raw memory chunk has completed */
  chunkComplete(t) {
    t instanceof ArrayBuffer && (this.bytesUsed += t.byteLength), typeof t == "string" && (this.bytesUsed += t.length), this.isChunkComplete = !0;
  }
  getFullBatch(t) {
    return this._isFull() ? this._getBatch(t) : null;
  }
  getFinalBatch(t) {
    return this._getBatch(t);
  }
  // INTERNAL
  _estimateRowMB(t) {
    return Array.isArray(t) ? t.length * 8 : Object.keys(t).length * 8;
  }
  _isFull() {
    if (!this.aggregator || this.aggregator.rowCount() === 0)
      return !1;
    if (this.options.batchSize === "auto") {
      if (!this.isChunkComplete)
        return !1;
    } else if (this.options.batchSize > this.aggregator.rowCount())
      return !1;
    return this.options.batchDebounceMs > Date.now() - this.lastBatchEmittedMs ? !1 : (this.isChunkComplete = !1, this.lastBatchEmittedMs = Date.now(), !0);
  }
  /**
   * bytesUsed can be set via chunkComplete or via getBatch*
   */
  _getBatch(t) {
    if (!this.aggregator)
      return null;
    t != null && t.bytesUsed && (this.bytesUsed = t.bytesUsed);
    const n = this.aggregator.getBatch();
    return n.count = this.batchCount, n.bytesUsed = this.bytesUsed, Object.assign(n, t), this.batchCount++, this.aggregator = null, n;
  }
  _getTableBatchType() {
    switch (this.options.shape) {
      case "array-row-table":
      case "object-row-table":
        return Kf;
      case "columnar-table":
        return Wf;
      case "arrow-table":
        if (!mn.ArrowBatch)
          throw new Error($f);
        return mn.ArrowBatch;
      default:
        return Hf;
    }
  }
};
y(mn, "ArrowBatch");
let Is = mn;
function Xf(e) {
  let t = 1 / 0, n = 1 / 0, r = 1 / 0, s = -1 / 0, i = -1 / 0, o = -1 / 0;
  const a = e.POSITION ? e.POSITION.value : [], c = a && a.length;
  for (let h = 0; h < c; h += 3) {
    const f = a[h], d = a[h + 1], p = a[h + 2];
    t = f < t ? f : t, n = d < n ? d : n, r = p < r ? p : r, s = f > s ? f : s, i = d > i ? d : i, o = p > o ? p : o;
  }
  return [
    [t, n, r],
    [s, i, o]
  ];
}
function qf(e, t, n) {
  const r = vf(t.value), s = n || Yf(t);
  return {
    name: e,
    type: { type: "fixed-size-list", listSize: t.size, children: [{ name: "value", type: r }] },
    nullable: !1,
    metadata: s
  };
}
function Yf(e) {
  const t = {};
  return "byteOffset" in e && (t.byteOffset = e.byteOffset.toString(10)), "byteStride" in e && (t.byteStride = e.byteStride.toString(10)), "normalized" in e && (t.normalized = e.normalized.toString()), t;
}
async function Qe(e, t, n, r) {
  let s, i;
  !Array.isArray(t) && !ri(t) ? (s = [], i = t) : (s = t, i = n);
  const o = oc(i);
  let a = e;
  return typeof e == "string" && (a = await o(e)), Se(e) && (a = await o(e)), Array.isArray(s) ? await cr(a, s, i) : await cr(a, s, i);
}
const Zf = 1 / Math.PI * 180, td = 1 / 180 * Math.PI, ed = {
  EPSILON: 1e-12,
  debug: !1,
  precision: 4,
  printTypes: !1,
  printDegrees: !1,
  printRowMajor: !0,
  _cartographicRadians: !1
};
globalThis.mathgl = globalThis.mathgl || { config: { ...ed } };
const Bt = globalThis.mathgl.config;
function nd(e, { precision: t = Bt.precision } = {}) {
  return e = ad(e), `${parseFloat(e.toPrecision(t))}`;
}
function Ie(e) {
  return Array.isArray(e) || ArrayBuffer.isView(e) && !(e instanceof DataView);
}
function rd(e) {
  return id(e);
}
function sd(e) {
  return Kt(e);
}
function id(e, t) {
  return si(e, (n) => n * td, t);
}
function Kt(e, t) {
  return si(e, (n) => n * Zf, t);
}
function od(e, t, n) {
  return si(e, (r) => Math.max(t, Math.min(n, r)));
}
function ye(e, t, n) {
  const r = Bt.EPSILON;
  n && (Bt.EPSILON = n);
  try {
    if (e === t)
      return !0;
    if (Ie(e) && Ie(t)) {
      if (e.length !== t.length)
        return !1;
      for (let s = 0; s < e.length; ++s)
        if (!ye(e[s], t[s]))
          return !1;
      return !0;
    }
    return e && e.equals ? e.equals(t) : t && t.equals ? t.equals(e) : typeof e == "number" && typeof t == "number" ? Math.abs(e - t) <= Bt.EPSILON * Math.max(1, Math.abs(e), Math.abs(t)) : !1;
  } finally {
    Bt.EPSILON = r;
  }
}
function ad(e) {
  return Math.round(e / Bt.EPSILON) * Bt.EPSILON;
}
function cd(e) {
  return e.clone ? e.clone() : new Array(e.length);
}
function si(e, t, n) {
  if (Ie(e)) {
    const r = e;
    n = n || cd(r);
    for (let s = 0; s < n.length && s < r.length; ++s) {
      const i = typeof e == "number" ? e : e[s];
      n[s] = t(i, s, n);
    }
    return n;
  }
  return t(e);
}
class ii extends Array {
  // Common methods
  /**
   * Clone the current object
   * @returns a new copy of this object
   */
  clone() {
    return new this.constructor().copy(this);
  }
  fromArray(t, n = 0) {
    for (let r = 0; r < this.ELEMENTS; ++r)
      this[r] = t[r + n];
    return this.check();
  }
  toArray(t = [], n = 0) {
    for (let r = 0; r < this.ELEMENTS; ++r)
      t[n + r] = this[r];
    return t;
  }
  toObject(t) {
    return t;
  }
  from(t) {
    return Array.isArray(t) ? this.copy(t) : (
      // @ts-ignore
      this.fromObject(t)
    );
  }
  to(t) {
    return t === this ? this : Ie(t) ? this.toArray(t) : this.toObject(t);
  }
  toTarget(t) {
    return t ? this.to(t) : this;
  }
  /** @deprecated */
  toFloat32Array() {
    return new Float32Array(this);
  }
  toString() {
    return this.formatString(Bt);
  }
  /** Formats string according to options */
  formatString(t) {
    let n = "";
    for (let r = 0; r < this.ELEMENTS; ++r)
      n += (r > 0 ? ", " : "") + nd(this[r], t);
    return `${t.printTypes ? this.constructor.name : ""}[${n}]`;
  }
  equals(t) {
    if (!t || this.length !== t.length)
      return !1;
    for (let n = 0; n < this.ELEMENTS; ++n)
      if (!ye(this[n], t[n]))
        return !1;
    return !0;
  }
  exactEquals(t) {
    if (!t || this.length !== t.length)
      return !1;
    for (let n = 0; n < this.ELEMENTS; ++n)
      if (this[n] !== t[n])
        return !1;
    return !0;
  }
  // Modifiers
  /** Negates all values in this object */
  negate() {
    for (let t = 0; t < this.ELEMENTS; ++t)
      this[t] = -this[t];
    return this.check();
  }
  lerp(t, n, r) {
    if (r === void 0)
      return this.lerp(this, t, n);
    for (let s = 0; s < this.ELEMENTS; ++s) {
      const i = t[s], o = typeof n == "number" ? n : n[s];
      this[s] = i + r * (o - i);
    }
    return this.check();
  }
  /** Minimal */
  min(t) {
    for (let n = 0; n < this.ELEMENTS; ++n)
      this[n] = Math.min(t[n], this[n]);
    return this.check();
  }
  /** Maximal */
  max(t) {
    for (let n = 0; n < this.ELEMENTS; ++n)
      this[n] = Math.max(t[n], this[n]);
    return this.check();
  }
  clamp(t, n) {
    for (let r = 0; r < this.ELEMENTS; ++r)
      this[r] = Math.min(Math.max(this[r], t[r]), n[r]);
    return this.check();
  }
  add(...t) {
    for (const n of t)
      for (let r = 0; r < this.ELEMENTS; ++r)
        this[r] += n[r];
    return this.check();
  }
  subtract(...t) {
    for (const n of t)
      for (let r = 0; r < this.ELEMENTS; ++r)
        this[r] -= n[r];
    return this.check();
  }
  scale(t) {
    if (typeof t == "number")
      for (let n = 0; n < this.ELEMENTS; ++n)
        this[n] *= t;
    else
      for (let n = 0; n < this.ELEMENTS && n < t.length; ++n)
        this[n] *= t[n];
    return this.check();
  }
  /**
   * Multiplies all elements by `scale`
   * Note: `Matrix4.multiplyByScalar` only scales its 3x3 "minor"
   */
  multiplyByScalar(t) {
    for (let n = 0; n < this.ELEMENTS; ++n)
      this[n] *= t;
    return this.check();
  }
  // Debug checks
  /** Throws an error if array length is incorrect or contains illegal values */
  check() {
    if (Bt.debug && !this.validate())
      throw new Error(`math.gl: ${this.constructor.name} some fields set to invalid numbers'`);
    return this;
  }
  /** Returns false if the array length is incorrect or contains illegal values */
  validate() {
    let t = this.length === this.ELEMENTS;
    for (let n = 0; n < this.ELEMENTS; ++n)
      t = t && Number.isFinite(this[n]);
    return t;
  }
  // three.js compatibility
  /** @deprecated */
  sub(t) {
    return this.subtract(t);
  }
  /** @deprecated */
  setScalar(t) {
    for (let n = 0; n < this.ELEMENTS; ++n)
      this[n] = t;
    return this.check();
  }
  /** @deprecated */
  addScalar(t) {
    for (let n = 0; n < this.ELEMENTS; ++n)
      this[n] += t;
    return this.check();
  }
  /** @deprecated */
  subScalar(t) {
    return this.addScalar(-t);
  }
  /** @deprecated */
  multiplyScalar(t) {
    for (let n = 0; n < this.ELEMENTS; ++n)
      this[n] *= t;
    return this.check();
  }
  /** @deprecated */
  divideScalar(t) {
    return this.multiplyByScalar(1 / t);
  }
  /** @deprecated */
  clampScalar(t, n) {
    for (let r = 0; r < this.ELEMENTS; ++r)
      this[r] = Math.min(Math.max(this[r], t), n);
    return this.check();
  }
  /** @deprecated */
  get elements() {
    return this;
  }
}
function ud(e, t) {
  if (e.length !== t)
    return !1;
  for (let n = 0; n < e.length; ++n)
    if (!Number.isFinite(e[n]))
      return !1;
  return !0;
}
function Q(e) {
  if (!Number.isFinite(e))
    throw new Error(`Invalid number ${JSON.stringify(e)}`);
  return e;
}
function hn(e, t, n = "") {
  if (Bt.debug && !ud(e, t))
    throw new Error(`math.gl: ${n} some fields set to invalid numbers'`);
  return e;
}
function et(e, t) {
  if (!e)
    throw new Error(`math.gl assertion ${t}`);
}
class oi extends ii {
  // ACCESSORS
  get x() {
    return this[0];
  }
  set x(t) {
    this[0] = Q(t);
  }
  get y() {
    return this[1];
  }
  set y(t) {
    this[1] = Q(t);
  }
  /**
   * Returns the length of the vector from the origin to the point described by this vector
   *
   * @note `length` is a reserved word for Arrays, so `v.length()` will return number of elements
   * Instead we provide `len` and `magnitude`
   */
  len() {
    return Math.sqrt(this.lengthSquared());
  }
  /**
   * Returns the length of the vector from the origin to the point described by this vector
   */
  magnitude() {
    return this.len();
  }
  /**
   * Returns the squared length of the vector from the origin to the point described by this vector
   */
  lengthSquared() {
    let t = 0;
    for (let n = 0; n < this.ELEMENTS; ++n)
      t += this[n] * this[n];
    return t;
  }
  /**
   * Returns the squared length of the vector from the origin to the point described by this vector
   */
  magnitudeSquared() {
    return this.lengthSquared();
  }
  distance(t) {
    return Math.sqrt(this.distanceSquared(t));
  }
  distanceSquared(t) {
    let n = 0;
    for (let r = 0; r < this.ELEMENTS; ++r) {
      const s = this[r] - t[r];
      n += s * s;
    }
    return Q(n);
  }
  dot(t) {
    let n = 0;
    for (let r = 0; r < this.ELEMENTS; ++r)
      n += this[r] * t[r];
    return Q(n);
  }
  // MODIFIERS
  normalize() {
    const t = this.magnitude();
    if (t !== 0)
      for (let n = 0; n < this.ELEMENTS; ++n)
        this[n] /= t;
    return this.check();
  }
  multiply(...t) {
    for (const n of t)
      for (let r = 0; r < this.ELEMENTS; ++r)
        this[r] *= n[r];
    return this.check();
  }
  divide(...t) {
    for (const n of t)
      for (let r = 0; r < this.ELEMENTS; ++r)
        this[r] /= n[r];
    return this.check();
  }
  // THREE.js compatibility
  lengthSq() {
    return this.lengthSquared();
  }
  distanceTo(t) {
    return this.distance(t);
  }
  distanceToSquared(t) {
    return this.distanceSquared(t);
  }
  getComponent(t) {
    return et(t >= 0 && t < this.ELEMENTS, "index is out of range"), Q(this[t]);
  }
  setComponent(t, n) {
    return et(t >= 0 && t < this.ELEMENTS, "index is out of range"), this[t] = n, this.check();
  }
  addVectors(t, n) {
    return this.copy(t).add(n);
  }
  subVectors(t, n) {
    return this.copy(t).subtract(n);
  }
  multiplyVectors(t, n) {
    return this.copy(t).multiply(n);
  }
  addScaledVector(t, n) {
    return this.add(new this.constructor(t).multiplyScalar(n));
  }
}
const ln = 1e-6;
let $t = typeof Float32Array < "u" ? Float32Array : Array;
function hd() {
  const e = new $t(2);
  return $t != Float32Array && (e[0] = 0, e[1] = 0), e;
}
function ld(e, t, n) {
  const r = t[0], s = t[1];
  return e[0] = n[0] * r + n[2] * s, e[1] = n[1] * r + n[3] * s, e;
}
function fd(e, t, n) {
  const r = t[0], s = t[1];
  return e[0] = n[0] * r + n[2] * s + n[4], e[1] = n[1] * r + n[3] * s + n[5], e;
}
function ac(e, t, n) {
  const r = t[0], s = t[1];
  return e[0] = n[0] * r + n[3] * s + n[6], e[1] = n[1] * r + n[4] * s + n[7], e;
}
function cc(e, t, n) {
  const r = t[0], s = t[1];
  return e[0] = n[0] * r + n[4] * s + n[12], e[1] = n[1] * r + n[5] * s + n[13], e;
}
(function() {
  const e = hd();
  return function(t, n, r, s, i, o) {
    let a, c;
    for (n || (n = 2), r || (r = 0), s ? c = Math.min(s * n + r, t.length) : c = t.length, a = r; a < c; a += n)
      e[0] = t[a], e[1] = t[a + 1], i(e, e, o), t[a] = e[0], t[a + 1] = e[1];
    return t;
  };
})();
function uc(e, t, n) {
  const r = t[0], s = t[1], i = n[3] * r + n[7] * s || 1;
  return e[0] = (n[0] * r + n[4] * s) / i, e[1] = (n[1] * r + n[5] * s) / i, e;
}
function hc(e, t, n) {
  const r = t[0], s = t[1], i = t[2], o = n[3] * r + n[7] * s + n[11] * i || 1;
  return e[0] = (n[0] * r + n[4] * s + n[8] * i) / o, e[1] = (n[1] * r + n[5] * s + n[9] * i) / o, e[2] = (n[2] * r + n[6] * s + n[10] * i) / o, e;
}
function dd(e, t, n) {
  const r = t[0], s = t[1];
  return e[0] = n[0] * r + n[2] * s, e[1] = n[1] * r + n[3] * s, e[2] = t[2], e;
}
function md(e, t, n) {
  const r = t[0], s = t[1];
  return e[0] = n[0] * r + n[2] * s, e[1] = n[1] * r + n[3] * s, e[2] = t[2], e[3] = t[3], e;
}
function lc(e, t, n) {
  const r = t[0], s = t[1], i = t[2];
  return e[0] = n[0] * r + n[3] * s + n[6] * i, e[1] = n[1] * r + n[4] * s + n[7] * i, e[2] = n[2] * r + n[5] * s + n[8] * i, e[3] = t[3], e;
}
class _r extends oi {
  // Creates a new, empty vec2
  constructor(t = 0, n = 0) {
    super(2), Ie(t) && arguments.length === 1 ? this.copy(t) : (Bt.debug && (Q(t), Q(n)), this[0] = t, this[1] = n);
  }
  set(t, n) {
    return this[0] = t, this[1] = n, this.check();
  }
  copy(t) {
    return this[0] = t[0], this[1] = t[1], this.check();
  }
  fromObject(t) {
    return Bt.debug && (Q(t.x), Q(t.y)), this[0] = t.x, this[1] = t.y, this.check();
  }
  toObject(t) {
    return t.x = this[0], t.y = this[1], t;
  }
  // Getters/setters
  get ELEMENTS() {
    return 2;
  }
  /**
   * Returns angle from x axis
   * @returns
   */
  horizontalAngle() {
    return Math.atan2(this.y, this.x);
  }
  /**
   * Returns angle from y axis
   * @returns
   */
  verticalAngle() {
    return Math.atan2(this.x, this.y);
  }
  // Transforms
  /**
   * Transforms as point
   * @param matrix4
   * @returns
   */
  transform(t) {
    return this.transformAsPoint(t);
  }
  /**
   * transforms as point (4th component is implicitly 1)
   * @param matrix4
   * @returns
   */
  transformAsPoint(t) {
    return cc(this, this, t), this.check();
  }
  /**
   * transforms as vector (4th component is implicitly 0, ignores translation. slightly faster)
   * @param matrix4
   * @returns
   */
  transformAsVector(t) {
    return uc(this, this, t), this.check();
  }
  transformByMatrix3(t) {
    return ac(this, this, t), this.check();
  }
  transformByMatrix2x3(t) {
    return fd(this, this, t), this.check();
  }
  transformByMatrix2(t) {
    return ld(this, this, t), this.check();
  }
}
function fc() {
  const e = new $t(3);
  return $t != Float32Array && (e[0] = 0, e[1] = 0, e[2] = 0), e;
}
function dc(e) {
  const t = e[0], n = e[1], r = e[2];
  return Math.sqrt(t * t + n * n + r * r);
}
function Qi(e, t, n) {
  const r = new $t(3);
  return r[0] = e, r[1] = t, r[2] = n, r;
}
function pd(e, t) {
  const n = t[0], r = t[1], s = t[2];
  let i = n * n + r * r + s * s;
  return i > 0 && (i = 1 / Math.sqrt(i)), e[0] = t[0] * i, e[1] = t[1] * i, e[2] = t[2] * i, e;
}
function ai(e, t) {
  return e[0] * t[0] + e[1] * t[1] + e[2] * t[2];
}
function Zn(e, t, n) {
  const r = t[0], s = t[1], i = t[2], o = n[0], a = n[1], c = n[2];
  return e[0] = s * c - i * a, e[1] = i * o - r * c, e[2] = r * a - s * o, e;
}
function ci(e, t, n) {
  const r = t[0], s = t[1], i = t[2];
  let o = n[3] * r + n[7] * s + n[11] * i + n[15];
  return o = o || 1, e[0] = (n[0] * r + n[4] * s + n[8] * i + n[12]) / o, e[1] = (n[1] * r + n[5] * s + n[9] * i + n[13]) / o, e[2] = (n[2] * r + n[6] * s + n[10] * i + n[14]) / o, e;
}
function mc(e, t, n) {
  const r = t[0], s = t[1], i = t[2];
  return e[0] = r * n[0] + s * n[3] + i * n[6], e[1] = r * n[1] + s * n[4] + i * n[7], e[2] = r * n[2] + s * n[5] + i * n[8], e;
}
function pc(e, t, n) {
  const r = n[0], s = n[1], i = n[2], o = n[3], a = t[0], c = t[1], h = t[2];
  let f = s * h - i * c, d = i * a - r * h, p = r * c - s * a, g = s * p - i * d, B = i * f - r * p, C = r * d - s * f;
  const b = o * 2;
  return f *= b, d *= b, p *= b, g *= 2, B *= 2, C *= 2, e[0] = a + f + g, e[1] = c + d + B, e[2] = h + p + C, e;
}
function gd(e, t, n, r) {
  const s = [], i = [];
  return s[0] = t[0] - n[0], s[1] = t[1] - n[1], s[2] = t[2] - n[2], i[0] = s[0], i[1] = s[1] * Math.cos(r) - s[2] * Math.sin(r), i[2] = s[1] * Math.sin(r) + s[2] * Math.cos(r), e[0] = i[0] + n[0], e[1] = i[1] + n[1], e[2] = i[2] + n[2], e;
}
function Ad(e, t, n, r) {
  const s = [], i = [];
  return s[0] = t[0] - n[0], s[1] = t[1] - n[1], s[2] = t[2] - n[2], i[0] = s[2] * Math.sin(r) + s[0] * Math.cos(r), i[1] = s[1], i[2] = s[2] * Math.cos(r) - s[0] * Math.sin(r), e[0] = i[0] + n[0], e[1] = i[1] + n[1], e[2] = i[2] + n[2], e;
}
function yd(e, t, n, r) {
  const s = [], i = [];
  return s[0] = t[0] - n[0], s[1] = t[1] - n[1], s[2] = t[2] - n[2], i[0] = s[0] * Math.cos(r) - s[1] * Math.sin(r), i[1] = s[0] * Math.sin(r) + s[1] * Math.cos(r), i[2] = s[2], e[0] = i[0] + n[0], e[1] = i[1] + n[1], e[2] = i[2] + n[2], e;
}
function Bd(e, t) {
  const n = e[0], r = e[1], s = e[2], i = t[0], o = t[1], a = t[2], c = Math.sqrt((n * n + r * r + s * s) * (i * i + o * o + a * a)), h = c && ai(e, t) / c;
  return Math.acos(Math.min(Math.max(h, -1), 1));
}
const Ed = dc;
(function() {
  const e = fc();
  return function(t, n, r, s, i, o) {
    let a, c;
    for (n || (n = 3), r || (r = 0), s ? c = Math.min(s * n + r, t.length) : c = t.length, a = r; a < c; a += n)
      e[0] = t[a], e[1] = t[a + 1], e[2] = t[a + 2], i(e, e, o), t[a] = e[0], t[a + 1] = e[1], t[a + 2] = e[2];
    return t;
  };
})();
const zr = [0, 0, 0];
let On;
class T extends oi {
  static get ZERO() {
    return On || (On = new T(0, 0, 0), Object.freeze(On)), On;
  }
  /**
   * @class
   * @param x
   * @param y
   * @param z
   */
  constructor(t = 0, n = 0, r = 0) {
    super(-0, -0, -0), arguments.length === 1 && Ie(t) ? this.copy(t) : (Bt.debug && (Q(t), Q(n), Q(r)), this[0] = t, this[1] = n, this[2] = r);
  }
  set(t, n, r) {
    return this[0] = t, this[1] = n, this[2] = r, this.check();
  }
  copy(t) {
    return this[0] = t[0], this[1] = t[1], this[2] = t[2], this.check();
  }
  fromObject(t) {
    return Bt.debug && (Q(t.x), Q(t.y), Q(t.z)), this[0] = t.x, this[1] = t.y, this[2] = t.z, this.check();
  }
  toObject(t) {
    return t.x = this[0], t.y = this[1], t.z = this[2], t;
  }
  // Getters/setters
  get ELEMENTS() {
    return 3;
  }
  get z() {
    return this[2];
  }
  set z(t) {
    this[2] = Q(t);
  }
  // ACCESSORS
  angle(t) {
    return Bd(this, t);
  }
  // MODIFIERS
  cross(t) {
    return Zn(this, this, t), this.check();
  }
  rotateX({ radians: t, origin: n = zr }) {
    return gd(this, this, n, t), this.check();
  }
  rotateY({ radians: t, origin: n = zr }) {
    return Ad(this, this, n, t), this.check();
  }
  rotateZ({ radians: t, origin: n = zr }) {
    return yd(this, this, n, t), this.check();
  }
  // Transforms
  // transforms as point (4th component is implicitly 1)
  transform(t) {
    return this.transformAsPoint(t);
  }
  // transforms as point (4th component is implicitly 1)
  transformAsPoint(t) {
    return ci(this, this, t), this.check();
  }
  // transforms as vector  (4th component is implicitly 0, ignores translation. slightly faster)
  transformAsVector(t) {
    return hc(this, this, t), this.check();
  }
  transformByMatrix3(t) {
    return mc(this, this, t), this.check();
  }
  transformByMatrix2(t) {
    return dd(this, this, t), this.check();
  }
  transformByQuaternion(t) {
    return pc(this, this, t), this.check();
  }
}
let Dn;
class ui extends oi {
  static get ZERO() {
    return Dn || (Dn = new ui(0, 0, 0, 0), Object.freeze(Dn)), Dn;
  }
  constructor(t = 0, n = 0, r = 0, s = 0) {
    super(-0, -0, -0, -0), Ie(t) && arguments.length === 1 ? this.copy(t) : (Bt.debug && (Q(t), Q(n), Q(r), Q(s)), this[0] = t, this[1] = n, this[2] = r, this[3] = s);
  }
  set(t, n, r, s) {
    return this[0] = t, this[1] = n, this[2] = r, this[3] = s, this.check();
  }
  copy(t) {
    return this[0] = t[0], this[1] = t[1], this[2] = t[2], this[3] = t[3], this.check();
  }
  fromObject(t) {
    return Bt.debug && (Q(t.x), Q(t.y), Q(t.z), Q(t.w)), this[0] = t.x, this[1] = t.y, this[2] = t.z, this[3] = t.w, this;
  }
  toObject(t) {
    return t.x = this[0], t.y = this[1], t.z = this[2], t.w = this[3], t;
  }
  // Getters/setters
  /* eslint-disable no-multi-spaces, brace-style, no-return-assign */
  get ELEMENTS() {
    return 4;
  }
  get z() {
    return this[2];
  }
  set z(t) {
    this[2] = Q(t);
  }
  get w() {
    return this[3];
  }
  set w(t) {
    this[3] = Q(t);
  }
  transform(t) {
    return ci(this, this, t), this.check();
  }
  transformByMatrix3(t) {
    return lc(this, this, t), this.check();
  }
  transformByMatrix2(t) {
    return md(this, this, t), this.check();
  }
  transformByQuaternion(t) {
    return pc(this, this, t), this.check();
  }
  // three.js compatibility
  applyMatrix4(t) {
    return t.transform(this, this), this;
  }
}
class gc extends ii {
  // fromObject(object) {
  //   const array = object.elements;
  //   return this.fromRowMajor(array);
  // }
  // toObject(object) {
  //   const array = object.elements;
  //   this.toRowMajor(array);
  //   return object;
  // }
  // TODO better override formatString?
  toString() {
    let t = "[";
    if (Bt.printRowMajor) {
      t += "row-major:";
      for (let n = 0; n < this.RANK; ++n)
        for (let r = 0; r < this.RANK; ++r)
          t += ` ${this[r * this.RANK + n]}`;
    } else {
      t += "column-major:";
      for (let n = 0; n < this.ELEMENTS; ++n)
        t += ` ${this[n]}`;
    }
    return t += "]", t;
  }
  getElementIndex(t, n) {
    return n * this.RANK + t;
  }
  // By default assumes row major indices
  getElement(t, n) {
    return this[n * this.RANK + t];
  }
  // By default assumes row major indices
  setElement(t, n, r) {
    return this[n * this.RANK + t] = Q(r), this;
  }
  getColumn(t, n = new Array(this.RANK).fill(-0)) {
    const r = t * this.RANK;
    for (let s = 0; s < this.RANK; ++s)
      n[s] = this[r + s];
    return n;
  }
  setColumn(t, n) {
    const r = t * this.RANK;
    for (let s = 0; s < this.RANK; ++s)
      this[r + s] = n[s];
    return this;
  }
}
function Cd() {
  const e = new $t(9);
  return $t != Float32Array && (e[1] = 0, e[2] = 0, e[3] = 0, e[5] = 0, e[6] = 0, e[7] = 0), e[0] = 1, e[4] = 1, e[8] = 1, e;
}
function Td(e, t) {
  if (e === t) {
    const n = t[1], r = t[2], s = t[5];
    e[1] = t[3], e[2] = t[6], e[3] = n, e[5] = t[7], e[6] = r, e[7] = s;
  } else
    e[0] = t[0], e[1] = t[3], e[2] = t[6], e[3] = t[1], e[4] = t[4], e[5] = t[7], e[6] = t[2], e[7] = t[5], e[8] = t[8];
  return e;
}
function wd(e, t) {
  const n = t[0], r = t[1], s = t[2], i = t[3], o = t[4], a = t[5], c = t[6], h = t[7], f = t[8], d = f * o - a * h, p = -f * i + a * c, g = h * i - o * c;
  let B = n * d + r * p + s * g;
  return B ? (B = 1 / B, e[0] = d * B, e[1] = (-f * r + s * h) * B, e[2] = (a * r - s * o) * B, e[3] = p * B, e[4] = (f * n - s * c) * B, e[5] = (-a * n + s * i) * B, e[6] = g * B, e[7] = (-h * n + r * c) * B, e[8] = (o * n - r * i) * B, e) : null;
}
function bd(e) {
  const t = e[0], n = e[1], r = e[2], s = e[3], i = e[4], o = e[5], a = e[6], c = e[7], h = e[8];
  return t * (h * i - o * c) + n * (-h * s + o * a) + r * (c * s - i * a);
}
function $i(e, t, n) {
  const r = t[0], s = t[1], i = t[2], o = t[3], a = t[4], c = t[5], h = t[6], f = t[7], d = t[8], p = n[0], g = n[1], B = n[2], C = n[3], b = n[4], M = n[5], D = n[6], _ = n[7], x = n[8];
  return e[0] = p * r + g * o + B * h, e[1] = p * s + g * a + B * f, e[2] = p * i + g * c + B * d, e[3] = C * r + b * o + M * h, e[4] = C * s + b * a + M * f, e[5] = C * i + b * c + M * d, e[6] = D * r + _ * o + x * h, e[7] = D * s + _ * a + x * f, e[8] = D * i + _ * c + x * d, e;
}
function _d(e, t, n) {
  const r = t[0], s = t[1], i = t[2], o = t[3], a = t[4], c = t[5], h = t[6], f = t[7], d = t[8], p = n[0], g = n[1];
  return e[0] = r, e[1] = s, e[2] = i, e[3] = o, e[4] = a, e[5] = c, e[6] = p * r + g * o + h, e[7] = p * s + g * a + f, e[8] = p * i + g * c + d, e;
}
function Id(e, t, n) {
  const r = t[0], s = t[1], i = t[2], o = t[3], a = t[4], c = t[5], h = t[6], f = t[7], d = t[8], p = Math.sin(n), g = Math.cos(n);
  return e[0] = g * r + p * o, e[1] = g * s + p * a, e[2] = g * i + p * c, e[3] = g * o - p * r, e[4] = g * a - p * s, e[5] = g * c - p * i, e[6] = h, e[7] = f, e[8] = d, e;
}
function Xi(e, t, n) {
  const r = n[0], s = n[1];
  return e[0] = r * t[0], e[1] = r * t[1], e[2] = r * t[2], e[3] = s * t[3], e[4] = s * t[4], e[5] = s * t[5], e[6] = t[6], e[7] = t[7], e[8] = t[8], e;
}
function xd(e, t) {
  const n = t[0], r = t[1], s = t[2], i = t[3], o = n + n, a = r + r, c = s + s, h = n * o, f = r * o, d = r * a, p = s * o, g = s * a, B = s * c, C = i * o, b = i * a, M = i * c;
  return e[0] = 1 - d - B, e[3] = f - M, e[6] = p + b, e[1] = f + M, e[4] = 1 - h - B, e[7] = g - C, e[2] = p - b, e[5] = g + C, e[8] = 1 - h - d, e;
}
var xs;
(function(e) {
  e[e.COL0ROW0 = 0] = "COL0ROW0", e[e.COL0ROW1 = 1] = "COL0ROW1", e[e.COL0ROW2 = 2] = "COL0ROW2", e[e.COL1ROW0 = 3] = "COL1ROW0", e[e.COL1ROW1 = 4] = "COL1ROW1", e[e.COL1ROW2 = 5] = "COL1ROW2", e[e.COL2ROW0 = 6] = "COL2ROW0", e[e.COL2ROW1 = 7] = "COL2ROW1", e[e.COL2ROW2 = 8] = "COL2ROW2";
})(xs || (xs = {}));
const Md = Object.freeze([1, 0, 0, 0, 1, 0, 0, 0, 1]);
class lt extends gc {
  static get IDENTITY() {
    return Sd();
  }
  static get ZERO() {
    return Rd();
  }
  get ELEMENTS() {
    return 9;
  }
  get RANK() {
    return 3;
  }
  get INDICES() {
    return xs;
  }
  constructor(t, ...n) {
    super(-0, -0, -0, -0, -0, -0, -0, -0, -0), arguments.length === 1 && Array.isArray(t) ? this.copy(t) : n.length > 0 ? this.copy([t, ...n]) : this.identity();
  }
  copy(t) {
    return this[0] = t[0], this[1] = t[1], this[2] = t[2], this[3] = t[3], this[4] = t[4], this[5] = t[5], this[6] = t[6], this[7] = t[7], this[8] = t[8], this.check();
  }
  // Constructors
  identity() {
    return this.copy(Md);
  }
  /**
   *
   * @param object
   * @returns self
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  fromObject(t) {
    return this.check();
  }
  /** Calculates a 3x3 matrix from the given quaternion
   * q quat  Quaternion to create matrix from
   */
  fromQuaternion(t) {
    return xd(this, t), this.check();
  }
  /**
   * accepts column major order, stores in column major order
   */
  // eslint-disable-next-line max-params
  set(t, n, r, s, i, o, a, c, h) {
    return this[0] = t, this[1] = n, this[2] = r, this[3] = s, this[4] = i, this[5] = o, this[6] = a, this[7] = c, this[8] = h, this.check();
  }
  /**
   * accepts row major order, stores as column major
   */
  // eslint-disable-next-line max-params
  setRowMajor(t, n, r, s, i, o, a, c, h) {
    return this[0] = t, this[1] = s, this[2] = a, this[3] = n, this[4] = i, this[5] = c, this[6] = r, this[7] = o, this[8] = h, this.check();
  }
  // Accessors
  determinant() {
    return bd(this);
  }
  // Modifiers
  transpose() {
    return Td(this, this), this.check();
  }
  /** Invert a matrix. Note that this can fail if the matrix is not invertible */
  invert() {
    return wd(this, this), this.check();
  }
  // Operations
  multiplyLeft(t) {
    return $i(this, t, this), this.check();
  }
  multiplyRight(t) {
    return $i(this, this, t), this.check();
  }
  rotate(t) {
    return Id(this, this, t), this.check();
  }
  scale(t) {
    return Array.isArray(t) ? Xi(this, this, t) : Xi(this, this, [t, t]), this.check();
  }
  translate(t) {
    return _d(this, this, t), this.check();
  }
  // Transforms
  transform(t, n) {
    let r;
    switch (t.length) {
      case 2:
        r = ac(n || [-0, -0], t, this);
        break;
      case 3:
        r = mc(n || [-0, -0, -0], t, this);
        break;
      case 4:
        r = lc(n || [-0, -0, -0, -0], t, this);
        break;
      default:
        throw new Error("Illegal vector");
    }
    return hn(r, t.length), r;
  }
  /** @deprecated */
  transformVector(t, n) {
    return this.transform(t, n);
  }
  /** @deprecated */
  transformVector2(t, n) {
    return this.transform(t, n);
  }
  /** @deprecated */
  transformVector3(t, n) {
    return this.transform(t, n);
  }
}
let Ln, Un = null;
function Rd() {
  return Ln || (Ln = new lt([0, 0, 0, 0, 0, 0, 0, 0, 0]), Object.freeze(Ln)), Ln;
}
function Sd() {
  return Un || (Un = new lt(), Object.freeze(Un)), Un;
}
function Fd(e) {
  return e[0] = 1, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = 1, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 1, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
}
function Od(e, t) {
  if (e === t) {
    const n = t[1], r = t[2], s = t[3], i = t[6], o = t[7], a = t[11];
    e[1] = t[4], e[2] = t[8], e[3] = t[12], e[4] = n, e[6] = t[9], e[7] = t[13], e[8] = r, e[9] = i, e[11] = t[14], e[12] = s, e[13] = o, e[14] = a;
  } else
    e[0] = t[0], e[1] = t[4], e[2] = t[8], e[3] = t[12], e[4] = t[1], e[5] = t[5], e[6] = t[9], e[7] = t[13], e[8] = t[2], e[9] = t[6], e[10] = t[10], e[11] = t[14], e[12] = t[3], e[13] = t[7], e[14] = t[11], e[15] = t[15];
  return e;
}
function Dd(e, t) {
  const n = t[0], r = t[1], s = t[2], i = t[3], o = t[4], a = t[5], c = t[6], h = t[7], f = t[8], d = t[9], p = t[10], g = t[11], B = t[12], C = t[13], b = t[14], M = t[15], D = n * a - r * o, _ = n * c - s * o, x = n * h - i * o, L = r * c - s * a, S = r * h - i * a, G = s * h - i * c, v = f * C - d * B, P = f * b - p * B, J = f * M - g * B, tt = d * b - p * C, it = d * M - g * C, ft = p * M - g * b;
  let k = D * ft - _ * it + x * tt + L * J - S * P + G * v;
  return k ? (k = 1 / k, e[0] = (a * ft - c * it + h * tt) * k, e[1] = (s * it - r * ft - i * tt) * k, e[2] = (C * G - b * S + M * L) * k, e[3] = (p * S - d * G - g * L) * k, e[4] = (c * J - o * ft - h * P) * k, e[5] = (n * ft - s * J + i * P) * k, e[6] = (b * x - B * G - M * _) * k, e[7] = (f * G - p * x + g * _) * k, e[8] = (o * it - a * J + h * v) * k, e[9] = (r * J - n * it - i * v) * k, e[10] = (B * S - C * x + M * D) * k, e[11] = (d * x - f * S - g * D) * k, e[12] = (a * P - o * tt - c * v) * k, e[13] = (n * tt - r * P + s * v) * k, e[14] = (C * _ - B * L - b * D) * k, e[15] = (f * L - d * _ + p * D) * k, e) : null;
}
function Ld(e) {
  const t = e[0], n = e[1], r = e[2], s = e[3], i = e[4], o = e[5], a = e[6], c = e[7], h = e[8], f = e[9], d = e[10], p = e[11], g = e[12], B = e[13], C = e[14], b = e[15], M = t * o - n * i, D = t * a - r * i, _ = n * a - r * o, x = h * B - f * g, L = h * C - d * g, S = f * C - d * B, G = t * S - n * L + r * x, v = i * S - o * L + a * x, P = h * _ - f * D + d * M, J = g * _ - B * D + C * M;
  return c * G - s * v + b * P - p * J;
}
function qi(e, t, n) {
  const r = t[0], s = t[1], i = t[2], o = t[3], a = t[4], c = t[5], h = t[6], f = t[7], d = t[8], p = t[9], g = t[10], B = t[11], C = t[12], b = t[13], M = t[14], D = t[15];
  let _ = n[0], x = n[1], L = n[2], S = n[3];
  return e[0] = _ * r + x * a + L * d + S * C, e[1] = _ * s + x * c + L * p + S * b, e[2] = _ * i + x * h + L * g + S * M, e[3] = _ * o + x * f + L * B + S * D, _ = n[4], x = n[5], L = n[6], S = n[7], e[4] = _ * r + x * a + L * d + S * C, e[5] = _ * s + x * c + L * p + S * b, e[6] = _ * i + x * h + L * g + S * M, e[7] = _ * o + x * f + L * B + S * D, _ = n[8], x = n[9], L = n[10], S = n[11], e[8] = _ * r + x * a + L * d + S * C, e[9] = _ * s + x * c + L * p + S * b, e[10] = _ * i + x * h + L * g + S * M, e[11] = _ * o + x * f + L * B + S * D, _ = n[12], x = n[13], L = n[14], S = n[15], e[12] = _ * r + x * a + L * d + S * C, e[13] = _ * s + x * c + L * p + S * b, e[14] = _ * i + x * h + L * g + S * M, e[15] = _ * o + x * f + L * B + S * D, e;
}
function Ud(e, t, n) {
  const r = n[0], s = n[1], i = n[2];
  let o, a, c, h, f, d, p, g, B, C, b, M;
  return t === e ? (e[12] = t[0] * r + t[4] * s + t[8] * i + t[12], e[13] = t[1] * r + t[5] * s + t[9] * i + t[13], e[14] = t[2] * r + t[6] * s + t[10] * i + t[14], e[15] = t[3] * r + t[7] * s + t[11] * i + t[15]) : (o = t[0], a = t[1], c = t[2], h = t[3], f = t[4], d = t[5], p = t[6], g = t[7], B = t[8], C = t[9], b = t[10], M = t[11], e[0] = o, e[1] = a, e[2] = c, e[3] = h, e[4] = f, e[5] = d, e[6] = p, e[7] = g, e[8] = B, e[9] = C, e[10] = b, e[11] = M, e[12] = o * r + f * s + B * i + t[12], e[13] = a * r + d * s + C * i + t[13], e[14] = c * r + p * s + b * i + t[14], e[15] = h * r + g * s + M * i + t[15]), e;
}
function Nd(e, t, n) {
  const r = n[0], s = n[1], i = n[2];
  return e[0] = t[0] * r, e[1] = t[1] * r, e[2] = t[2] * r, e[3] = t[3] * r, e[4] = t[4] * s, e[5] = t[5] * s, e[6] = t[6] * s, e[7] = t[7] * s, e[8] = t[8] * i, e[9] = t[9] * i, e[10] = t[10] * i, e[11] = t[11] * i, e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15], e;
}
function Pd(e, t, n, r) {
  let s = r[0], i = r[1], o = r[2], a = Math.sqrt(s * s + i * i + o * o), c, h, f, d, p, g, B, C, b, M, D, _, x, L, S, G, v, P, J, tt, it, ft, k, gt;
  return a < ln ? null : (a = 1 / a, s *= a, i *= a, o *= a, h = Math.sin(n), c = Math.cos(n), f = 1 - c, d = t[0], p = t[1], g = t[2], B = t[3], C = t[4], b = t[5], M = t[6], D = t[7], _ = t[8], x = t[9], L = t[10], S = t[11], G = s * s * f + c, v = i * s * f + o * h, P = o * s * f - i * h, J = s * i * f - o * h, tt = i * i * f + c, it = o * i * f + s * h, ft = s * o * f + i * h, k = i * o * f - s * h, gt = o * o * f + c, e[0] = d * G + C * v + _ * P, e[1] = p * G + b * v + x * P, e[2] = g * G + M * v + L * P, e[3] = B * G + D * v + S * P, e[4] = d * J + C * tt + _ * it, e[5] = p * J + b * tt + x * it, e[6] = g * J + M * tt + L * it, e[7] = B * J + D * tt + S * it, e[8] = d * ft + C * k + _ * gt, e[9] = p * ft + b * k + x * gt, e[10] = g * ft + M * k + L * gt, e[11] = B * ft + D * k + S * gt, t !== e && (e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15]), e);
}
function Gd(e, t, n) {
  const r = Math.sin(n), s = Math.cos(n), i = t[4], o = t[5], a = t[6], c = t[7], h = t[8], f = t[9], d = t[10], p = t[11];
  return t !== e && (e[0] = t[0], e[1] = t[1], e[2] = t[2], e[3] = t[3], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15]), e[4] = i * s + h * r, e[5] = o * s + f * r, e[6] = a * s + d * r, e[7] = c * s + p * r, e[8] = h * s - i * r, e[9] = f * s - o * r, e[10] = d * s - a * r, e[11] = p * s - c * r, e;
}
function vd(e, t, n) {
  const r = Math.sin(n), s = Math.cos(n), i = t[0], o = t[1], a = t[2], c = t[3], h = t[8], f = t[9], d = t[10], p = t[11];
  return t !== e && (e[4] = t[4], e[5] = t[5], e[6] = t[6], e[7] = t[7], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15]), e[0] = i * s - h * r, e[1] = o * s - f * r, e[2] = a * s - d * r, e[3] = c * s - p * r, e[8] = i * r + h * s, e[9] = o * r + f * s, e[10] = a * r + d * s, e[11] = c * r + p * s, e;
}
function Hd(e, t, n) {
  const r = Math.sin(n), s = Math.cos(n), i = t[0], o = t[1], a = t[2], c = t[3], h = t[4], f = t[5], d = t[6], p = t[7];
  return t !== e && (e[8] = t[8], e[9] = t[9], e[10] = t[10], e[11] = t[11], e[12] = t[12], e[13] = t[13], e[14] = t[14], e[15] = t[15]), e[0] = i * s + h * r, e[1] = o * s + f * r, e[2] = a * s + d * r, e[3] = c * s + p * r, e[4] = h * s - i * r, e[5] = f * s - o * r, e[6] = d * s - a * r, e[7] = p * s - c * r, e;
}
function Jd(e, t) {
  const n = t[0], r = t[1], s = t[2], i = t[4], o = t[5], a = t[6], c = t[8], h = t[9], f = t[10];
  return e[0] = Math.sqrt(n * n + r * r + s * s), e[1] = Math.sqrt(i * i + o * o + a * a), e[2] = Math.sqrt(c * c + h * h + f * f), e;
}
function kd(e, t) {
  const n = t[0], r = t[1], s = t[2], i = t[3], o = n + n, a = r + r, c = s + s, h = n * o, f = r * o, d = r * a, p = s * o, g = s * a, B = s * c, C = i * o, b = i * a, M = i * c;
  return e[0] = 1 - d - B, e[1] = f + M, e[2] = p - b, e[3] = 0, e[4] = f - M, e[5] = 1 - h - B, e[6] = g + C, e[7] = 0, e[8] = p + b, e[9] = g - C, e[10] = 1 - h - d, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, e;
}
function Vd(e, t, n, r, s, i, o) {
  const a = 1 / (n - t), c = 1 / (s - r), h = 1 / (i - o);
  return e[0] = i * 2 * a, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = i * 2 * c, e[6] = 0, e[7] = 0, e[8] = (n + t) * a, e[9] = (s + r) * c, e[10] = (o + i) * h, e[11] = -1, e[12] = 0, e[13] = 0, e[14] = o * i * 2 * h, e[15] = 0, e;
}
function jd(e, t, n, r, s) {
  const i = 1 / Math.tan(t / 2);
  if (e[0] = i / n, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = i, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[11] = -1, e[12] = 0, e[13] = 0, e[15] = 0, s != null && s !== 1 / 0) {
    const o = 1 / (r - s);
    e[10] = (s + r) * o, e[14] = 2 * s * r * o;
  } else
    e[10] = -1, e[14] = -2 * r;
  return e;
}
const Kd = jd;
function zd(e, t, n, r, s, i, o) {
  const a = 1 / (t - n), c = 1 / (r - s), h = 1 / (i - o);
  return e[0] = -2 * a, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = -2 * c, e[6] = 0, e[7] = 0, e[8] = 0, e[9] = 0, e[10] = 2 * h, e[11] = 0, e[12] = (t + n) * a, e[13] = (s + r) * c, e[14] = (o + i) * h, e[15] = 1, e;
}
const Wd = zd;
function Qd(e, t, n, r) {
  let s, i, o, a, c, h, f, d, p, g;
  const B = t[0], C = t[1], b = t[2], M = r[0], D = r[1], _ = r[2], x = n[0], L = n[1], S = n[2];
  return Math.abs(B - x) < ln && Math.abs(C - L) < ln && Math.abs(b - S) < ln ? Fd(e) : (d = B - x, p = C - L, g = b - S, s = 1 / Math.sqrt(d * d + p * p + g * g), d *= s, p *= s, g *= s, i = D * g - _ * p, o = _ * d - M * g, a = M * p - D * d, s = Math.sqrt(i * i + o * o + a * a), s ? (s = 1 / s, i *= s, o *= s, a *= s) : (i = 0, o = 0, a = 0), c = p * a - g * o, h = g * i - d * a, f = d * o - p * i, s = Math.sqrt(c * c + h * h + f * f), s ? (s = 1 / s, c *= s, h *= s, f *= s) : (c = 0, h = 0, f = 0), e[0] = i, e[1] = c, e[2] = d, e[3] = 0, e[4] = o, e[5] = h, e[6] = p, e[7] = 0, e[8] = a, e[9] = f, e[10] = g, e[11] = 0, e[12] = -(i * B + o * C + a * b), e[13] = -(c * B + h * C + f * b), e[14] = -(d * B + p * C + g * b), e[15] = 1, e);
}
function $d() {
  const e = new $t(4);
  return $t != Float32Array && (e[0] = 0, e[1] = 0, e[2] = 0, e[3] = 0), e;
}
function Xd(e, t, n) {
  return e[0] = t[0] + n[0], e[1] = t[1] + n[1], e[2] = t[2] + n[2], e[3] = t[3] + n[3], e;
}
function qd(e, t, n) {
  return e[0] = t[0] * n, e[1] = t[1] * n, e[2] = t[2] * n, e[3] = t[3] * n, e;
}
function Yd(e) {
  const t = e[0], n = e[1], r = e[2], s = e[3];
  return Math.sqrt(t * t + n * n + r * r + s * s);
}
function Zd(e) {
  const t = e[0], n = e[1], r = e[2], s = e[3];
  return t * t + n * n + r * r + s * s;
}
function tm(e, t) {
  const n = t[0], r = t[1], s = t[2], i = t[3];
  let o = n * n + r * r + s * s + i * i;
  return o > 0 && (o = 1 / Math.sqrt(o)), e[0] = n * o, e[1] = r * o, e[2] = s * o, e[3] = i * o, e;
}
function em(e, t) {
  return e[0] * t[0] + e[1] * t[1] + e[2] * t[2] + e[3] * t[3];
}
function nm(e, t, n, r) {
  const s = t[0], i = t[1], o = t[2], a = t[3];
  return e[0] = s + r * (n[0] - s), e[1] = i + r * (n[1] - i), e[2] = o + r * (n[2] - o), e[3] = a + r * (n[3] - a), e;
}
function rm(e, t, n) {
  const r = t[0], s = t[1], i = t[2], o = t[3];
  return e[0] = n[0] * r + n[4] * s + n[8] * i + n[12] * o, e[1] = n[1] * r + n[5] * s + n[9] * i + n[13] * o, e[2] = n[2] * r + n[6] * s + n[10] * i + n[14] * o, e[3] = n[3] * r + n[7] * s + n[11] * i + n[15] * o, e;
}
function sm(e, t, n) {
  const r = t[0], s = t[1], i = t[2], o = n[0], a = n[1], c = n[2], h = n[3], f = h * r + a * i - c * s, d = h * s + c * r - o * i, p = h * i + o * s - a * r, g = -o * r - a * s - c * i;
  return e[0] = f * h + g * -o + d * -c - p * -a, e[1] = d * h + g * -a + p * -o - f * -c, e[2] = p * h + g * -c + f * -a - d * -o, e[3] = t[3], e;
}
(function() {
  const e = $d();
  return function(t, n, r, s, i, o) {
    let a, c;
    for (n || (n = 4), r || (r = 0), s ? c = Math.min(s * n + r, t.length) : c = t.length, a = r; a < c; a += n)
      e[0] = t[a], e[1] = t[a + 1], e[2] = t[a + 2], e[3] = t[a + 3], i(e, e, o), t[a] = e[0], t[a + 1] = e[1], t[a + 2] = e[2], t[a + 3] = e[3];
    return t;
  };
})();
var Ms;
(function(e) {
  e[e.COL0ROW0 = 0] = "COL0ROW0", e[e.COL0ROW1 = 1] = "COL0ROW1", e[e.COL0ROW2 = 2] = "COL0ROW2", e[e.COL0ROW3 = 3] = "COL0ROW3", e[e.COL1ROW0 = 4] = "COL1ROW0", e[e.COL1ROW1 = 5] = "COL1ROW1", e[e.COL1ROW2 = 6] = "COL1ROW2", e[e.COL1ROW3 = 7] = "COL1ROW3", e[e.COL2ROW0 = 8] = "COL2ROW0", e[e.COL2ROW1 = 9] = "COL2ROW1", e[e.COL2ROW2 = 10] = "COL2ROW2", e[e.COL2ROW3 = 11] = "COL2ROW3", e[e.COL3ROW0 = 12] = "COL3ROW0", e[e.COL3ROW1 = 13] = "COL3ROW1", e[e.COL3ROW2 = 14] = "COL3ROW2", e[e.COL3ROW3 = 15] = "COL3ROW3";
})(Ms || (Ms = {}));
const im = 45 * Math.PI / 180, om = 1, Wr = 0.1, Qr = 500, am = Object.freeze([1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]);
class Z extends gc {
  static get IDENTITY() {
    return um();
  }
  static get ZERO() {
    return cm();
  }
  get ELEMENTS() {
    return 16;
  }
  get RANK() {
    return 4;
  }
  get INDICES() {
    return Ms;
  }
  constructor(t) {
    super(-0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0), arguments.length === 1 && Array.isArray(t) ? this.copy(t) : this.identity();
  }
  copy(t) {
    return this[0] = t[0], this[1] = t[1], this[2] = t[2], this[3] = t[3], this[4] = t[4], this[5] = t[5], this[6] = t[6], this[7] = t[7], this[8] = t[8], this[9] = t[9], this[10] = t[10], this[11] = t[11], this[12] = t[12], this[13] = t[13], this[14] = t[14], this[15] = t[15], this.check();
  }
  // eslint-disable-next-line max-params
  set(t, n, r, s, i, o, a, c, h, f, d, p, g, B, C, b) {
    return this[0] = t, this[1] = n, this[2] = r, this[3] = s, this[4] = i, this[5] = o, this[6] = a, this[7] = c, this[8] = h, this[9] = f, this[10] = d, this[11] = p, this[12] = g, this[13] = B, this[14] = C, this[15] = b, this.check();
  }
  // accepts row major order, stores as column major
  // eslint-disable-next-line max-params
  setRowMajor(t, n, r, s, i, o, a, c, h, f, d, p, g, B, C, b) {
    return this[0] = t, this[1] = i, this[2] = h, this[3] = g, this[4] = n, this[5] = o, this[6] = f, this[7] = B, this[8] = r, this[9] = a, this[10] = d, this[11] = C, this[12] = s, this[13] = c, this[14] = p, this[15] = b, this.check();
  }
  toRowMajor(t) {
    return t[0] = this[0], t[1] = this[4], t[2] = this[8], t[3] = this[12], t[4] = this[1], t[5] = this[5], t[6] = this[9], t[7] = this[13], t[8] = this[2], t[9] = this[6], t[10] = this[10], t[11] = this[14], t[12] = this[3], t[13] = this[7], t[14] = this[11], t[15] = this[15], t;
  }
  // Constructors
  /** Set to identity matrix */
  identity() {
    return this.copy(am);
  }
  /**
   *
   * @param object
   * @returns self
   */
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  fromObject(t) {
    return this.check();
  }
  /**
   * Calculates a 4x4 matrix from the given quaternion
   * @param quaternion Quaternion to create matrix from
   * @returns self
   */
  fromQuaternion(t) {
    return kd(this, t), this.check();
  }
  /**
   * Generates a frustum matrix with the given bounds
   * @param view.left - Left bound of the frustum
   * @param view.right - Right bound of the frustum
   * @param view.bottom - Bottom bound of the frustum
   * @param view.top - Top bound of the frustum
   * @param view.near - Near bound of the frustum
   * @param view.far - Far bound of the frustum. Can be set to Infinity.
   * @returns self
   */
  frustum(t) {
    const { left: n, right: r, bottom: s, top: i, near: o = Wr, far: a = Qr } = t;
    return a === 1 / 0 ? hm(this, n, r, s, i, o) : Vd(this, n, r, s, i, o, a), this.check();
  }
  /**
   * Generates a look-at matrix with the given eye position, focal point,
   * and up axis
   * @param view.eye - (vector) Position of the viewer
   * @param view.center - (vector) Point the viewer is looking at
   * @param view.up - (vector) Up axis
   * @returns self
   */
  lookAt(t) {
    const { eye: n, center: r = [0, 0, 0], up: s = [0, 1, 0] } = t;
    return Qd(this, n, r, s), this.check();
  }
  /**
   * Generates a orthogonal projection matrix with the given bounds
   * from "traditional" view space parameters
   * @param view.left - Left bound of the frustum
   * @param view.right number  Right bound of the frustum
   * @param view.bottom - Bottom bound of the frustum
   * @param view.top number  Top bound of the frustum
   * @param view.near - Near bound of the frustum
   * @param view.far number  Far bound of the frustum
   * @returns self
   */
  ortho(t) {
    const { left: n, right: r, bottom: s, top: i, near: o = Wr, far: a = Qr } = t;
    return Wd(this, n, r, s, i, o, a), this.check();
  }
  /**
   * Generates an orthogonal projection matrix with the same parameters
   * as a perspective matrix (plus focalDistance)
   * @param view.fovy Vertical field of view in radians
   * @param view.aspect Aspect ratio. Typically viewport width / viewport height
   * @param view.focalDistance Distance in the view frustum used for extent calculations
   * @param view.near Near bound of the frustum
   * @param view.far Far bound of the frustum
   * @returns self
   */
  orthographic(t) {
    const { fovy: n = im, aspect: r = om, focalDistance: s = 1, near: i = Wr, far: o = Qr } = t;
    Yi(n);
    const a = n / 2, c = s * Math.tan(a), h = c * r;
    return this.ortho({
      left: -h,
      right: h,
      bottom: -c,
      top: c,
      near: i,
      far: o
    });
  }
  /**
   * Generates a perspective projection matrix with the given bounds
   * @param view.fovy Vertical field of view in radians
   * @param view.aspect Aspect ratio. typically viewport width/height
   * @param view.near Near bound of the frustum
   * @param view.far Far bound of the frustum
   * @returns self
   */
  perspective(t) {
    const { fovy: n = 45 * Math.PI / 180, aspect: r = 1, near: s = 0.1, far: i = 500 } = t;
    return Yi(n), Kd(this, n, r, s, i), this.check();
  }
  // Accessors
  determinant() {
    return Ld(this);
  }
  /**
   * Extracts the non-uniform scale assuming the matrix is an affine transformation.
   * The scales are the "lengths" of the column vectors in the upper-left 3x3 matrix.
   * @param result
   * @returns self
   */
  getScale(t = [-0, -0, -0]) {
    return t[0] = Math.sqrt(this[0] * this[0] + this[1] * this[1] + this[2] * this[2]), t[1] = Math.sqrt(this[4] * this[4] + this[5] * this[5] + this[6] * this[6]), t[2] = Math.sqrt(this[8] * this[8] + this[9] * this[9] + this[10] * this[10]), t;
  }
  /**
   * Gets the translation portion, assuming the matrix is a affine transformation matrix.
   * @param result
   * @returns self
   */
  getTranslation(t = [-0, -0, -0]) {
    return t[0] = this[12], t[1] = this[13], t[2] = this[14], t;
  }
  /**
   * Gets upper left 3x3 pure rotation matrix (non-scaling), assume affine transformation matrix
   * @param result
   * @param scaleResult
   * @returns self
   */
  getRotation(t, n) {
    t = t || [-0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0, -0], n = n || [-0, -0, -0];
    const r = this.getScale(n), s = 1 / r[0], i = 1 / r[1], o = 1 / r[2];
    return t[0] = this[0] * s, t[1] = this[1] * i, t[2] = this[2] * o, t[3] = 0, t[4] = this[4] * s, t[5] = this[5] * i, t[6] = this[6] * o, t[7] = 0, t[8] = this[8] * s, t[9] = this[9] * i, t[10] = this[10] * o, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t;
  }
  /**
   *
   * @param result
   * @param scaleResult
   * @returns self
   */
  getRotationMatrix3(t, n) {
    t = t || [-0, -0, -0, -0, -0, -0, -0, -0, -0], n = n || [-0, -0, -0];
    const r = this.getScale(n), s = 1 / r[0], i = 1 / r[1], o = 1 / r[2];
    return t[0] = this[0] * s, t[1] = this[1] * i, t[2] = this[2] * o, t[3] = this[4] * s, t[4] = this[5] * i, t[5] = this[6] * o, t[6] = this[8] * s, t[7] = this[9] * i, t[8] = this[10] * o, t;
  }
  // Modifiers
  transpose() {
    return Od(this, this), this.check();
  }
  invert() {
    return Dd(this, this), this.check();
  }
  // Operations
  multiplyLeft(t) {
    return qi(this, t, this), this.check();
  }
  multiplyRight(t) {
    return qi(this, this, t), this.check();
  }
  // Rotates a matrix by the given angle around the X axis
  rotateX(t) {
    return Gd(this, this, t), this.check();
  }
  // Rotates a matrix by the given angle around the Y axis.
  rotateY(t) {
    return vd(this, this, t), this.check();
  }
  /**
   * Rotates a matrix by the given angle around the Z axis.
   * @param radians
   * @returns self
   */
  rotateZ(t) {
    return Hd(this, this, t), this.check();
  }
  /**
   *
   * @param param0
   * @returns self
   */
  rotateXYZ(t) {
    return this.rotateX(t[0]).rotateY(t[1]).rotateZ(t[2]);
  }
  /**
   *
   * @param radians
   * @param axis
   * @returns self
   */
  rotateAxis(t, n) {
    return Pd(this, this, t, n), this.check();
  }
  /**
   *
   * @param factor
   * @returns self
   */
  scale(t) {
    return Nd(this, this, Array.isArray(t) ? t : [t, t, t]), this.check();
  }
  /**
   *
   * @param vec
   * @returns self
   */
  translate(t) {
    return Ud(this, this, t), this.check();
  }
  // Transforms
  /**
   * Transforms any 2, 3 or 4 element vector. 2 and 3 elements are treated as points
   * @param vector
   * @param result
   * @returns self
   */
  transform(t, n) {
    return t.length === 4 ? (n = rm(n || [-0, -0, -0, -0], t, this), hn(n, 4), n) : this.transformAsPoint(t, n);
  }
  /**
   * Transforms any 2 or 3 element array as point (w implicitly 1)
   * @param vector
   * @param result
   * @returns self
   */
  transformAsPoint(t, n) {
    const { length: r } = t;
    let s;
    switch (r) {
      case 2:
        s = cc(n || [-0, -0], t, this);
        break;
      case 3:
        s = ci(n || [-0, -0, -0], t, this);
        break;
      default:
        throw new Error("Illegal vector");
    }
    return hn(s, t.length), s;
  }
  /**
   * Transforms any 2 or 3 element array as vector (w implicitly 0)
   * @param vector
   * @param result
   * @returns self
   */
  transformAsVector(t, n) {
    let r;
    switch (t.length) {
      case 2:
        r = uc(n || [-0, -0], t, this);
        break;
      case 3:
        r = hc(n || [-0, -0, -0], t, this);
        break;
      default:
        throw new Error("Illegal vector");
    }
    return hn(r, t.length), r;
  }
  /** @deprecated */
  transformPoint(t, n) {
    return this.transformAsPoint(t, n);
  }
  /** @deprecated */
  transformVector(t, n) {
    return this.transformAsPoint(t, n);
  }
  /** @deprecated */
  transformDirection(t, n) {
    return this.transformAsVector(t, n);
  }
  // three.js math API compatibility
  makeRotationX(t) {
    return this.identity().rotateX(t);
  }
  makeTranslation(t, n, r) {
    return this.identity().translate([t, n, r]);
  }
}
let Nn, Pn;
function cm() {
  return Nn || (Nn = new Z([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]), Object.freeze(Nn)), Nn;
}
function um() {
  return Pn || (Pn = new Z(), Object.freeze(Pn)), Pn;
}
function Yi(e) {
  if (e > Math.PI * 2)
    throw Error("expected radians");
}
function hm(e, t, n, r, s, i) {
  const o = 2 * i / (n - t), a = 2 * i / (s - r), c = (n + t) / (n - t), h = (s + r) / (s - r), f = -1, d = -1, p = -2 * i;
  return e[0] = o, e[1] = 0, e[2] = 0, e[3] = 0, e[4] = 0, e[5] = a, e[6] = 0, e[7] = 0, e[8] = c, e[9] = h, e[10] = f, e[11] = d, e[12] = 0, e[13] = 0, e[14] = p, e[15] = 0, e;
}
function Zi() {
  const e = new $t(4);
  return $t != Float32Array && (e[0] = 0, e[1] = 0, e[2] = 0), e[3] = 1, e;
}
function lm(e) {
  return e[0] = 0, e[1] = 0, e[2] = 0, e[3] = 1, e;
}
function Ac(e, t, n) {
  n = n * 0.5;
  const r = Math.sin(n);
  return e[0] = r * t[0], e[1] = r * t[1], e[2] = r * t[2], e[3] = Math.cos(n), e;
}
function to(e, t, n) {
  const r = t[0], s = t[1], i = t[2], o = t[3], a = n[0], c = n[1], h = n[2], f = n[3];
  return e[0] = r * f + o * a + s * h - i * c, e[1] = s * f + o * c + i * a - r * h, e[2] = i * f + o * h + r * c - s * a, e[3] = o * f - r * a - s * c - i * h, e;
}
function fm(e, t, n) {
  n *= 0.5;
  const r = t[0], s = t[1], i = t[2], o = t[3], a = Math.sin(n), c = Math.cos(n);
  return e[0] = r * c + o * a, e[1] = s * c + i * a, e[2] = i * c - s * a, e[3] = o * c - r * a, e;
}
function dm(e, t, n) {
  n *= 0.5;
  const r = t[0], s = t[1], i = t[2], o = t[3], a = Math.sin(n), c = Math.cos(n);
  return e[0] = r * c - i * a, e[1] = s * c + o * a, e[2] = i * c + r * a, e[3] = o * c - s * a, e;
}
function mm(e, t, n) {
  n *= 0.5;
  const r = t[0], s = t[1], i = t[2], o = t[3], a = Math.sin(n), c = Math.cos(n);
  return e[0] = r * c + s * a, e[1] = s * c - r * a, e[2] = i * c + o * a, e[3] = o * c - i * a, e;
}
function pm(e, t) {
  const n = t[0], r = t[1], s = t[2];
  return e[0] = n, e[1] = r, e[2] = s, e[3] = Math.sqrt(Math.abs(1 - n * n - r * r - s * s)), e;
}
function tr(e, t, n, r) {
  const s = t[0], i = t[1], o = t[2], a = t[3];
  let c = n[0], h = n[1], f = n[2], d = n[3], p, g, B, C, b;
  return p = s * c + i * h + o * f + a * d, p < 0 && (p = -p, c = -c, h = -h, f = -f, d = -d), 1 - p > ln ? (g = Math.acos(p), b = Math.sin(g), B = Math.sin((1 - r) * g) / b, C = Math.sin(r * g) / b) : (B = 1 - r, C = r), e[0] = B * s + C * c, e[1] = B * i + C * h, e[2] = B * o + C * f, e[3] = B * a + C * d, e;
}
function gm(e, t) {
  const n = t[0], r = t[1], s = t[2], i = t[3], o = n * n + r * r + s * s + i * i, a = o ? 1 / o : 0;
  return e[0] = -n * a, e[1] = -r * a, e[2] = -s * a, e[3] = i * a, e;
}
function Am(e, t) {
  return e[0] = -t[0], e[1] = -t[1], e[2] = -t[2], e[3] = t[3], e;
}
function yc(e, t) {
  const n = t[0] + t[4] + t[8];
  let r;
  if (n > 0)
    r = Math.sqrt(n + 1), e[3] = 0.5 * r, r = 0.5 / r, e[0] = (t[5] - t[7]) * r, e[1] = (t[6] - t[2]) * r, e[2] = (t[1] - t[3]) * r;
  else {
    let s = 0;
    t[4] > t[0] && (s = 1), t[8] > t[s * 3 + s] && (s = 2);
    const i = (s + 1) % 3, o = (s + 2) % 3;
    r = Math.sqrt(t[s * 3 + s] - t[i * 3 + i] - t[o * 3 + o] + 1), e[s] = 0.5 * r, r = 0.5 / r, e[3] = (t[i * 3 + o] - t[o * 3 + i]) * r, e[i] = (t[i * 3 + s] + t[s * 3 + i]) * r, e[o] = (t[o * 3 + s] + t[s * 3 + o]) * r;
  }
  return e;
}
const ym = Xd, Bm = qd, Em = em, Cm = nm, Tm = Yd, wm = Zd, Bc = tm, bm = function() {
  const e = fc(), t = Qi(1, 0, 0), n = Qi(0, 1, 0);
  return function(r, s, i) {
    const o = ai(s, i);
    return o < -0.999999 ? (Zn(e, t, s), Ed(e) < 1e-6 && Zn(e, n, s), pd(e, e), Ac(r, e, Math.PI), r) : o > 0.999999 ? (r[0] = 0, r[1] = 0, r[2] = 0, r[3] = 1, r) : (Zn(e, s, i), r[0] = e[0], r[1] = e[1], r[2] = e[2], r[3] = 1 + o, Bc(r, r));
  };
}();
(function() {
  const e = Zi(), t = Zi();
  return function(n, r, s, i, o, a) {
    return tr(e, r, o, a), tr(t, s, i, a), tr(n, e, t, 2 * a * (1 - a)), n;
  };
})();
(function() {
  const e = Cd();
  return function(t, n, r, s) {
    return e[0] = r[0], e[3] = r[1], e[6] = r[2], e[1] = s[0], e[4] = s[1], e[7] = s[2], e[2] = -n[0], e[5] = -n[1], e[8] = -n[2], Bc(t, yc(t, e));
  };
})();
const _m = [0, 0, 0, 1];
class ur extends ii {
  constructor(t = 0, n = 0, r = 0, s = 1) {
    super(-0, -0, -0, -0), Array.isArray(t) && arguments.length === 1 ? this.copy(t) : this.set(t, n, r, s);
  }
  copy(t) {
    return this[0] = t[0], this[1] = t[1], this[2] = t[2], this[3] = t[3], this.check();
  }
  set(t, n, r, s) {
    return this[0] = t, this[1] = n, this[2] = r, this[3] = s, this.check();
  }
  fromObject(t) {
    return this[0] = t.x, this[1] = t.y, this[2] = t.z, this[3] = t.w, this.check();
  }
  /**
   * Creates a quaternion from the given 3x3 rotation matrix.
   * NOTE: The resultant quaternion is not normalized, so you should
   * be sure to renormalize the quaternion yourself where necessary.
   * @param m
   * @returns
   */
  fromMatrix3(t) {
    return yc(this, t), this.check();
  }
  fromAxisRotation(t, n) {
    return Ac(this, t, n), this.check();
  }
  /** Set a quat to the identity quaternion */
  identity() {
    return lm(this), this.check();
  }
  // Set the components of a quat to the given values
  // set(i, j, k, l) {
  //   quat_set(this, i, j, k, l);
  //   return this.check();
  // }
  // Sets a quat from the given angle and rotation axis, then returns it.
  setAxisAngle(t, n) {
    return this.fromAxisRotation(t, n);
  }
  // Getters/setters
  get ELEMENTS() {
    return 4;
  }
  get x() {
    return this[0];
  }
  set x(t) {
    this[0] = Q(t);
  }
  get y() {
    return this[1];
  }
  set y(t) {
    this[1] = Q(t);
  }
  get z() {
    return this[2];
  }
  set z(t) {
    this[2] = Q(t);
  }
  get w() {
    return this[3];
  }
  set w(t) {
    this[3] = Q(t);
  }
  // Calculates the length of a quat
  len() {
    return Tm(this);
  }
  // Calculates the squared length of a quat
  lengthSquared() {
    return wm(this);
  }
  // Calculates the dot product of two quat's
  // @return {Number}
  dot(t) {
    return Em(this, t);
  }
  // Gets the rotation axis and angle for a given quaternion.
  // If a quaternion is created with setAxisAngle, this method will
  // return the same values as providied in the original parameter
  // list OR functionally equivalent values.
  // Example: The quaternion formed by axis [0, 0, 1] and angle -90
  // is the same as the quaternion formed by [0, 0, 1] and 270.
  // This method favors the latter.
  // @return {{[x,y,z], Number}}
  // getAxisAngle() {
  //   const axis = [];
  // //   const angle = quat_getAxisAngle(axis, this);
  //   return {axis, angle};
  // }
  // MODIFIERS
  // Sets a quaternion to represent the shortest rotation from one vector
  // to another. Both vectors are assumed to be unit length.
  rotationTo(t, n) {
    return bm(this, t, n), this.check();
  }
  // Sets the specified quaternion with values corresponding to the given axes.
  // Each axis is a vec3 and is expected to be unit length and perpendicular
  // to all other specified axes.
  // setAxes() {
  //   Number
  // }
  // Performs a spherical linear interpolation with two control points
  // sqlerp() {
  //   Number;
  // }
  // Adds two quat's
  add(t) {
    return ym(this, this, t), this.check();
  }
  // Calculates the W component of a quat from the X, Y, and Z components.
  // Any existing W component will be ignored.
  calculateW() {
    return pm(this, this), this.check();
  }
  // Calculates the conjugate of a quat If the quaternion is normalized,
  // this function is faster than quat_invert and produces the same result.
  conjugate() {
    return Am(this, this), this.check();
  }
  // Calculates the inverse of a quat
  invert() {
    return gm(this, this), this.check();
  }
  // Performs a linear interpolation between two quat's
  lerp(t, n, r) {
    return r === void 0 ? this.lerp(this, t, n) : (Cm(this, t, n, r), this.check());
  }
  // Multiplies two quat's
  multiplyRight(t) {
    return to(this, this, t), this.check();
  }
  multiplyLeft(t) {
    return to(this, t, this), this.check();
  }
  // Normalize a quat
  normalize() {
    const t = this.len(), n = t > 0 ? 1 / t : 0;
    return this[0] = this[0] * n, this[1] = this[1] * n, this[2] = this[2] * n, this[3] = this[3] * n, t === 0 && (this[3] = 1), this.check();
  }
  // Rotates a quaternion by the given angle about the X axis
  rotateX(t) {
    return fm(this, this, t), this.check();
  }
  // Rotates a quaternion by the given angle about the Y axis
  rotateY(t) {
    return dm(this, this, t), this.check();
  }
  // Rotates a quaternion by the given angle about the Z axis
  rotateZ(t) {
    return mm(this, this, t), this.check();
  }
  // Scales a quat by a scalar number
  scale(t) {
    return Bm(this, this, t), this.check();
  }
  // Performs a spherical linear interpolation between two quat
  slerp(t, n, r) {
    let s, i, o;
    switch (arguments.length) {
      case 1:
        ({
          start: s = _m,
          target: i,
          ratio: o
        } = t);
        break;
      case 2:
        s = this, i = t, o = n;
        break;
      default:
        s = t, i = n, o = r;
    }
    return tr(this, s, i, o), this.check();
  }
  transformVector4(t, n = new ui()) {
    return sm(n, t, this), hn(n, 4);
  }
  // THREE.js Math API compatibility
  lengthSq() {
    return this.lengthSquared();
  }
  setFromAxisAngle(t, n) {
    return this.setAxisAngle(t, n);
  }
  premultiply(t) {
    return this.multiplyLeft(t);
  }
  multiply(t) {
    return this.multiplyRight(t);
  }
}
const Im = 0.1, xm = 1e-12, Ec = 1e-15, Mm = 1e-20, Rm = 6378137, Sm = 6378137, Fm = 6356752314245179e-9;
function Ir(e) {
  return e;
}
new T();
function Om(e, t = [], n = Ir) {
  return "longitude" in e ? (t[0] = n(e.longitude), t[1] = n(e.latitude), t[2] = e.height) : "x" in e ? (t[0] = n(e.x), t[1] = n(e.y), t[2] = e.z) : (t[0] = n(e[0]), t[1] = n(e[1]), t[2] = e[2]), t;
}
function Dm(e, t = []) {
  return Om(e, t, Bt._cartographicRadians ? Ir : rd);
}
function Lm(e, t, n = Ir) {
  return "longitude" in t ? (t.longitude = n(e[0]), t.latitude = n(e[1]), t.height = e[2]) : "x" in t ? (t.x = n(e[0]), t.y = n(e[1]), t.z = e[2]) : (t[0] = n(e[0]), t[1] = n(e[1]), t[2] = e[2]), t;
}
function Um(e, t) {
  return Lm(e, t, Bt._cartographicRadians ? Ir : sd);
}
const eo = 1e-14, Nm = new T(), no = {
  up: {
    south: "east",
    north: "west",
    west: "south",
    east: "north"
  },
  down: {
    south: "west",
    north: "east",
    west: "north",
    east: "south"
  },
  south: {
    up: "west",
    down: "east",
    west: "down",
    east: "up"
  },
  north: {
    up: "east",
    down: "west",
    west: "up",
    east: "down"
  },
  west: {
    up: "north",
    down: "south",
    north: "down",
    south: "up"
  },
  east: {
    up: "south",
    down: "north",
    north: "up",
    south: "down"
  }
}, $r = {
  north: [-1, 0, 0],
  east: [0, 1, 0],
  up: [0, 0, 1],
  south: [1, 0, 0],
  west: [0, -1, 0],
  down: [0, 0, -1]
}, en = {
  east: new T(),
  north: new T(),
  up: new T(),
  west: new T(),
  south: new T(),
  down: new T()
}, Pm = new T(), Gm = new T(), vm = new T();
function ro(e, t, n, r, s, i) {
  const o = no[t] && no[t][n];
  et(o && (!r || r === o));
  let a, c, h;
  const f = Nm.copy(s);
  if (ye(f.x, 0, eo) && ye(f.y, 0, eo)) {
    const p = Math.sign(f.z);
    a = Pm.fromArray($r[t]), t !== "east" && t !== "west" && a.scale(p), c = Gm.fromArray($r[n]), n !== "east" && n !== "west" && c.scale(p), h = vm.fromArray($r[r]), r !== "east" && r !== "west" && h.scale(p);
  } else {
    const { up: p, east: g, north: B } = en;
    g.set(-f.y, f.x, 0).normalize(), e.geodeticSurfaceNormal(f, p), B.copy(p).cross(g);
    const { down: C, west: b, south: M } = en;
    C.copy(p).scale(-1), b.copy(g).scale(-1), M.copy(B).scale(-1), a = en[t], c = en[n], h = en[r];
  }
  return i[0] = a.x, i[1] = a.y, i[2] = a.z, i[3] = 0, i[4] = c.x, i[5] = c.y, i[6] = c.z, i[7] = 0, i[8] = h.x, i[9] = h.y, i[10] = h.z, i[11] = 0, i[12] = f.x, i[13] = f.y, i[14] = f.z, i[15] = 1, i;
}
const Ge = new T(), Hm = new T(), Jm = new T();
function km(e, t, n = []) {
  const { oneOverRadii: r, oneOverRadiiSquared: s, centerToleranceSquared: i } = t;
  Ge.from(e);
  const o = Ge.x, a = Ge.y, c = Ge.z, h = r.x, f = r.y, d = r.z, p = o * o * h * h, g = a * a * f * f, B = c * c * d * d, C = p + g + B, b = Math.sqrt(1 / C);
  if (!Number.isFinite(b))
    return;
  const M = Hm;
  if (M.copy(e).scale(b), C < i)
    return M.to(n);
  const D = s.x, _ = s.y, x = s.z, L = Jm;
  L.set(M.x * D * 2, M.y * _ * 2, M.z * x * 2);
  let S = (1 - b) * Ge.len() / (0.5 * L.len()), G = 0, v, P, J, tt;
  do {
    S -= G, v = 1 / (1 + S * D), P = 1 / (1 + S * _), J = 1 / (1 + S * x);
    const it = v * v, ft = P * P, k = J * J, gt = it * v, Nt = ft * P, Pt = k * J;
    tt = p * it + g * ft + B * k - 1;
    const Xt = -2 * (p * gt * D + g * Nt * _ + B * Pt * x);
    G = tt / Xt;
  } while (Math.abs(tt) > xm);
  return Ge.scale([v, P, J]).to(n);
}
const Gn = new T(), so = new T(), Vm = new T(), jt = new T(), jm = new T(), vn = new T();
class q {
  constructor(t = 0, n = 0, r = 0) {
    this.centerToleranceSquared = Im, et(t >= 0), et(n >= 0), et(r >= 0), this.radii = new T(t, n, r), this.radiiSquared = new T(t * t, n * n, r * r), this.radiiToTheFourth = new T(t * t * t * t, n * n * n * n, r * r * r * r), this.oneOverRadii = new T(t === 0 ? 0 : 1 / t, n === 0 ? 0 : 1 / n, r === 0 ? 0 : 1 / r), this.oneOverRadiiSquared = new T(t === 0 ? 0 : 1 / (t * t), n === 0 ? 0 : 1 / (n * n), r === 0 ? 0 : 1 / (r * r)), this.minimumRadius = Math.min(t, n, r), this.maximumRadius = Math.max(t, n, r), this.radiiSquared.z !== 0 && (this.squaredXOverSquaredZ = this.radiiSquared.x / this.radiiSquared.z), Object.freeze(this);
  }
  /** Compares this Ellipsoid against the provided Ellipsoid componentwise */
  equals(t) {
    return this === t || !!(t && this.radii.equals(t.radii));
  }
  /** Creates a string representing this Ellipsoid in the format '(radii.x, radii.y, radii.z)'. */
  toString() {
    return this.radii.toString();
  }
  cartographicToCartesian(t, n = [0, 0, 0]) {
    const r = so, s = Vm, [, , i] = t;
    this.geodeticSurfaceNormalCartographic(t, r), s.copy(this.radiiSquared).scale(r);
    const o = Math.sqrt(r.dot(s));
    return s.scale(1 / o), r.scale(i), s.add(r), s.to(n);
  }
  cartesianToCartographic(t, n = [0, 0, 0]) {
    vn.from(t);
    const r = this.scaleToGeodeticSurface(vn, jt);
    if (!r)
      return;
    const s = this.geodeticSurfaceNormal(r, so), i = jm;
    i.copy(vn).subtract(r);
    const o = Math.atan2(s.y, s.x), a = Math.asin(s.z), c = Math.sign(ai(i, vn)) * dc(i);
    return Um([o, a, c], n);
  }
  eastNorthUpToFixedFrame(t, n = new Z()) {
    return ro(this, "east", "north", "up", t, n);
  }
  // Computes a 4x4 transformation matrix from a reference frame centered at
  // the provided origin to the ellipsoid's fixed reference frame.
  localFrameToFixedFrame(t, n, r, s, i = new Z()) {
    return ro(this, t, n, r, s, i);
  }
  geocentricSurfaceNormal(t, n = [0, 0, 0]) {
    return Gn.from(t).normalize().to(n);
  }
  geodeticSurfaceNormalCartographic(t, n = [0, 0, 0]) {
    const r = Dm(t), s = r[0], i = r[1], o = Math.cos(i);
    return Gn.set(o * Math.cos(s), o * Math.sin(s), Math.sin(i)).normalize(), Gn.to(n);
  }
  geodeticSurfaceNormal(t, n = [0, 0, 0]) {
    return Gn.from(t).scale(this.oneOverRadiiSquared).normalize().to(n);
  }
  /** Scales the provided Cartesian position along the geodetic surface normal
   * so that it is on the surface of this ellipsoid.  If the position is
   * at the center of the ellipsoid, this function returns undefined. */
  scaleToGeodeticSurface(t, n) {
    return km(t, this, n);
  }
  /** Scales the provided Cartesian position along the geocentric surface normal
   * so that it is on the surface of this ellipsoid. */
  scaleToGeocentricSurface(t, n = [0, 0, 0]) {
    jt.from(t);
    const r = jt.x, s = jt.y, i = jt.z, o = this.oneOverRadiiSquared, a = 1 / Math.sqrt(r * r * o.x + s * s * o.y + i * i * o.z);
    return jt.multiplyScalar(a).to(n);
  }
  /** Transforms a Cartesian X, Y, Z position to the ellipsoid-scaled space by multiplying
   * its components by the result of `Ellipsoid#oneOverRadii` */
  transformPositionToScaledSpace(t, n = [0, 0, 0]) {
    return jt.from(t).scale(this.oneOverRadii).to(n);
  }
  /** Transforms a Cartesian X, Y, Z position from the ellipsoid-scaled space by multiplying
   * its components by the result of `Ellipsoid#radii`. */
  transformPositionFromScaledSpace(t, n = [0, 0, 0]) {
    return jt.from(t).scale(this.radii).to(n);
  }
  /** Computes a point which is the intersection of the surface normal with the z-axis. */
  getSurfaceNormalIntersectionWithZAxis(t, n = 0, r = [0, 0, 0]) {
    et(ye(this.radii.x, this.radii.y, Ec)), et(this.radii.z > 0), jt.from(t);
    const s = jt.z * (1 - this.squaredXOverSquaredZ);
    if (!(Math.abs(s) >= this.radii.z - n))
      return jt.set(0, 0, s).to(r);
  }
}
q.WGS84 = new q(Rm, Sm, Fm);
class Km {
  constructor(t, n, r) {
    y(this, "item");
    y(this, "previous");
    y(this, "next");
    this.item = t, this.previous = n, this.next = r;
  }
}
class zm {
  constructor() {
    y(this, "head", null);
    y(this, "tail", null);
    y(this, "_length", 0);
  }
  get length() {
    return this._length;
  }
  /**
   * Adds the item to the end of the list
   * @param {*} [item]
   * @return {DoublyLinkedListNode}
   */
  add(t) {
    const n = new Km(t, this.tail, null);
    return this.tail ? (this.tail.next = n, this.tail = n) : (this.head = n, this.tail = n), ++this._length, n;
  }
  /**
   * Removes the given node from the list
   * @param {DoublyLinkedListNode} node
   */
  remove(t) {
    t && (t.previous && t.next ? (t.previous.next = t.next, t.next.previous = t.previous) : t.previous ? (t.previous.next = null, this.tail = t.previous) : t.next ? (t.next.previous = null, this.head = t.next) : (this.head = null, this.tail = null), t.next = null, t.previous = null, --this._length);
  }
  /**
   * Moves nextNode after node
   * @param {DoublyLinkedListNode} node
   * @param {DoublyLinkedListNode} nextNode
   */
  splice(t, n) {
    t !== n && (this.remove(n), this._insert(t, n));
  }
  _insert(t, n) {
    const r = t.next;
    t.next = n, this.tail === t ? this.tail = n : r.previous = n, n.next = r, n.previous = t, ++this._length;
  }
}
class Wm {
  constructor() {
    y(this, "_list");
    y(this, "_sentinel");
    y(this, "_trimTiles");
    this._list = new zm(), this._sentinel = this._list.add("sentinel"), this._trimTiles = !1;
  }
  reset() {
    this._list.splice(this._list.tail, this._sentinel);
  }
  touch(t) {
    const n = t._cacheNode;
    n && this._list.splice(this._sentinel, n);
  }
  add(t, n, r) {
    n._cacheNode || (n._cacheNode = this._list.add(n), r && r(t, n));
  }
  unloadTile(t, n, r) {
    const s = n._cacheNode;
    s && (this._list.remove(s), n._cacheNode = null, r && r(t, n));
  }
  unloadTiles(t, n) {
    const r = this._trimTiles;
    this._trimTiles = !1;
    const s = this._list, i = t.maximumMemoryUsage * 1024 * 1024, o = this._sentinel;
    let a = s.head;
    for (; a !== o && (t.gpuMemoryUsageInBytes > i || r); ) {
      const c = a.item;
      a = a.next, this.unloadTile(t, c, n);
    }
  }
  trim() {
    this._trimTiles = !0;
  }
}
function Qm(e, t) {
  $(e), $(t);
  const { rtcCenter: n, gltfUpAxis: r } = t, { computedTransform: s, boundingVolume: { center: i } } = e;
  let o = new Z(s);
  switch (n && o.translate(n), r) {
    case "Z":
      break;
    case "Y":
      const d = new Z().rotateX(Math.PI / 2);
      o = o.multiplyRight(d);
      break;
    case "X":
      const p = new Z().rotateY(-Math.PI / 2);
      o = o.multiplyRight(p);
      break;
  }
  t.isQuantized && o.translate(t.quantizedVolumeOffset).scale(t.quantizedVolumeScale);
  const a = new T(i);
  t.cartesianModelMatrix = o, t.cartesianOrigin = a;
  const c = q.WGS84.cartesianToCartographic(a, new T()), f = q.WGS84.eastNorthUpToFixedFrame(a).invert();
  t.cartographicModelMatrix = f.multiplyRight(o), t.cartographicOrigin = c, t.coordinateSystem || (t.modelMatrix = t.cartographicModelMatrix);
}
const Lt = {
  OUTSIDE: -1,
  // Represents that an object is not contained within the frustum.
  INTERSECTING: 0,
  // Represents that an object intersects one of the frustum's planes.
  INSIDE: 1
  // Represents that an object is fully within the frustum.
};
new T();
new T();
const nn = new T(), io = new T();
class bn {
  /** Creates a bounding sphere */
  constructor(t = [0, 0, 0], n = 0) {
    this.radius = -0, this.center = new T(), this.fromCenterRadius(t, n);
  }
  /** Sets the bounding sphere from `center` and `radius`. */
  fromCenterRadius(t, n) {
    return this.center.from(t), this.radius = n, this;
  }
  /**
   * Computes a bounding sphere from the corner points of an axis-aligned bounding box.  The sphere
   * tightly and fully encompasses the box.
   */
  fromCornerPoints(t, n) {
    return n = nn.from(n), this.center = new T().from(t).add(n).scale(0.5), this.radius = this.center.distance(n), this;
  }
  /** Compares the provided BoundingSphere component wise */
  equals(t) {
    return this === t || !!t && this.center.equals(t.center) && this.radius === t.radius;
  }
  /** Duplicates a BoundingSphere instance. */
  clone() {
    return new bn(this.center, this.radius);
  }
  /** Computes a bounding sphere that contains both the left and right bounding spheres. */
  union(t) {
    const n = this.center, r = this.radius, s = t.center, i = t.radius, o = nn.copy(s).subtract(n), a = o.magnitude();
    if (r >= a + i)
      return this.clone();
    if (i >= a + r)
      return t.clone();
    const c = (r + a + i) * 0.5;
    return io.copy(o).scale((-r + c) / a).add(n), this.center.copy(io), this.radius = c, this;
  }
  /** Computes a bounding sphere by enlarging the provided sphere to contain the provided point. */
  expand(t) {
    const r = nn.from(t).subtract(this.center).magnitude();
    return r > this.radius && (this.radius = r), this;
  }
  // BoundingVolume interface
  /**
   * Applies a 4x4 affine transformation matrix to a bounding sphere.
   * @param sphere The bounding sphere to apply the transformation to.
   * @param transform The transformation matrix to apply to the bounding sphere.
   * @returns self.
   */
  transform(t) {
    this.center.transform(t);
    const n = Jd(nn, t);
    return this.radius = Math.max(n[0], Math.max(n[1], n[2])) * this.radius, this;
  }
  /** Computes the estimated distance squared from the closest point on a bounding sphere to a point. */
  distanceSquaredTo(t) {
    const n = this.distanceTo(t);
    return n * n;
  }
  /** Computes the estimated distance from the closest point on a bounding sphere to a point. */
  distanceTo(t) {
    const r = nn.from(t).subtract(this.center);
    return Math.max(0, r.len() - this.radius);
  }
  /** Determines which side of a plane a sphere is located. */
  intersectPlane(t) {
    const n = this.center, r = this.radius, i = t.normal.dot(n) + t.distance;
    return i < -r ? Lt.OUTSIDE : i < r ? Lt.INTERSECTING : Lt.INSIDE;
  }
}
const $m = new T(), Xm = new T(), Hn = new T(), Jn = new T(), kn = new T(), qm = new T(), Ym = new T(), ae = {
  COLUMN0ROW0: 0,
  COLUMN0ROW1: 1,
  COLUMN0ROW2: 2,
  COLUMN1ROW0: 3,
  COLUMN1ROW1: 4,
  COLUMN1ROW2: 5,
  COLUMN2ROW0: 6,
  COLUMN2ROW1: 7,
  COLUMN2ROW2: 8
};
class _n {
  constructor(t = [0, 0, 0], n = [0, 0, 0, 0, 0, 0, 0, 0, 0]) {
    this.center = new T().from(t), this.halfAxes = new lt(n);
  }
  /** Returns an array with three halfSizes for the bounding box */
  get halfSize() {
    const t = this.halfAxes.getColumn(0), n = this.halfAxes.getColumn(1), r = this.halfAxes.getColumn(2);
    return [new T(t).len(), new T(n).len(), new T(r).len()];
  }
  /** Returns a quaternion describing the orientation of the bounding box */
  get quaternion() {
    const t = this.halfAxes.getColumn(0), n = this.halfAxes.getColumn(1), r = this.halfAxes.getColumn(2), s = new T(t).normalize(), i = new T(n).normalize(), o = new T(r).normalize();
    return new ur().fromMatrix3(new lt([...s, ...i, ...o]));
  }
  /**
   * Create OrientedBoundingBox from quaternion based OBB,
   */
  fromCenterHalfSizeQuaternion(t, n, r) {
    const s = new ur(r), i = new lt().fromQuaternion(s);
    return i[0] = i[0] * n[0], i[1] = i[1] * n[0], i[2] = i[2] * n[0], i[3] = i[3] * n[1], i[4] = i[4] * n[1], i[5] = i[5] * n[1], i[6] = i[6] * n[2], i[7] = i[7] * n[2], i[8] = i[8] * n[2], this.center = new T().from(t), this.halfAxes = i, this;
  }
  /** Duplicates a OrientedBoundingBox instance. */
  clone() {
    return new _n(this.center, this.halfAxes);
  }
  /** Compares the provided OrientedBoundingBox component wise and returns */
  equals(t) {
    return this === t || !!t && this.center.equals(t.center) && this.halfAxes.equals(t.halfAxes);
  }
  /** Computes a tight-fitting bounding sphere enclosing the provided oriented bounding box. */
  getBoundingSphere(t = new bn()) {
    const n = this.halfAxes, r = n.getColumn(0, Hn), s = n.getColumn(1, Jn), i = n.getColumn(2, kn), o = $m.copy(r).add(s).add(i);
    return t.center.copy(this.center), t.radius = o.magnitude(), t;
  }
  /** Determines which side of a plane the oriented bounding box is located. */
  intersectPlane(t) {
    const n = this.center, r = t.normal, s = this.halfAxes, i = r.x, o = r.y, a = r.z, c = Math.abs(i * s[ae.COLUMN0ROW0] + o * s[ae.COLUMN0ROW1] + a * s[ae.COLUMN0ROW2]) + Math.abs(i * s[ae.COLUMN1ROW0] + o * s[ae.COLUMN1ROW1] + a * s[ae.COLUMN1ROW2]) + Math.abs(i * s[ae.COLUMN2ROW0] + o * s[ae.COLUMN2ROW1] + a * s[ae.COLUMN2ROW2]), h = r.dot(n) + t.distance;
    return h <= -c ? Lt.OUTSIDE : h >= c ? Lt.INSIDE : Lt.INTERSECTING;
  }
  /** Computes the estimated distance from the closest point on a bounding box to a point. */
  distanceTo(t) {
    return Math.sqrt(this.distanceSquaredTo(t));
  }
  /**
   * Computes the estimated distance squared from the closest point
   * on a bounding box to a point.
   * See Geometric Tools for Computer Graphics 10.4.2
   */
  distanceSquaredTo(t) {
    const n = Xm.from(t).subtract(this.center), r = this.halfAxes, s = r.getColumn(0, Hn), i = r.getColumn(1, Jn), o = r.getColumn(2, kn), a = s.magnitude(), c = i.magnitude(), h = o.magnitude();
    s.normalize(), i.normalize(), o.normalize();
    let f = 0, d;
    return d = Math.abs(n.dot(s)) - a, d > 0 && (f += d * d), d = Math.abs(n.dot(i)) - c, d > 0 && (f += d * d), d = Math.abs(n.dot(o)) - h, d > 0 && (f += d * d), f;
  }
  /**
   * The distances calculated by the vector from the center of the bounding box
   * to position projected onto direction.
   *
   * - If you imagine the infinite number of planes with normal direction,
   *   this computes the smallest distance to the closest and farthest planes
   *   from `position` that intersect the bounding box.
   *
   * @param position The position to calculate the distance from.
   * @param direction The direction from position.
   * @param result An Interval (array of length 2) to store the nearest and farthest distances.
   * @returns Interval (array of length 2) with nearest and farthest distances
   *   on the bounding box from position in direction.
   */
  // eslint-disable-next-line max-statements
  computePlaneDistances(t, n, r = [-0, -0]) {
    let s = Number.POSITIVE_INFINITY, i = Number.NEGATIVE_INFINITY;
    const o = this.center, a = this.halfAxes, c = a.getColumn(0, Hn), h = a.getColumn(1, Jn), f = a.getColumn(2, kn), d = qm.copy(c).add(h).add(f).add(o), p = Ym.copy(d).subtract(t);
    let g = n.dot(p);
    return s = Math.min(g, s), i = Math.max(g, i), d.copy(o).add(c).add(h).subtract(f), p.copy(d).subtract(t), g = n.dot(p), s = Math.min(g, s), i = Math.max(g, i), d.copy(o).add(c).subtract(h).add(f), p.copy(d).subtract(t), g = n.dot(p), s = Math.min(g, s), i = Math.max(g, i), d.copy(o).add(c).subtract(h).subtract(f), p.copy(d).subtract(t), g = n.dot(p), s = Math.min(g, s), i = Math.max(g, i), o.copy(d).subtract(c).add(h).add(f), p.copy(d).subtract(t), g = n.dot(p), s = Math.min(g, s), i = Math.max(g, i), o.copy(d).subtract(c).add(h).subtract(f), p.copy(d).subtract(t), g = n.dot(p), s = Math.min(g, s), i = Math.max(g, i), o.copy(d).subtract(c).subtract(h).add(f), p.copy(d).subtract(t), g = n.dot(p), s = Math.min(g, s), i = Math.max(g, i), o.copy(d).subtract(c).subtract(h).subtract(f), p.copy(d).subtract(t), g = n.dot(p), s = Math.min(g, s), i = Math.max(g, i), r[0] = s, r[1] = i, r;
  }
  /**
   * Applies a 4x4 affine transformation matrix to a bounding sphere.
   * @param transform The transformation matrix to apply to the bounding sphere.
   * @returns itself, i.e. the modified BoundingVolume.
   */
  transform(t) {
    this.center.transformAsPoint(t);
    const n = this.halfAxes.getColumn(0, Hn);
    n.transformAsPoint(t);
    const r = this.halfAxes.getColumn(1, Jn);
    r.transformAsPoint(t);
    const s = this.halfAxes.getColumn(2, kn);
    return s.transformAsPoint(t), this.halfAxes = new lt([...n, ...r, ...s]), this;
  }
  getTransform() {
    throw new Error("not implemented");
  }
}
const oo = new T(), ao = new T();
class Et {
  constructor(t = [0, 0, 1], n = 0) {
    this.normal = new T(), this.distance = -0, this.fromNormalDistance(t, n);
  }
  /** Creates a plane from a normal and a distance from the origin. */
  fromNormalDistance(t, n) {
    return et(Number.isFinite(n)), this.normal.from(t).normalize(), this.distance = n, this;
  }
  /** Creates a plane from a normal and a point on the plane. */
  fromPointNormal(t, n) {
    t = oo.from(t), this.normal.from(n).normalize();
    const r = -this.normal.dot(t);
    return this.distance = r, this;
  }
  /** Creates a plane from the general equation */
  fromCoefficients(t, n, r, s) {
    return this.normal.set(t, n, r), et(ye(this.normal.len(), 1)), this.distance = s, this;
  }
  /** Duplicates a Plane instance. */
  clone() {
    return new Et(this.normal, this.distance);
  }
  /** Compares the provided Planes by normal and distance */
  equals(t) {
    return ye(this.distance, t.distance) && ye(this.normal, t.normal);
  }
  /** Computes the signed shortest distance of a point to a plane.
   * The sign of the distance determines which side of the plane the point is on.
   */
  getPointDistance(t) {
    return this.normal.dot(t) + this.distance;
  }
  /** Transforms the plane by the given transformation matrix. */
  transform(t) {
    const n = ao.copy(this.normal).transformAsVector(t).normalize(), r = this.normal.scale(-this.distance).transform(t);
    return this.fromPointNormal(r, n);
  }
  projectPointOntoPlane(t, n = [0, 0, 0]) {
    const r = oo.from(t), s = this.getPointDistance(r), i = ao.copy(this.normal).scale(s);
    return r.subtract(i).to(n);
  }
}
const co = [new T([1, 0, 0]), new T([0, 1, 0]), new T([0, 0, 1])], uo = new T(), Zm = new T();
class Ft {
  /**
   * Create a new `CullingVolume` bounded by an array of clipping planed
   * @param planes Array of clipping planes.
   * */
  constructor(t = []) {
    this.planes = t;
  }
  /**
   * Constructs a culling volume from a bounding sphere. Creates six planes that create a box containing the sphere.
   * The planes are aligned to the x, y, and z axes in world coordinates.
   */
  fromBoundingSphere(t) {
    this.planes.length = 2 * co.length;
    const n = t.center, r = t.radius;
    let s = 0;
    for (const i of co) {
      let o = this.planes[s], a = this.planes[s + 1];
      o || (o = this.planes[s] = new Et()), a || (a = this.planes[s + 1] = new Et());
      const c = uo.copy(i).scale(-r).add(n);
      o.fromPointNormal(c, i);
      const h = uo.copy(i).scale(r).add(n), f = Zm.copy(i).negate();
      a.fromPointNormal(h, f), s += 2;
    }
    return this;
  }
  /** Determines whether a bounding volume intersects the culling volume. */
  computeVisibility(t) {
    let n = Lt.INSIDE;
    for (const r of this.planes)
      switch (t.intersectPlane(r)) {
        case Lt.OUTSIDE:
          return Lt.OUTSIDE;
        case Lt.INTERSECTING:
          n = Lt.INTERSECTING;
          break;
      }
    return n;
  }
  /**
   * Determines whether a bounding volume intersects the culling volume.
   *
   * @param parentPlaneMask A bit mask from the boundingVolume's parent's check against the same culling
   *   volume, such that if (planeMask & (1 << planeIndex) === 0), for k < 31, then
   *   the parent (and therefore this) volume is completely inside plane[planeIndex]
   *   and that plane check can be skipped.
   */
  computeVisibilityWithPlaneMask(t, n) {
    if (et(Number.isFinite(n), "parentPlaneMask is required."), n === Ft.MASK_OUTSIDE || n === Ft.MASK_INSIDE)
      return n;
    let r = Ft.MASK_INSIDE;
    const s = this.planes;
    for (let i = 0; i < this.planes.length; ++i) {
      const o = i < 31 ? 1 << i : 0;
      if (i < 31 && !(n & o))
        continue;
      const a = s[i], c = t.intersectPlane(a);
      if (c === Lt.OUTSIDE)
        return Ft.MASK_OUTSIDE;
      c === Lt.INTERSECTING && (r |= o);
    }
    return r;
  }
}
Ft.MASK_OUTSIDE = 4294967295;
Ft.MASK_INSIDE = 0;
Ft.MASK_INDETERMINATE = 2147483647;
const t0 = new T(), e0 = new T(), n0 = new T(), r0 = new T(), s0 = new T();
class hr {
  /**
   * The viewing frustum is defined by 6 planes.
   * Each plane is represented by a {@link Vector4} object, where the x, y, and z components
   * define the unit vector normal to the plane, and the w component is the distance of the
   * plane from the origin/camera position.
   *
   * @alias PerspectiveOffCenterFrustum
   *
   * @example
   * const frustum = new PerspectiveOffCenterFrustum({
   *     left : -1.0,
   *     right : 1.0,
   *     top : 1.0,
   *     bottom : -1.0,
   *     near : 1.0,
   *     far : 100.0
   * });
   *
   * @see PerspectiveFrustum
   */
  constructor(t = {}) {
    this._cullingVolume = new Ft([
      new Et(),
      new Et(),
      new Et(),
      new Et(),
      new Et(),
      new Et()
    ]), this._perspectiveMatrix = new Z(), this._infinitePerspective = new Z();
    const { near: n = 1, far: r = 5e8 } = t;
    this.left = t.left, this._left = void 0, this.right = t.right, this._right = void 0, this.top = t.top, this._top = void 0, this.bottom = t.bottom, this._bottom = void 0, this.near = n, this._near = n, this.far = r, this._far = r;
  }
  /**
   * Returns a duplicate of a PerspectiveOffCenterFrustum instance.
   * @returns {PerspectiveOffCenterFrustum} A new PerspectiveFrustum instance.
   * */
  clone() {
    return new hr({
      right: this.right,
      left: this.left,
      top: this.top,
      bottom: this.bottom,
      near: this.near,
      far: this.far
    });
  }
  /**
   * Compares the provided PerspectiveOffCenterFrustum componentwise and returns
   * <code>true</code> if they are equal, <code>false</code> otherwise.
   *
   * @returns {Boolean} <code>true</code> if they are equal, <code>false</code> otherwise.
   */
  equals(t) {
    return t && t instanceof hr && this.right === t.right && this.left === t.left && this.top === t.top && this.bottom === t.bottom && this.near === t.near && this.far === t.far;
  }
  /**
   * Gets the perspective projection matrix computed from the view frustum.
   * @memberof PerspectiveOffCenterFrustum.prototype
   * @type {Matrix4}
   *
   * @see PerspectiveOffCenterFrustum#infiniteProjectionMatrix
   */
  get projectionMatrix() {
    return this._update(), this._perspectiveMatrix;
  }
  /**
   * Gets the perspective projection matrix computed from the view frustum with an infinite far plane.
   * @memberof PerspectiveOffCenterFrustum.prototype
   * @type {Matrix4}
   *
   * @see PerspectiveOffCenterFrustum#projectionMatrix
   */
  get infiniteProjectionMatrix() {
    return this._update(), this._infinitePerspective;
  }
  /**
   * Creates a culling volume for this frustum.
   * @returns {CullingVolume} A culling volume at the given position and orientation.
   *
   * @example
   * // Check if a bounding volume intersects the frustum.
   * const cullingVolume = frustum.computeCullingVolume(cameraPosition, cameraDirection, cameraUp);
   * const intersect = cullingVolume.computeVisibility(boundingVolume);
   */
  // eslint-disable-next-line complexity, max-statements
  computeCullingVolume(t, n, r) {
    et(t, "position is required."), et(n, "direction is required."), et(r, "up is required.");
    const s = this._cullingVolume.planes;
    r = t0.copy(r).normalize();
    const i = e0.copy(n).cross(r).normalize(), o = n0.copy(n).multiplyByScalar(this.near).add(t), a = r0.copy(n).multiplyByScalar(this.far).add(t);
    let c = s0;
    return c.copy(i).multiplyByScalar(this.left).add(o).subtract(t).cross(r), s[0].fromPointNormal(t, c), c.copy(i).multiplyByScalar(this.right).add(o).subtract(t).cross(r).negate(), s[1].fromPointNormal(t, c), c.copy(r).multiplyByScalar(this.bottom).add(o).subtract(t).cross(i).negate(), s[2].fromPointNormal(t, c), c.copy(r).multiplyByScalar(this.top).add(o).subtract(t).cross(i), s[3].fromPointNormal(t, c), c = new T().copy(n), s[4].fromPointNormal(o, c), c.negate(), s[5].fromPointNormal(a, c), this._cullingVolume;
  }
  /**
   * Returns the pixel's width and height in meters.
   *
   * @returns {Vector2} The modified result parameter or a new instance of {@link Vector2} with the pixel's width and height in the x and y properties, respectively.
   *
   * @exception {DeveloperError} drawingBufferWidth must be greater than zero.
   * @exception {DeveloperError} drawingBufferHeight must be greater than zero.
   *
   * @example
   * // Example 1
   * // Get the width and height of a pixel.
   * const pixelSize = camera.frustum.getPixelDimensions(scene.drawingBufferWidth, scene.drawingBufferHeight, 1.0, new Vector2());
   *
   * @example
   * // Example 2
   * // Get the width and height of a pixel if the near plane was set to 'distance'.
   * // For example, get the size of a pixel of an image on a billboard.
   * const position = camera.position;
   * const direction = camera.direction;
   * const toCenter = Vector3.subtract(primitive.boundingVolume.center, position, new Vector3());      // vector from camera to a primitive
   * const toCenterProj = Vector3.multiplyByScalar(direction, Vector3.dot(direction, toCenter), new Vector3()); // project vector onto camera direction vector
   * const distance = Vector3.magnitude(toCenterProj);
   * const pixelSize = camera.frustum.getPixelDimensions(scene.drawingBufferWidth, scene.drawingBufferHeight, distance, new Vector2());
   */
  getPixelDimensions(t, n, r, s) {
    this._update(), et(Number.isFinite(t) && Number.isFinite(n)), et(t > 0), et(n > 0), et(r > 0), et(s);
    const i = 1 / this.near;
    let o = this.top * i;
    const a = 2 * r * o / n;
    o = this.right * i;
    const c = 2 * r * o / t;
    return s.x = c, s.y = a, s;
  }
  // eslint-disable-next-line complexity, max-statements
  _update() {
    et(Number.isFinite(this.right) && Number.isFinite(this.left) && Number.isFinite(this.top) && Number.isFinite(this.bottom) && Number.isFinite(this.near) && Number.isFinite(this.far));
    const { top: t, bottom: n, right: r, left: s, near: i, far: o } = this;
    (t !== this._top || n !== this._bottom || s !== this._left || r !== this._right || i !== this._near || o !== this._far) && (et(this.near > 0 && this.near < this.far, "near must be greater than zero and less than far."), this._left = s, this._right = r, this._top = t, this._bottom = n, this._near = i, this._far = o, this._perspectiveMatrix = new Z().frustum({
      left: s,
      right: r,
      bottom: n,
      top: t,
      near: i,
      far: o
    }), this._infinitePerspective = new Z().frustum({
      left: s,
      right: r,
      bottom: n,
      top: t,
      near: i,
      far: 1 / 0
    }));
  }
}
const i0 = (e) => e !== null && typeof e < "u";
class lr {
  constructor(t = {}) {
    this._offCenterFrustum = new hr();
    const { fov: n, aspectRatio: r, near: s = 1, far: i = 5e8, xOffset: o = 0, yOffset: a = 0 } = t;
    this.fov = n, this.aspectRatio = r, this.near = s, this.far = i, this.xOffset = o, this.yOffset = a;
  }
  /**
   * Returns a duplicate of a PerspectiveFrustum instance.
   */
  clone() {
    return new lr({
      aspectRatio: this.aspectRatio,
      fov: this.fov,
      near: this.near,
      far: this.far
    });
  }
  /**
   * Compares the provided PerspectiveFrustum componentwise and returns
   * <code>true</code> if they are equal, <code>false</code> otherwise.
   */
  equals(t) {
    return !i0(t) || !(t instanceof lr) ? !1 : (this._update(), t._update(), this.fov === t.fov && this.aspectRatio === t.aspectRatio && this.near === t.near && this.far === t.far && this._offCenterFrustum.equals(t._offCenterFrustum));
  }
  /**
   * Gets the perspective projection matrix computed from the view this.
   */
  get projectionMatrix() {
    return this._update(), this._offCenterFrustum.projectionMatrix;
  }
  /**
   * The perspective projection matrix computed from the view frustum with an infinite far plane.
   */
  get infiniteProjectionMatrix() {
    return this._update(), this._offCenterFrustum.infiniteProjectionMatrix;
  }
  /**
   * Gets the angle of the vertical field of view, in radians.
   */
  get fovy() {
    return this._update(), this._fovy;
  }
  /**
   * @private
   */
  get sseDenominator() {
    return this._update(), this._sseDenominator;
  }
  /**
   * Creates a culling volume for this this.ion.
   * @returns {CullingVolume} A culling volume at the given position and orientation.
   *
   * @example
   * // Check if a bounding volume intersects the this.
   * var cullingVolume = this.computeCullingVolume(cameraPosition, cameraDirection, cameraUp);
   * var intersect = cullingVolume.computeVisibility(boundingVolume);
   */
  computeCullingVolume(t, n, r) {
    return this._update(), this._offCenterFrustum.computeCullingVolume(t, n, r);
  }
  /**
   * Returns the pixel's width and height in meters.
   * @returns {Vector2} The modified result parameter or a new instance of {@link Vector2} with the pixel's width and height in the x and y properties, respectively.
   *
   * @exception {DeveloperError} drawingBufferWidth must be greater than zero.
   * @exception {DeveloperError} drawingBufferHeight must be greater than zero.
   *
   * @example
   * // Example 1
   * // Get the width and height of a pixel.
   * var pixelSize = camera.this.getPixelDimensions(scene.drawingBufferWidth, scene.drawingBufferHeight, 1.0, new Vector2());
   *
   * @example
   * // Example 2
   * // Get the width and height of a pixel if the near plane was set to 'distance'.
   * // For example, get the size of a pixel of an image on a billboard.
   * var position = camera.position;
   * var direction = camera.direction;
   * var toCenter = Vector3.subtract(primitive.boundingVolume.center, position, new Vector3());      // vector from camera to a primitive
   * var toCenterProj = Vector3.multiplyByScalar(direction, Vector3.dot(direction, toCenter), new Vector3()); // project vector onto camera direction vector
   * var distance = Vector3.magnitude(toCenterProj);
   * var pixelSize = camera.this.getPixelDimensions(scene.drawingBufferWidth, scene.drawingBufferHeight, distance, new Vector2());
   */
  getPixelDimensions(t, n, r, s) {
    return this._update(), this._offCenterFrustum.getPixelDimensions(t, n, r, s || new _r());
  }
  // eslint-disable-next-line complexity, max-statements
  _update() {
    et(Number.isFinite(this.fov) && Number.isFinite(this.aspectRatio) && Number.isFinite(this.near) && Number.isFinite(this.far));
    const t = this._offCenterFrustum;
    (this.fov !== this._fov || this.aspectRatio !== this._aspectRatio || this.near !== this._near || this.far !== this._far || this.xOffset !== this._xOffset || this.yOffset !== this._yOffset) && (et(this.fov >= 0 && this.fov < Math.PI), et(this.aspectRatio > 0), et(this.near >= 0 && this.near < this.far), this._aspectRatio = this.aspectRatio, this._fov = this.fov, this._fovy = this.aspectRatio <= 1 ? this.fov : Math.atan(Math.tan(this.fov * 0.5) / this.aspectRatio) * 2, this._near = this.near, this._far = this.far, this._sseDenominator = 2 * Math.tan(0.5 * this._fovy), this._xOffset = this.xOffset, this._yOffset = this.yOffset, t.top = this.near * Math.tan(0.5 * this._fovy), t.bottom = -t.top, t.right = this.aspectRatio * t.top, t.left = -t.right, t.near = this.near, t.far = this.far, t.right += this.xOffset, t.left += this.xOffset, t.top += this.yOffset, t.bottom += this.yOffset);
  }
}
new T();
new T();
new T();
new T();
new T();
new T();
new T();
new T();
new T();
new T();
new T();
new T();
const Yt = new lt(), o0 = new lt(), a0 = new lt(), Vn = new lt(), ho = new lt();
function c0(e, t = {}) {
  const n = Mm, r = 10;
  let s = 0, i = 0;
  const o = o0, a = a0;
  o.identity(), a.copy(e);
  const c = n * u0(a);
  for (; i < r && h0(a) > c; )
    l0(a, Vn), ho.copy(Vn).transpose(), a.multiplyRight(Vn), a.multiplyLeft(ho), o.multiplyRight(Vn), ++s > 2 && (++i, s = 0);
  return t.unitary = o.toTarget(t.unitary), t.diagonal = a.toTarget(t.diagonal), t;
}
function u0(e) {
  let t = 0;
  for (let n = 0; n < 9; ++n) {
    const r = e[n];
    t += r * r;
  }
  return Math.sqrt(t);
}
const Rs = [1, 0, 0], Ss = [2, 2, 1];
function h0(e) {
  let t = 0;
  for (let n = 0; n < 3; ++n) {
    const r = e[Yt.getElementIndex(Ss[n], Rs[n])];
    t += 2 * r * r;
  }
  return Math.sqrt(t);
}
function l0(e, t) {
  const n = Ec;
  let r = 0, s = 1;
  for (let h = 0; h < 3; ++h) {
    const f = Math.abs(e[Yt.getElementIndex(Ss[h], Rs[h])]);
    f > r && (s = h, r = f);
  }
  const i = Rs[s], o = Ss[s];
  let a = 1, c = 0;
  if (Math.abs(e[Yt.getElementIndex(o, i)]) > n) {
    const h = e[Yt.getElementIndex(o, o)], f = e[Yt.getElementIndex(i, i)], d = e[Yt.getElementIndex(o, i)], p = (h - f) / 2 / d;
    let g;
    p < 0 ? g = -1 / (-p + Math.sqrt(1 + p * p)) : g = 1 / (p + Math.sqrt(1 + p * p)), a = 1 / Math.sqrt(1 + g * g), c = g * a;
  }
  return lt.IDENTITY.to(t), t[Yt.getElementIndex(i, i)] = t[Yt.getElementIndex(o, o)] = a, t[Yt.getElementIndex(o, i)] = c, t[Yt.getElementIndex(i, o)] = -c, t;
}
const me = new T(), f0 = new T(), d0 = new T(), m0 = new T(), p0 = new T(), g0 = new lt(), A0 = {
  diagonal: new lt(),
  unitary: new lt()
};
function y0(e, t = new _n()) {
  if (!e || e.length === 0)
    return t.halfAxes = new lt([0, 0, 0, 0, 0, 0, 0, 0, 0]), t.center = new T(), t;
  const n = e.length, r = new T(0, 0, 0);
  for (const P of e)
    r.add(P);
  const s = 1 / n;
  r.multiplyByScalar(s);
  let i = 0, o = 0, a = 0, c = 0, h = 0, f = 0;
  for (const P of e) {
    const J = me.copy(P).subtract(r);
    i += J.x * J.x, o += J.x * J.y, a += J.x * J.z, c += J.y * J.y, h += J.y * J.z, f += J.z * J.z;
  }
  i *= s, o *= s, a *= s, c *= s, h *= s, f *= s;
  const d = g0;
  d[0] = i, d[1] = o, d[2] = a, d[3] = o, d[4] = c, d[5] = h, d[6] = a, d[7] = h, d[8] = f;
  const { unitary: p } = c0(d, A0), g = t.halfAxes.copy(p);
  let B = g.getColumn(0, d0), C = g.getColumn(1, m0), b = g.getColumn(2, p0), M = -Number.MAX_VALUE, D = -Number.MAX_VALUE, _ = -Number.MAX_VALUE, x = Number.MAX_VALUE, L = Number.MAX_VALUE, S = Number.MAX_VALUE;
  for (const P of e)
    me.copy(P), M = Math.max(me.dot(B), M), D = Math.max(me.dot(C), D), _ = Math.max(me.dot(b), _), x = Math.min(me.dot(B), x), L = Math.min(me.dot(C), L), S = Math.min(me.dot(b), S);
  B = B.multiplyByScalar(0.5 * (x + M)), C = C.multiplyByScalar(0.5 * (L + D)), b = b.multiplyByScalar(0.5 * (S + _)), t.center.copy(B).add(C).add(b);
  const G = f0.set(M - x, D - L, _ - S).multiplyByScalar(0.5), v = new lt([G[0], 0, 0, 0, G[1], 0, 0, 0, G[2]]);
  return t.halfAxes.multiplyRight(v), t;
}
const lo = new T(), Xr = new T(), Fs = new Ft([
  new Et(),
  new Et(),
  new Et(),
  new Et(),
  new Et(),
  new Et()
]);
function B0(e, t) {
  const { cameraDirection: n, cameraUp: r, height: s } = e, { metersPerUnit: i } = e.distanceScales, o = er(e, e.center), a = q.WGS84.eastNorthUpToFixedFrame(o), c = e.unprojectPosition(e.cameraPosition), h = q.WGS84.cartographicToCartesian(c, new T()), f = new T(
    // @ts-ignore
    a.transformAsVector(new T(n).scale(i))
  ).normalize(), d = new T(
    // @ts-ignore
    a.transformAsVector(new T(r).scale(i))
  ).normalize();
  C0(e);
  const p = e.constructor, { longitude: g, latitude: B, width: C, bearing: b, zoom: M } = e, D = new p({
    longitude: g,
    latitude: B,
    height: s,
    width: C,
    bearing: b,
    zoom: M,
    pitch: 0
  });
  return {
    camera: {
      position: h,
      direction: f,
      up: d
    },
    viewport: e,
    topDownViewport: D,
    height: s,
    cullingVolume: Fs,
    frameNumber: t,
    // TODO: This can be the same between updates, what number is unique for between updates?
    sseDenominator: 1.15
    // Assumes fovy = 60 degrees
  };
}
function E0(e, t, n) {
  if (n === 0 || e.length <= n)
    return [e, []];
  const r = [], { longitude: s, latitude: i } = t.viewport;
  for (const [h, f] of e.entries()) {
    const [d, p] = f.header.mbs, g = Math.abs(s - d), B = Math.abs(i - p), C = Math.sqrt(B * B + g * g);
    r.push([h, C]);
  }
  const o = r.sort((h, f) => h[1] - f[1]), a = [];
  for (let h = 0; h < n; h++)
    a.push(e[o[h][0]]);
  const c = [];
  for (let h = n; h < o.length; h++)
    c.push(e[o[h][0]]);
  return [a, c];
}
function C0(e) {
  const t = e.getFrustumPlanes(), n = fo(t.near, e.cameraPosition), r = er(e, n), s = er(e, e.cameraPosition, Xr);
  let i = 0;
  Fs.planes[i++].fromPointNormal(r, lo.copy(r).subtract(s));
  for (const o in t) {
    if (o === "near")
      continue;
    const a = t[o], c = fo(a, n, Xr), h = er(e, c, Xr);
    Fs.planes[i++].fromPointNormal(
      h,
      // Want the normal to point into the frustum since that's what culling expects
      lo.copy(r).subtract(h)
    );
  }
}
function fo(e, t, n = new T()) {
  const r = e.normal.dot(t);
  return n.copy(e.normal).scale(e.distance - r).add(t), n;
}
function er(e, t, n = new T()) {
  const r = e.unprojectPosition(t);
  return q.WGS84.cartographicToCartesian(r, n);
}
const T0 = 6378137, w0 = 6378137, Os = 6356752314245179e-9, Ve = new T();
function b0(e, t) {
  if (e instanceof _n) {
    const { halfAxes: n } = e, r = I0(n);
    return Math.log2(Os / (r + t[2]));
  } else if (e instanceof bn) {
    const { radius: n } = e;
    return Math.log2(Os / (n + t[2]));
  } else if (e.width && e.height) {
    const { width: n, height: r } = e, s = Math.log2(T0 / n), i = Math.log2(w0 / r);
    return (s + i) / 2;
  }
  return 1;
}
function Cc(e, t, n) {
  q.WGS84.cartographicToCartesian([e.xmax, e.ymax, e.zmax], Ve);
  const r = Math.sqrt(Math.pow(Ve[0] - n[0], 2) + Math.pow(Ve[1] - n[1], 2) + Math.pow(Ve[2] - n[2], 2));
  return Math.log2(Os / (r + t[2]));
}
function _0(e, t, n) {
  const [r, s, i, o] = e;
  return Cc({ xmax: i, ymax: o, zmax: 0 }, t, n);
}
function I0(e) {
  e.getColumn(0, Ve);
  const t = e.getColumn(1), n = e.getColumn(2);
  return Ve.add(t).add(n).len();
}
const xt = {
  UNLOADED: 0,
  // Has never been requested
  LOADING: 1,
  // Is waiting on a pending request
  PROCESSING: 2,
  // Request received.  Contents are being processed for rendering.  Depending on the content, it might make its own requests for external data.
  READY: 3,
  // Ready to render.
  EXPIRED: 4,
  // Is expired and will be unloaded once new content is loaded.
  FAILED: 5
  // Request failed.
};
var Qt;
(function(e) {
  e[e.ADD = 1] = "ADD", e[e.REPLACE = 2] = "REPLACE";
})(Qt || (Qt = {}));
var ue;
(function(e) {
  e.EMPTY = "empty", e.SCENEGRAPH = "scenegraph", e.POINTCLOUD = "pointcloud", e.MESH = "mesh";
})(ue || (ue = {}));
var Rt;
(function(e) {
  e.I3S = "I3S", e.TILES3D = "TILES3D";
})(Rt || (Rt = {}));
var $e;
(function(e) {
  e.GEOMETRIC_ERROR = "geometricError", e.MAX_SCREEN_THRESHOLD = "maxScreenThreshold";
})($e || ($e = {}));
const x0 = {
  USE_OPTIMIZATION: 1
};
function Tc(e) {
  return e != null;
}
const wt = new T(), nr = new T(), M0 = new T(), R0 = new T(), Ee = new T(), mo = new T(), po = new T(), go = new T();
function qr(e, t, n) {
  if ($(e, "3D Tile: boundingVolume must be defined"), e.box)
    return wc(e.box, t, n);
  if (e.region)
    return O0(e.region);
  if (e.sphere)
    return F0(e.sphere, t, n);
  throw new Error("3D Tile: boundingVolume must contain a sphere, region, or box");
}
function S0(e, t) {
  if (e.box)
    return D0(t);
  if (e.region) {
    const [n, r, s, i, o, a] = e.region;
    return [
      [Kt(n), Kt(r), o],
      [Kt(s), Kt(i), a]
    ];
  }
  if (e.sphere)
    return L0(t);
  throw new Error("Unkown boundingVolume type");
}
function wc(e, t, n) {
  const r = new T(e[0], e[1], e[2]);
  t.transform(r, r);
  let s = [];
  if (e.length === 10) {
    const h = e.slice(3, 6), f = new ur();
    f.fromArray(e, 6);
    const d = new T([1, 0, 0]), p = new T([0, 1, 0]), g = new T([0, 0, 1]);
    d.transformByQuaternion(f), d.scale(h[0]), p.transformByQuaternion(f), p.scale(h[1]), g.transformByQuaternion(f), g.scale(h[2]), s = [...d.toArray(), ...p.toArray(), ...g.toArray()];
  } else
    s = [...e.slice(3, 6), ...e.slice(6, 9), ...e.slice(9, 12)];
  const i = t.transformAsVector(s.slice(0, 3)), o = t.transformAsVector(s.slice(3, 6)), a = t.transformAsVector(s.slice(6, 9)), c = new lt([
    i[0],
    i[1],
    i[2],
    o[0],
    o[1],
    o[2],
    a[0],
    a[1],
    a[2]
  ]);
  return Tc(n) ? (n.center = r, n.halfAxes = c, n) : new _n(r, c);
}
function F0(e, t, n) {
  const r = new T(e[0], e[1], e[2]);
  t.transform(r, r);
  const s = t.getScale(nr), i = Math.max(Math.max(s[0], s[1]), s[2]), o = e[3] * i;
  return Tc(n) ? (n.center = r, n.radius = o, n) : new bn(r, o);
}
function O0(e) {
  const [t, n, r, s, i, o] = e, a = q.WGS84.cartographicToCartesian([Kt(t), Kt(s), i], M0), c = q.WGS84.cartographicToCartesian([Kt(r), Kt(n), o], R0), h = new T().addVectors(a, c).multiplyByScalar(0.5);
  return q.WGS84.cartesianToCartographic(h, Ee), q.WGS84.cartographicToCartesian([Kt(r), Ee[1], Ee[2]], mo), q.WGS84.cartographicToCartesian([Ee[0], Kt(s), Ee[2]], po), q.WGS84.cartographicToCartesian([Ee[0], Ee[1], o], go), wc([
    ...h,
    ...mo.subtract(h),
    ...po.subtract(h),
    ...go.subtract(h)
  ], new Z());
}
function D0(e) {
  const t = bc(), { halfAxes: n } = e, r = new T(n.getColumn(0)), s = new T(n.getColumn(1)), i = new T(n.getColumn(2));
  for (let o = 0; o < 2; o++) {
    for (let a = 0; a < 2; a++) {
      for (let c = 0; c < 2; c++)
        wt.copy(e.center), wt.add(r), wt.add(s), wt.add(i), _c(t, wt), i.negate();
      s.negate();
    }
    r.negate();
  }
  return t;
}
function L0(e) {
  const t = bc(), { center: n, radius: r } = e, s = q.WGS84.scaleToGeodeticSurface(n, wt);
  let i;
  s ? i = q.WGS84.geodeticSurfaceNormal(s) : i = new T(0, 0, 1);
  let o = new T(i[2], -i[1], 0);
  o.len() > 0 ? o.normalize() : o = new T(0, 1, 0);
  const a = o.clone().cross(i);
  for (const c of [o, a, i]) {
    nr.copy(c).scale(r);
    for (let h = 0; h < 2; h++)
      wt.copy(n), wt.add(nr), _c(t, wt), nr.negate();
  }
  return t;
}
function bc() {
  return [
    [1 / 0, 1 / 0, 1 / 0],
    [-1 / 0, -1 / 0, -1 / 0]
  ];
}
function _c(e, t) {
  q.WGS84.cartesianToCartographic(t, wt), e[0][0] = Math.min(e[0][0], wt[0]), e[0][1] = Math.min(e[0][1], wt[1]), e[0][2] = Math.min(e[0][2], wt[2]), e[1][0] = Math.max(e[1][0], wt[0]), e[1][1] = Math.max(e[1][1], wt[1]), e[1][2] = Math.max(e[1][2], wt[2]);
}
new T();
new T();
new Z();
new T();
new T();
new T();
function U0(e, t) {
  const n = e * t;
  return 1 - Math.exp(-(n * n));
}
function N0(e, t) {
  if (e.dynamicScreenSpaceError && e.dynamicScreenSpaceErrorComputedDensity) {
    const n = e.dynamicScreenSpaceErrorComputedDensity, r = e.dynamicScreenSpaceErrorFactor;
    return U0(t, n) * r;
  }
  return 0;
}
function P0(e, t, n) {
  const r = e.tileset, s = e.parent && e.parent.lodMetricValue || e.lodMetricValue, i = n ? s : e.lodMetricValue;
  if (i === 0)
    return 0;
  const o = Math.max(e._distanceToCamera, 1e-7), { height: a, sseDenominator: c } = t, { viewDistanceScale: h } = r.options;
  let f = i * a * (h || 1) / (o * c);
  return f -= N0(r, o), f;
}
const Yr = new T(), Ao = new T(), pe = new T(), yo = new T(), G0 = new T(), Zr = new Z(), Bo = new Z();
function v0(e, t) {
  if (e.lodMetricValue === 0 || isNaN(e.lodMetricValue))
    return "DIG";
  const n = 2 * Ic(e, t);
  return n < 2 ? "OUT" : !e.header.children || n <= e.lodMetricValue ? "DRAW" : e.header.children ? "DIG" : "OUT";
}
function Ic(e, t) {
  const { topDownViewport: n } = t, r = e.header.mbs[1], s = e.header.mbs[0], i = e.header.mbs[2], o = e.header.mbs[3], a = [...e.boundingVolume.center], c = n.unprojectPosition(n.cameraPosition);
  q.WGS84.cartographicToCartesian(c, Yr), Ao.copy(Yr).subtract(a).normalize(), q.WGS84.eastNorthUpToFixedFrame(a, Zr), Bo.copy(Zr).invert(), pe.copy(Yr).transform(Bo);
  const h = Math.sqrt(pe[0] * pe[0] + pe[1] * pe[1]), f = h * h / pe[2];
  yo.copy([pe[0], pe[1], f]);
  const p = yo.transform(Zr).subtract(a).normalize(), B = Ao.cross(p).normalize().scale(o).add(a), C = q.WGS84.cartesianToCartographic(B), b = n.project([s, r, i]), M = n.project(C);
  return G0.copy(b).subtract(M).magnitude();
}
function H0(e) {
  return {
    assetGltfUpAxis: e.asset && e.asset.gltfUpAxis || "Y"
  };
}
class Eo {
  constructor(t = 0) {
    y(this, "_map", /* @__PURE__ */ new Map());
    y(this, "_array");
    y(this, "_length");
    this._array = new Array(t), this._length = t;
  }
  /**
   * Gets or sets the length of the array.
   * If the set length is greater than the length of the internal array, the internal array is resized.
   *
   * @memberof ManagedArray.prototype
   * @type Number
   */
  get length() {
    return this._length;
  }
  set length(t) {
    this._length = t, t > this._array.length && (this._array.length = t);
  }
  /**
   * Gets the internal array.
   *
   * @memberof ManagedArray.prototype
   * @type Array
   * @readonly
   */
  get values() {
    return this._array;
  }
  /**
   * Gets the element at an index.
   *
   * @param {Number} index The index to get.
   */
  get(t) {
    return $(t < this._array.length), this._array[t];
  }
  /**
   * Sets the element at an index. Resizes the array if index is greater than the length of the array.
   *
   * @param {Number} index The index to set.
   * @param {*} element The element to set at index.
   */
  set(t, n) {
    $(t >= 0), t >= this.length && (this.length = t + 1), this._map.has(this._array[t]) && this._map.delete(this._array[t]), this._array[t] = n, this._map.set(n, t);
  }
  delete(t) {
    const n = this._map.get(t);
    n >= 0 && (this._array.splice(n, 1), this._map.delete(t), this.length--);
  }
  /**
   * Returns the last element in the array without modifying the array.
   *
   * @returns {*} The last element in the array.
   */
  peek() {
    return this._array[this._length - 1];
  }
  /**
   * Push an element into the array.
   *
   * @param {*} element The element to push.
   */
  push(t) {
    if (!this._map.has(t)) {
      const n = this.length++;
      this._array[n] = t, this._map.set(t, n);
    }
  }
  /**
   * Pop an element from the array.
   *
   * @returns {*} The last element in the array.
   */
  pop() {
    const t = this._array[--this.length];
    return this._map.delete(t), t;
  }
  /**
   * Resize the internal array if length > _array.length.
   *
   * @param {Number} length The length.
   */
  reserve(t) {
    $(t >= 0), t > this._array.length && (this._array.length = t);
  }
  /**
   * Resize the array.
   *
   * @param {Number} length The length.
   */
  resize(t) {
    $(t >= 0), this.length = t;
  }
  /**
   * Trim the internal array to the specified length. Defaults to the current length.
   *
   * @param {Number} [length] The length.
   */
  trim(t) {
    t == null && (t = this.length), this._array.length = t;
  }
  reset() {
    this._array = [], this._map = /* @__PURE__ */ new Map(), this._length = 0;
  }
  find(t) {
    return this._map.has(t);
  }
}
const J0 = {
  loadSiblings: !1,
  skipLevelOfDetail: !1,
  updateTransforms: !0,
  onTraversalEnd: () => {
  },
  viewportTraversersMap: {},
  basePath: ""
};
class xr {
  // TODO nested props
  constructor(t) {
    y(this, "options");
    // fulfill in traverse call
    y(this, "root", null);
    // tiles should be rendered
    y(this, "selectedTiles", {});
    // tiles should be loaded from server
    y(this, "requestedTiles", {});
    // tiles does not have render content
    y(this, "emptyTiles", {});
    y(this, "lastUpdate", (/* @__PURE__ */ new Date()).getTime());
    y(this, "updateDebounceTime", 1e3);
    /** temporary storage to hold the traversed tiles during a traversal */
    y(this, "_traversalStack", new Eo());
    y(this, "_emptyTraversalStack", new Eo());
    /** set in every traverse cycle */
    y(this, "_frameNumber", null);
    this.options = { ...J0, ...t };
  }
  // RESULT
  traversalFinished(t) {
    return !0;
  }
  // tiles should be visible
  traverse(t, n, r) {
    this.root = t, this.options = { ...this.options, ...r }, this.reset(), this.updateTile(t, n), this._frameNumber = n.frameNumber, this.executeTraversal(t, n);
  }
  reset() {
    this.requestedTiles = {}, this.selectedTiles = {}, this.emptyTiles = {}, this._traversalStack.reset(), this._emptyTraversalStack.reset();
  }
  /**
   * Execute traverse
   * Depth-first traversal that traverses all visible tiles and marks tiles for selection.
   * If skipLevelOfDetail is off then a tile does not refine until all children are loaded.
   * This is the traditional replacement refinement approach and is called the base traversal.
   * Tiles that have a greater screen space error than the base screen space error are part of the base traversal,
   * all other tiles are part of the skip traversal. The skip traversal allows for skipping levels of the tree
   * and rendering children and parent tiles simultaneously.
   */
  /* eslint-disable-next-line complexity, max-statements */
  executeTraversal(t, n) {
    const r = this._traversalStack;
    for (t._selectionDepth = 1, r.push(t); r.length > 0; ) {
      const i = r.pop();
      let o = !1;
      this.canTraverse(i, n) && (this.updateChildTiles(i, n), o = this.updateAndPushChildren(i, n, r, i.hasRenderContent ? i._selectionDepth + 1 : i._selectionDepth));
      const a = i.parent, c = !!(!a || a._shouldRefine), h = !o;
      i.hasRenderContent ? i.refine === Qt.ADD ? (this.loadTile(i, n), this.selectTile(i, n)) : i.refine === Qt.REPLACE && (this.loadTile(i, n), h && this.selectTile(i, n)) : (this.emptyTiles[i.id] = i, this.loadTile(i, n), h && this.selectTile(i, n)), this.touchTile(i, n), i._shouldRefine = o && c;
    }
    const s = (/* @__PURE__ */ new Date()).getTime();
    (this.traversalFinished(n) || s - this.lastUpdate > this.updateDebounceTime) && (this.lastUpdate = s, this.options.onTraversalEnd(n));
  }
  updateChildTiles(t, n) {
    const r = t.children;
    for (const s of r)
      this.updateTile(s, n);
  }
  /* eslint-disable complexity, max-statements */
  updateAndPushChildren(t, n, r, s) {
    const { loadSiblings: i, skipLevelOfDetail: o } = this.options, a = t.children;
    a.sort(this.compareDistanceToCamera.bind(this));
    const c = t.refine === Qt.REPLACE && t.hasRenderContent && !o;
    let h = !1, f = !0;
    for (const d of a)
      if (d._selectionDepth = s, d.isVisibleAndInRequestVolume ? (r.find(d) && r.delete(d), r.push(d), h = !0) : (c || i) && (this.loadTile(d, n), this.touchTile(d, n)), c) {
        let p;
        if (d._inRequestVolume ? d.hasRenderContent ? p = d.contentAvailable : p = this.executeEmptyTraversal(d, n) : p = !1, f = f && p, !f)
          return !1;
      }
    return h || (f = !1), f;
  }
  /* eslint-enable complexity, max-statements */
  updateTile(t, n) {
    this.updateTileVisibility(t, n);
  }
  // tile to render in the browser
  selectTile(t, n) {
    this.shouldSelectTile(t) && (t._selectedFrame = n.frameNumber, this.selectedTiles[t.id] = t);
  }
  // tile to load from server
  loadTile(t, n) {
    this.shouldLoadTile(t) && (t._requestedFrame = n.frameNumber, t._priority = t._getPriority(), this.requestedTiles[t.id] = t);
  }
  // cache tile
  touchTile(t, n) {
    t.tileset._cache.touch(t), t._touchedFrame = n.frameNumber;
  }
  // tile should be visible
  // tile should have children
  // tile LoD (level of detail) is not sufficient under current viewport
  canTraverse(t, n) {
    return t.hasChildren ? t.hasTilesetContent ? !t.contentExpired : this.shouldRefine(t, n) : !1;
  }
  shouldLoadTile(t) {
    return t.hasUnloadedContent || t.contentExpired;
  }
  shouldSelectTile(t) {
    return t.contentAvailable && !this.options.skipLevelOfDetail;
  }
  /** Decide if tile LoD (level of detail) is not sufficient under current viewport */
  shouldRefine(t, n, r = !1) {
    let s = t._screenSpaceError;
    return r && (s = t.getScreenSpaceError(n, !0)), s > t.tileset.memoryAdjustedScreenSpaceError;
  }
  updateTileVisibility(t, n) {
    const r = [];
    if (this.options.viewportTraversersMap)
      for (const s in this.options.viewportTraversersMap)
        this.options.viewportTraversersMap[s] === n.viewport.id && r.push(s);
    else
      r.push(n.viewport.id);
    t.updateVisibility(n, r);
  }
  // UTILITIES
  compareDistanceToCamera(t, n) {
    return t._distanceToCamera - n._distanceToCamera;
  }
  anyChildrenVisible(t, n) {
    let r = !1;
    for (const s of t.children)
      s.updateVisibility(n), r = r || s.isVisibleAndInRequestVolume;
    return r;
  }
  // Depth-first traversal that checks if all nearest descendants with content are loaded.
  // Ignores visibility.
  executeEmptyTraversal(t, n) {
    let r = !0;
    const s = this._emptyTraversalStack;
    for (s.push(t); s.length > 0; ) {
      const i = s.pop(), o = !i.hasRenderContent && this.canTraverse(i, n), a = !i.hasRenderContent && i.children.length === 0;
      if (!o && !i.contentAvailable && !a && (r = !1), this.updateTile(i, n), i.isVisibleAndInRequestVolume || (this.loadTile(i, n), this.touchTile(i, n)), o) {
        const c = i.children;
        for (const h of c)
          s.push(h);
      }
    }
    return r;
  }
}
const Co = new T();
function k0(e) {
  return e != null;
}
class Ds {
  // TODO i3s specific, needs to remove
  /**
   * @constructs
   * Create a Tile3D instance
   * @param tileset - Tileset3D instance
   * @param header - tile header - JSON loaded from a dataset
   * @param parentHeader - parent Tile3D instance
   * @param extendedId - optional ID to separate copies of a tile for different viewports.
   *    const extendedId = `${tile.id}-${frameState.viewport.id}`;
   */
  // eslint-disable-next-line max-statements
  constructor(t, n, r, s = "") {
    y(this, "tileset");
    y(this, "header");
    y(this, "id");
    y(this, "url");
    y(this, "parent");
    /* Specifies the type of refine that is used when traversing this tile for rendering. */
    y(this, "refine");
    y(this, "type");
    y(this, "contentUrl");
    /** Different refinement algorithms used by I3S and 3D tiles */
    y(this, "lodMetricType", "geometricError");
    /** The error, in meters, introduced if this tile is rendered and its children are not. */
    y(this, "lodMetricValue", 0);
    /** @todo math.gl is not exporting BoundingVolume base type? */
    y(this, "boundingVolume", null);
    /**
     * The tile's content.  This represents the actual tile's payload,
     * not the content's metadata in the tileset JSON file.
     */
    y(this, "content", null);
    y(this, "contentState", xt.UNLOADED);
    y(this, "gpuMemoryUsageInBytes", 0);
    /** The tile's children - an array of Tile3D objects. */
    y(this, "children", []);
    y(this, "depth", 0);
    y(this, "viewportIds", []);
    y(this, "transform", new Z());
    y(this, "extensions", null);
    /** TODO Cesium 3d tiles specific */
    y(this, "implicitTiling", null);
    /** Container to store application specific data */
    y(this, "userData", {});
    y(this, "computedTransform");
    y(this, "hasEmptyContent", !1);
    y(this, "hasTilesetContent", !1);
    y(this, "traverser", new xr({}));
    /** Used by TilesetCache */
    y(this, "_cacheNode", null);
    y(this, "_frameNumber", null);
    // TODO Cesium 3d tiles specific
    y(this, "_expireDate", null);
    y(this, "_expiredContent", null);
    y(this, "_boundingBox");
    /** updated every frame for tree traversal and rendering optimizations: */
    y(this, "_distanceToCamera", 0);
    y(this, "_screenSpaceError", 0);
    y(this, "_visibilityPlaneMask");
    y(this, "_visible");
    y(this, "_contentBoundingVolume");
    y(this, "_viewerRequestVolume");
    y(this, "_initialTransform", new Z());
    // Used by traverser, cannot be marked private
    y(this, "_priority", 0);
    y(this, "_selectedFrame", 0);
    y(this, "_requestedFrame", 0);
    y(this, "_selectionDepth", 0);
    y(this, "_touchedFrame", 0);
    y(this, "_centerZDepth", 0);
    y(this, "_shouldRefine", !1);
    y(this, "_stackLength", 0);
    y(this, "_visitedFrame", 0);
    y(this, "_inRequestVolume", !1);
    y(this, "_lodJudge", null);
    this.header = n, this.tileset = t, this.id = s || n.id, this.url = n.url, this.parent = r, this.refine = this._getRefine(n.refine), this.type = n.type, this.contentUrl = n.contentUrl, this._initializeLodMetric(n), this._initializeTransforms(n), this._initializeBoundingVolumes(n), this._initializeContent(n), this._initializeRenderingState(n), Object.seal(this);
  }
  destroy() {
    this.header = null;
  }
  isDestroyed() {
    return this.header === null;
  }
  get selected() {
    return this._selectedFrame === this.tileset._frameNumber;
  }
  get isVisible() {
    return this._visible;
  }
  get isVisibleAndInRequestVolume() {
    return this._visible && this._inRequestVolume;
  }
  /** Returns true if tile is not an empty tile and not an external tileset */
  get hasRenderContent() {
    return !this.hasEmptyContent && !this.hasTilesetContent;
  }
  /** Returns true if tile has children */
  get hasChildren() {
    return this.children.length > 0 || this.header.children && this.header.children.length > 0;
  }
  /**
   * Determines if the tile's content is ready. This is automatically `true` for
   * tiles with empty content.
   */
  get contentReady() {
    return this.contentState === xt.READY || this.hasEmptyContent;
  }
  /**
   * Determines if the tile has available content to render.  `true` if the tile's
   * content is ready or if it has expired content this renders while new content loads; otherwise,
   */
  get contentAvailable() {
    return !!(this.contentReady && this.hasRenderContent || this._expiredContent && !this.contentFailed);
  }
  /** Returns true if tile has renderable content but it's unloaded */
  get hasUnloadedContent() {
    return this.hasRenderContent && this.contentUnloaded;
  }
  /**
   * Determines if the tile's content has not be requested. `true` if tile's
   * content has not be requested; otherwise, `false`.
   */
  get contentUnloaded() {
    return this.contentState === xt.UNLOADED;
  }
  /**
   * Determines if the tile's content is expired. `true` if tile's
   * content is expired; otherwise, `false`.
   */
  get contentExpired() {
    return this.contentState === xt.EXPIRED;
  }
  // Determines if the tile's content failed to load.  `true` if the tile's
  // content failed to load; otherwise, `false`.
  get contentFailed() {
    return this.contentState === xt.FAILED;
  }
  /**
   * Distance from the tile's bounding volume center to the camera
   */
  get distanceToCamera() {
    return this._distanceToCamera;
  }
  /**
   * Screen space error for LOD selection
   */
  get screenSpaceError() {
    return this._screenSpaceError;
  }
  /**
   * Get bounding box in cartographic coordinates
   * @returns [min, max] each in [longitude, latitude, altitude]
   */
  get boundingBox() {
    return this._boundingBox || (this._boundingBox = S0(this.header.boundingVolume, this.boundingVolume)), this._boundingBox;
  }
  /** Get the tile's screen space error. */
  getScreenSpaceError(t, n) {
    switch (this.tileset.type) {
      case Rt.I3S:
        return Ic(this, t);
      case Rt.TILES3D:
        return P0(this, t, n);
      default:
        throw new Error("Unsupported tileset type");
    }
  }
  /**
   * Make tile unselected than means it won't be shown
   * but it can be still loaded in memory
   */
  unselect() {
    this._selectedFrame = 0;
  }
  /**
   * Memory usage of tile on GPU
   */
  _getGpuMemoryUsageInBytes() {
    return this.content.gpuMemoryUsageInBytes || this.content.byteLength || 0;
  }
  /*
   * If skipLevelOfDetail is off try to load child tiles as soon as possible so that their parent can refine sooner.
   * Tiles are prioritized by screen space error.
   */
  // eslint-disable-next-line complexity
  _getPriority() {
    const t = this.tileset._traverser, { skipLevelOfDetail: n } = t.options, r = this.refine === Qt.ADD || n;
    if (r && !this.isVisible && this._visible !== void 0 || this.tileset._frameNumber - this._touchedFrame >= 1 || this.contentState === xt.UNLOADED)
      return -1;
    const s = this.parent, o = s && (!r || this._screenSpaceError === 0 || s.hasTilesetContent) ? s._screenSpaceError : this._screenSpaceError, a = t.root ? t.root._screenSpaceError : 0;
    return Math.max(a - o, 0);
  }
  /**
   *  Requests the tile's content.
   * The request may not be made if the Request Scheduler can't prioritize it.
   */
  // eslint-disable-next-line max-statements, complexity
  async loadContent() {
    if (this.hasEmptyContent)
      return !1;
    if (this.content)
      return !0;
    this.contentExpired && (this._expireDate = null), this.contentState = xt.LOADING;
    const n = await this.tileset._requestScheduler.scheduleRequest(this.id, this._getPriority.bind(this));
    if (!n)
      return this.contentState = xt.UNLOADED, !1;
    try {
      const r = this.tileset.getTileUrl(this.contentUrl), s = this.tileset.loader, i = {
        ...this.tileset.loadOptions,
        [s.id]: {
          // @ts-expect-error
          ...this.tileset.loadOptions[s.id],
          isTileset: this.type === "json",
          ...this._getLoaderSpecificOptions(s.id)
        }
      };
      return this.content = await Qe(r, s, i), this.tileset.options.contentLoader && await this.tileset.options.contentLoader(this), this._isTileset() && this.tileset._initializeTileHeaders(this.content, this), this.contentState = xt.READY, this._onContentLoaded(), !0;
    } catch (r) {
      throw this.contentState = xt.FAILED, r;
    } finally {
      n.done();
    }
  }
  // Unloads the tile's content.
  unloadContent() {
    return this.content && this.content.destroy && this.content.destroy(), this.content = null, this.header.content && this.header.content.destroy && this.header.content.destroy(), this.header.content = null, this.contentState = xt.UNLOADED, !0;
  }
  /**
   * Update the tile's visibility
   * @param {Object} frameState - frame state for tile culling
   * @param {string[]} viewportIds - a list of viewport ids that show this tile
   * @return {void}
   */
  updateVisibility(t, n) {
    if (this._frameNumber === t.frameNumber)
      return;
    const r = this.parent, s = r ? r._visibilityPlaneMask : Ft.MASK_INDETERMINATE;
    if (this.tileset._traverser.options.updateTransforms) {
      const i = r ? r.computedTransform : this.tileset.modelMatrix;
      this._updateTransform(i);
    }
    this._distanceToCamera = this.distanceToTile(t), this._screenSpaceError = this.getScreenSpaceError(t, !1), this._visibilityPlaneMask = this.visibility(t, s), this._visible = this._visibilityPlaneMask !== Ft.MASK_OUTSIDE, this._inRequestVolume = this.insideViewerRequestVolume(t), this._frameNumber = t.frameNumber, this.viewportIds = n;
  }
  // Determines whether the tile's bounding volume intersects the culling volume.
  // @param {FrameState} frameState The frame state.
  // @param {Number} parentVisibilityPlaneMask The parent's plane mask to speed up the visibility check.
  // @returns {Number} A plane mask as described above in {@link CullingVolume#computeVisibilityWithPlaneMask}.
  visibility(t, n) {
    const { cullingVolume: r } = t, { boundingVolume: s } = this;
    return r.computeVisibilityWithPlaneMask(s, n);
  }
  // Assuming the tile's bounding volume intersects the culling volume, determines
  // whether the tile's content's bounding volume intersects the culling volume.
  // @param {FrameState} frameState The frame state.
  // @returns {Intersect} The result of the intersection: the tile's content is completely outside, completely inside, or intersecting the culling volume.
  contentVisibility() {
    return !0;
  }
  /**
   * Computes the (potentially approximate) distance from the closest point of the tile's bounding volume to the camera.
   * @param frameState The frame state.
   * @returns {Number} The distance, in meters, or zero if the camera is inside the bounding volume.
   */
  distanceToTile(t) {
    const n = this.boundingVolume;
    return Math.sqrt(Math.max(n.distanceSquaredTo(t.camera.position), 0));
  }
  /**
   * Computes the tile's camera-space z-depth.
   * @param frameState The frame state.
   * @returns The distance, in meters.
   */
  cameraSpaceZDepth({ camera: t }) {
    const n = this.boundingVolume;
    return Co.subVectors(n.center, t.position), t.direction.dot(Co);
  }
  /**
   * Checks if the camera is inside the viewer request volume.
   * @param {FrameState} frameState The frame state.
   * @returns {Boolean} Whether the camera is inside the volume.
   */
  insideViewerRequestVolume(t) {
    const n = this._viewerRequestVolume;
    return !n || n.distanceSquaredTo(t.camera.position) <= 0;
  }
  // TODO Cesium specific
  // Update whether the tile has expired.
  updateExpiration() {
    if (k0(this._expireDate) && this.contentReady && !this.hasEmptyContent) {
      const t = Date.now();
      Date.lessThan(this._expireDate, t) && (this.contentState = xt.EXPIRED, this._expiredContent = this.content);
    }
  }
  get extras() {
    return this.header.extras;
  }
  // INTERNAL METHODS
  _initializeLodMetric(t) {
    "lodMetricType" in t ? this.lodMetricType = t.lodMetricType : (this.lodMetricType = this.parent && this.parent.lodMetricType || this.tileset.lodMetricType, console.warn("3D Tile: Required prop lodMetricType is undefined. Using parent lodMetricType")), "lodMetricValue" in t ? this.lodMetricValue = t.lodMetricValue : (this.lodMetricValue = this.parent && this.parent.lodMetricValue || this.tileset.lodMetricValue, console.warn("3D Tile: Required prop lodMetricValue is undefined. Using parent lodMetricValue"));
  }
  _initializeTransforms(t) {
    this.transform = t.transform ? new Z(t.transform) : new Z();
    const n = this.parent, r = this.tileset, s = n && n.computedTransform ? n.computedTransform.clone() : r.modelMatrix.clone();
    this.computedTransform = new Z(s).multiplyRight(this.transform);
    const i = n && n._initialTransform ? n._initialTransform.clone() : new Z();
    this._initialTransform = new Z(i).multiplyRight(this.transform);
  }
  _initializeBoundingVolumes(t) {
    this._contentBoundingVolume = null, this._viewerRequestVolume = null, this._updateBoundingVolume(t);
  }
  _initializeContent(t) {
    this.content = { _tileset: this.tileset, _tile: this }, this.hasEmptyContent = !0, this.contentState = xt.UNLOADED, this.hasTilesetContent = !1, t.contentUrl && (this.content = null, this.hasEmptyContent = !1);
  }
  // TODO - remove anything not related to basic visibility detection
  _initializeRenderingState(t) {
    this.depth = t.level || (this.parent ? this.parent.depth + 1 : 0), this._shouldRefine = !1, this._distanceToCamera = 0, this._centerZDepth = 0, this._screenSpaceError = 0, this._visibilityPlaneMask = Ft.MASK_INDETERMINATE, this._visible = void 0, this._inRequestVolume = !1, this._stackLength = 0, this._selectionDepth = 0, this._frameNumber = 0, this._touchedFrame = 0, this._visitedFrame = 0, this._selectedFrame = 0, this._requestedFrame = 0, this._priority = 0;
  }
  _getRefine(t) {
    return t || this.parent && this.parent.refine || Qt.REPLACE;
  }
  _isTileset() {
    return this.contentUrl.indexOf(".json") !== -1;
  }
  _onContentLoaded() {
    switch (this.content && this.content.type) {
      case "vctr":
      case "geom":
        this.tileset._traverser.disableSkipLevelOfDetail = !0;
        break;
    }
    this._isTileset() ? this.hasTilesetContent = !0 : this.gpuMemoryUsageInBytes = this._getGpuMemoryUsageInBytes();
  }
  _updateBoundingVolume(t) {
    this.boundingVolume = qr(t.boundingVolume, this.computedTransform, this.boundingVolume);
    const n = t.content;
    n && (n.boundingVolume && (this._contentBoundingVolume = qr(n.boundingVolume, this.computedTransform, this._contentBoundingVolume)), t.viewerRequestVolume && (this._viewerRequestVolume = qr(t.viewerRequestVolume, this.computedTransform, this._viewerRequestVolume)));
  }
  // Update the tile's transform. The transform is applied to the tile's bounding volumes.
  _updateTransform(t = new Z()) {
    const n = t.clone().multiplyRight(this.transform);
    n.equals(this.computedTransform) || (this.computedTransform = n, this._updateBoundingVolume(this.header));
  }
  // Get options which are applicable only for the particular loader
  _getLoaderSpecificOptions(t) {
    switch (t) {
      case "i3s":
        return {
          ...this.tileset.options.i3s,
          _tileOptions: {
            attributeUrls: this.header.attributeUrls,
            textureUrl: this.header.textureUrl,
            textureFormat: this.header.textureFormat,
            textureLoaderOptions: this.header.textureLoaderOptions,
            materialDefinition: this.header.materialDefinition,
            isDracoGeometry: this.header.isDracoGeometry,
            mbs: this.header.mbs
          },
          _tilesetOptions: {
            store: this.tileset.tileset.store,
            attributeStorageInfo: this.tileset.tileset.attributeStorageInfo,
            fields: this.tileset.tileset.fields
          },
          isTileHeader: !1
        };
      case "3d-tiles":
      case "cesium-ion":
      default:
        return H0(this.tileset.tileset);
    }
  }
}
class V0 extends xr {
  compareDistanceToCamera(t, n) {
    return n._distanceToCamera === 0 && t._distanceToCamera === 0 ? n._centerZDepth - t._centerZDepth : n._distanceToCamera - t._distanceToCamera;
  }
  updateTileVisibility(t, n) {
    if (super.updateTileVisibility(t, n), !t.isVisibleAndInRequestVolume)
      return;
    const r = t.children.length > 0;
    if (t.hasTilesetContent && r) {
      const o = t.children[0];
      this.updateTileVisibility(o, n), t._visible = o._visible;
      return;
    }
    if (this.meetsScreenSpaceErrorEarly(t, n)) {
      t._visible = !1;
      return;
    }
    const s = t.refine === Qt.REPLACE, i = t._optimChildrenWithinParent === x0.USE_OPTIMIZATION;
    if (s && i && r && !this.anyChildrenVisible(t, n)) {
      t._visible = !1;
      return;
    }
  }
  meetsScreenSpaceErrorEarly(t, n) {
    const { parent: r } = t;
    return !r || r.hasTilesetContent || r.refine !== Qt.ADD ? !1 : !this.shouldRefine(t, n, !0);
  }
}
class j0 {
  constructor() {
    y(this, "frameNumberMap", /* @__PURE__ */ new Map());
  }
  /**
   * Register a new pending tile header for the particular frameNumber
   * @param viewportId
   * @param frameNumber
   */
  register(t, n) {
    const r = this.frameNumberMap.get(t) || /* @__PURE__ */ new Map(), s = r.get(n) || 0;
    r.set(n, s + 1), this.frameNumberMap.set(t, r);
  }
  /**
   * Deregister a pending tile header for the particular frameNumber
   * @param viewportId
   * @param frameNumber
   */
  deregister(t, n) {
    const r = this.frameNumberMap.get(t);
    if (!r)
      return;
    const s = r.get(n) || 1;
    r.set(n, s - 1);
  }
  /**
   * Check is there are no pending tile headers registered for the particular frameNumber
   * @param viewportId
   * @param frameNumber
   * @returns
   */
  isZero(t, n) {
    var s;
    return (((s = this.frameNumberMap.get(t)) == null ? void 0 : s.get(n)) || 0) === 0;
  }
}
const ts = {
  REQUESTED: "REQUESTED",
  COMPLETED: "COMPLETED",
  ERROR: "ERROR"
};
class K0 {
  constructor() {
    y(this, "_statusMap");
    y(this, "pendingTilesRegister", new j0());
    this._statusMap = {};
  }
  /**
   * Add request to map
   * @param request - node metadata request
   * @param key - unique key
   * @param callback - callback after request completed
   * @param frameState - frameState data
   */
  add(t, n, r, s) {
    if (!this._statusMap[n]) {
      const { frameNumber: i, viewport: { id: o } } = s;
      this._statusMap[n] = { request: t, callback: r, key: n, frameState: s, status: ts.REQUESTED }, this.pendingTilesRegister.register(o, i), t().then((a) => {
        this._statusMap[n].status = ts.COMPLETED;
        const { frameNumber: c, viewport: { id: h } } = this._statusMap[n].frameState;
        this.pendingTilesRegister.deregister(h, c), this._statusMap[n].callback(a, s);
      }).catch((a) => {
        this._statusMap[n].status = ts.ERROR;
        const { frameNumber: c, viewport: { id: h } } = this._statusMap[n].frameState;
        this.pendingTilesRegister.deregister(h, c), r(a);
      });
    }
  }
  /**
   * Update request if it is still actual for the new frameState
   * @param key - unique key
   * @param frameState - frameState data
   */
  update(t, n) {
    if (this._statusMap[t]) {
      const { frameNumber: r, viewport: { id: s } } = this._statusMap[t].frameState;
      this.pendingTilesRegister.deregister(s, r);
      const { frameNumber: i, viewport: { id: o } } = n;
      this.pendingTilesRegister.register(o, i), this._statusMap[t].frameState = n;
    }
  }
  /**
   * Find request in the map
   * @param key - unique key
   * @returns
   */
  find(t) {
    return this._statusMap[t];
  }
  /**
   * Check it there are pending tile headers for the particular frameNumber
   * @param viewportId
   * @param frameNumber
   * @returns
   */
  hasPendingTiles(t, n) {
    return !this.pendingTilesRegister.isZero(t, n);
  }
}
class z0 extends xr {
  constructor(n) {
    super(n);
    y(this, "_tileManager");
    this._tileManager = new K0();
  }
  /**
   * Check if there are no penging tile header requests,
   * that means the traversal is finished and we can call
   * following-up callbacks.
   */
  traversalFinished(n) {
    return !this._tileManager.hasPendingTiles(n.viewport.id, this._frameNumber || 0);
  }
  shouldRefine(n, r) {
    return n._lodJudge = v0(n, r), n._lodJudge === "DIG";
  }
  updateChildTiles(n, r) {
    const s = n.header.children || [], i = n.children, o = n.tileset;
    for (const a of s) {
      const c = `${a.id}-${r.viewport.id}`, h = i && i.find((f) => f.id === c);
      if (h)
        h && this.updateTile(h, r);
      else {
        let f = () => this._loadTile(a.id, o);
        this._tileManager.find(c) ? this._tileManager.update(c, r) : (o.tileset.nodePages && (f = () => o.tileset.nodePagesTile.formTileFromNodePages(a.id)), this._tileManager.add(f, c, (p) => this._onTileLoad(p, n, c), r));
      }
    }
    return !1;
  }
  async _loadTile(n, r) {
    const { loader: s } = r, i = r.getTileUrl(`${r.url}/nodes/${n}`), o = {
      ...r.loadOptions,
      i3s: {
        ...r.loadOptions.i3s,
        isTileHeader: !0
      }
    };
    return await Qe(i, s, o);
  }
  /**
   * The callback to init Tile3D instance after loading the tile JSON
   * @param {Object} header - the tile JSON from a dataset
   * @param {Tile3D} tile - the parent Tile3D instance
   * @param {string} extendedId - optional ID to separate copies of a tile for different viewports.
   *                              const extendedId = `${tile.id}-${frameState.viewport.id}`;
   * @return {void}
   */
  _onTileLoad(n, r, s) {
    const i = new Ds(r.tileset, n, r, s);
    r.children.push(i);
    const o = this._tileManager.find(i.id).frameState;
    this.updateTile(i, o), this._frameNumber === o.frameNumber && (this.traversalFinished(o) || (/* @__PURE__ */ new Date()).getTime() - this.lastUpdate > this.updateDebounceTime) && this.executeTraversal(i, o);
  }
}
const W0 = {
  description: "",
  ellipsoid: q.WGS84,
  modelMatrix: new Z(),
  throttleRequests: !0,
  maxRequests: 64,
  /** Default memory values optimized for viewing mesh-based 3D Tiles on both mobile and desktop devices */
  maximumMemoryUsage: 32,
  memoryCacheOverflow: 1,
  maximumTilesSelected: 0,
  debounceTime: 0,
  onTileLoad: () => {
  },
  onTileUnload: () => {
  },
  onTileError: () => {
  },
  onTraversalComplete: (e) => e,
  contentLoader: void 0,
  viewDistanceScale: 1,
  maximumScreenSpaceError: 8,
  memoryAdjustedScreenSpaceError: !1,
  loadTiles: !0,
  updateTransforms: !0,
  viewportTraversersMap: null,
  loadOptions: { fetch: {} },
  attributions: [],
  basePath: "",
  i3s: {}
}, jn = "Tiles In Tileset(s)", es = "Tiles In Memory", To = "Tiles In View", wo = "Tiles To Render", bo = "Tiles Loaded", ns = "Tiles Loading", _o = "Tiles Unloaded", Io = "Failed Tile Loads", xo = "Points/Vertices", rs = "Tile Memory Use", Mo = "Maximum Screen Space Error";
class Q0 {
  /**
   * Create a new Tileset3D
   * @param json
   * @param props
   */
  // eslint-disable-next-line max-statements
  constructor(t, n) {
    // props: Tileset3DProps;
    y(this, "options");
    y(this, "loadOptions");
    y(this, "type");
    y(this, "tileset");
    y(this, "loader");
    y(this, "url");
    y(this, "basePath");
    y(this, "modelMatrix");
    y(this, "ellipsoid");
    y(this, "lodMetricType");
    y(this, "lodMetricValue");
    y(this, "refine");
    y(this, "root", null);
    y(this, "roots", {});
    /** @todo any->unknown */
    y(this, "asset", {});
    // Metadata for the entire tileset
    y(this, "description", "");
    y(this, "properties");
    y(this, "extras", null);
    y(this, "attributions", {});
    y(this, "credits", {});
    y(this, "stats");
    /** flags that contain information about data types in nested tiles */
    y(this, "contentFormats", { draco: !1, meshopt: !1, dds: !1, ktx2: !1 });
    // view props
    y(this, "cartographicCenter", null);
    y(this, "cartesianCenter", null);
    y(this, "zoom", 1);
    y(this, "boundingVolume", null);
    /** Updated based on the camera position and direction */
    y(this, "dynamicScreenSpaceErrorComputedDensity", 0);
    // METRICS
    /**
     * The maximum amount of GPU memory (in MB) that may be used to cache tiles
     * Tiles not in view are unloaded to enforce private
     */
    y(this, "maximumMemoryUsage", 32);
    /** The total amount of GPU memory in bytes used by the tileset. */
    y(this, "gpuMemoryUsageInBytes", 0);
    /**
     * If loading the level of detail required by maximumScreenSpaceError
     * results in the memory usage exceeding maximumMemoryUsage (GPU), level of detail refinement
     * will instead use this (larger) adjusted screen space error to achieve the
     * best possible visual quality within the available memory.
     */
    y(this, "memoryAdjustedScreenSpaceError", 0);
    y(this, "_cacheBytes", 0);
    y(this, "_cacheOverflowBytes", 0);
    /** Update tracker. increase in each update cycle. */
    y(this, "_frameNumber", 0);
    y(this, "_queryParams", {});
    y(this, "_extensionsUsed", []);
    y(this, "_tiles", {});
    /** counter for tracking tiles requests */
    y(this, "_pendingCount", 0);
    /** Hold traversal results */
    y(this, "selectedTiles", []);
    // TRAVERSAL
    y(this, "traverseCounter", 0);
    y(this, "geometricError", 0);
    y(this, "lastUpdatedVieports", null);
    y(this, "_requestedTiles", []);
    y(this, "_emptyTiles", []);
    y(this, "frameStateData", {});
    y(this, "_traverser");
    y(this, "_cache", new Wm());
    y(this, "_requestScheduler");
    // Promise tracking
    y(this, "updatePromise", null);
    y(this, "tilesetInitializationPromise");
    this.options = { ...W0, ...n }, this.tileset = t, this.loader = t.loader, this.type = t.type, this.url = t.url, this.basePath = t.basePath || ti(this.url), this.modelMatrix = this.options.modelMatrix, this.ellipsoid = this.options.ellipsoid, this.lodMetricType = t.lodMetricType, this.lodMetricValue = t.lodMetricValue, this.refine = t.root.refine, this.loadOptions = this.options.loadOptions || {}, this._traverser = this._initializeTraverser(), this._requestScheduler = new Ol({
      throttleRequests: this.options.throttleRequests,
      maxRequests: this.options.maxRequests
    }), this.memoryAdjustedScreenSpaceError = this.options.maximumScreenSpaceError, this._cacheBytes = this.options.maximumMemoryUsage * 1024 * 1024, this._cacheOverflowBytes = this.options.memoryCacheOverflow * 1024 * 1024, this.stats = new za({ id: this.url }), this._initializeStats(), this.tilesetInitializationPromise = this._initializeTileSet(t);
  }
  /** Release resources */
  destroy() {
    this._destroy();
  }
  /** Is the tileset loaded (update needs to have been called at least once) */
  isLoaded() {
    return this._pendingCount === 0 && this._frameNumber !== 0 && this._requestedTiles.length === 0;
  }
  get tiles() {
    return Object.values(this._tiles);
  }
  get frameNumber() {
    return this._frameNumber;
  }
  get queryParams() {
    return new URLSearchParams(this._queryParams).toString();
  }
  setProps(t) {
    this.options = { ...this.options, ...t };
  }
  /** @deprecated */
  // setOptions(options: Tileset3DProps): void {
  //   this.options = {...this.options, ...options};
  // }
  /**
   * Return a loadable tile url for a specific tile subpath
   * @param tilePath a tile subpath
   */
  getTileUrl(t) {
    if (t.startsWith("data:"))
      return t;
    let r = t;
    return this.queryParams.length && (r = `${t}${t.includes("?") ? "&" : "?"}${this.queryParams}`), r;
  }
  // TODO CESIUM specific
  hasExtension(t) {
    return this._extensionsUsed.indexOf(t) > -1;
  }
  /**
   * Update visible tiles relying on a list of viewports
   * @param viewports - list of viewports
   * @deprecated
   */
  update(t = null) {
    this.tilesetInitializationPromise.then(() => {
      !t && this.lastUpdatedVieports ? t = this.lastUpdatedVieports : this.lastUpdatedVieports = t, t && this.doUpdate(t);
    });
  }
  /**
   * Update visible tiles relying on a list of viewports.
   * Do it with debounce delay to prevent update spam
   * @param viewports viewports
   * @returns Promise of new frameNumber
   */
  async selectTiles(t = null) {
    return await this.tilesetInitializationPromise, t && (this.lastUpdatedVieports = t), this.updatePromise || (this.updatePromise = new Promise((n) => {
      setTimeout(() => {
        this.lastUpdatedVieports && this.doUpdate(this.lastUpdatedVieports), n(this._frameNumber), this.updatePromise = null;
      }, this.options.debounceTime);
    })), this.updatePromise;
  }
  adjustScreenSpaceError() {
    this.gpuMemoryUsageInBytes < this._cacheBytes ? this.memoryAdjustedScreenSpaceError = Math.max(this.memoryAdjustedScreenSpaceError / 1.02, this.options.maximumScreenSpaceError) : this.gpuMemoryUsageInBytes > this._cacheBytes + this._cacheOverflowBytes && (this.memoryAdjustedScreenSpaceError *= 1.02);
  }
  /**
   * Update visible tiles relying on a list of viewports
   * @param viewports viewports
   */
  // eslint-disable-next-line max-statements, complexity
  doUpdate(t) {
    if ("loadTiles" in this.options && !this.options.loadTiles || this.traverseCounter > 0)
      return;
    const n = t instanceof Array ? t : [t];
    this._cache.reset(), this._frameNumber++, this.traverseCounter = n.length;
    const r = [];
    for (const s of n) {
      const i = s.id;
      this._needTraverse(i) ? r.push(i) : this.traverseCounter--;
    }
    for (const s of n) {
      const i = s.id;
      if (this.roots[i] || (this.roots[i] = this._initializeTileHeaders(this.tileset, null)), !r.includes(i))
        continue;
      const o = B0(s, this._frameNumber);
      this._traverser.traverse(this.roots[i], o, this.options);
    }
  }
  /**
   * Check if traversal is needed for particular viewport
   * @param {string} viewportId - id of a viewport
   * @return {boolean}
   */
  _needTraverse(t) {
    let n = t;
    return this.options.viewportTraversersMap && (n = this.options.viewportTraversersMap[t]), n === t;
  }
  /**
   * The callback to post-process tiles after traversal procedure
   * @param frameState - frame state for tile culling
   */
  _onTraversalEnd(t) {
    const n = t.viewport.id;
    this.frameStateData[n] || (this.frameStateData[n] = { selectedTiles: [], _requestedTiles: [], _emptyTiles: [] });
    const r = this.frameStateData[n], s = Object.values(this._traverser.selectedTiles), [i, o] = E0(s, t, this.options.maximumTilesSelected);
    r.selectedTiles = i;
    for (const a of o)
      a.unselect();
    r._requestedTiles = Object.values(this._traverser.requestedTiles), r._emptyTiles = Object.values(this._traverser.emptyTiles), this.traverseCounter--, !(this.traverseCounter > 0) && this._updateTiles();
  }
  /**
   * Update tiles relying on data from all traversers
   */
  _updateTiles() {
    this.selectedTiles = [], this._requestedTiles = [], this._emptyTiles = [];
    for (const t in this.frameStateData) {
      const n = this.frameStateData[t];
      this.selectedTiles = this.selectedTiles.concat(n.selectedTiles), this._requestedTiles = this._requestedTiles.concat(n._requestedTiles), this._emptyTiles = this._emptyTiles.concat(n._emptyTiles);
    }
    this.selectedTiles = this.options.onTraversalComplete(this.selectedTiles);
    for (const t of this.selectedTiles)
      this._tiles[t.id] = t;
    this._loadTiles(), this._unloadTiles(), this._updateStats();
  }
  _tilesChanged(t, n) {
    if (t.length !== n.length)
      return !0;
    const r = new Set(t.map((o) => o.id)), s = new Set(n.map((o) => o.id));
    let i = t.filter((o) => !s.has(o.id)).length > 0;
    return i = i || n.filter((o) => !r.has(o.id)).length > 0, i;
  }
  _loadTiles() {
    for (const t of this._requestedTiles)
      t.contentUnloaded && this._loadTile(t);
  }
  _unloadTiles() {
    this._cache.unloadTiles(this, (t, n) => t._unloadTile(n));
  }
  _updateStats() {
    let t = 0, n = 0;
    for (const r of this.selectedTiles)
      r.contentAvailable && r.content && (t++, r.content.pointCount ? n += r.content.pointCount : n += r.content.vertexCount);
    this.stats.get(To).count = this.selectedTiles.length, this.stats.get(wo).count = t, this.stats.get(xo).count = n, this.stats.get(Mo).count = this.memoryAdjustedScreenSpaceError;
  }
  async _initializeTileSet(t) {
    this.type === Rt.I3S && (this.calculateViewPropsI3S(), t.root = await t.root), this.root = this._initializeTileHeaders(t, null), this.type === Rt.TILES3D && (this._initializeTiles3DTileset(t), this.calculateViewPropsTiles3D()), this.type === Rt.I3S && this._initializeI3STileset();
  }
  /**
   * Called during initialize Tileset to initialize the tileset's cartographic center (longitude, latitude) and zoom.
   * These metrics help apps center view on tileset
   * For I3S there is extent (<1.8 version) or fullExtent (>=1.8 version) to calculate view props
   * @returns
   */
  calculateViewPropsI3S() {
    var r;
    const t = this.tileset.fullExtent;
    if (t) {
      const { xmin: s, xmax: i, ymin: o, ymax: a, zmin: c, zmax: h } = t;
      this.cartographicCenter = new T(s + (i - s) / 2, o + (a - o) / 2, c + (h - c) / 2), this.cartesianCenter = new T(), q.WGS84.cartographicToCartesian(this.cartographicCenter, this.cartesianCenter), this.zoom = Cc(t, this.cartographicCenter, this.cartesianCenter);
      return;
    }
    const n = (r = this.tileset.store) == null ? void 0 : r.extent;
    if (n) {
      const [s, i, o, a] = n;
      this.cartographicCenter = new T(s + (o - s) / 2, i + (a - i) / 2, 0), this.cartesianCenter = new T(), q.WGS84.cartographicToCartesian(this.cartographicCenter, this.cartesianCenter), this.zoom = _0(n, this.cartographicCenter, this.cartesianCenter);
      return;
    }
    console.warn("Extent is not defined in the tileset header"), this.cartographicCenter = new T(), this.zoom = 1;
  }
  /**
   * Called during initialize Tileset to initialize the tileset's cartographic center (longitude, latitude) and zoom.
   * These metrics help apps center view on tileset.
   * For 3DTiles the root tile data is used to calculate view props.
   * @returns
   */
  calculateViewPropsTiles3D() {
    const t = this.root, { center: n } = t.boundingVolume;
    if (!n) {
      console.warn("center was not pre-calculated for the root tile"), this.cartographicCenter = new T(), this.zoom = 1;
      return;
    }
    n[0] !== 0 || n[1] !== 0 || n[2] !== 0 ? (this.cartographicCenter = new T(), q.WGS84.cartesianToCartographic(n, this.cartographicCenter)) : this.cartographicCenter = new T(0, 0, -q.WGS84.radii[0]), this.cartesianCenter = n, this.zoom = b0(t.boundingVolume, this.cartographicCenter);
  }
  _initializeStats() {
    this.stats.get(jn), this.stats.get(ns), this.stats.get(es), this.stats.get(To), this.stats.get(wo), this.stats.get(bo), this.stats.get(_o), this.stats.get(Io), this.stats.get(xo), this.stats.get(rs, "memory"), this.stats.get(Mo);
  }
  // Installs the main tileset JSON file or a tileset JSON file referenced from a tile.
  // eslint-disable-next-line max-statements
  _initializeTileHeaders(t, n) {
    var s;
    const r = new Ds(this, t.root, n);
    if (n && (n.children.push(r), r.depth = n.depth + 1), this.type === Rt.TILES3D) {
      const i = [];
      for (i.push(r); i.length > 0; ) {
        const o = i.pop();
        this.stats.get(jn).incrementCount();
        const a = o.header.children || [];
        for (const c of a) {
          const h = new Ds(this, c, o);
          if ((s = h.contentUrl) != null && s.includes("?session=")) {
            const d = new URL(h.contentUrl).searchParams.get("session");
            d && (this._queryParams.session = d);
          }
          o.children.push(h), h.depth = o.depth + 1, i.push(h);
        }
      }
    }
    return r;
  }
  _initializeTraverser() {
    let t;
    switch (this.type) {
      case Rt.TILES3D:
        t = V0;
        break;
      case Rt.I3S:
        t = z0;
        break;
      default:
        t = xr;
    }
    return new t({
      basePath: this.basePath,
      onTraversalEnd: this._onTraversalEnd.bind(this)
    });
  }
  _destroyTileHeaders(t) {
    this._destroySubtree(t);
  }
  async _loadTile(t) {
    let n;
    try {
      this._onStartTileLoading(), n = await t.loadContent();
    } catch (r) {
      this._onTileLoadError(t, r instanceof Error ? r : new Error("load failed"));
    } finally {
      this._onEndTileLoading(), this._onTileLoad(t, n);
    }
  }
  _onTileLoadError(t, n) {
    this.stats.get(Io).incrementCount();
    const r = n.message || n.toString(), s = t.url;
    console.error(`A 3D tile failed to load: ${t.url} ${r}`), this.options.onTileError(t, r, s);
  }
  _onTileLoad(t, n) {
    var r, s;
    if (n) {
      if (this.type === Rt.I3S) {
        const i = ((s = (r = this.tileset) == null ? void 0 : r.nodePagesTile) == null ? void 0 : s.nodesInNodePages) || 0;
        this.stats.get(jn).reset(), this.stats.get(jn).addCount(i);
      }
      t && t.content && Qm(t, t.content), this.updateContentTypes(t), this._addTileToCache(t), this.options.onTileLoad(t);
    }
  }
  /**
   * Update information about data types in nested tiles
   * @param tile instance of a nested Tile3D
   */
  updateContentTypes(t) {
    var n;
    if (this.type === Rt.I3S)
      switch (t.header.isDracoGeometry && (this.contentFormats.draco = !0), t.header.textureFormat) {
        case "dds":
          this.contentFormats.dds = !0;
          break;
        case "ktx2":
          this.contentFormats.ktx2 = !0;
          break;
      }
    else if (this.type === Rt.TILES3D) {
      const { extensionsRemoved: r = [] } = ((n = t.content) == null ? void 0 : n.gltf) || {};
      r.includes("KHR_draco_mesh_compression") && (this.contentFormats.draco = !0), r.includes("EXT_meshopt_compression") && (this.contentFormats.meshopt = !0), r.includes("KHR_texture_basisu") && (this.contentFormats.ktx2 = !0);
    }
  }
  _onStartTileLoading() {
    this._pendingCount++, this.stats.get(ns).incrementCount();
  }
  _onEndTileLoading() {
    this._pendingCount--, this.stats.get(ns).decrementCount();
  }
  _addTileToCache(t) {
    this._cache.add(this, t, (n) => n._updateCacheStats(t));
  }
  _updateCacheStats(t) {
    this.stats.get(bo).incrementCount(), this.stats.get(es).incrementCount(), this.gpuMemoryUsageInBytes += t.gpuMemoryUsageInBytes || 0, this.stats.get(rs).count = this.gpuMemoryUsageInBytes, this.options.memoryAdjustedScreenSpaceError && this.adjustScreenSpaceError();
  }
  _unloadTile(t) {
    this.gpuMemoryUsageInBytes -= t.gpuMemoryUsageInBytes || 0, this.stats.get(es).decrementCount(), this.stats.get(_o).incrementCount(), this.stats.get(rs).count = this.gpuMemoryUsageInBytes, this.options.onTileUnload(t), t.unloadContent();
  }
  // Traverse the tree and destroy all tiles
  _destroy() {
    const t = [];
    for (this.root && t.push(this.root); t.length > 0; ) {
      const n = t.pop();
      for (const r of n.children)
        t.push(r);
      this._destroyTile(n);
    }
    this.root = null;
  }
  // Traverse the tree and destroy all sub tiles
  _destroySubtree(t) {
    const n = t, r = [];
    for (r.push(n); r.length > 0; ) {
      t = r.pop();
      for (const s of t.children)
        r.push(s);
      t !== n && this._destroyTile(t);
    }
    n.children = [];
  }
  _destroyTile(t) {
    this._cache.unloadTile(this, t), this._unloadTile(t), t.destroy();
  }
  _initializeTiles3DTileset(t) {
    if (t.queryString) {
      const n = new URLSearchParams(t.queryString), r = Object.fromEntries(n.entries());
      this._queryParams = { ...this._queryParams, ...r };
    }
    if (this.asset = t.asset, !this.asset)
      throw new Error("Tileset must have an asset property.");
    if (this.asset.version !== "0.0" && this.asset.version !== "1.0" && this.asset.version !== "1.1")
      throw new Error("The tileset must be 3D Tiles version either 0.0 or 1.0 or 1.1.");
    "tilesetVersion" in this.asset && (this._queryParams.v = this.asset.tilesetVersion), this.credits = {
      attributions: this.options.attributions || []
    }, this.description = this.options.description || "", this.properties = t.properties, this.geometricError = t.geometricError, this._extensionsUsed = t.extensionsUsed || [], this.extras = t.extras;
  }
  _initializeI3STileset() {
    this.loadOptions.i3s && "token" in this.loadOptions.i3s && (this._queryParams.token = this.loadOptions.i3s.token);
  }
}
const xc = "4.3.3", rn = {
  COMPOSITE: "cmpt",
  POINT_CLOUD: "pnts",
  BATCHED_3D_MODEL: "b3dm",
  INSTANCED_3D_MODEL: "i3dm",
  GLTF: "glTF"
};
function Mc(e, t, n) {
  $(e instanceof ArrayBuffer);
  const r = new TextDecoder("utf8"), s = new Uint8Array(e, t, n);
  return r.decode(s);
}
function $0(e, t = 0) {
  const n = new DataView(e);
  return `${String.fromCharCode(n.getUint8(t + 0))}${String.fromCharCode(n.getUint8(t + 1))}${String.fromCharCode(n.getUint8(t + 2))}${String.fromCharCode(n.getUint8(t + 3))}`;
}
const X0 = "4.3.3", q0 = {
  dataType: null,
  batchType: null,
  name: "Draco",
  id: "draco",
  module: "draco",
  // shapes: ['mesh'],
  version: X0,
  worker: !0,
  extensions: ["drc"],
  mimeTypes: ["application/octet-stream"],
  binary: !0,
  tests: ["DRACO"],
  options: {
    draco: {
      decoderType: typeof WebAssembly == "object" ? "wasm" : "js",
      // 'js' for IE11
      libraryPath: "libs/",
      extraAttributes: {},
      attributeNameEntry: void 0
    }
  }
};
function Y0(e, t, n) {
  const r = Rc(t.metadata), s = [], i = Z0(t.attributes);
  for (const o in e) {
    const a = e[o], c = Ro(o, a, i[o]);
    s.push(c);
  }
  if (n) {
    const o = Ro("indices", n);
    s.push(o);
  }
  return { fields: s, metadata: r };
}
function Z0(e) {
  const t = {};
  for (const n in e) {
    const r = e[n];
    t[r.name || "undefined"] = r;
  }
  return t;
}
function Ro(e, t, n) {
  const r = n ? Rc(n.metadata) : void 0;
  return qf(e, t, r);
}
function Rc(e) {
  Object.entries(e);
  const t = {};
  for (const n in e)
    t[`${n}.string`] = JSON.stringify(e[n]);
  return t;
}
const So = {
  POSITION: "POSITION",
  NORMAL: "NORMAL",
  COLOR: "COLOR_0",
  TEX_COORD: "TEXCOORD_0"
}, tp = {
  1: Int8Array,
  2: Uint8Array,
  3: Int16Array,
  4: Uint16Array,
  5: Int32Array,
  6: Uint32Array,
  // 7: BigInt64Array,
  // 8: BigUint64Array,
  9: Float32Array
  // 10: Float64Array
  // 11: BOOL - What array type do we use for this?
}, ep = 4;
class np {
  // draco - the draco decoder, either import `draco3d` or load dynamically
  constructor(t) {
    y(this, "draco");
    y(this, "decoder");
    y(this, "metadataQuerier");
    this.draco = t, this.decoder = new this.draco.Decoder(), this.metadataQuerier = new this.draco.MetadataQuerier();
  }
  /**
   * Destroy draco resources
   */
  destroy() {
    this.draco.destroy(this.decoder), this.draco.destroy(this.metadataQuerier);
  }
  /**
   * NOTE: caller must call `destroyGeometry` on the return value after using it
   * @param arrayBuffer
   * @param options
   */
  parseSync(t, n = {}) {
    const r = new this.draco.DecoderBuffer();
    r.Init(new Int8Array(t), t.byteLength), this._disableAttributeTransforms(n);
    const s = this.decoder.GetEncodedGeometryType(r), i = s === this.draco.TRIANGULAR_MESH ? new this.draco.Mesh() : new this.draco.PointCloud();
    try {
      let o;
      switch (s) {
        case this.draco.TRIANGULAR_MESH:
          o = this.decoder.DecodeBufferToMesh(r, i);
          break;
        case this.draco.POINT_CLOUD:
          o = this.decoder.DecodeBufferToPointCloud(r, i);
          break;
        default:
          throw new Error("DRACO: Unknown geometry type.");
      }
      if (!o.ok() || !i.ptr) {
        const p = `DRACO decompression failed: ${o.error_msg()}`;
        throw new Error(p);
      }
      const a = this._getDracoLoaderData(i, s, n), c = this._getMeshData(i, a, n), h = Xf(c.attributes), f = Y0(c.attributes, a, c.indices);
      return {
        loader: "draco",
        loaderData: a,
        header: {
          vertexCount: i.num_points(),
          boundingBox: h
        },
        ...c,
        schema: f
      };
    } finally {
      this.draco.destroy(r), i && this.draco.destroy(i);
    }
  }
  // Draco specific "loader data"
  /**
   * Extract
   * @param dracoGeometry
   * @param geometry_type
   * @param options
   * @returns
   */
  _getDracoLoaderData(t, n, r) {
    const s = this._getTopLevelMetadata(t), i = this._getDracoAttributes(t, r);
    return {
      geometry_type: n,
      num_attributes: t.num_attributes(),
      num_points: t.num_points(),
      num_faces: t instanceof this.draco.Mesh ? t.num_faces() : 0,
      metadata: s,
      attributes: i
    };
  }
  /**
   * Extract all draco provided information and metadata for each attribute
   * @param dracoGeometry
   * @param options
   * @returns
   */
  _getDracoAttributes(t, n) {
    const r = {};
    for (let s = 0; s < t.num_attributes(); s++) {
      const i = this.decoder.GetAttribute(t, s), o = this._getAttributeMetadata(t, s);
      r[i.unique_id()] = {
        unique_id: i.unique_id(),
        attribute_type: i.attribute_type(),
        data_type: i.data_type(),
        num_components: i.num_components(),
        byte_offset: i.byte_offset(),
        byte_stride: i.byte_stride(),
        normalized: i.normalized(),
        attribute_index: s,
        metadata: o
      };
      const a = this._getQuantizationTransform(i, n);
      a && (r[i.unique_id()].quantization_transform = a);
      const c = this._getOctahedronTransform(i, n);
      c && (r[i.unique_id()].octahedron_transform = c);
    }
    return r;
  }
  /**
   * Get standard loaders.gl mesh category data
   * Extracts the geometry from draco
   * @param dracoGeometry
   * @param options
   */
  _getMeshData(t, n, r) {
    const s = this._getMeshAttributes(n, t, r);
    if (!s.POSITION)
      throw new Error("DRACO: No position attribute found.");
    if (t instanceof this.draco.Mesh)
      switch (r.topology) {
        case "triangle-strip":
          return {
            topology: "triangle-strip",
            mode: 4,
            // GL.TRIANGLES
            attributes: s,
            indices: {
              value: this._getTriangleStripIndices(t),
              size: 1
            }
          };
        case "triangle-list":
        default:
          return {
            topology: "triangle-list",
            mode: 5,
            // GL.TRIANGLE_STRIP
            attributes: s,
            indices: {
              value: this._getTriangleListIndices(t),
              size: 1
            }
          };
      }
    return {
      topology: "point-list",
      mode: 0,
      // GL.POINTS
      attributes: s
    };
  }
  _getMeshAttributes(t, n, r) {
    const s = {};
    for (const i of Object.values(t.attributes)) {
      const o = this._deduceAttributeName(i, r);
      i.name = o;
      const a = this._getAttributeValues(n, i);
      if (a) {
        const { value: c, size: h } = a;
        s[o] = {
          value: c,
          size: h,
          byteOffset: i.byte_offset,
          byteStride: i.byte_stride,
          normalized: i.normalized
        };
      }
    }
    return s;
  }
  // MESH INDICES EXTRACTION
  /**
   * For meshes, we need indices to define the faces.
   * @param dracoGeometry
   */
  _getTriangleListIndices(t) {
    const r = t.num_faces() * 3, s = r * ep, i = this.draco._malloc(s);
    try {
      return this.decoder.GetTrianglesUInt32Array(t, s, i), new Uint32Array(this.draco.HEAPF32.buffer, i, r).slice();
    } finally {
      this.draco._free(i);
    }
  }
  /**
   * For meshes, we need indices to define the faces.
   * @param dracoGeometry
   */
  _getTriangleStripIndices(t) {
    const n = new this.draco.DracoInt32Array();
    try {
      return this.decoder.GetTriangleStripsFromMesh(t, n), ip(n);
    } finally {
      this.draco.destroy(n);
    }
  }
  /**
   *
   * @param dracoGeometry
   * @param dracoAttribute
   * @param attributeName
   */
  _getAttributeValues(t, n) {
    const r = tp[n.data_type];
    if (!r)
      return console.warn(`DRACO: Unsupported attribute type ${n.data_type}`), null;
    const s = n.num_components, o = t.num_points() * s, a = o * r.BYTES_PER_ELEMENT, c = rp(this.draco, r);
    let h;
    const f = this.draco._malloc(a);
    try {
      const d = this.decoder.GetAttribute(t, n.attribute_index);
      this.decoder.GetAttributeDataArrayForAllPoints(t, d, c, a, f), h = new r(this.draco.HEAPF32.buffer, f, o).slice();
    } finally {
      this.draco._free(f);
    }
    return { value: h, size: s };
  }
  // Attribute names
  /**
   * DRACO does not store attribute names - We need to deduce an attribute name
   * for each attribute
  _getAttributeNames(
    dracoGeometry: Mesh | PointCloud,
    options: DracoParseOptions
  ): {[unique_id: number]: string} {
    const attributeNames: {[unique_id: number]: string} = {};
    for (let attributeId = 0; attributeId < dracoGeometry.num_attributes(); attributeId++) {
      const dracoAttribute = this.decoder.GetAttribute(dracoGeometry, attributeId);
      const attributeName = this._deduceAttributeName(dracoAttribute, options);
      attributeNames[attributeName] = attributeName;
    }
    return attributeNames;
  }
   */
  /**
   * Deduce an attribute name.
   * @note DRACO does not save attribute names, just general type (POSITION, COLOR)
   * to help optimize compression. We generate GLTF compatible names for the Draco-recognized
   * types
   * @param attributeData
   */
  _deduceAttributeName(t, n) {
    const r = t.unique_id;
    for (const [o, a] of Object.entries(n.extraAttributes || {}))
      if (a === r)
        return o;
    const s = t.attribute_type;
    for (const o in So)
      if (this.draco[o] === s)
        return So[o];
    const i = n.attributeNameEntry || "name";
    return t.metadata[i] ? t.metadata[i].string : `CUSTOM_ATTRIBUTE_${r}`;
  }
  // METADATA EXTRACTION
  /** Get top level metadata */
  _getTopLevelMetadata(t) {
    const n = this.decoder.GetMetadata(t);
    return this._getDracoMetadata(n);
  }
  /** Get per attribute metadata */
  _getAttributeMetadata(t, n) {
    const r = this.decoder.GetAttributeMetadata(t, n);
    return this._getDracoMetadata(r);
  }
  /**
   * Extract metadata field values
   * @param dracoMetadata
   * @returns
   */
  _getDracoMetadata(t) {
    if (!t || !t.ptr)
      return {};
    const n = {}, r = this.metadataQuerier.NumEntries(t);
    for (let s = 0; s < r; s++) {
      const i = this.metadataQuerier.GetEntryName(t, s);
      n[i] = this._getDracoMetadataField(t, i);
    }
    return n;
  }
  /**
   * Extracts possible values for one metadata entry by name
   * @param dracoMetadata
   * @param entryName
   */
  _getDracoMetadataField(t, n) {
    const r = new this.draco.DracoInt32Array();
    try {
      this.metadataQuerier.GetIntEntryArray(t, n, r);
      const s = sp(r);
      return {
        int: this.metadataQuerier.GetIntEntry(t, n),
        string: this.metadataQuerier.GetStringEntry(t, n),
        double: this.metadataQuerier.GetDoubleEntry(t, n),
        intArray: s
      };
    } finally {
      this.draco.destroy(r);
    }
  }
  // QUANTIZED ATTRIBUTE SUPPORT (NO DECOMPRESSION)
  /** Skip transforms for specific attribute types */
  _disableAttributeTransforms(t) {
    const { quantizedAttributes: n = [], octahedronAttributes: r = [] } = t, s = [...n, ...r];
    for (const i of s)
      this.decoder.SkipAttributeTransform(this.draco[i]);
  }
  /**
   * Extract (and apply?) Position Transform
   * @todo not used
   */
  _getQuantizationTransform(t, n) {
    const { quantizedAttributes: r = [] } = n, s = t.attribute_type();
    if (r.map((o) => this.decoder[o]).includes(s)) {
      const o = new this.draco.AttributeQuantizationTransform();
      try {
        if (o.InitFromAttribute(t))
          return {
            quantization_bits: o.quantization_bits(),
            range: o.range(),
            min_values: new Float32Array([1, 2, 3]).map((a) => o.min_value(a))
          };
      } finally {
        this.draco.destroy(o);
      }
    }
    return null;
  }
  _getOctahedronTransform(t, n) {
    const { octahedronAttributes: r = [] } = n, s = t.attribute_type();
    if (r.map((o) => this.decoder[o]).includes(s)) {
      const o = new this.draco.AttributeQuantizationTransform();
      try {
        if (o.InitFromAttribute(t))
          return {
            quantization_bits: o.quantization_bits()
          };
      } finally {
        this.draco.destroy(o);
      }
    }
    return null;
  }
}
function rp(e, t) {
  switch (t) {
    case Float32Array:
      return e.DT_FLOAT32;
    case Int8Array:
      return e.DT_INT8;
    case Int16Array:
      return e.DT_INT16;
    case Int32Array:
      return e.DT_INT32;
    case Uint8Array:
      return e.DT_UINT8;
    case Uint16Array:
      return e.DT_UINT16;
    case Uint32Array:
      return e.DT_UINT32;
    default:
      return e.DT_INVALID;
  }
}
function sp(e) {
  const t = e.size(), n = new Int32Array(t);
  for (let r = 0; r < t; r++)
    n[r] = e.GetValue(r);
  return n;
}
function ip(e) {
  const t = e.size(), n = new Int32Array(t);
  for (let r = 0; r < t; r++)
    n[r] = e.GetValue(r);
  return n;
}
const op = "1.5.6", ap = "1.4.1", ss = `https://www.gstatic.com/draco/versioned/decoders/${op}`, St = {
  /** The primary Draco3D encoder, javascript wrapper part */
  DECODER: "draco_wasm_wrapper.js",
  /** The primary draco decoder, compiled web assembly part */
  DECODER_WASM: "draco_decoder.wasm",
  /** Fallback decoder for non-webassebly environments. Very big bundle, lower performance */
  FALLBACK_DECODER: "draco_decoder.js",
  /** Draco encoder */
  ENCODER: "draco_encoder.js"
}, is = {
  [St.DECODER]: `${ss}/${St.DECODER}`,
  [St.DECODER_WASM]: `${ss}/${St.DECODER_WASM}`,
  [St.FALLBACK_DECODER]: `${ss}/${St.FALLBACK_DECODER}`,
  [St.ENCODER]: `https://raw.githubusercontent.com/google/draco/${ap}/javascript/${St.ENCODER}`
};
let os;
async function cp(e) {
  const t = e.modules || {};
  return t.draco3d ? os || (os = t.draco3d.createDecoderModule({}).then((n) => ({ draco: n }))) : os || (os = up(e)), await os;
}
async function up(e) {
  let t, n;
  switch (e.draco && e.draco.decoderType) {
    case "js":
      t = await be(is[St.FALLBACK_DECODER], "draco", e, St.FALLBACK_DECODER);
      break;
    case "wasm":
    default:
      [t, n] = await Promise.all([
        await be(is[St.DECODER], "draco", e, St.DECODER),
        await be(is[St.DECODER_WASM], "draco", e, St.DECODER_WASM)
      ]);
  }
  return t = t || globalThis.DracoDecoderModule, await hp(t, n);
}
function hp(e, t) {
  const n = {};
  return t && (n.wasmBinary = t), new Promise((r) => {
    e({
      ...n,
      onModuleLoaded: (s) => r({ draco: s })
      // Module is Promise-like. Wrap in object to avoid loop.
    });
  });
}
const Sc = {
  ...q0,
  parse: lp
};
async function lp(e, t) {
  const { draco: n } = await cp(t), r = new np(n);
  try {
    return r.parseSync(e, t == null ? void 0 : t.draco);
  } finally {
    r.destroy();
  }
}
const fp = {
  POINTS: 0,
  // Points. single points.
  LINES: 1,
  // Lines. Each vertex connects to the one after it.
  LINE_LOOP: 2,
  // Lines. Each set of two vertices is treated as a separate line segment.
  LINE_STRIP: 3,
  // Lines/ a connected group of line segments from the first vertex to the last
  TRIANGLES: 4,
  // Triangles. Each set of three vertices creates a separate triangle.
  TRIANGLE_STRIP: 5,
  // Triangles. A connected group of triangles.
  TRIANGLE_FAN: 6
  // Triangles. A connected group of triangles.
  // Each vertex connects to the previous and the first vertex in the fan.
}, pt = {
  BYTE: 5120,
  UNSIGNED_BYTE: 5121,
  SHORT: 5122,
  UNSIGNED_SHORT: 5123,
  INT: 5124,
  UNSIGNED_INT: 5125,
  FLOAT: 5126,
  DOUBLE: 5130
}, K = {
  ...fp,
  ...pt
}, as = {
  [pt.DOUBLE]: Float64Array,
  [pt.FLOAT]: Float32Array,
  [pt.UNSIGNED_SHORT]: Uint16Array,
  [pt.UNSIGNED_INT]: Uint32Array,
  [pt.UNSIGNED_BYTE]: Uint8Array,
  [pt.BYTE]: Int8Array,
  [pt.SHORT]: Int16Array,
  [pt.INT]: Int32Array
}, dp = {
  DOUBLE: pt.DOUBLE,
  FLOAT: pt.FLOAT,
  UNSIGNED_SHORT: pt.UNSIGNED_SHORT,
  UNSIGNED_INT: pt.UNSIGNED_INT,
  UNSIGNED_BYTE: pt.UNSIGNED_BYTE,
  BYTE: pt.BYTE,
  SHORT: pt.SHORT,
  INT: pt.INT
}, cs = "Failed to convert GL type";
class se {
  // Signature: fromTypedArray(new Uint8Array())
  // Signature: fromTypedArray(Uint8Array)
  /**
   * Returns the size, in bytes, of the corresponding datatype
   * @param arrayOrType
   * @returns glType a a string
   */
  static fromTypedArray(t) {
    t = ArrayBuffer.isView(t) ? t.constructor : t;
    for (const n in as)
      if (as[n] === t)
        return n;
    throw new Error(cs);
  }
  /**
   * Extracts name for glType from array NAME_TO_GL_TYPE
   * @param name
   * @returns glType as a number
   */
  static fromName(t) {
    const n = dp[t];
    if (!n)
      throw new Error(cs);
    return n;
  }
  // Converts GL constant to corresponding typed array type
  // eslint-disable-next-line complexity
  static getArrayType(t) {
    switch (t) {
      case pt.UNSIGNED_SHORT_5_6_5:
      case pt.UNSIGNED_SHORT_4_4_4_4:
      case pt.UNSIGNED_SHORT_5_5_5_1:
        return Uint16Array;
      default:
        const n = as[t];
        if (!n)
          throw new Error(cs);
        return n;
    }
  }
  /**
   * Returns the size in bytes of one element of the provided WebGL type
   * @param glType
   * @returns size of glType
   */
  static getByteSize(t) {
    return se.getArrayType(t).BYTES_PER_ELEMENT;
  }
  /**
   * Returns `true` if `glType` is a valid WebGL data type.
   * @param glType
   * @returns boolean
   */
  static validate(t) {
    return !!se.getArrayType(t);
  }
  /**
   * Creates a typed view of an array of bytes
   * @param glType The type of typed array (ArrayBuffer view) to create
   * @param buffer The buffer storage to use for the view.
   * @param byteOffset The offset, in bytes, to the first element in the view
   * @param length The number of elements in the view. Defaults to buffer length
   * @returns A typed array view of the buffer
   */
  static createTypedArray(t, n, r = 0, s) {
    s === void 0 && (s = (n.byteLength - r) / se.getByteSize(t));
    const i = se.getArrayType(t);
    return new i(n, r, s);
  }
}
function mp(e, t) {
  if (!e)
    throw new Error(`math.gl assertion failed. ${t}`);
}
function pp(e, t = [0, 0, 0]) {
  const n = e >> 11 & 31, r = e >> 5 & 63, s = e & 31;
  return t[0] = n << 3, t[1] = r << 2, t[2] = s << 3, t;
}
new _r();
new T();
new _r();
new _r();
function Fo(e, t = 255) {
  return od(e, 0, t) / t * 2 - 1;
}
function Oo(e) {
  return e < 0 ? -1 : 1;
}
function gp(e, t, n, r) {
  if (mp(r), e < 0 || e > n || t < 0 || t > n)
    throw new Error(`x and y must be unsigned normalized integers between 0 and ${n}`);
  if (r.x = Fo(e, n), r.y = Fo(t, n), r.z = 1 - (Math.abs(r.x) + Math.abs(r.y)), r.z < 0) {
    const s = r.x;
    r.x = (1 - Math.abs(r.y)) * Oo(s), r.y = (1 - Math.abs(s)) * Oo(r.y);
  }
  return r.normalize();
}
function Ap(e, t, n) {
  return gp(e, t, 255, n);
}
class hi {
  constructor(t, n) {
    y(this, "json");
    y(this, "buffer");
    y(this, "featuresLength", 0);
    y(this, "_cachedTypedArrays", {});
    this.json = t, this.buffer = n;
  }
  getExtension(t) {
    return this.json.extensions && this.json.extensions[t];
  }
  hasProperty(t) {
    return !!this.json[t];
  }
  getGlobalProperty(t, n = K.UNSIGNED_INT, r = 1) {
    const s = this.json[t];
    return s && Number.isFinite(s.byteOffset) ? this._getTypedArrayFromBinary(t, n, r, 1, s.byteOffset) : s;
  }
  getPropertyArray(t, n, r) {
    const s = this.json[t];
    return s && Number.isFinite(s.byteOffset) ? ("componentType" in s && (n = se.fromName(s.componentType)), this._getTypedArrayFromBinary(t, n, r, this.featuresLength, s.byteOffset)) : this._getTypedArrayFromArray(t, n, s);
  }
  getProperty(t, n, r, s, i) {
    const o = this.json[t];
    if (!o)
      return o;
    const a = this.getPropertyArray(t, n, r);
    if (r === 1)
      return a[s];
    for (let c = 0; c < r; ++c)
      i[c] = a[r * s + c];
    return i;
  }
  // HELPERS
  _getTypedArrayFromBinary(t, n, r, s, i) {
    const o = this._cachedTypedArrays;
    let a = o[t];
    return a || (a = se.createTypedArray(n, this.buffer.buffer, this.buffer.byteOffset + i, s * r), o[t] = a), a;
  }
  _getTypedArrayFromArray(t, n, r) {
    const s = this._cachedTypedArrays;
    let i = s[t];
    return i || (i = se.createTypedArray(n, r), s[t] = i), i;
  }
}
const yp = {
  SCALAR: 1,
  VEC2: 2,
  VEC3: 3,
  VEC4: 4,
  MAT2: 4,
  MAT3: 9,
  MAT4: 16
}, Bp = {
  SCALAR: (e, t) => e[t],
  VEC2: (e, t) => [e[2 * t + 0], e[2 * t + 1]],
  VEC3: (e, t) => [e[3 * t + 0], e[3 * t + 1], e[3 * t + 2]],
  VEC4: (e, t) => [e[4 * t + 0], e[4 * t + 1], e[4 * t + 2], e[4 * t + 3]],
  // TODO: check column major
  MAT2: (e, t) => [
    e[4 * t + 0],
    e[4 * t + 1],
    e[4 * t + 2],
    e[4 * t + 3]
  ],
  MAT3: (e, t) => [
    e[9 * t + 0],
    e[9 * t + 1],
    e[9 * t + 2],
    e[9 * t + 3],
    e[9 * t + 4],
    e[9 * t + 5],
    e[9 * t + 6],
    e[9 * t + 7],
    e[9 * t + 8]
  ],
  MAT4: (e, t) => [
    e[16 * t + 0],
    e[16 * t + 1],
    e[16 * t + 2],
    e[16 * t + 3],
    e[16 * t + 4],
    e[16 * t + 5],
    e[16 * t + 6],
    e[16 * t + 7],
    e[16 * t + 8],
    e[16 * t + 9],
    e[16 * t + 10],
    e[16 * t + 11],
    e[16 * t + 12],
    e[16 * t + 13],
    e[16 * t + 14],
    e[16 * t + 15]
  ]
}, Ep = {
  SCALAR: (e, t, n) => {
    t[n] = e;
  },
  VEC2: (e, t, n) => {
    t[2 * n + 0] = e[0], t[2 * n + 1] = e[1];
  },
  VEC3: (e, t, n) => {
    t[3 * n + 0] = e[0], t[3 * n + 1] = e[1], t[3 * n + 2] = e[2];
  },
  VEC4: (e, t, n) => {
    t[4 * n + 0] = e[0], t[4 * n + 1] = e[1], t[4 * n + 2] = e[2], t[4 * n + 3] = e[3];
  },
  // TODO: check column major correctness
  MAT2: (e, t, n) => {
    t[4 * n + 0] = e[0], t[4 * n + 1] = e[1], t[4 * n + 2] = e[2], t[4 * n + 3] = e[3];
  },
  MAT3: (e, t, n) => {
    t[9 * n + 0] = e[0], t[9 * n + 1] = e[1], t[9 * n + 2] = e[2], t[9 * n + 3] = e[3], t[9 * n + 4] = e[4], t[9 * n + 5] = e[5], t[9 * n + 6] = e[6], t[9 * n + 7] = e[7], t[9 * n + 8] = e[8], t[9 * n + 9] = e[9];
  },
  MAT4: (e, t, n) => {
    t[16 * n + 0] = e[0], t[16 * n + 1] = e[1], t[16 * n + 2] = e[2], t[16 * n + 3] = e[3], t[16 * n + 4] = e[4], t[16 * n + 5] = e[5], t[16 * n + 6] = e[6], t[16 * n + 7] = e[7], t[16 * n + 8] = e[8], t[16 * n + 9] = e[9], t[16 * n + 10] = e[10], t[16 * n + 11] = e[11], t[16 * n + 12] = e[12], t[16 * n + 13] = e[13], t[16 * n + 14] = e[14], t[16 * n + 15] = e[15];
  }
};
function Cp(e, t, n, r) {
  const { componentType: s } = e;
  $(e.componentType);
  const i = typeof s == "string" ? se.fromName(s) : s, o = yp[e.type], a = Bp[e.type], c = Ep[e.type];
  return n += e.byteOffset, {
    values: se.createTypedArray(i, t, n, o * r),
    type: i,
    size: o,
    unpacker: a,
    packer: c
  };
}
const ne = (e) => e !== void 0;
function Tp(e, t, n) {
  if (!t)
    return null;
  let r = e.getExtension("3DTILES_batch_table_hierarchy");
  const s = t.HIERARCHY;
  return s && (console.warn("3D Tile Parser: HIERARCHY is deprecated. Use 3DTILES_batch_table_hierarchy."), t.extensions = t.extensions || {}, t.extensions["3DTILES_batch_table_hierarchy"] = s, r = s), r ? wp(r, n) : null;
}
function wp(e, t) {
  let n, r, s;
  const i = e.instancesLength, o = e.classes;
  let a = e.classIds, c = e.parentCounts, h = e.parentIds, f = i;
  ne(a.byteOffset) && (a.componentType = defaultValue(a.componentType, GL.UNSIGNED_SHORT), a.type = AttributeType.SCALAR, s = getBinaryAccessor(a), a = s.createArrayBufferView(t.buffer, t.byteOffset + a.byteOffset, i));
  let d;
  if (ne(c))
    for (ne(c.byteOffset) && (c.componentType = defaultValue(c.componentType, GL.UNSIGNED_SHORT), c.type = AttributeType.SCALAR, s = getBinaryAccessor(c), c = s.createArrayBufferView(t.buffer, t.byteOffset + c.byteOffset, i)), d = new Uint16Array(i), f = 0, n = 0; n < i; ++n)
      d[n] = f, f += c[n];
  ne(h) && ne(h.byteOffset) && (h.componentType = defaultValue(h.componentType, GL.UNSIGNED_SHORT), h.type = AttributeType.SCALAR, s = getBinaryAccessor(h), h = s.createArrayBufferView(t.buffer, t.byteOffset + h.byteOffset, f));
  const p = o.length;
  for (n = 0; n < p; ++n) {
    const b = o[n].length, M = o[n].instances, D = getBinaryProperties(b, M, t);
    o[n].instances = combine(D, M);
  }
  const g = new Array(p).fill(0), B = new Uint16Array(i);
  for (n = 0; n < i; ++n)
    r = a[n], B[n] = g[r], ++g[r];
  const C = {
    classes: o,
    classIds: a,
    classIndexes: B,
    parentCounts: c,
    parentIndexes: d,
    parentIds: h
  };
  return Ip(C), C;
}
function sn(e, t, n) {
  if (!e)
    return;
  const r = e.parentCounts;
  return e.parentIds ? n(e, t) : r > 0 ? bp(e, t, n) : _p(e, t, n);
}
function bp(e, t, n) {
  const r = e.classIds, s = e.parentCounts, i = e.parentIds, o = e.parentIndexes, a = r.length, c = scratchVisited;
  c.length = Math.max(c.length, a);
  const h = ++marker, f = scratchStack;
  for (f.length = 0, f.push(t); f.length > 0; ) {
    if (t = f.pop(), c[t] === h)
      continue;
    c[t] = h;
    const d = n(e, t);
    if (ne(d))
      return d;
    const p = s[t], g = o[t];
    for (let B = 0; B < p; ++B) {
      const C = i[g + B];
      C !== t && f.push(C);
    }
  }
  return null;
}
function _p(e, t, n) {
  let r = !0;
  for (; r; ) {
    const s = n(e, t);
    if (ne(s))
      return s;
    const i = e.parentIds[t];
    r = i !== t, t = i;
  }
  throw new Error("traverseHierarchySingleParent");
}
function Ip(e) {
  const n = e.classIds.length;
  for (let r = 0; r < n; ++r)
    Fc(e, r, stack);
}
function Fc(e, t, n) {
  const r = e.parentCounts, s = e.parentIds, i = e.parentIndexes, a = e.classIds.length;
  if (!ne(s))
    return;
  assert(t < a, `Parent index ${t} exceeds the total number of instances: ${a}`), assert(n.indexOf(t) === -1, "Circular dependency detected in the batch table hierarchy."), n.push(t);
  const c = ne(r) ? r[t] : 1, h = ne(r) ? i[t] : t;
  for (let f = 0; f < c; ++f) {
    const d = s[h + f];
    d !== t && Fc(e, d, n);
  }
  n.pop(t);
}
function It(e) {
  return e != null;
}
const Kn = (e, t) => e, xp = {
  HIERARCHY: !0,
  // Deprecated HIERARCHY property
  extensions: !0,
  extras: !0
};
class Oc {
  constructor(t, n, r, s = {}) {
    y(this, "json");
    y(this, "binary");
    y(this, "featureCount");
    y(this, "_extensions");
    // Copy all top-level property fields from the json object, ignoring special fields
    y(this, "_properties");
    y(this, "_binaryProperties");
    // TODO: hierarchy support is only partially implemented and not tested
    y(this, "_hierarchy");
    var i;
    $(r >= 0), this.json = t || {}, this.binary = n, this.featureCount = r, this._extensions = ((i = this.json) == null ? void 0 : i.extensions) || {}, this._properties = {};
    for (const o in this.json)
      xp[o] || (this._properties[o] = this.json[o]);
    this._binaryProperties = this._initializeBinaryProperties(), s["3DTILES_batch_table_hierarchy"] && (this._hierarchy = Tp(this, this.json, this.binary));
  }
  getExtension(t) {
    return this.json && this.json.extensions && this.json.extensions[t];
  }
  memorySizeInBytes() {
    return 0;
  }
  isClass(t, n) {
    if (this._checkBatchId(t), $(typeof n == "string", n), this._hierarchy) {
      const r = sn(this._hierarchy, t, (s, i) => {
        const o = s.classIds[i];
        return s.classes[o].name === n;
      });
      return It(r);
    }
    return !1;
  }
  isExactClass(t, n) {
    return $(typeof n == "string", n), this.getExactClassName(t) === n;
  }
  getExactClassName(t) {
    if (this._checkBatchId(t), this._hierarchy) {
      const n = this._hierarchy.classIds[t];
      return this._hierarchy.classes[n].name;
    }
  }
  hasProperty(t, n) {
    return this._checkBatchId(t), $(typeof n == "string", n), It(this._properties[n]) || this._hasPropertyInHierarchy(t, n);
  }
  getPropertyNames(t, n) {
    this._checkBatchId(t), n = It(n) ? n : [], n.length = 0;
    const r = Object.keys(this._properties);
    return n.push(...r), this._hierarchy && this._getPropertyNamesInHierarchy(t, n), n;
  }
  getProperty(t, n) {
    if (this._checkBatchId(t), $(typeof n == "string", n), this._binaryProperties) {
      const s = this._binaryProperties[n];
      if (It(s))
        return this._getBinaryProperty(s, t);
    }
    const r = this._properties[n];
    if (It(r))
      return Kn(r[t]);
    if (this._hierarchy) {
      const s = this._getHierarchyProperty(t, n);
      if (It(s))
        return s;
    }
  }
  setProperty(t, n, r) {
    const s = this.featureCount;
    if (this._checkBatchId(t), $(typeof n == "string", n), this._binaryProperties) {
      const o = this._binaryProperties[n];
      if (o) {
        this._setBinaryProperty(o, t, r);
        return;
      }
    }
    if (this._hierarchy && this._setHierarchyProperty(this, t, n, r))
      return;
    let i = this._properties[n];
    It(i) || (this._properties[n] = new Array(s), i = this._properties[n]), i[t] = Kn(r);
  }
  // PRIVATE METHODS
  _checkBatchId(t) {
    if (!(t >= 0 && t < this.featureCount))
      throw new Error("batchId not in range [0, featureCount - 1].");
  }
  _getBinaryProperty(t, n) {
    return t.unpack(t.typedArray, n);
  }
  _setBinaryProperty(t, n, r) {
    t.pack(r, t.typedArray, n);
  }
  _initializeBinaryProperties() {
    let t = null;
    for (const n in this._properties) {
      const r = this._properties[n], s = this._initializeBinaryProperty(n, r);
      s && (t = t || {}, t[n] = s);
    }
    return t;
  }
  _initializeBinaryProperty(t, n) {
    if ("byteOffset" in n) {
      const r = n;
      $(this.binary, `Property ${t} requires a batch table binary.`), $(r.type, `Property ${t} requires a type.`);
      const s = Cp(r, this.binary.buffer, this.binary.byteOffset | 0, this.featureCount);
      return {
        typedArray: s.values,
        componentCount: s.size,
        unpack: s.unpacker,
        pack: s.packer
      };
    }
    return null;
  }
  //  EXTENSION SUPPORT: 3DTILES_batch_table_hierarchy
  _hasPropertyInHierarchy(t, n) {
    if (!this._hierarchy)
      return !1;
    const r = sn(this._hierarchy, t, (s, i) => {
      const o = s.classIds[i], a = s.classes[o].instances;
      return It(a[n]);
    });
    return It(r);
  }
  _getPropertyNamesInHierarchy(t, n) {
    sn(this._hierarchy, t, (r, s) => {
      const i = r.classIds[s], o = r.classes[i].instances;
      for (const a in o)
        o.hasOwnProperty(a) && n.indexOf(a) === -1 && n.push(a);
    });
  }
  _getHierarchyProperty(t, n) {
    return sn(this._hierarchy, t, (r, s) => {
      const i = r.classIds[s], o = r.classes[i], a = r.classIndexes[s], c = o.instances[n];
      return It(c) ? It(c.typedArray) ? this._getBinaryProperty(c, a) : Kn(c[a]) : null;
    });
  }
  _setHierarchyProperty(t, n, r, s) {
    const i = sn(this._hierarchy, n, (o, a) => {
      const c = o.classIds[a], h = o.classes[c], f = o.classIndexes[a], d = h.instances[r];
      return It(d) ? ($(a === n, `Inherited property "${r}" is read-only.`), It(d.typedArray) ? this._setBinaryProperty(d, f, s) : d[f] = Kn(s), !0) : !1;
    });
    return It(i);
  }
}
const us = 4;
function Mr(e, t, n = 0) {
  const r = new DataView(t);
  if (e.magic = r.getUint32(n, !0), n += us, e.version = r.getUint32(n, !0), n += us, e.byteLength = r.getUint32(n, !0), n += us, e.version !== 1)
    throw new Error(`3D Tile Version ${e.version} not supported`);
  return n;
}
const ve = 4, Do = "b3dm tile in legacy format.";
function li(e, t, n) {
  const r = new DataView(t);
  let s;
  e.header = e.header || {};
  let i = r.getUint32(n, !0);
  n += ve;
  let o = r.getUint32(n, !0);
  n += ve;
  let a = r.getUint32(n, !0);
  n += ve;
  let c = r.getUint32(n, !0);
  return n += ve, a >= 570425344 ? (n -= ve * 2, s = i, a = o, c = 0, i = 0, o = 0, console.warn(Do)) : c >= 570425344 && (n -= ve, s = a, a = i, c = o, i = 0, o = 0, console.warn(Do)), e.header.featureTableJsonByteLength = i, e.header.featureTableBinaryByteLength = o, e.header.batchTableJsonByteLength = a, e.header.batchTableBinaryByteLength = c, e.header.batchLength = s, n;
}
function fi(e, t, n, r) {
  return n = Mp(e, t, n), n = Rp(e, t, n), n;
}
function Mp(e, t, n, r) {
  const { featureTableJsonByteLength: s, featureTableBinaryByteLength: i, batchLength: o } = e.header || {};
  if (e.featureTableJson = {
    BATCH_LENGTH: o || 0
  }, s && s > 0) {
    const a = Mc(t, n, s);
    e.featureTableJson = JSON.parse(a);
  }
  return n += s || 0, e.featureTableBinary = new Uint8Array(t, n, i), n += i || 0, n;
}
function Rp(e, t, n, r) {
  const { batchTableJsonByteLength: s, batchTableBinaryByteLength: i } = e.header || {};
  if (s && s > 0) {
    const o = Mc(t, n, s);
    e.batchTableJson = JSON.parse(o), n += s, i && i > 0 && (e.batchTableBinary = new Uint8Array(t, n, i), e.batchTableBinary = new Uint8Array(e.batchTableBinary), n += i);
  }
  return n;
}
function Dc(e, t, n) {
  if (!t && (!e || !e.batchIds || !n))
    return null;
  const { batchIds: r, isRGB565: s, pointCount: i = 0 } = e;
  if (r && n) {
    const o = new Uint8ClampedArray(i * 3);
    for (let a = 0; a < i; a++) {
      const c = r[a], f = n.getProperty(c, "dimensions").map((d) => d * 255);
      o[a * 3] = f[0], o[a * 3 + 1] = f[1], o[a * 3 + 2] = f[2];
    }
    return {
      type: K.UNSIGNED_BYTE,
      value: o,
      size: 3,
      normalized: !0
    };
  }
  if (t && s) {
    const o = new Uint8ClampedArray(i * 3);
    for (let a = 0; a < i; a++) {
      const c = pp(t[a]);
      o[a * 3] = c[0], o[a * 3 + 1] = c[1], o[a * 3 + 2] = c[2];
    }
    return {
      type: K.UNSIGNED_BYTE,
      value: o,
      size: 3,
      normalized: !0
    };
  }
  return t && t.length === i * 3 ? {
    type: K.UNSIGNED_BYTE,
    value: t,
    size: 3,
    normalized: !0
  } : {
    type: K.UNSIGNED_BYTE,
    value: t || new Uint8ClampedArray(),
    size: 4,
    normalized: !0
  };
}
const Lo = new T();
function Sp(e, t) {
  if (!t)
    return null;
  if (e.isOctEncoded16P) {
    const n = new Float32Array((e.pointsLength || 0) * 3);
    for (let r = 0; r < (e.pointsLength || 0); r++)
      Ap(t[r * 2], t[r * 2 + 1], Lo), Lo.toArray(n, r * 3);
    return {
      type: K.FLOAT,
      size: 2,
      value: n
    };
  }
  return {
    type: K.FLOAT,
    size: 2,
    value: t
  };
}
function Fp(e, t, n) {
  return e.isQuantized ? n["3d-tiles"] && n["3d-tiles"].decodeQuantizedPositions ? (e.isQuantized = !1, Op(e, t)) : {
    type: K.UNSIGNED_SHORT,
    value: t,
    size: 3,
    normalized: !0
  } : t;
}
function Op(e, t) {
  const n = new T(), r = new Float32Array(e.pointCount * 3);
  for (let s = 0; s < e.pointCount; s++)
    n.set(t[s * 3], t[s * 3 + 1], t[s * 3 + 2]).scale(1 / e.quantizedRange).multiply(e.quantizedVolumeScale).add(e.quantizedVolumeOffset).toArray(r, s * 3);
  return r;
}
async function Dp(e, t, n, r, s) {
  n = Mr(e, t, n), n = li(e, t, n), n = fi(e, t, n), Lp(e);
  const { featureTable: i, batchTable: o } = Up(e);
  return await Hp(e, i, o, r, s), Np(e, i, r), Pp(e, i, o), Gp(e, i), n;
}
function Lp(e) {
  e.attributes = {
    positions: null,
    colors: null,
    normals: null,
    batchIds: null
  }, e.isQuantized = !1, e.isTranslucent = !1, e.isRGB565 = !1, e.isOctEncoded16P = !1;
}
function Up(e) {
  const t = new hi(e.featureTableJson, e.featureTableBinary), n = t.getGlobalProperty("POINTS_LENGTH");
  if (!Number.isFinite(n))
    throw new Error("POINTS_LENGTH must be defined");
  t.featuresLength = n, e.featuresLength = n, e.pointsLength = n, e.pointCount = n, e.rtcCenter = t.getGlobalProperty("RTC_CENTER", K.FLOAT, 3);
  const r = vp(e, t);
  return { featureTable: t, batchTable: r };
}
function Np(e, t, n) {
  if (e.attributes = e.attributes || {
    positions: null,
    colors: null,
    normals: null,
    batchIds: null
  }, !e.attributes.positions) {
    if (t.hasProperty("POSITION"))
      e.attributes.positions = t.getPropertyArray("POSITION", K.FLOAT, 3);
    else if (t.hasProperty("POSITION_QUANTIZED")) {
      const r = t.getPropertyArray("POSITION_QUANTIZED", K.UNSIGNED_SHORT, 3);
      if (e.isQuantized = !0, e.quantizedRange = 65535, e.quantizedVolumeScale = t.getGlobalProperty("QUANTIZED_VOLUME_SCALE", K.FLOAT, 3), !e.quantizedVolumeScale)
        throw new Error("QUANTIZED_VOLUME_SCALE must be defined for quantized positions.");
      if (e.quantizedVolumeOffset = t.getGlobalProperty("QUANTIZED_VOLUME_OFFSET", K.FLOAT, 3), !e.quantizedVolumeOffset)
        throw new Error("QUANTIZED_VOLUME_OFFSET must be defined for quantized positions.");
      e.attributes.positions = Fp(e, r, n);
    }
  }
  if (!e.attributes.positions)
    throw new Error("Either POSITION or POSITION_QUANTIZED must be defined.");
}
function Pp(e, t, n) {
  if (e.attributes = e.attributes || {
    positions: null,
    colors: null,
    normals: null,
    batchIds: null
  }, !e.attributes.colors) {
    let r = null;
    t.hasProperty("RGBA") ? (r = t.getPropertyArray("RGBA", K.UNSIGNED_BYTE, 4), e.isTranslucent = !0) : t.hasProperty("RGB") ? r = t.getPropertyArray("RGB", K.UNSIGNED_BYTE, 3) : t.hasProperty("RGB565") && (r = t.getPropertyArray("RGB565", K.UNSIGNED_SHORT, 1), e.isRGB565 = !0), e.attributes.colors = Dc(e, r, n);
  }
  t.hasProperty("CONSTANT_RGBA") && (e.constantRGBA = t.getGlobalProperty("CONSTANT_RGBA", K.UNSIGNED_BYTE, 4));
}
function Gp(e, t) {
  if (e.attributes = e.attributes || {
    positions: null,
    colors: null,
    normals: null,
    batchIds: null
  }, !e.attributes.normals) {
    let n = null;
    t.hasProperty("NORMAL") ? n = t.getPropertyArray("NORMAL", K.FLOAT, 3) : t.hasProperty("NORMAL_OCT16P") && (n = t.getPropertyArray("NORMAL_OCT16P", K.UNSIGNED_BYTE, 2), e.isOctEncoded16P = !0), e.attributes.normals = Sp(e, n);
  }
}
function vp(e, t) {
  let n = null;
  if (!e.batchIds && t.hasProperty("BATCH_ID") && (e.batchIds = t.getPropertyArray("BATCH_ID", K.UNSIGNED_SHORT, 1), e.batchIds)) {
    const r = t.getGlobalProperty("BATCH_LENGTH");
    if (!r)
      throw new Error("Global property: BATCH_LENGTH must be defined when BATCH_ID is defined.");
    const { batchTableJson: s, batchTableBinary: i } = e;
    n = new Oc(s, i, r);
  }
  return n;
}
async function Hp(e, t, n, r, s) {
  let i, o, a;
  const c = e.batchTableJson && e.batchTableJson.extensions && e.batchTableJson.extensions["3DTILES_draco_point_compression"];
  c && (a = c.properties);
  const h = t.getExtension("3DTILES_draco_point_compression");
  if (h) {
    o = h.properties;
    const d = h.byteOffset, p = h.byteLength;
    if (!o || !Number.isFinite(d) || !p)
      throw new Error("Draco properties, byteOffset, and byteLength must be defined");
    i = (e.featureTableBinary || []).slice(d, d + p), e.hasPositions = Number.isFinite(o.POSITION), e.hasColors = Number.isFinite(o.RGB) || Number.isFinite(o.RGBA), e.hasNormals = Number.isFinite(o.NORMAL), e.hasBatchIds = Number.isFinite(o.BATCH_ID), e.isTranslucent = Number.isFinite(o.RGBA);
  }
  if (!i)
    return !0;
  const f = {
    buffer: i,
    properties: { ...o, ...a },
    batchTableProperties: a
  };
  return await Jp(e, f, r, s);
}
async function Jp(e, t, n, r) {
  if (!r)
    return;
  const s = {
    ...n,
    draco: {
      ...n == null ? void 0 : n.draco,
      extraAttributes: t.batchTableProperties || {}
    }
  };
  delete s["3d-tiles"];
  const i = await Cn(t.buffer, Sc, s, r), o = i.attributes.POSITION && i.attributes.POSITION.value, a = i.attributes.COLOR_0 && i.attributes.COLOR_0.value, c = i.attributes.NORMAL && i.attributes.NORMAL.value, h = i.attributes.BATCH_ID && i.attributes.BATCH_ID.value, f = o && i.attributes.POSITION.value.quantization, d = c && i.attributes.NORMAL.value.quantization;
  if (f) {
    const g = i.POSITION.data.quantization, B = g.range;
    e.quantizedVolumeScale = new T(B, B, B), e.quantizedVolumeOffset = new T(g.minValues), e.quantizedRange = (1 << g.quantizationBits) - 1, e.isQuantizedDraco = !0;
  }
  d && (e.octEncodedRange = (1 << i.NORMAL.data.quantization.quantizationBits) - 1, e.isOctEncodedDraco = !0);
  const p = {};
  if (t.batchTableProperties)
    for (const g of Object.keys(t.batchTableProperties))
      i.attributes[g] && i.attributes[g].value && (p[g.toLowerCase()] = i.attributes[g].value);
  e.attributes = {
    // @ts-expect-error
    positions: o,
    // @ts-expect-error
    colors: Dc(e, a, void 0),
    // @ts-expect-error
    normals: c,
    // @ts-expect-error
    batchIds: h,
    ...p
  };
}
const kp = "4.3.3";
var ma;
const Vp = (ma = globalThis.loaders) == null ? void 0 : ma.parseImageNode, Ls = typeof Image < "u", Us = typeof ImageBitmap < "u", jp = !!Vp, Ns = Tr ? !0 : jp;
function Kp(e) {
  switch (e) {
    case "auto":
      return Us || Ls || Ns;
    case "imagebitmap":
      return Us;
    case "image":
      return Ls;
    case "data":
      return Ns;
    default:
      throw new Error(`@loaders.gl/images: image ${e} not supported in this environment`);
  }
}
function zp() {
  if (Us)
    return "imagebitmap";
  if (Ls)
    return "image";
  if (Ns)
    return "data";
  throw new Error("Install '@loaders.gl/polyfills' to parse images under Node.js");
}
function Wp(e) {
  const t = Qp(e);
  if (!t)
    throw new Error("Not an image");
  return t;
}
function Lc(e) {
  switch (Wp(e)) {
    case "data":
      return e;
    case "image":
    case "imagebitmap":
      const t = document.createElement("canvas"), n = t.getContext("2d");
      if (!n)
        throw new Error("getImageData");
      return t.width = e.width, t.height = e.height, n.drawImage(e, 0, 0), n.getImageData(0, 0, e.width, e.height);
    default:
      throw new Error("getImageData");
  }
}
function Qp(e) {
  return typeof ImageBitmap < "u" && e instanceof ImageBitmap ? "imagebitmap" : typeof Image < "u" && e instanceof Image ? "image" : e && typeof e == "object" && e.data && e.width && e.height ? "data" : null;
}
const $p = /^data:image\/svg\+xml/, Xp = /\.svg((\?|#).*)?$/;
function di(e) {
  return e && ($p.test(e) || Xp.test(e));
}
function qp(e, t) {
  if (di(t)) {
    let r = new TextDecoder().decode(e);
    try {
      typeof unescape == "function" && typeof encodeURIComponent == "function" && (r = unescape(encodeURIComponent(r)));
    } catch (i) {
      throw new Error(i.message);
    }
    return `data:image/svg+xml;base64,${btoa(r)}`;
  }
  return Uc(e, t);
}
function Uc(e, t) {
  if (di(t))
    throw new Error("SVG cannot be parsed directly to imagebitmap");
  return new Blob([new Uint8Array(e)]);
}
async function Nc(e, t, n) {
  const r = qp(e, n), s = self.URL || self.webkitURL, i = typeof r != "string" && s.createObjectURL(r);
  try {
    return await Yp(i || r, t);
  } finally {
    i && s.revokeObjectURL(i);
  }
}
async function Yp(e, t) {
  const n = new Image();
  return n.src = e, t.image && t.image.decode && n.decode ? (await n.decode(), n) : await new Promise((r, s) => {
    try {
      n.onload = () => r(n), n.onerror = (i) => {
        const o = i instanceof Error ? i.message : "error";
        s(new Error(o));
      };
    } catch (i) {
      s(i);
    }
  });
}
const Zp = {};
let Uo = !0;
async function tg(e, t, n) {
  let r;
  di(n) ? r = await Nc(e, t, n) : r = Uc(e, n);
  const s = t && t.imagebitmap;
  return await eg(r, s);
}
async function eg(e, t = null) {
  if ((ng(t) || !Uo) && (t = null), t)
    try {
      return await createImageBitmap(e, t);
    } catch (n) {
      console.warn(n), Uo = !1;
    }
  return await createImageBitmap(e);
}
function ng(e) {
  for (const t in e || Zp)
    return !1;
  return !0;
}
function rg(e) {
  return !ag(e, "ftyp", 4) || !(e[8] & 96) ? null : sg(e);
}
function sg(e) {
  switch (ig(e, 8, 12).replace("\0", " ").trim()) {
    case "avif":
    case "avis":
      return { extension: "avif", mimeType: "image/avif" };
    default:
      return null;
  }
}
function ig(e, t, n) {
  return String.fromCharCode(...e.slice(t, n));
}
function og(e) {
  return [...e].map((t) => t.charCodeAt(0));
}
function ag(e, t, n = 0) {
  const r = og(t);
  for (let s = 0; s < r.length; ++s)
    if (r[s] !== e[s + n])
      return !1;
  return !0;
}
const re = !1, fn = !0;
function mi(e) {
  const t = In(e);
  return ug(t) || fg(t) || hg(t) || lg(t) || cg(t);
}
function cg(e) {
  const t = new Uint8Array(e instanceof DataView ? e.buffer : e), n = rg(t);
  return n ? {
    mimeType: n.mimeType,
    // TODO - decode width and height
    width: 0,
    height: 0
  } : null;
}
function ug(e) {
  const t = In(e);
  return t.byteLength >= 24 && t.getUint32(0, re) === 2303741511 ? {
    mimeType: "image/png",
    width: t.getUint32(16, re),
    height: t.getUint32(20, re)
  } : null;
}
function hg(e) {
  const t = In(e);
  return t.byteLength >= 10 && t.getUint32(0, re) === 1195984440 ? {
    mimeType: "image/gif",
    width: t.getUint16(6, fn),
    height: t.getUint16(8, fn)
  } : null;
}
function lg(e) {
  const t = In(e);
  return t.byteLength >= 14 && t.getUint16(0, re) === 16973 && t.getUint32(2, fn) === t.byteLength ? {
    mimeType: "image/bmp",
    width: t.getUint32(18, fn),
    height: t.getUint32(22, fn)
  } : null;
}
function fg(e) {
  const t = In(e);
  if (!(t.byteLength >= 3 && t.getUint16(0, re) === 65496 && t.getUint8(2) === 255))
    return null;
  const { tableMarkers: r, sofMarkers: s } = dg();
  let i = 2;
  for (; i + 9 < t.byteLength; ) {
    const o = t.getUint16(i, re);
    if (s.has(o))
      return {
        mimeType: "image/jpeg",
        height: t.getUint16(i + 5, re),
        // Number of lines
        width: t.getUint16(i + 7, re)
        // Number of pixels per line
      };
    if (!r.has(o))
      return null;
    i += 2, i += t.getUint16(i, re);
  }
  return null;
}
function dg() {
  const e = /* @__PURE__ */ new Set([65499, 65476, 65484, 65501, 65534]);
  for (let n = 65504; n < 65520; ++n)
    e.add(n);
  return { tableMarkers: e, sofMarkers: /* @__PURE__ */ new Set([
    65472,
    65473,
    65474,
    65475,
    65477,
    65478,
    65479,
    65481,
    65482,
    65483,
    65485,
    65486,
    65487,
    65502
  ]) };
}
function In(e) {
  if (e instanceof DataView)
    return e;
  if (ArrayBuffer.isView(e))
    return new DataView(e.buffer);
  if (e instanceof ArrayBuffer)
    return new DataView(e);
  throw new Error("toDataView");
}
async function mg(e, t) {
  var s;
  const { mimeType: n } = mi(e) || {}, r = (s = globalThis.loaders) == null ? void 0 : s.parseImageNode;
  return $(r), await r(e, n);
}
async function pg(e, t, n) {
  t = t || {};
  const s = (t.image || {}).type || "auto", { url: i } = n || {}, o = gg(s);
  let a;
  switch (o) {
    case "imagebitmap":
      a = await tg(e, t, i);
      break;
    case "image":
      a = await Nc(e, t, i);
      break;
    case "data":
      a = await mg(e);
      break;
    default:
      $(!1);
  }
  return s === "data" && (a = Lc(a)), a;
}
function gg(e) {
  switch (e) {
    case "auto":
    case "data":
      return zp();
    default:
      return Kp(e), e;
  }
}
const Ag = ["png", "jpg", "jpeg", "gif", "webp", "bmp", "ico", "svg", "avif"], yg = [
  "image/png",
  "image/jpeg",
  "image/gif",
  "image/webp",
  "image/avif",
  "image/bmp",
  "image/vnd.microsoft.icon",
  "image/svg+xml"
], Bg = {
  image: {
    type: "auto",
    decode: !0
    // if format is HTML
  }
  // imagebitmap: {} - passes (platform dependent) parameters to ImageBitmap constructor
}, Eg = {
  dataType: null,
  batchType: null,
  id: "image",
  module: "images",
  name: "Images",
  version: kp,
  mimeTypes: yg,
  extensions: Ag,
  parse: pg,
  // TODO: byteOffset, byteLength;
  tests: [(e) => !!mi(new DataView(e))],
  options: Bg
}, hs = {};
function Cg(e) {
  if (hs[e] === void 0) {
    const t = Tr ? wg(e) : Tg(e);
    hs[e] = t;
  }
  return hs[e];
}
function Tg(e) {
  var s, i;
  const t = ["image/png", "image/jpeg", "image/gif"], n = ((s = globalThis.loaders) == null ? void 0 : s.imageFormatsNode) || t;
  return !!((i = globalThis.loaders) == null ? void 0 : i.parseImageNode) && n.includes(e);
}
function wg(e) {
  switch (e) {
    case "image/avif":
    case "image/webp":
      return bg(e);
    default:
      return !0;
  }
}
function bg(e) {
  try {
    return document.createElement("canvas").toDataURL(e).indexOf(`data:${e}`) === 0;
  } catch {
    return !1;
  }
}
function Ut(e, t) {
  if (!e)
    throw new Error(t || "assert failed: gltf");
}
const Pc = {
  SCALAR: 1,
  VEC2: 2,
  VEC3: 3,
  VEC4: 4,
  MAT2: 4,
  MAT3: 9,
  MAT4: 16
}, Gc = {
  5120: 1,
  // BYTE
  5121: 1,
  // UNSIGNED_BYTE
  5122: 2,
  // SHORT
  5123: 2,
  // UNSIGNED_SHORT
  5125: 4,
  // UNSIGNED_INT
  5126: 4
  // FLOAT
}, _g = 1.33, No = ["SCALAR", "VEC2", "VEC3", "VEC4"], Ig = [
  [Int8Array, 5120],
  [Uint8Array, 5121],
  [Int16Array, 5122],
  [Uint16Array, 5123],
  [Uint32Array, 5125],
  [Float32Array, 5126],
  [Float64Array, 5130]
], xg = new Map(Ig), Mg = {
  SCALAR: 1,
  VEC2: 2,
  VEC3: 3,
  VEC4: 4,
  MAT2: 4,
  MAT3: 9,
  MAT4: 16
}, Rg = {
  5120: 1,
  5121: 1,
  5122: 2,
  5123: 2,
  5125: 4,
  5126: 4
}, Sg = {
  5120: Int8Array,
  5121: Uint8Array,
  5122: Int16Array,
  5123: Uint16Array,
  5125: Uint32Array,
  5126: Float32Array
};
function vc(e) {
  return No[e - 1] || No[0];
}
function Rr(e) {
  const t = xg.get(e.constructor);
  if (!t)
    throw new Error("Illegal typed array");
  return t;
}
function pi(e, t) {
  const n = Sg[e.componentType], r = Mg[e.type], s = Rg[e.componentType], i = e.count * r, o = e.count * r * s;
  Ut(o >= 0 && o <= t.byteLength);
  const a = Gc[e.componentType], c = Pc[e.type];
  return { ArrayType: n, length: i, byteLength: o, componentByteSize: a, numberOfComponentsInElement: c };
}
function Hc(e) {
  let { images: t, bufferViews: n } = e;
  t = t || [], n = n || [];
  const r = t.map((o) => o.bufferView);
  n = n.filter((o) => !r.includes(o));
  const s = n.reduce((o, a) => o + a.byteLength, 0), i = t.reduce((o, a) => {
    const { width: c, height: h } = a.image;
    return o + c * h;
  }, 0);
  return s + Math.ceil(4 * i * _g);
}
function Fg(e, t, n) {
  const r = e.bufferViews[n];
  Ut(r);
  const s = r.buffer, i = t[s];
  Ut(i);
  const o = (r.byteOffset || 0) + i.byteOffset;
  return new Uint8Array(i.arrayBuffer, o, r.byteLength);
}
function Og(e, t, n) {
  var C, b;
  const r = typeof n == "number" ? (C = e.accessors) == null ? void 0 : C[n] : n;
  if (!r)
    throw new Error(`No gltf accessor ${JSON.stringify(n)}`);
  const s = (b = e.bufferViews) == null ? void 0 : b[r.bufferView || 0];
  if (!s)
    throw new Error(`No gltf buffer view for accessor ${s}`);
  const { arrayBuffer: i, byteOffset: o } = t[s.buffer], a = (o || 0) + (r.byteOffset || 0) + (s.byteOffset || 0), { ArrayType: c, length: h, componentByteSize: f, numberOfComponentsInElement: d } = pi(r, s), p = f * d, g = s.byteStride || p;
  if (typeof s.byteStride > "u" || s.byteStride === p)
    return new c(i, a, h);
  const B = new c(h);
  for (let M = 0; M < r.count; M++) {
    const D = new c(i, a + M * g, d);
    B.set(D, M * d);
  }
  return B;
}
function Dg() {
  return {
    asset: {
      version: "2.0",
      generator: "loaders.gl"
    },
    buffers: [],
    extensions: {},
    extensionsRequired: [],
    extensionsUsed: []
  };
}
class Ct {
  // TODO - why is this not GLTFWithBuffers - what happens to images?
  constructor(t) {
    // internal
    y(this, "gltf");
    y(this, "sourceBuffers");
    y(this, "byteLength");
    this.gltf = {
      json: (t == null ? void 0 : t.json) || Dg(),
      buffers: (t == null ? void 0 : t.buffers) || [],
      images: (t == null ? void 0 : t.images) || []
    }, this.sourceBuffers = [], this.byteLength = 0, this.gltf.buffers && this.gltf.buffers[0] && (this.byteLength = this.gltf.buffers[0].byteLength, this.sourceBuffers = [this.gltf.buffers[0]]);
  }
  // Accessors
  get json() {
    return this.gltf.json;
  }
  getApplicationData(t) {
    return this.json[t];
  }
  getExtraData(t) {
    return (this.json.extras || {})[t];
  }
  hasExtension(t) {
    const n = this.getUsedExtensions().find((s) => s === t), r = this.getRequiredExtensions().find((s) => s === t);
    return typeof n == "string" || typeof r == "string";
  }
  getExtension(t) {
    const n = this.getUsedExtensions().find((s) => s === t), r = this.json.extensions || {};
    return n ? r[t] : null;
  }
  getRequiredExtension(t) {
    return this.getRequiredExtensions().find((r) => r === t) ? this.getExtension(t) : null;
  }
  getRequiredExtensions() {
    return this.json.extensionsRequired || [];
  }
  getUsedExtensions() {
    return this.json.extensionsUsed || [];
  }
  getRemovedExtensions() {
    return this.json.extensionsRemoved || [];
  }
  getObjectExtension(t, n) {
    return (t.extensions || {})[n];
  }
  getScene(t) {
    return this.getObject("scenes", t);
  }
  getNode(t) {
    return this.getObject("nodes", t);
  }
  getSkin(t) {
    return this.getObject("skins", t);
  }
  getMesh(t) {
    return this.getObject("meshes", t);
  }
  getMaterial(t) {
    return this.getObject("materials", t);
  }
  getAccessor(t) {
    return this.getObject("accessors", t);
  }
  // getCamera(index: number): object | null {
  //   return null; // TODO: fix thi: object  as null;
  // }
  getTexture(t) {
    return this.getObject("textures", t);
  }
  getSampler(t) {
    return this.getObject("samplers", t);
  }
  getImage(t) {
    return this.getObject("images", t);
  }
  getBufferView(t) {
    return this.getObject("bufferViews", t);
  }
  getBuffer(t) {
    return this.getObject("buffers", t);
  }
  getObject(t, n) {
    if (typeof n == "object")
      return n;
    const r = this.json[t] && this.json[t][n];
    if (!r)
      throw new Error(`glTF file error: Could not find ${t}[${n}]`);
    return r;
  }
  /**
   * Accepts buffer view index or buffer view object
   * @returns a `Uint8Array`
   */
  getTypedArrayForBufferView(t) {
    t = this.getBufferView(t);
    const n = t.buffer, r = this.gltf.buffers[n];
    Ut(r);
    const s = (t.byteOffset || 0) + r.byteOffset;
    return new Uint8Array(r.arrayBuffer, s, t.byteLength);
  }
  /** Accepts accessor index or accessor object
   * @returns a typed array with type that matches the types
   */
  getTypedArrayForAccessor(t) {
    const n = this.getAccessor(t);
    return Og(this.gltf.json, this.gltf.buffers, n);
  }
  /** accepts accessor index or accessor object
   * returns a `Uint8Array`
   */
  getTypedArrayForImageData(t) {
    t = this.getAccessor(t);
    const n = this.getBufferView(t.bufferView), s = this.getBuffer(n.buffer).data, i = n.byteOffset || 0;
    return new Uint8Array(s, i, n.byteLength);
  }
  // MODIFERS
  /**
   * Add an extra application-defined key to the top-level data structure
   */
  addApplicationData(t, n) {
    return this.json[t] = n, this;
  }
  /**
   * `extras` - Standard GLTF field for storing application specific data
   */
  addExtraData(t, n) {
    return this.json.extras = this.json.extras || {}, this.json.extras[t] = n, this;
  }
  addObjectExtension(t, n, r) {
    return t.extensions = t.extensions || {}, t.extensions[n] = r, this.registerUsedExtension(n), this;
  }
  setObjectExtension(t, n, r) {
    const s = t.extensions || {};
    s[n] = r;
  }
  removeObjectExtension(t, n) {
    const r = (t == null ? void 0 : t.extensions) || {};
    if (r[n]) {
      this.json.extensionsRemoved = this.json.extensionsRemoved || [];
      const s = this.json.extensionsRemoved;
      s.includes(n) || s.push(n);
    }
    delete r[n];
  }
  /**
   * Add to standard GLTF top level extension object, mark as used
   */
  addExtension(t, n = {}) {
    return Ut(n), this.json.extensions = this.json.extensions || {}, this.json.extensions[t] = n, this.registerUsedExtension(t), n;
  }
  /**
   * Standard GLTF top level extension object, mark as used and required
   */
  addRequiredExtension(t, n = {}) {
    return Ut(n), this.addExtension(t, n), this.registerRequiredExtension(t), n;
  }
  /**
   * Add extensionName to list of used extensions
   */
  registerUsedExtension(t) {
    this.json.extensionsUsed = this.json.extensionsUsed || [], this.json.extensionsUsed.find((n) => n === t) || this.json.extensionsUsed.push(t);
  }
  /**
   * Add extensionName to list of required extensions
   */
  registerRequiredExtension(t) {
    this.registerUsedExtension(t), this.json.extensionsRequired = this.json.extensionsRequired || [], this.json.extensionsRequired.find((n) => n === t) || this.json.extensionsRequired.push(t);
  }
  /**
   * Removes an extension from the top-level list
   */
  removeExtension(t) {
    var n;
    if ((n = this.json.extensions) != null && n[t]) {
      this.json.extensionsRemoved = this.json.extensionsRemoved || [];
      const r = this.json.extensionsRemoved;
      r.includes(t) || r.push(t);
    }
    this.json.extensions && delete this.json.extensions[t], this.json.extensionsRequired && this._removeStringFromArray(this.json.extensionsRequired, t), this.json.extensionsUsed && this._removeStringFromArray(this.json.extensionsUsed, t);
  }
  /**
   *  Set default scene which is to be displayed at load time
   */
  setDefaultScene(t) {
    this.json.scene = t;
  }
  /**
   * @todo: add more properties for scene initialization:
   *   name`, `extensions`, `extras`
   *   https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#reference-scene
   */
  addScene(t) {
    const { nodeIndices: n } = t;
    return this.json.scenes = this.json.scenes || [], this.json.scenes.push({ nodes: n }), this.json.scenes.length - 1;
  }
  /**
   * @todo: add more properties for node initialization:
   *   `name`, `extensions`, `extras`, `camera`, `children`, `skin`, `rotation`, `scale`, `translation`, `weights`
   *   https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#node
   */
  addNode(t) {
    const { meshIndex: n, matrix: r } = t;
    this.json.nodes = this.json.nodes || [];
    const s = { mesh: n };
    return r && (s.matrix = r), this.json.nodes.push(s), this.json.nodes.length - 1;
  }
  /** Adds a mesh to the json part */
  addMesh(t) {
    const { attributes: n, indices: r, material: s, mode: i = 4 } = t, a = {
      primitives: [
        {
          attributes: this._addAttributes(n),
          mode: i
        }
      ]
    };
    if (r) {
      const c = this._addIndices(r);
      a.primitives[0].indices = c;
    }
    return Number.isFinite(s) && (a.primitives[0].material = s), this.json.meshes = this.json.meshes || [], this.json.meshes.push(a), this.json.meshes.length - 1;
  }
  addPointCloud(t) {
    const r = {
      primitives: [
        {
          attributes: this._addAttributes(t),
          mode: 0
          // GL.POINTS
        }
      ]
    };
    return this.json.meshes = this.json.meshes || [], this.json.meshes.push(r), this.json.meshes.length - 1;
  }
  /**
   * Adds a binary image. Builds glTF "JSON metadata" and saves buffer reference
   * Buffer will be copied into BIN chunk during "pack"
   * Currently encodes as glTF image
   * @param imageData
   * @param mimeType
   */
  addImage(t, n) {
    const r = mi(t), s = n || (r == null ? void 0 : r.mimeType), o = {
      bufferView: this.addBufferView(t),
      mimeType: s
    };
    return this.json.images = this.json.images || [], this.json.images.push(o), this.json.images.length - 1;
  }
  /**
   * Add one untyped source buffer, create a matching glTF `bufferView`, and return its index
   * @param buffer
   */
  addBufferView(t, n = 0, r = this.byteLength) {
    const s = t.byteLength;
    Ut(Number.isFinite(s)), this.sourceBuffers = this.sourceBuffers || [], this.sourceBuffers.push(t);
    const i = {
      buffer: n,
      // Write offset from the start of the binary body
      byteOffset: r,
      byteLength: s
    };
    return this.byteLength += Tn(s, 4), this.json.bufferViews = this.json.bufferViews || [], this.json.bufferViews.push(i), this.json.bufferViews.length - 1;
  }
  /**
   * Adds an accessor to a bufferView
   * @param bufferViewIndex
   * @param accessor
   */
  addAccessor(t, n) {
    const r = {
      bufferView: t,
      // @ts-ignore
      type: vc(n.size),
      // @ts-ignore
      componentType: n.componentType,
      // @ts-ignore
      count: n.count,
      // @ts-ignore
      max: n.max,
      // @ts-ignore
      min: n.min
    };
    return this.json.accessors = this.json.accessors || [], this.json.accessors.push(r), this.json.accessors.length - 1;
  }
  /**
   * Add a binary buffer. Builds glTF "JSON metadata" and saves buffer reference
   * Buffer will be copied into BIN chunk during "pack"
   * Currently encodes buffers as glTF accessors, but this could be optimized
   * @param sourceBuffer
   * @param accessor
   */
  addBinaryBuffer(t, n = { size: 3 }) {
    const r = this.addBufferView(t);
    let s = { min: n.min, max: n.max };
    (!s.min || !s.max) && (s = this._getAccessorMinMax(t, n.size));
    const i = {
      // @ts-ignore
      size: n.size,
      componentType: Rr(t),
      // @ts-ignore
      count: Math.round(t.length / n.size),
      min: s.min,
      max: s.max
    };
    return this.addAccessor(r, Object.assign(i, n));
  }
  /**
   * Adds a texture to the json part
   * @todo: add more properties for texture initialization
   * `sampler`, `name`, `extensions`, `extras`
   * https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#texture
   */
  addTexture(t) {
    const { imageIndex: n } = t, r = {
      source: n
    };
    return this.json.textures = this.json.textures || [], this.json.textures.push(r), this.json.textures.length - 1;
  }
  /** Adds a material to the json part */
  addMaterial(t) {
    return this.json.materials = this.json.materials || [], this.json.materials.push(t), this.json.materials.length - 1;
  }
  /** Pack the binary chunk */
  createBinaryChunk() {
    var i, o;
    const t = this.byteLength, n = new ArrayBuffer(t), r = new Uint8Array(n);
    let s = 0;
    for (const a of this.sourceBuffers || [])
      s = wl(a, r, s);
    (o = (i = this.json) == null ? void 0 : i.buffers) != null && o[0] ? this.json.buffers[0].byteLength = t : this.json.buffers = [{ byteLength: t }], this.gltf.binary = n, this.sourceBuffers = [n], this.gltf.buffers = [{ arrayBuffer: n, byteOffset: 0, byteLength: n.byteLength }];
  }
  // PRIVATE
  _removeStringFromArray(t, n) {
    let r = !0;
    for (; r; ) {
      const s = t.indexOf(n);
      s > -1 ? t.splice(s, 1) : r = !1;
    }
  }
  /**
   * Add attributes to buffers and create `attributes` object which is part of `mesh`
   */
  _addAttributes(t = {}) {
    const n = {};
    for (const r in t) {
      const s = t[r], i = this._getGltfAttributeName(r), o = this.addBinaryBuffer(s.value, s);
      n[i] = o;
    }
    return n;
  }
  /**
   * Add indices to buffers
   */
  _addIndices(t) {
    return this.addBinaryBuffer(t, { size: 1 });
  }
  /**
   * Deduce gltf specific attribue name from input attribute name
   */
  _getGltfAttributeName(t) {
    switch (t.toLowerCase()) {
      case "position":
      case "positions":
      case "vertices":
        return "POSITION";
      case "normal":
      case "normals":
        return "NORMAL";
      case "color":
      case "colors":
        return "COLOR_0";
      case "texcoord":
      case "texcoords":
        return "TEXCOORD_0";
      default:
        return t;
    }
  }
  /**
   * Calculate `min` and `max` arrays of accessor according to spec:
   * https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#reference-accessor
   */
  _getAccessorMinMax(t, n) {
    const r = { min: null, max: null };
    if (t.length < n)
      return r;
    r.min = [], r.max = [];
    const s = t.subarray(0, n);
    for (const i of s)
      r.min.push(i), r.max.push(i);
    for (let i = n; i < t.length; i += n)
      for (let o = 0; o < n; o++)
        r.min[0 + o] = Math.min(
          // @ts-ignore
          r.min[0 + o],
          t[i + o]
        ), r.max[0 + o] = Math.max(
          // @ts-ignore
          r.max[0 + o],
          t[i + o]
        );
    return r;
  }
}
function Po(e) {
  return (e % 1 + 1) % 1;
}
const Jc = {
  SCALAR: 1,
  VEC2: 2,
  VEC3: 3,
  VEC4: 4,
  MAT2: 4,
  MAT3: 9,
  MAT4: 16,
  BOOLEAN: 1,
  STRING: 1,
  ENUM: 1
}, Lg = {
  INT8: Int8Array,
  UINT8: Uint8Array,
  INT16: Int16Array,
  UINT16: Uint16Array,
  INT32: Int32Array,
  UINT32: Uint32Array,
  INT64: BigInt64Array,
  UINT64: BigUint64Array,
  FLOAT32: Float32Array,
  FLOAT64: Float64Array
}, kc = {
  INT8: 1,
  UINT8: 1,
  INT16: 2,
  UINT16: 2,
  INT32: 4,
  UINT32: 4,
  INT64: 8,
  UINT64: 8,
  FLOAT32: 4,
  FLOAT64: 8
};
function gi(e, t) {
  return kc[t] * Jc[e];
}
function Sr(e, t, n, r) {
  if (n !== "UINT8" && n !== "UINT16" && n !== "UINT32" && n !== "UINT64")
    return null;
  const s = e.getTypedArrayForBufferView(t), i = Fr(
    s,
    "SCALAR",
    // offsets consist of ONE component
    n,
    r + 1
    // The number of offsets is equal to the property table `count` plus one.
  );
  return i instanceof BigInt64Array || i instanceof BigUint64Array ? null : i;
}
function Fr(e, t, n, r = 1) {
  const s = Jc[t], i = Lg[n], o = kc[n], a = r * s, c = a * o;
  let h = e.buffer, f = e.byteOffset;
  return f % o !== 0 && (h = new Uint8Array(h).slice(f, f + c).buffer, f = 0), new i(h, f, a);
}
function Ai(e, t, n) {
  var h, f, d, p, g;
  const r = `TEXCOORD_${t.texCoord || 0}`, s = n.attributes[r], i = e.getTypedArrayForAccessor(s), o = e.gltf.json, a = t.index, c = (f = (h = o.textures) == null ? void 0 : h[a]) == null ? void 0 : f.source;
  if (typeof c < "u") {
    const B = (p = (d = o.images) == null ? void 0 : d[c]) == null ? void 0 : p.mimeType, C = (g = e.gltf.images) == null ? void 0 : g[c];
    if (C && typeof C.width < "u") {
      const b = [];
      for (let M = 0; M < i.length; M += 2) {
        const D = Ug(C, B, i, M, t.channels);
        b.push(D);
      }
      return b;
    }
  }
  return [];
}
function Vc(e, t, n, r, s) {
  if (!(n != null && n.length))
    return;
  const i = [];
  for (const f of n) {
    let d = r.findIndex((p) => p === f);
    d === -1 && (d = r.push(f) - 1), i.push(d);
  }
  const o = new Uint32Array(i), a = e.gltf.buffers.push({
    arrayBuffer: o.buffer,
    byteOffset: o.byteOffset,
    byteLength: o.byteLength
  }) - 1, c = e.addBufferView(o, a, 0), h = e.addAccessor(c, {
    size: 1,
    componentType: Rr(o),
    count: o.length
  });
  s.attributes[t] = h;
}
function Ug(e, t, n, r, s = [0]) {
  const i = {
    r: { offset: 0, shift: 0 },
    g: { offset: 1, shift: 8 },
    b: { offset: 2, shift: 16 },
    a: { offset: 3, shift: 24 }
  }, o = n[r], a = n[r + 1];
  let c = 1;
  t && (t.indexOf("image/jpeg") !== -1 || t.indexOf("image/png") !== -1) && (c = 4);
  const h = Ng(o, a, e, c);
  let f = 0;
  for (const d of s) {
    const p = typeof d == "number" ? Object.values(i)[d] : i[d], g = h + p.offset, B = Lc(e);
    if (B.data.length <= g)
      throw new Error(`${B.data.length} <= ${g}`);
    const C = B.data[g];
    f |= C << p.shift;
  }
  return f;
}
function Ng(e, t, n, r = 1) {
  const s = n.width, i = Po(e) * (s - 1), o = Math.round(i), a = n.height, c = Po(t) * (a - 1), h = Math.round(c), f = n.components ? n.components : r;
  return (h * s + o) * f;
}
function jc(e, t, n, r, s) {
  const i = [];
  for (let o = 0; o < t; o++) {
    const a = n[o], c = n[o + 1] - n[o];
    if (c + a > r)
      break;
    const h = a / s, f = c / s;
    i.push(e.slice(h, h + f));
  }
  return i;
}
function Kc(e, t, n) {
  const r = [];
  for (let s = 0; s < t; s++) {
    const i = s * n;
    r.push(e.slice(i, i + n));
  }
  return r;
}
function zc(e, t, n, r) {
  if (n)
    throw new Error("Not implemented - arrayOffsets for strings is specified");
  if (r) {
    const s = [], i = new TextDecoder("utf8");
    let o = 0;
    for (let a = 0; a < e; a++) {
      const c = r[a + 1] - r[a];
      if (c + o <= t.length) {
        const h = t.subarray(o, c + o), f = i.decode(h);
        s.push(f), o += c;
      }
    }
    return s;
  }
  return [];
}
const We = "EXT_mesh_features", Pg = We;
async function Gg(e, t) {
  const n = new Ct(e);
  Hg(n, t);
}
function vg(e, t) {
  const n = new Ct(e);
  return kg(n), n.createBinaryChunk(), n.gltf;
}
function Hg(e, t) {
  const n = e.gltf.json;
  if (n.meshes)
    for (const r of n.meshes)
      for (const s of r.primitives)
        Jg(e, s, t);
}
function Jg(e, t, n) {
  var i, o, a;
  if (!((i = n == null ? void 0 : n.gltf) != null && i.loadBuffers))
    return;
  const r = (o = t.extensions) == null ? void 0 : o[We], s = r == null ? void 0 : r.featureIds;
  if (s)
    for (const c of s) {
      let h;
      if (typeof c.attribute < "u") {
        const f = `_FEATURE_ID_${c.attribute}`, d = t.attributes[f];
        h = e.getTypedArrayForAccessor(d);
      } else typeof c.texture < "u" && ((a = n == null ? void 0 : n.gltf) != null && a.loadImages) ? h = Ai(e, c.texture, t) : h = [];
      c.data = h;
    }
}
function kg(e, t) {
  const n = e.gltf.json.meshes;
  if (n)
    for (const r of n)
      for (const s of r.primitives)
        jg(e, s);
}
function Vg(e, t, n, r) {
  t.extensions || (t.extensions = {});
  let s = t.extensions[We];
  s || (s = { featureIds: [] }, t.extensions[We] = s);
  const { featureIds: i } = s, o = {
    featureCount: n.length,
    propertyTable: r,
    data: n
  };
  i.push(o), e.addObjectExtension(t, We, s);
}
function jg(e, t) {
  var s;
  const n = (s = t.extensions) == null ? void 0 : s[We];
  if (!n)
    return;
  const r = n.featureIds;
  r.forEach((i, o) => {
    if (i.data) {
      const { accessorKey: a, index: c } = Kg(t.attributes), h = new Uint32Array(i.data);
      r[o] = {
        featureCount: h.length,
        propertyTable: i.propertyTable,
        attribute: c
      }, e.gltf.buffers.push({
        arrayBuffer: h.buffer,
        byteOffset: h.byteOffset,
        byteLength: h.byteLength
      });
      const f = e.addBufferView(h), d = e.addAccessor(f, {
        size: 1,
        componentType: Rr(h),
        count: h.length
      });
      t.attributes[a] = d;
    }
  });
}
function Kg(e) {
  const t = "_FEATURE_ID_", n = Object.keys(e).filter((i) => i.indexOf(t) === 0);
  let r = -1;
  for (const i of n) {
    const o = Number(i.substring(t.length));
    o > r && (r = o);
  }
  return r++, { accessorKey: `${t}${r}`, index: r };
}
const zg = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createExtMeshFeatures: Vg,
  decode: Gg,
  encode: vg,
  name: Pg
}, Symbol.toStringTag, { value: "Module" })), Xe = "EXT_structural_metadata", Wg = Xe;
async function Qg(e, t) {
  const n = new Ct(e);
  Xg(n, t);
}
function $g(e, t) {
  const n = new Ct(e);
  return fA(n), n.createBinaryChunk(), n.gltf;
}
function Xg(e, t) {
  var r, s;
  if (!((r = t.gltf) != null && r.loadBuffers))
    return;
  const n = e.getExtension(Xe);
  n && ((s = t.gltf) != null && s.loadImages && qg(e, n), Yg(e, n));
}
function qg(e, t) {
  const n = t.propertyTextures, r = e.gltf.json;
  if (n && r.meshes)
    for (const s of r.meshes)
      for (const i of s.primitives)
        tA(e, n, i, t);
}
function Yg(e, t) {
  const n = t.schema;
  if (!n)
    return;
  const r = n.classes, s = t.propertyTables;
  if (r && s)
    for (const i in r) {
      const o = Zg(s, i);
      o && nA(e, n, o);
    }
}
function Zg(e, t) {
  for (const n of e)
    if (n.class === t)
      return n;
  return null;
}
function tA(e, t, n, r) {
  var o;
  if (!t)
    return;
  const s = (o = n.extensions) == null ? void 0 : o[Xe], i = s == null ? void 0 : s.propertyTextures;
  if (i)
    for (const a of i) {
      const c = t[a];
      eA(e, c, n, r);
    }
}
function eA(e, t, n, r) {
  var i;
  if (!t.properties)
    return;
  r.dataAttributeNames || (r.dataAttributeNames = []);
  const s = t.class;
  for (const o in t.properties) {
    const a = `${s}_${o}`, c = (i = t.properties) == null ? void 0 : i[o];
    if (!c)
      continue;
    c.data || (c.data = []);
    const h = c.data, f = Ai(e, c, n);
    f !== null && (Vc(e, a, f, h, n), c.data = h, r.dataAttributeNames.push(a));
  }
}
function nA(e, t, n) {
  var i, o;
  const r = (i = t.classes) == null ? void 0 : i[n.class];
  if (!r)
    throw new Error(`Incorrect data in the EXT_structural_metadata extension: no schema class with name ${n.class}`);
  const s = n.count;
  for (const a in r.properties) {
    const c = r.properties[a], h = (o = n.properties) == null ? void 0 : o[a];
    if (h) {
      const f = rA(e, t, c, s, h);
      h.data = f;
    }
  }
}
function rA(e, t, n, r, s) {
  let i = [];
  const o = s.values, a = e.getTypedArrayForBufferView(o), c = sA(e, n, s, r), h = iA(e, s, r);
  switch (n.type) {
    case "SCALAR":
    case "VEC2":
    case "VEC3":
    case "VEC4":
    case "MAT2":
    case "MAT3":
    case "MAT4": {
      i = oA(n, r, a, c);
      break;
    }
    case "BOOLEAN":
      throw new Error(`Not implemented - classProperty.type=${n.type}`);
    case "STRING": {
      i = zc(r, a, c, h);
      break;
    }
    case "ENUM": {
      i = aA(t, n, r, a, c);
      break;
    }
    default:
      throw new Error(`Unknown classProperty type ${n.type}`);
  }
  return i;
}
function sA(e, t, n, r) {
  return t.array && // `count` is a number of array elements. May only be defined when `array` is true.
  // If `count` is NOT defined, it's a VARIABLE-length array
  typeof t.count > "u" && // `arrayOffsets` is an index of the buffer view containing offsets for variable-length arrays.
  typeof n.arrayOffsets < "u" ? Sr(e, n.arrayOffsets, n.arrayOffsetType || "UINT32", r) : null;
}
function iA(e, t, n) {
  return typeof t.stringOffsets < "u" ? Sr(e, t.stringOffsets, t.stringOffsetType || "UINT32", n) : null;
}
function oA(e, t, n, r) {
  const s = e.array, i = e.count, o = gi(e.type, e.componentType), a = n.byteLength / o;
  let c;
  return e.componentType ? c = Fr(
    n,
    e.type,
    // The datatype of the element's components. Only applicable to `SCALAR`, `VECN`, and `MATN` types.
    e.componentType,
    a
  ) : c = n, s ? r ? jc(c, t, r, n.length, o) : i ? Kc(c, t, i) : [] : c;
}
function aA(e, t, n, r, s) {
  var d;
  const i = t.enumType;
  if (!i)
    throw new Error("Incorrect data in the EXT_structural_metadata extension: classProperty.enumType is not set for type ENUM");
  const o = (d = e.enums) == null ? void 0 : d[i];
  if (!o)
    throw new Error(`Incorrect data in the EXT_structural_metadata extension: schema.enums does't contain ${i}`);
  const a = o.valueType || "UINT16", c = gi(t.type, a), h = r.byteLength / c;
  let f = Fr(r, t.type, a, h);
  if (f || (f = r), t.array) {
    if (s)
      return cA({
        valuesData: f,
        numberOfElements: n,
        arrayOffsets: s,
        valuesDataBytesLength: r.length,
        elementSize: c,
        enumEntry: o
      });
    const p = t.count;
    return p ? uA(f, n, p, o) : [];
  }
  return yi(f, 0, n, o);
}
function cA(e) {
  const { valuesData: t, numberOfElements: n, arrayOffsets: r, valuesDataBytesLength: s, elementSize: i, enumEntry: o } = e, a = [];
  for (let c = 0; c < n; c++) {
    const h = r[c], f = r[c + 1] - r[c];
    if (f + h > s)
      break;
    const d = h / i, p = f / i, g = yi(t, d, p, o);
    a.push(g);
  }
  return a;
}
function uA(e, t, n, r) {
  const s = [];
  for (let i = 0; i < t; i++) {
    const o = n * i, a = yi(e, o, n, r);
    s.push(a);
  }
  return s;
}
function yi(e, t, n, r) {
  const s = [];
  for (let i = 0; i < n; i++)
    if (e instanceof BigInt64Array || e instanceof BigUint64Array)
      s.push("");
    else {
      const o = e[t + i], a = hA(r, o);
      a ? s.push(a.name) : s.push("");
    }
  return s;
}
function hA(e, t) {
  for (const n of e.values)
    if (n.value === t)
      return n;
  return null;
}
const lA = "schemaClassId";
function fA(e, t) {
  var r, s;
  const n = e.getExtension(Xe);
  if (n && n.propertyTables)
    for (const i of n.propertyTables) {
      const o = i.class, a = (s = (r = n.schema) == null ? void 0 : r.classes) == null ? void 0 : s[o];
      i.properties && a && dA(i, a, e);
    }
}
function dA(e, t, n) {
  for (const r in e.properties) {
    const s = e.properties[r].data;
    if (s) {
      const i = t.properties[r];
      if (i) {
        const o = AA(s, i, n);
        e.properties[r] = o;
      }
    }
  }
}
function mA(e, t, n = lA) {
  let r = e.getExtension(Xe);
  r || (r = e.addExtension(Xe)), r.schema = pA(t, n, r.schema);
  const s = gA(t, n, r.schema);
  return r.propertyTables || (r.propertyTables = []), r.propertyTables.push(s) - 1;
}
function pA(e, t, n) {
  const r = n ?? {
    id: "schema_id"
  }, s = {
    properties: {}
  };
  for (const i of e) {
    const o = {
      type: i.elementType,
      componentType: i.componentType
    };
    s.properties[i.name] = o;
  }
  return r.classes = {}, r.classes[t] = s, r;
}
function gA(e, t, n) {
  var o;
  const r = {
    class: t,
    count: 0
  };
  let s = 0;
  const i = (o = n.classes) == null ? void 0 : o[t];
  for (const a of e) {
    if (s === 0 && (s = a.values.length), s !== a.values.length && a.values.length)
      throw new Error("Illegal values in attributes");
    (i == null ? void 0 : i.properties[a.name]) && (r.properties || (r.properties = {}), r.properties[a.name] = { values: 0, data: a.values });
  }
  return r.count = s, r;
}
function AA(e, t, n) {
  const r = { values: 0 };
  if (t.type === "STRING") {
    const { stringData: s, stringOffsets: i } = EA(e);
    r.stringOffsets = ls(i, n), r.values = ls(s, n);
  } else if (t.type === "SCALAR" && t.componentType) {
    const s = BA(e, t.componentType);
    r.values = ls(s, n);
  }
  return r;
}
const yA = {
  INT8: Int8Array,
  UINT8: Uint8Array,
  INT16: Int16Array,
  UINT16: Uint16Array,
  INT32: Int32Array,
  UINT32: Uint32Array,
  INT64: Int32Array,
  UINT64: Uint32Array,
  FLOAT32: Float32Array,
  FLOAT64: Float64Array
};
function BA(e, t) {
  const n = [];
  for (const s of e)
    n.push(Number(s));
  const r = yA[t];
  if (!r)
    throw new Error("Illegal component type");
  return new r(n);
}
function EA(e) {
  const t = new TextEncoder(), n = [];
  let r = 0;
  for (const c of e) {
    const h = t.encode(c);
    r += h.length, n.push(h);
  }
  const s = new Uint8Array(r), i = [];
  let o = 0;
  for (const c of n)
    s.set(c, o), i.push(o), o += c.length;
  i.push(o);
  const a = new Uint32Array(i);
  return { stringData: s, stringOffsets: a };
}
function ls(e, t) {
  return t.gltf.buffers.push({
    arrayBuffer: e.buffer,
    byteOffset: e.byteOffset,
    byteLength: e.byteLength
  }), t.addBufferView(e);
}
const CA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  createExtStructuralMetadata: mA,
  decode: Qg,
  encode: $g,
  name: Wg
}, Symbol.toStringTag, { value: "Module" })), Wc = "EXT_feature_metadata", TA = Wc;
async function wA(e, t) {
  const n = new Ct(e);
  bA(n, t);
}
function bA(e, t) {
  var r, s;
  if (!((r = t.gltf) != null && r.loadBuffers))
    return;
  const n = e.getExtension(Wc);
  n && ((s = t.gltf) != null && s.loadImages && _A(e, n), IA(e, n));
}
function _A(e, t) {
  const n = t.schema;
  if (!n)
    return;
  const r = n.classes, { featureTextures: s } = t;
  if (r && s)
    for (const i in r) {
      const o = r[i], a = MA(s, i);
      a && SA(e, a, o);
    }
}
function IA(e, t) {
  const n = t.schema;
  if (!n)
    return;
  const r = n.classes, s = t.featureTables;
  if (r && s)
    for (const i in r) {
      const o = xA(s, i);
      o && RA(e, n, o);
    }
}
function xA(e, t) {
  for (const n in e) {
    const r = e[n];
    if (r.class === t)
      return r;
  }
  return null;
}
function MA(e, t) {
  for (const n in e) {
    const r = e[n];
    if (r.class === t)
      return r;
  }
  return null;
}
function RA(e, t, n) {
  var i, o;
  if (!n.class)
    return;
  const r = (i = t.classes) == null ? void 0 : i[n.class];
  if (!r)
    throw new Error(`Incorrect data in the EXT_structural_metadata extension: no schema class with name ${n.class}`);
  const s = n.count;
  for (const a in r.properties) {
    const c = r.properties[a], h = (o = n.properties) == null ? void 0 : o[a];
    if (h) {
      const f = FA(e, t, c, s, h);
      h.data = f;
    }
  }
}
function SA(e, t, n) {
  var s;
  const r = t.class;
  for (const i in n.properties) {
    const o = (s = t == null ? void 0 : t.properties) == null ? void 0 : s[i];
    if (o) {
      const a = NA(e, o, r);
      o.data = a;
    }
  }
}
function FA(e, t, n, r, s) {
  let i = [];
  const o = s.bufferView, a = e.getTypedArrayForBufferView(o), c = OA(e, n, s, r), h = DA(e, n, s, r);
  return n.type === "STRING" || n.componentType === "STRING" ? i = zc(r, a, c, h) : LA(n) && (i = UA(n, r, a, c)), i;
}
function OA(e, t, n, r) {
  return t.type === "ARRAY" && // `componentCount` is a number of fixed-length array elements.
  // If `componentCount` is NOT defined, it's a VARIABLE-length array
  typeof t.componentCount > "u" && // `arrayOffsetBufferView` is an index of the buffer view containing offsets for variable-length arrays.
  typeof n.arrayOffsetBufferView < "u" ? Sr(
    e,
    n.arrayOffsetBufferView,
    n.offsetType || "UINT32",
    // offsetType is used both for stringOffsetBufferView and arrayOffsetBufferView
    r
  ) : null;
}
function DA(e, t, n, r) {
  return typeof n.stringOffsetBufferView < "u" ? Sr(
    e,
    n.stringOffsetBufferView,
    n.offsetType || "UINT32",
    // offsetType is used both for stringOffsetBufferView and arrayOffsetBufferView
    r
  ) : null;
}
function LA(e) {
  const t = [
    "UINT8",
    "INT16",
    "UINT16",
    "INT32",
    "UINT32",
    "INT64",
    "UINT64",
    "FLOAT32",
    "FLOAT64"
  ];
  return t.includes(e.type) || typeof e.componentType < "u" && t.includes(e.componentType);
}
function UA(e, t, n, r) {
  const s = e.type === "ARRAY", i = e.componentCount, o = "SCALAR", a = e.componentType || e.type, c = gi(o, a), h = n.byteLength / c, f = Fr(n, o, a, h);
  return s ? r ? jc(f, t, r, n.length, c) : i ? Kc(f, t, i) : [] : f;
}
function NA(e, t, n) {
  const r = e.gltf.json;
  if (!r.meshes)
    return [];
  const s = [];
  for (const i of r.meshes)
    for (const o of i.primitives)
      PA(e, n, t, s, o);
  return s;
}
function PA(e, t, n, r, s) {
  const i = {
    channels: n.channels,
    ...n.texture
  }, o = Ai(e, i, s);
  o && Vc(e, t, o, r, s);
}
const GA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: wA,
  name: TA
}, Symbol.toStringTag, { value: "Module" })), vA = "4.3.3", HA = "4.3.3", fr = {
  /** Basis transcoder, javascript wrapper part */
  TRANSCODER: "basis_transcoder.js",
  /** Basis transcoder, compiled web assembly part */
  TRANSCODER_WASM: "basis_transcoder.wasm",
  /** Basis encoder, javascript wrapper part */
  ENCODER: "basis_encoder.js",
  /** Basis encoder, compiled web assembly part */
  ENCODER_WASM: "basis_encoder.wasm"
};
let Go;
async function vo(e) {
  qh(e.modules);
  const t = Yh("basis");
  return t || (Go || (Go = JA(e)), await Go);
}
async function JA(e) {
  let t = null, n = null;
  return [t, n] = await Promise.all([
    await be(fr.TRANSCODER, "textures", e),
    await be(fr.TRANSCODER_WASM, "textures", e)
  ]), t = t || globalThis.BASIS, await kA(t, n);
}
function kA(e, t) {
  const n = {};
  return t && (n.wasmBinary = t), new Promise((r) => {
    e(n).then((s) => {
      const { BasisFile: i, initializeBasis: o } = s;
      o(), r({ BasisFile: i });
    });
  });
}
let fs;
async function Ho(e) {
  const t = e.modules || {};
  return t.basisEncoder ? t.basisEncoder : (fs = fs || VA(e), await fs);
}
async function VA(e) {
  let t = null, n = null;
  return [t, n] = await Promise.all([
    await be(fr.ENCODER, "textures", e),
    await be(fr.ENCODER_WASM, "textures", e)
  ]), t = t || globalThis.BASIS, await jA(t, n);
}
function jA(e, t) {
  const n = {};
  return t && (n.wasmBinary = t), new Promise((r) => {
    e(n).then((s) => {
      const { BasisFile: i, KTX2File: o, initializeBasis: a, BasisEncoder: c } = s;
      a(), r({ BasisFile: i, KTX2File: o, BasisEncoder: c });
    });
  });
}
const He = {
  // WEBGL_compressed_texture_s3tc
  COMPRESSED_RGB_S3TC_DXT1_EXT: 33776,
  COMPRESSED_RGBA_S3TC_DXT5_EXT: 33779,
  // WEBGL_compressed_texture_pvrtc
  COMPRESSED_RGB_PVRTC_4BPPV1_IMG: 35840,
  COMPRESSED_RGBA_PVRTC_4BPPV1_IMG: 35842,
  // WEBGL_compressed_texture_etc1
  COMPRESSED_RGB_ETC1_WEBGL: 36196,
  // WEBGL_compressed_texture_astc
  COMPRESSED_RGBA_ASTC_4X4_KHR: 37808
}, KA = ["", "WEBKIT_", "MOZ_"], Jo = {
  /* eslint-disable camelcase */
  WEBGL_compressed_texture_s3tc: "dxt",
  WEBGL_compressed_texture_s3tc_srgb: "dxt-srgb",
  WEBGL_compressed_texture_etc1: "etc1",
  WEBGL_compressed_texture_etc: "etc2",
  WEBGL_compressed_texture_pvrtc: "pvrtc",
  WEBGL_compressed_texture_atc: "atc",
  WEBGL_compressed_texture_astc: "astc",
  EXT_texture_compression_rgtc: "rgtc"
  /* eslint-enable camelcase */
};
let zn = null;
function zA(e) {
  if (!zn) {
    e = e || WA() || void 0, zn = /* @__PURE__ */ new Set();
    for (const t of KA)
      for (const n in Jo)
        if (e && e.getExtension(`${t}${n}`)) {
          const r = Jo[n];
          zn.add(r);
        }
  }
  return zn;
}
function WA() {
  try {
    return document.createElement("canvas").getContext("webgl");
  } catch {
    return null;
  }
}
const Dt = [
  // '´', 'K', 'T', 'X', '2', '0', 'ª', '\r', '\n', '\x1A', '\n'
  171,
  75,
  84,
  88,
  32,
  50,
  48,
  187,
  13,
  10,
  26,
  10
];
function QA(e) {
  const t = new Uint8Array(e);
  return !(t.byteLength < Dt.length || t[0] !== Dt[0] || // '´'
  t[1] !== Dt[1] || // 'K'
  t[2] !== Dt[2] || // 'T'
  t[3] !== Dt[3] || // 'X'
  t[4] !== Dt[4] || // ' '
  t[5] !== Dt[5] || // '2'
  t[6] !== Dt[6] || // '0'
  t[7] !== Dt[7] || // 'ª'
  t[8] !== Dt[8] || // '\r'
  t[9] !== Dt[9] || // '\n'
  t[10] !== Dt[10] || // '\x1A'
  t[11] !== Dt[11]);
}
const $A = {
  etc1: {
    basisFormat: 0,
    compressed: !0,
    format: He.COMPRESSED_RGB_ETC1_WEBGL
  },
  etc2: { basisFormat: 1, compressed: !0 },
  bc1: {
    basisFormat: 2,
    compressed: !0,
    format: He.COMPRESSED_RGB_S3TC_DXT1_EXT
  },
  bc3: {
    basisFormat: 3,
    compressed: !0,
    format: He.COMPRESSED_RGBA_S3TC_DXT5_EXT
  },
  bc4: { basisFormat: 4, compressed: !0 },
  bc5: { basisFormat: 5, compressed: !0 },
  "bc7-m6-opaque-only": { basisFormat: 6, compressed: !0 },
  "bc7-m5": { basisFormat: 7, compressed: !0 },
  "pvrtc1-4-rgb": {
    basisFormat: 8,
    compressed: !0,
    format: He.COMPRESSED_RGB_PVRTC_4BPPV1_IMG
  },
  "pvrtc1-4-rgba": {
    basisFormat: 9,
    compressed: !0,
    format: He.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG
  },
  "astc-4x4": {
    basisFormat: 10,
    compressed: !0,
    format: He.COMPRESSED_RGBA_ASTC_4X4_KHR
  },
  "atc-rgb": { basisFormat: 11, compressed: !0 },
  "atc-rgba-interpolated-alpha": { basisFormat: 12, compressed: !0 },
  rgba32: { basisFormat: 13, compressed: !1 },
  rgb565: { basisFormat: 14, compressed: !1 },
  bgr565: { basisFormat: 15, compressed: !1 },
  rgba4444: { basisFormat: 16, compressed: !1 }
};
async function XA(e, t) {
  if (t.basis.containerFormat === "auto") {
    if (QA(e)) {
      const r = await Ho(t);
      return ko(r.KTX2File, e, t);
    }
    const { BasisFile: n } = await vo(t);
    return ds(n, e, t);
  }
  switch (t.basis.module) {
    case "encoder":
      const n = await Ho(t);
      switch (t.basis.containerFormat) {
        case "ktx2":
          return ko(n.KTX2File, e, t);
        case "basis":
        default:
          return ds(n.BasisFile, e, t);
      }
    case "transcoder":
    default:
      const { BasisFile: r } = await vo(t);
      return ds(r, e, t);
  }
}
function ds(e, t, n) {
  const r = new e(new Uint8Array(t));
  try {
    if (!r.startTranscoding())
      throw new Error("Failed to start basis transcoding");
    const s = r.getNumImages(), i = [];
    for (let o = 0; o < s; o++) {
      const a = r.getNumLevels(o), c = [];
      for (let h = 0; h < a; h++)
        c.push(qA(r, o, h, n));
      i.push(c);
    }
    return i;
  } finally {
    r.close(), r.delete();
  }
}
function qA(e, t, n, r) {
  const s = e.getImageWidth(t, n), i = e.getImageHeight(t, n), o = e.getHasAlpha(
    /* imageIndex, levelIndex */
  ), { compressed: a, format: c, basisFormat: h } = Qc(r, o), f = e.getImageTranscodedSizeInBytes(t, n, h), d = new Uint8Array(f);
  if (!e.transcodeImage(d, t, n, h, 0, 0))
    throw new Error("failed to start Basis transcoding");
  return {
    // standard loaders.gl image category payload
    width: s,
    height: i,
    data: d,
    compressed: a,
    format: c,
    // Additional fields
    // Add levelSize field.
    hasAlpha: o
  };
}
function ko(e, t, n) {
  const r = new e(new Uint8Array(t));
  try {
    if (!r.startTranscoding())
      throw new Error("failed to start KTX2 transcoding");
    const s = r.getLevels(), i = [];
    for (let o = 0; o < s; o++)
      i.push(YA(r, o, n));
    return [i];
  } finally {
    r.close(), r.delete();
  }
}
function YA(e, t, n) {
  const { alphaFlag: r, height: s, width: i } = e.getImageLevelInfo(t, 0, 0), { compressed: o, format: a, basisFormat: c } = Qc(n, r), h = e.getImageTranscodedSizeInBytes(t, 0, 0, c), f = new Uint8Array(h);
  if (!e.transcodeImage(
    f,
    t,
    0,
    0,
    c,
    0,
    -1,
    -1
    /* channel1 */
  ))
    throw new Error("Failed to transcode KTX2 image");
  return {
    // standard loaders.gl image category payload
    width: i,
    height: s,
    data: f,
    compressed: o,
    // Additional fields
    levelSize: h,
    hasAlpha: r,
    format: a
  };
}
function Qc(e, t) {
  let n = e && e.basis && e.basis.format;
  return n === "auto" && (n = $c()), typeof n == "object" && (n = t ? n.alpha : n.noAlpha), n = n.toLowerCase(), $A[n];
}
function $c() {
  const e = zA();
  return e.has("astc") ? "astc-4x4" : e.has("dxt") ? {
    alpha: "bc3",
    noAlpha: "bc1"
  } : e.has("pvrtc") ? {
    alpha: "pvrtc1-4-rgba",
    noAlpha: "pvrtc1-4-rgb"
  } : e.has("etc1") ? "etc1" : e.has("etc2") ? "etc2" : "rgb565";
}
const ZA = {
  dataType: null,
  batchType: null,
  name: "Basis",
  id: "basis",
  module: "textures",
  version: HA,
  worker: !0,
  extensions: ["basis", "ktx2"],
  mimeTypes: ["application/octet-stream", "image/ktx2"],
  tests: ["sB"],
  binary: !0,
  options: {
    basis: {
      format: "auto",
      libraryPath: "libs/",
      containerFormat: "auto",
      module: "transcoder"
    }
  }
}, ty = {
  ...ZA,
  parse: XA
}, qe = !0, Vo = 1735152710, Bi = 12, dr = 8, ey = 1313821514, ny = 5130562, ry = 0, sy = 0, iy = 1;
function oy(e, t = 0) {
  return `${String.fromCharCode(e.getUint8(t + 0))}${String.fromCharCode(e.getUint8(t + 1))}${String.fromCharCode(e.getUint8(t + 2))}${String.fromCharCode(e.getUint8(t + 3))}`;
}
function ay(e, t = 0, n = {}) {
  const r = new DataView(e), { magic: s = Vo } = n, i = r.getUint32(t, !1);
  return i === s || i === Vo;
}
function cy(e, t, n = 0, r = {}) {
  const s = new DataView(t), i = oy(s, n + 0), o = s.getUint32(n + 4, qe), a = s.getUint32(n + 8, qe);
  switch (Object.assign(e, {
    // Put less important stuff in a header, to avoid clutter
    header: {
      byteOffset: n,
      // Byte offset into the initial arrayBuffer
      byteLength: a,
      hasBinChunk: !1
    },
    type: i,
    version: o,
    json: {},
    binChunks: []
  }), n += Bi, e.version) {
    case 1:
      return uy(e, s, n);
    case 2:
      return hy(e, s, n, r = {});
    default:
      throw new Error(`Invalid GLB version ${e.version}. Only supports version 1 and 2.`);
  }
}
function uy(e, t, n) {
  $(e.header.byteLength > Bi + dr);
  const r = t.getUint32(n + 0, qe), s = t.getUint32(n + 4, qe);
  return n += dr, $(s === ry), Ps(e, t, n, r), n += r, n += Gs(e, t, n, e.header.byteLength), n;
}
function hy(e, t, n, r) {
  return $(e.header.byteLength > Bi + dr), ly(e, t, n, r), n + e.header.byteLength;
}
function ly(e, t, n, r) {
  for (; n + 8 <= e.header.byteLength; ) {
    const s = t.getUint32(n + 0, qe), i = t.getUint32(n + 4, qe);
    switch (n += dr, i) {
      case ey:
        Ps(e, t, n, s);
        break;
      case ny:
        Gs(e, t, n, s);
        break;
      case sy:
        r.strict || Ps(e, t, n, s);
        break;
      case iy:
        r.strict || Gs(e, t, n, s);
        break;
    }
    n += Tn(s, 4);
  }
  return n;
}
function Ps(e, t, n, r) {
  const s = new Uint8Array(t.buffer, n, r), o = new TextDecoder("utf8").decode(s);
  return e.json = JSON.parse(o), Tn(r, 4);
}
function Gs(e, t, n, r) {
  return e.header.hasBinChunk = !0, e.binChunks.push({
    byteOffset: n,
    byteLength: r,
    arrayBuffer: t.buffer
    // TODO - copy, or create typed array view?
  }), Tn(r, 4);
}
function Xc(e, t) {
  if (e.startsWith("data:") || e.startsWith("http:") || e.startsWith("https:"))
    return e;
  const r = t.baseUri || t.uri;
  if (!r)
    throw new Error(`'baseUri' must be provided to resolve relative url ${e}`);
  return r.substr(0, r.lastIndexOf("/") + 1) + e;
}
const fy = "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", dy = "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", my = new Uint8Array([
  0,
  97,
  115,
  109,
  1,
  0,
  0,
  0,
  1,
  4,
  1,
  96,
  0,
  0,
  3,
  3,
  2,
  0,
  0,
  5,
  3,
  1,
  0,
  1,
  12,
  1,
  0,
  10,
  22,
  2,
  12,
  0,
  65,
  0,
  65,
  0,
  65,
  0,
  252,
  10,
  0,
  0,
  11,
  7,
  0,
  65,
  0,
  253,
  15,
  26,
  11
]), py = new Uint8Array([
  32,
  0,
  65,
  253,
  3,
  1,
  2,
  34,
  4,
  106,
  6,
  5,
  11,
  8,
  7,
  20,
  13,
  33,
  12,
  16,
  128,
  9,
  116,
  64,
  19,
  113,
  127,
  15,
  10,
  21,
  22,
  14,
  255,
  66,
  24,
  54,
  136,
  107,
  18,
  23,
  192,
  26,
  114,
  118,
  132,
  17,
  77,
  101,
  130,
  144,
  27,
  87,
  131,
  44,
  45,
  74,
  156,
  154,
  70,
  167
]), gy = {
  // legacy index-based enums for glTF
  0: "",
  1: "meshopt_decodeFilterOct",
  2: "meshopt_decodeFilterQuat",
  3: "meshopt_decodeFilterExp",
  // string-based enums for glTF
  NONE: "",
  OCTAHEDRAL: "meshopt_decodeFilterOct",
  QUATERNION: "meshopt_decodeFilterQuat",
  EXPONENTIAL: "meshopt_decodeFilterExp"
}, Ay = {
  // legacy index-based enums for glTF
  0: "meshopt_decodeVertexBuffer",
  1: "meshopt_decodeIndexBuffer",
  2: "meshopt_decodeIndexSequence",
  // string-based enums for glTF
  ATTRIBUTES: "meshopt_decodeVertexBuffer",
  TRIANGLES: "meshopt_decodeIndexBuffer",
  INDICES: "meshopt_decodeIndexSequence"
};
async function yy(e, t, n, r, s, i = "NONE") {
  const o = await By();
  Ty(o, o.exports[Ay[s]], e, t, n, r, o.exports[gy[i || "NONE"]]);
}
let ms;
async function By() {
  return ms || (ms = Ey()), ms;
}
async function Ey() {
  let e = fy;
  WebAssembly.validate(my) && (e = dy, console.log("Warning: meshopt_decoder is using experimental SIMD support"));
  const t = await WebAssembly.instantiate(Cy(e), {});
  return await t.instance.exports.__wasm_call_ctors(), t.instance;
}
function Cy(e) {
  const t = new Uint8Array(e.length);
  for (let r = 0; r < e.length; ++r) {
    const s = e.charCodeAt(r);
    t[r] = s > 96 ? s - 71 : s > 64 ? s - 65 : s > 47 ? s + 4 : s > 46 ? 63 : 62;
  }
  let n = 0;
  for (let r = 0; r < e.length; ++r)
    t[n++] = t[r] < 60 ? py[t[r]] : (t[r] - 60) * 64 + t[++r];
  return t.buffer.slice(0, n);
}
function Ty(e, t, n, r, s, i, o) {
  const a = e.exports.sbrk, c = r + 3 & -4, h = a(c * s), f = a(i.length), d = new Uint8Array(e.exports.memory.buffer);
  d.set(i, f);
  const p = t(h, r, s, f, i.length);
  if (p === 0 && o && o(h, c, s), n.set(d.subarray(h, h + r * s)), a(h - a(0)), p !== 0)
    throw new Error(`Malformed buffer data: ${p}`);
}
const mr = "EXT_meshopt_compression", wy = mr;
async function by(e, t) {
  var s, i;
  const n = new Ct(e);
  if (!((s = t == null ? void 0 : t.gltf) != null && s.decompressMeshes) || !((i = t.gltf) != null && i.loadBuffers))
    return;
  const r = [];
  for (const o of e.json.bufferViews || [])
    r.push(_y(n, o));
  await Promise.all(r), n.removeExtension(mr);
}
async function _y(e, t) {
  const n = e.getObjectExtension(t, mr);
  if (n) {
    const { byteOffset: r = 0, byteLength: s = 0, byteStride: i, count: o, mode: a, filter: c = "NONE", buffer: h } = n, f = e.gltf.buffers[h], d = new Uint8Array(f.arrayBuffer, f.byteOffset + r, s), p = new Uint8Array(e.gltf.buffers[t.buffer].arrayBuffer, t.byteOffset, t.byteLength);
    await yy(p, o, i, d, a, c), e.removeObjectExtension(t, mr);
  }
}
const Iy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: by,
  name: wy
}, Symbol.toStringTag, { value: "Module" })), Je = "EXT_texture_webp", xy = Je;
function My(e, t) {
  const n = new Ct(e);
  if (!Cg("image/webp")) {
    if (n.getRequiredExtensions().includes(Je))
      throw new Error(`gltf: Required extension ${Je} not supported by browser`);
    return;
  }
  const { json: r } = n;
  for (const s of r.textures || []) {
    const i = n.getObjectExtension(s, Je);
    i && (s.source = i.source), n.removeObjectExtension(s, Je);
  }
  n.removeExtension(Je);
}
const Ry = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: xy,
  preprocess: My
}, Symbol.toStringTag, { value: "Module" })), rr = "KHR_texture_basisu", Sy = rr;
function Fy(e, t) {
  const n = new Ct(e), { json: r } = n;
  for (const s of r.textures || []) {
    const i = n.getObjectExtension(s, rr);
    i && (s.source = i.source, n.removeObjectExtension(s, rr));
  }
  n.removeExtension(rr);
}
const Oy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  name: Sy,
  preprocess: Fy
}, Symbol.toStringTag, { value: "Module" }));
function Dy(e) {
  const t = {};
  for (const n in e) {
    const r = e[n];
    if (n !== "indices") {
      const s = qc(r);
      t[n] = s;
    }
  }
  return t;
}
function qc(e) {
  const { buffer: t, size: n, count: r } = Ly(e);
  return {
    // glTF Accessor values
    // TODO: Instead of a bufferView index we could have an actual buffer (typed array)
    // bufferView: null,
    // TODO: Deprecate `value` in favor of bufferView?
    // @ts-ignore
    value: t,
    size: n,
    // Decoded `type` (e.g. SCALAR)
    byteOffset: 0,
    count: r,
    type: vc(n),
    componentType: Rr(t)
  };
}
function Ly(e) {
  let t = e, n = 1, r = 0;
  return e && e.value && (t = e.value, n = e.size || 1), t && (ArrayBuffer.isView(t) || (t = Uy(t, Float32Array)), r = t.length / n), { buffer: t, size: n, count: r };
}
function Uy(e, t, n = !1) {
  return e ? Array.isArray(e) ? new t(e) : n && !(e instanceof t) ? new t(e) : e : null;
}
const Be = "KHR_draco_mesh_compression", Ny = Be;
function Py(e, t, n) {
  const r = new Ct(e);
  for (const s of Yc(r))
    r.getObjectExtension(s, Be);
}
async function Gy(e, t, n) {
  var i;
  if (!((i = t == null ? void 0 : t.gltf) != null && i.decompressMeshes))
    return;
  const r = new Ct(e), s = [];
  for (const o of Yc(r))
    r.getObjectExtension(o, Be) && s.push(Hy(r, o, t, n));
  await Promise.all(s), r.removeExtension(Be);
}
function vy(e, t = {}) {
  const n = new Ct(e);
  for (const r of n.json.meshes || [])
    Jy(r), n.addRequiredExtension(Be);
}
async function Hy(e, t, n, r) {
  const s = e.getObjectExtension(t, Be);
  if (!s)
    return;
  const i = e.getTypedArrayForBufferView(s.bufferView), o = Zs(i.buffer, i.byteOffset), a = { ...n };
  delete a["3d-tiles"];
  const c = await Cn(o, Sc, a, r), h = Dy(c.attributes);
  for (const [f, d] of Object.entries(h))
    if (f in t.attributes) {
      const p = t.attributes[f], g = e.getAccessor(p);
      g != null && g.min && (g != null && g.max) && (d.min = g.min, d.max = g.max);
    }
  t.attributes = h, c.indices && (t.indices = qc(c.indices)), e.removeObjectExtension(t, Be), ky(t);
}
function Jy(e, t, n = 4, r, s) {
  var f;
  if (!r.DracoWriter)
    throw new Error("options.gltf.DracoWriter not provided");
  const i = r.DracoWriter.encodeSync({ attributes: e }), o = (f = s == null ? void 0 : s.parseSync) == null ? void 0 : f.call(s, { attributes: e }), a = r._addFauxAttributes(o.attributes), c = r.addBufferView(i);
  return {
    primitives: [
      {
        attributes: a,
        // TODO - verify with spec
        mode: n,
        // GL.POINTS
        extensions: {
          [Be]: {
            bufferView: c,
            attributes: a
            // TODO - verify with spec
          }
        }
      }
    ]
  };
}
function ky(e) {
  if (!e.attributes && Object.keys(e.attributes).length > 0)
    throw new Error("glTF: Empty primitive detected: Draco decompression failure?");
}
function* Yc(e) {
  for (const t of e.json.meshes || [])
    for (const n of t.primitives)
      yield n;
}
const Vy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: Gy,
  encode: vy,
  name: Ny,
  preprocess: Py
}, Symbol.toStringTag, { value: "Module" })), Or = "KHR_texture_transform", jy = Or, Wn = new T(), Ky = new lt(), zy = new lt();
async function Wy(e, t) {
  var i;
  if (!new Ct(e).hasExtension(Or) || !((i = t.gltf) != null && i.loadBuffers))
    return;
  const s = e.json.materials || [];
  for (let o = 0; o < s.length; o++)
    Qy(o, e);
}
function Qy(e, t) {
  var i, o, a, c;
  const n = (i = t.json.materials) == null ? void 0 : i[e], r = [
    (o = n == null ? void 0 : n.pbrMetallicRoughness) == null ? void 0 : o.baseColorTexture,
    n == null ? void 0 : n.emissiveTexture,
    n == null ? void 0 : n.normalTexture,
    n == null ? void 0 : n.occlusionTexture,
    (a = n == null ? void 0 : n.pbrMetallicRoughness) == null ? void 0 : a.metallicRoughnessTexture
  ], s = [];
  for (const h of r)
    h && ((c = h == null ? void 0 : h.extensions) != null && c[Or]) && $y(t, e, h, s);
}
function $y(e, t, n, r) {
  const s = Xy(n, r);
  if (!s)
    return;
  const i = e.json.meshes || [];
  for (const o of i)
    for (const a of o.primitives) {
      const c = a.material;
      Number.isFinite(c) && t === c && qy(e, a, s);
    }
}
function Xy(e, t) {
  var o;
  const n = (o = e.extensions) == null ? void 0 : o[Or], { texCoord: r = 0 } = e, { texCoord: s = r } = n;
  if (!(t.findIndex(([a, c]) => a === r && c === s) !== -1)) {
    const a = tB(n);
    return r !== s && (e.texCoord = s), t.push([r, s]), { originalTexCoord: r, texCoord: s, matrix: a };
  }
  return null;
}
function qy(e, t, n) {
  var a, c;
  const { originalTexCoord: r, texCoord: s, matrix: i } = n, o = t.attributes[`TEXCOORD_${r}`];
  if (Number.isFinite(o)) {
    const h = (a = e.json.accessors) == null ? void 0 : a[o];
    if (h && h.bufferView) {
      const f = (c = e.json.bufferViews) == null ? void 0 : c[h.bufferView];
      if (f) {
        const { arrayBuffer: d, byteOffset: p } = e.buffers[f.buffer], g = (p || 0) + (h.byteOffset || 0) + (f.byteOffset || 0), { ArrayType: B, length: C } = pi(h, f), b = Gc[h.componentType], M = Pc[h.type], D = f.byteStride || b * M, _ = new Float32Array(C);
        for (let x = 0; x < h.count; x++) {
          const L = new B(d, g + x * D, 2);
          Wn.set(L[0], L[1], 1), Wn.transformByMatrix3(i), _.set([Wn[0], Wn[1]], x * M);
        }
        r === s ? Yy(h, f, e.buffers, _) : Zy(s, h, t, e, _);
      }
    }
  }
}
function Yy(e, t, n, r) {
  e.componentType = 5126, n.push({
    arrayBuffer: r.buffer,
    byteOffset: 0,
    byteLength: r.buffer.byteLength
  }), t.buffer = n.length - 1, t.byteLength = r.buffer.byteLength, t.byteOffset = 0, delete t.byteStride;
}
function Zy(e, t, n, r, s) {
  r.buffers.push({
    arrayBuffer: s.buffer,
    byteOffset: 0,
    byteLength: s.buffer.byteLength
  });
  const i = r.json.bufferViews;
  if (!i)
    return;
  i.push({
    buffer: r.buffers.length - 1,
    byteLength: s.buffer.byteLength,
    byteOffset: 0
  });
  const o = r.json.accessors;
  o && (o.push({
    bufferView: (i == null ? void 0 : i.length) - 1,
    byteOffset: 0,
    componentType: 5126,
    count: t.count,
    type: "VEC2"
  }), n.attributes[`TEXCOORD_${e}`] = o.length - 1);
}
function tB(e) {
  const { offset: t = [0, 0], rotation: n = 0, scale: r = [1, 1] } = e, s = new lt().set(1, 0, 0, 0, 1, 0, t[0], t[1], 1), i = Ky.set(Math.cos(n), Math.sin(n), 0, -Math.sin(n), Math.cos(n), 0, 0, 0, 1), o = zy.set(r[0], 0, 0, 0, r[1], 0, 0, 0, 1);
  return s.multiplyRight(i).multiplyRight(o);
}
const eB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: Wy,
  name: jy
}, Symbol.toStringTag, { value: "Module" })), we = "KHR_lights_punctual", nB = we;
async function rB(e) {
  const t = new Ct(e), { json: n } = t, r = t.getExtension(we);
  r && (t.json.lights = r.lights, t.removeExtension(we));
  for (const s of n.nodes || []) {
    const i = t.getObjectExtension(s, we);
    i && (s.light = i.light), t.removeObjectExtension(s, we);
  }
}
async function sB(e) {
  const t = new Ct(e), { json: n } = t;
  if (n.lights) {
    const r = t.addExtension(we);
    Ut(!r.lights), r.lights = n.lights, delete n.lights;
  }
  if (t.json.lights) {
    for (const r of t.json.lights) {
      const s = r.node;
      t.addObjectExtension(s, we, r);
    }
    delete t.json.lights;
  }
}
const iB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: rB,
  encode: sB,
  name: nB
}, Symbol.toStringTag, { value: "Module" })), gn = "KHR_materials_unlit", oB = gn;
async function aB(e) {
  const t = new Ct(e), { json: n } = t;
  for (const r of n.materials || [])
    r.extensions && r.extensions.KHR_materials_unlit && (r.unlit = !0), t.removeObjectExtension(r, gn);
  t.removeExtension(gn);
}
function cB(e) {
  const t = new Ct(e), { json: n } = t;
  if (t.materials)
    for (const r of n.materials || [])
      r.unlit && (delete r.unlit, t.addObjectExtension(r, gn, {}), t.addExtension(gn));
}
const uB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: aB,
  encode: cB,
  name: oB
}, Symbol.toStringTag, { value: "Module" })), cn = "KHR_techniques_webgl", hB = cn;
async function lB(e) {
  const t = new Ct(e), { json: n } = t, r = t.getExtension(cn);
  if (r) {
    const s = dB(r, t);
    for (const i of n.materials || []) {
      const o = t.getObjectExtension(i, cn);
      o && (i.technique = Object.assign(
        {},
        o,
        // @ts-ignore
        s[o.technique]
      ), i.technique.values = mB(i.technique, t)), t.removeObjectExtension(i, cn);
    }
    t.removeExtension(cn);
  }
}
async function fB(e, t) {
}
function dB(e, t) {
  const { programs: n = [], shaders: r = [], techniques: s = [] } = e, i = new TextDecoder();
  return r.forEach((o) => {
    if (Number.isFinite(o.bufferView))
      o.code = i.decode(t.getTypedArrayForBufferView(o.bufferView));
    else
      throw new Error("KHR_techniques_webgl: no shader code");
  }), n.forEach((o) => {
    o.fragmentShader = r[o.fragmentShader], o.vertexShader = r[o.vertexShader];
  }), s.forEach((o) => {
    o.program = n[o.program];
  }), s;
}
function mB(e, t) {
  const n = Object.assign({}, e.values);
  return Object.keys(e.uniforms || {}).forEach((r) => {
    e.uniforms[r].value && !(r in n) && (n[r] = e.uniforms[r].value);
  }), Object.keys(n).forEach((r) => {
    typeof n[r] == "object" && n[r].index !== void 0 && (n[r].texture = t.getTexture(n[r].index));
  }), n;
}
const pB = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  decode: lB,
  encode: fB,
  name: hB
}, Symbol.toStringTag, { value: "Module" })), Zc = [
  // 1.0
  // KHR_binary_gltf is handled separately - must be processed before other parsing starts
  // KHR_binary_gltf,
  // 2.0
  CA,
  zg,
  Iy,
  Ry,
  // Basisu should come after webp, we want basisu to be preferred if both are provided
  Oy,
  Vy,
  iB,
  uB,
  pB,
  eB,
  GA
];
function gB(e, t = {}, n) {
  var s;
  const r = Zc.filter((i) => tu(i.name, t));
  for (const i of r)
    (s = i.preprocess) == null || s.call(i, e, t, n);
}
async function AB(e, t = {}, n) {
  var s;
  const r = Zc.filter((i) => tu(i.name, t));
  for (const i of r)
    await ((s = i.decode) == null ? void 0 : s.call(i, e, t, n));
}
function tu(e, t) {
  var s;
  const n = ((s = t == null ? void 0 : t.gltf) == null ? void 0 : s.excludeExtensions) || {};
  return !(e in n && !n[e]);
}
const ps = "KHR_binary_glTF";
function yB(e) {
  const t = new Ct(e), { json: n } = t;
  for (const r of n.images || []) {
    const s = t.getObjectExtension(r, ps);
    s && Object.assign(r, s), t.removeObjectExtension(r, ps);
  }
  n.buffers && n.buffers[0] && delete n.buffers[0].uri, t.removeExtension(ps);
}
const jo = {
  accessors: "accessor",
  animations: "animation",
  buffers: "buffer",
  bufferViews: "bufferView",
  images: "image",
  materials: "material",
  meshes: "mesh",
  nodes: "node",
  samplers: "sampler",
  scenes: "scene",
  skins: "skin",
  textures: "texture"
}, BB = {
  accessor: "accessors",
  animations: "animation",
  buffer: "buffers",
  bufferView: "bufferViews",
  image: "images",
  material: "materials",
  mesh: "meshes",
  node: "nodes",
  sampler: "samplers",
  scene: "scenes",
  skin: "skins",
  texture: "textures"
};
class EB {
  constructor() {
    y(this, "idToIndexMap", {
      animations: {},
      accessors: {},
      buffers: {},
      bufferViews: {},
      images: {},
      materials: {},
      meshes: {},
      nodes: {},
      samplers: {},
      scenes: {},
      skins: {},
      textures: {}
    });
    y(this, "json");
  }
  // constructor() {}
  /**
   * Convert (normalize) glTF < 2.0 to glTF 2.0
   * @param gltf - object with json and binChunks
   * @param options
   * @param options normalize Whether to actually normalize
   */
  normalize(t, n) {
    this.json = t.json;
    const r = t.json;
    switch (r.asset && r.asset.version) {
      case "2.0":
        return;
      case void 0:
      case "1.0":
        break;
      default:
        console.warn(`glTF: Unknown version ${r.asset.version}`);
        return;
    }
    if (!n.normalize)
      throw new Error("glTF v1 is not supported.");
    console.warn("Converting glTF v1 to glTF v2 format. This is experimental and may fail."), this._addAsset(r), this._convertTopLevelObjectsToArrays(r), yB(t), this._convertObjectIdsToArrayIndices(r), this._updateObjects(r), this._updateMaterial(r);
  }
  // asset is now required, #642 https://github.com/KhronosGroup/glTF/issues/639
  _addAsset(t) {
    t.asset = t.asset || {}, t.asset.version = "2.0", t.asset.generator = t.asset.generator || "Normalized to glTF 2.0 by loaders.gl";
  }
  _convertTopLevelObjectsToArrays(t) {
    for (const n in jo)
      this._convertTopLevelObjectToArray(t, n);
  }
  /** Convert one top level object to array */
  _convertTopLevelObjectToArray(t, n) {
    const r = t[n];
    if (!(!r || Array.isArray(r))) {
      t[n] = [];
      for (const s in r) {
        const i = r[s];
        i.id = i.id || s;
        const o = t[n].length;
        t[n].push(i), this.idToIndexMap[n][s] = o;
      }
    }
  }
  /** Go through all objects in all top-level arrays and replace ids with indices */
  _convertObjectIdsToArrayIndices(t) {
    for (const n in jo)
      this._convertIdsToIndices(t, n);
    "scene" in t && (t.scene = this._convertIdToIndex(t.scene, "scene"));
    for (const n of t.textures)
      this._convertTextureIds(n);
    for (const n of t.meshes)
      this._convertMeshIds(n);
    for (const n of t.nodes)
      this._convertNodeIds(n);
    for (const n of t.scenes)
      this._convertSceneIds(n);
  }
  _convertTextureIds(t) {
    t.source && (t.source = this._convertIdToIndex(t.source, "image"));
  }
  _convertMeshIds(t) {
    for (const n of t.primitives) {
      const { attributes: r, indices: s, material: i } = n;
      for (const o in r)
        r[o] = this._convertIdToIndex(r[o], "accessor");
      s && (n.indices = this._convertIdToIndex(s, "accessor")), i && (n.material = this._convertIdToIndex(i, "material"));
    }
  }
  _convertNodeIds(t) {
    t.children && (t.children = t.children.map((n) => this._convertIdToIndex(n, "node"))), t.meshes && (t.meshes = t.meshes.map((n) => this._convertIdToIndex(n, "mesh")));
  }
  _convertSceneIds(t) {
    t.nodes && (t.nodes = t.nodes.map((n) => this._convertIdToIndex(n, "node")));
  }
  /** Go through all objects in a top-level array and replace ids with indices */
  _convertIdsToIndices(t, n) {
    t[n] || (console.warn(`gltf v1: json doesn't contain attribute ${n}`), t[n] = []);
    for (const r of t[n])
      for (const s in r) {
        const i = r[s], o = this._convertIdToIndex(i, s);
        r[s] = o;
      }
  }
  _convertIdToIndex(t, n) {
    const r = BB[n];
    if (r in this.idToIndexMap) {
      const s = this.idToIndexMap[r][t];
      if (!Number.isFinite(s))
        throw new Error(`gltf v1: failed to resolve ${n} with id ${t}`);
      return s;
    }
    return t;
  }
  /**
   *
   * @param {*} json
   */
  _updateObjects(t) {
    for (const n of this.json.buffers)
      delete n.type;
  }
  /**
   * Update material (set pbrMetallicRoughness)
   * @param {*} json
   */
  _updateMaterial(t) {
    var n, r, s;
    for (const i of t.materials) {
      i.pbrMetallicRoughness = {
        baseColorFactor: [1, 1, 1, 1],
        metallicFactor: 1,
        roughnessFactor: 1
      };
      const o = ((n = i.values) == null ? void 0 : n.tex) || ((r = i.values) == null ? void 0 : r.texture2d_0) || ((s = i.values) == null ? void 0 : s.diffuseTex), a = t.textures.findIndex((c) => c.id === o);
      a !== -1 && (i.pbrMetallicRoughness.baseColorTexture = { index: a });
    }
  }
}
function CB(e, t = {}) {
  return new EB().normalize(e, t);
}
async function TB(e, t, n = 0, r, s) {
  var i, o, a;
  return wB(e, t, n, r), CB(e, { normalize: (i = r == null ? void 0 : r.gltf) == null ? void 0 : i.normalize }), gB(e, r, s), (o = r == null ? void 0 : r.gltf) != null && o.loadBuffers && e.json.buffers && await bB(e, r, s), (a = r == null ? void 0 : r.gltf) != null && a.loadImages && await _B(e, r, s), await AB(e, r, s), e;
}
function wB(e, t, n, r) {
  if (r.uri && (e.baseUri = r.uri), t instanceof ArrayBuffer && !ay(t, n, r) && (t = new TextDecoder().decode(t)), typeof t == "string")
    e.json = Bl(t);
  else if (t instanceof ArrayBuffer) {
    const o = {};
    n = cy(o, t, n, r.glb), Ut(o.type === "glTF", `Invalid GLB magic string ${o.type}`), e._glb = o, e.json = o.json;
  } else
    Ut(!1, "GLTF: must be ArrayBuffer or string");
  const s = e.json.buffers || [];
  if (e.buffers = new Array(s.length).fill(null), e._glb && e._glb.header.hasBinChunk) {
    const { binChunks: o } = e._glb;
    e.buffers[0] = {
      arrayBuffer: o[0].arrayBuffer,
      byteOffset: o[0].byteOffset,
      byteLength: o[0].byteLength
    };
  }
  const i = e.json.images || [];
  e.images = new Array(i.length).fill({});
}
async function bB(e, t, n) {
  var s, i;
  const r = e.json.buffers || [];
  for (let o = 0; o < r.length; ++o) {
    const a = r[o];
    if (a.uri) {
      const { fetch: c } = n;
      Ut(c);
      const h = Xc(a.uri, t), f = await ((s = n == null ? void 0 : n.fetch) == null ? void 0 : s.call(n, h)), d = await ((i = f == null ? void 0 : f.arrayBuffer) == null ? void 0 : i.call(f));
      e.buffers[o] = {
        arrayBuffer: d,
        byteOffset: 0,
        byteLength: d.byteLength
      }, delete a.uri;
    } else e.buffers[o] === null && (e.buffers[o] = {
      arrayBuffer: new ArrayBuffer(a.byteLength),
      byteOffset: 0,
      byteLength: a.byteLength
    });
  }
}
async function _B(e, t, n) {
  const r = IB(e), s = e.json.images || [], i = [];
  for (const o of r)
    i.push(xB(e, s[o], o, t, n));
  return await Promise.all(i);
}
function IB(e) {
  const t = /* @__PURE__ */ new Set(), n = e.json.textures || [];
  for (const r of n)
    r.source !== void 0 && t.add(r.source);
  return Array.from(t).sort();
}
async function xB(e, t, n, r, s) {
  let i;
  if (t.uri && !t.hasOwnProperty("bufferView")) {
    const a = Xc(t.uri, r), { fetch: c } = s;
    i = await (await c(a)).arrayBuffer(), t.bufferView = {
      data: i
    };
  }
  if (Number.isFinite(t.bufferView)) {
    const a = Fg(e.json, e.buffers, t.bufferView);
    i = Zs(a.buffer, a.byteOffset, a.byteLength);
  }
  Ut(i, "glTF image has no data");
  let o = await Cn(i, [Eg, ty], {
    ...r,
    mimeType: t.mimeType,
    basis: r.basis || { format: $c() }
  }, s);
  o && o[0] && (o = {
    compressed: !0,
    // @ts-expect-error
    mipmaps: !1,
    width: o[0].width,
    height: o[0].height,
    data: o[0]
  }), e.images = e.images || [], e.images[n] = o;
}
const pr = {
  dataType: null,
  batchType: null,
  name: "glTF",
  id: "gltf",
  module: "gltf",
  version: vA,
  extensions: ["gltf", "glb"],
  mimeTypes: ["model/gltf+json", "model/gltf-binary"],
  text: !0,
  binary: !0,
  tests: ["glTF"],
  parse: MB,
  options: {
    gltf: {
      normalize: !0,
      // Normalize glTF v1 to glTF v2 format (not yet stable)
      loadBuffers: !0,
      // Fetch any linked .BIN buffers, decode base64
      loadImages: !0,
      // Create image objects
      decompressMeshes: !0
      // Decompress Draco encoded meshes
    },
    // common?
    log: console
    // eslint-disable-line
  }
};
async function MB(e, t = {}, n) {
  t = { ...pr.options, ...t }, t.gltf = { ...pr.options.gltf, ...t.gltf };
  const { byteOffset: r = 0 } = t;
  return await TB({}, e, r, t, n);
}
const RB = {
  SCALAR: 1,
  VEC2: 2,
  VEC3: 3,
  VEC4: 4,
  MAT2: 4,
  MAT3: 9,
  MAT4: 16
}, SB = {
  5120: 1,
  // BYTE
  5121: 1,
  // UNSIGNED_BYTE
  5122: 2,
  // SHORT
  5123: 2,
  // UNSIGNED_SHORT
  5125: 4,
  // UNSIGNED_INT
  5126: 4
  // FLOAT
}, vt = {
  // Sampler parameters
  TEXTURE_MAG_FILTER: 10240,
  TEXTURE_MIN_FILTER: 10241,
  TEXTURE_WRAP_S: 10242,
  TEXTURE_WRAP_T: 10243,
  // Sampler default values
  REPEAT: 10497,
  LINEAR: 9729,
  NEAREST_MIPMAP_LINEAR: 9986
}, FB = {
  magFilter: vt.TEXTURE_MAG_FILTER,
  minFilter: vt.TEXTURE_MIN_FILTER,
  wrapS: vt.TEXTURE_WRAP_S,
  wrapT: vt.TEXTURE_WRAP_T
}, OB = {
  [vt.TEXTURE_MAG_FILTER]: vt.LINEAR,
  [vt.TEXTURE_MIN_FILTER]: vt.NEAREST_MIPMAP_LINEAR,
  [vt.TEXTURE_WRAP_S]: vt.REPEAT,
  [vt.TEXTURE_WRAP_T]: vt.REPEAT
};
function DB() {
  return {
    id: "default-sampler",
    parameters: OB
  };
}
function LB(e) {
  return SB[e];
}
function UB(e) {
  return RB[e];
}
class NB {
  constructor() {
    y(this, "baseUri", "");
    // @ts-expect-error
    y(this, "jsonUnprocessed");
    // @ts-expect-error
    y(this, "json");
    y(this, "buffers", []);
    y(this, "images", []);
  }
  postProcess(t, n = {}) {
    const { json: r, buffers: s = [], images: i = [] } = t, { baseUri: o = "" } = t;
    return Ut(r), this.baseUri = o, this.buffers = s, this.images = i, this.jsonUnprocessed = r, this.json = this._resolveTree(t.json, n), this.json;
  }
  // Convert indexed glTF structure into tree structure
  // cross-link index resolution, enum lookup, convenience calculations
  // eslint-disable-next-line complexity, max-statements
  _resolveTree(t, n = {}) {
    const r = { ...t };
    return this.json = r, t.bufferViews && (r.bufferViews = t.bufferViews.map((s, i) => this._resolveBufferView(s, i))), t.images && (r.images = t.images.map((s, i) => this._resolveImage(s, i))), t.samplers && (r.samplers = t.samplers.map((s, i) => this._resolveSampler(s, i))), t.textures && (r.textures = t.textures.map((s, i) => this._resolveTexture(s, i))), t.accessors && (r.accessors = t.accessors.map((s, i) => this._resolveAccessor(s, i))), t.materials && (r.materials = t.materials.map((s, i) => this._resolveMaterial(s, i))), t.meshes && (r.meshes = t.meshes.map((s, i) => this._resolveMesh(s, i))), t.nodes && (r.nodes = t.nodes.map((s, i) => this._resolveNode(s, i)), r.nodes = r.nodes.map((s, i) => this._resolveNodeChildren(s))), t.skins && (r.skins = t.skins.map((s, i) => this._resolveSkin(s, i))), t.scenes && (r.scenes = t.scenes.map((s, i) => this._resolveScene(s, i))), typeof this.json.scene == "number" && r.scenes && (r.scene = r.scenes[this.json.scene]), r;
  }
  getScene(t) {
    return this._get(this.json.scenes, t);
  }
  getNode(t) {
    return this._get(this.json.nodes, t);
  }
  getSkin(t) {
    return this._get(this.json.skins, t);
  }
  getMesh(t) {
    return this._get(this.json.meshes, t);
  }
  getMaterial(t) {
    return this._get(this.json.materials, t);
  }
  getAccessor(t) {
    return this._get(this.json.accessors, t);
  }
  getCamera(t) {
    return this._get(this.json.cameras, t);
  }
  getTexture(t) {
    return this._get(this.json.textures, t);
  }
  getSampler(t) {
    return this._get(this.json.samplers, t);
  }
  getImage(t) {
    return this._get(this.json.images, t);
  }
  getBufferView(t) {
    return this._get(this.json.bufferViews, t);
  }
  getBuffer(t) {
    return this._get(this.json.buffers, t);
  }
  _get(t, n) {
    if (typeof n == "object")
      return n;
    const r = t && t[n];
    return r || console.warn(`glTF file error: Could not find ${t}[${n}]`), r;
  }
  // PARSING HELPERS
  _resolveScene(t, n) {
    return {
      ...t,
      // @ts-ignore
      id: t.id || `scene-${n}`,
      nodes: (t.nodes || []).map((r) => this.getNode(r))
    };
  }
  _resolveNode(t, n) {
    const r = {
      ...t,
      // @ts-expect-error id could already be present, glTF standard does not prevent it
      id: (t == null ? void 0 : t.id) || `node-${n}`
    };
    return t.mesh !== void 0 && (r.mesh = this.getMesh(t.mesh)), t.camera !== void 0 && (r.camera = this.getCamera(t.camera)), t.skin !== void 0 && (r.skin = this.getSkin(t.skin)), t.meshes !== void 0 && t.meshes.length && (r.mesh = t.meshes.reduce((s, i) => {
      const o = this.getMesh(i);
      return s.id = o.id, s.primitives = s.primitives.concat(o.primitives), s;
    }, { primitives: [] })), r;
  }
  _resolveNodeChildren(t) {
    return t.children && (t.children = t.children.map((n) => this.getNode(n))), t;
  }
  _resolveSkin(t, n) {
    const r = typeof t.inverseBindMatrices == "number" ? this.getAccessor(t.inverseBindMatrices) : void 0;
    return {
      ...t,
      id: t.id || `skin-${n}`,
      inverseBindMatrices: r
    };
  }
  _resolveMesh(t, n) {
    const r = {
      ...t,
      id: t.id || `mesh-${n}`,
      primitives: []
    };
    return t.primitives && (r.primitives = t.primitives.map((s) => {
      const i = {
        ...s,
        attributes: {},
        indices: void 0,
        material: void 0
      }, o = s.attributes;
      for (const a in o)
        i.attributes[a] = this.getAccessor(o[a]);
      return s.indices !== void 0 && (i.indices = this.getAccessor(s.indices)), s.material !== void 0 && (i.material = this.getMaterial(s.material)), i;
    })), r;
  }
  _resolveMaterial(t, n) {
    const r = {
      ...t,
      // @ts-expect-error
      id: t.id || `material-${n}`
    };
    if (r.normalTexture && (r.normalTexture = { ...r.normalTexture }, r.normalTexture.texture = this.getTexture(r.normalTexture.index)), r.occlusionTexture && (r.occlusionTexture = { ...r.occlusionTexture }, r.occlusionTexture.texture = this.getTexture(r.occlusionTexture.index)), r.emissiveTexture && (r.emissiveTexture = { ...r.emissiveTexture }, r.emissiveTexture.texture = this.getTexture(r.emissiveTexture.index)), r.emissiveFactor || (r.emissiveFactor = r.emissiveTexture ? [1, 1, 1] : [0, 0, 0]), r.pbrMetallicRoughness) {
      r.pbrMetallicRoughness = { ...r.pbrMetallicRoughness };
      const s = r.pbrMetallicRoughness;
      s.baseColorTexture && (s.baseColorTexture = { ...s.baseColorTexture }, s.baseColorTexture.texture = this.getTexture(s.baseColorTexture.index)), s.metallicRoughnessTexture && (s.metallicRoughnessTexture = { ...s.metallicRoughnessTexture }, s.metallicRoughnessTexture.texture = this.getTexture(s.metallicRoughnessTexture.index));
    }
    return r;
  }
  _resolveAccessor(t, n) {
    const r = LB(t.componentType), s = UB(t.type), i = r * s, o = {
      ...t,
      // @ts-expect-error
      id: t.id || `accessor-${n}`,
      bytesPerComponent: r,
      components: s,
      bytesPerElement: i,
      value: void 0,
      bufferView: void 0,
      sparse: void 0
    };
    if (t.bufferView !== void 0 && (o.bufferView = this.getBufferView(t.bufferView)), o.bufferView) {
      const a = o.bufferView.buffer, { ArrayType: c, byteLength: h } = pi(o, o.bufferView), f = (o.bufferView.byteOffset || 0) + (o.byteOffset || 0) + a.byteOffset;
      let d = a.arrayBuffer.slice(f, f + h);
      o.bufferView.byteStride && (d = this._getValueFromInterleavedBuffer(a, f, o.bufferView.byteStride, o.bytesPerElement, o.count)), o.value = new c(d);
    }
    return o;
  }
  /**
   * Take values of particular accessor from interleaved buffer
   * various parts of the buffer
   * @param buffer
   * @param byteOffset
   * @param byteStride
   * @param bytesPerElement
   * @param count
   * @returns
   */
  _getValueFromInterleavedBuffer(t, n, r, s, i) {
    const o = new Uint8Array(i * s);
    for (let a = 0; a < i; a++) {
      const c = n + a * r;
      o.set(new Uint8Array(t.arrayBuffer.slice(c, c + s)), a * s);
    }
    return o.buffer;
  }
  _resolveTexture(t, n) {
    return {
      ...t,
      // @ts-expect-error id could already be present, glTF standard does not prevent it
      id: t.id || `texture-${n}`,
      sampler: typeof t.sampler == "number" ? this.getSampler(t.sampler) : DB(),
      source: typeof t.source == "number" ? this.getImage(t.source) : void 0
    };
  }
  _resolveSampler(t, n) {
    const r = {
      // @ts-expect-error id could already be present, glTF standard does not prevent it
      id: t.id || `sampler-${n}`,
      ...t,
      parameters: {}
    };
    for (const s in r) {
      const i = this._enumSamplerParameter(s);
      i !== void 0 && (r.parameters[i] = r[s]);
    }
    return r;
  }
  _enumSamplerParameter(t) {
    return FB[t];
  }
  _resolveImage(t, n) {
    const r = {
      ...t,
      // @ts-expect-error id could already be present, glTF standard does not prevent it
      id: t.id || `image-${n}`,
      image: null,
      bufferView: t.bufferView !== void 0 ? this.getBufferView(t.bufferView) : void 0
    }, s = this.images[n];
    return s && (r.image = s), r;
  }
  _resolveBufferView(t, n) {
    const r = t.buffer, s = this.buffers[r].arrayBuffer;
    let i = this.buffers[r].byteOffset || 0;
    return t.byteOffset && (i += t.byteOffset), {
      // // @ts-expect-error id could already be present, glTF standard does not prevent it
      id: `bufferView-${n}`,
      ...t,
      // ...this.buffers[bufferIndex],
      buffer: this.buffers[r],
      data: new Uint8Array(s, i, t.byteLength)
    };
  }
  _resolveCamera(t, n) {
    const r = {
      ...t,
      // @ts-expect-error id could already be present, glTF standard does not prevent it
      id: t.id || `camera-${n}`
    };
    return r.perspective, r.orthographic, r;
  }
}
function eu(e, t) {
  return new NB().postProcess(e, t);
}
const vs = {
  URI: 0,
  EMBEDDED: 1
};
function nu(e, t, n, r) {
  e.rotateYtoZ = !0;
  const s = (e.byteOffset || 0) + (e.byteLength || 0) - n;
  if (s === 0)
    throw new Error("glTF byte length must be greater than 0.");
  return e.gltfUpAxis = r != null && r["3d-tiles"] && r["3d-tiles"].assetGltfUpAxis ? r["3d-tiles"].assetGltfUpAxis : "Y", e.gltfArrayBuffer = Zs(t, n, s), e.gltfByteOffset = 0, e.gltfByteLength = s, n % 4 === 0 || console.warn(`${e.type}: embedded glb is not aligned to a 4-byte boundary.`), (e.byteOffset || 0) + (e.byteLength || 0);
}
async function ru(e, t, n, r) {
  const s = (n == null ? void 0 : n["3d-tiles"]) || {};
  if (PB(e, t), s.loadGLTF) {
    if (!r)
      return;
    if (e.gltfUrl) {
      const { fetch: i } = r, o = await i(e.gltfUrl, n);
      e.gltfArrayBuffer = await o.arrayBuffer(), e.gltfByteOffset = 0;
    }
    if (e.gltfArrayBuffer) {
      const i = await Cn(e.gltfArrayBuffer, pr, n, r);
      e.gltf = eu(i), e.gpuMemoryUsageInBytes = Hc(e.gltf), delete e.gltfArrayBuffer, delete e.gltfByteOffset, delete e.gltfByteLength;
    }
  }
}
function PB(e, t, n) {
  switch (t) {
    case vs.URI:
      if (e.gltfArrayBuffer) {
        const r = new Uint8Array(e.gltfArrayBuffer, e.gltfByteOffset), i = new TextDecoder().decode(r);
        e.gltfUrl = i.replace(/[\s\0]+$/, "");
      }
      delete e.gltfArrayBuffer, delete e.gltfByteOffset, delete e.gltfByteLength;
      break;
    case vs.EMBEDDED:
      break;
    default:
      throw new Error("b3dm: Illegal glTF format field");
  }
}
async function GB(e, t, n, r, s) {
  var o;
  n = vB(e, t, n, r), await ru(e, vs.EMBEDDED, r, s);
  const i = (o = e == null ? void 0 : e.gltf) == null ? void 0 : o.extensions;
  return i && i.CESIUM_RTC && (e.rtcCenter = i.CESIUM_RTC.center), n;
}
function vB(e, t, n, r, s) {
  n = Mr(e, t, n), n = li(e, t, n), n = fi(e, t, n), n = nu(e, t, n, r);
  const i = new hi(e.featureTableJson, e.featureTableBinary);
  return e.rtcCenter = i.getGlobalProperty("RTC_CENTER", K.FLOAT, 3), n;
}
async function HB(e, t, n, r, s) {
  return n = JB(e, t, n, r), await ru(e, e.gltfFormat || 0, r, s), n;
}
function JB(e, t, n, r, s) {
  var h;
  if (n = Mr(e, t, n), e.version !== 1)
    throw new Error(`Instanced 3D Model version ${e.version} is not supported`);
  n = li(e, t, n);
  const i = new DataView(t);
  if (e.gltfFormat = i.getUint32(n, !0), n += 4, n = fi(e, t, n), n = nu(e, t, n, r), !((h = e == null ? void 0 : e.header) != null && h.featureTableJsonByteLength) || e.header.featureTableJsonByteLength === 0)
    throw new Error("i3dm parser: featureTableJsonByteLength is zero.");
  const o = new hi(e.featureTableJson, e.featureTableBinary), a = o.getGlobalProperty("INSTANCES_LENGTH");
  if (o.featuresLength = a, !Number.isFinite(a))
    throw new Error("i3dm parser: INSTANCES_LENGTH must be defined");
  e.eastNorthUp = o.getGlobalProperty("EAST_NORTH_UP"), e.rtcCenter = o.getGlobalProperty("RTC_CENTER", K.FLOAT, 3);
  const c = new Oc(e.batchTableJson, e.batchTableBinary, a);
  return kB(e, o, c, a), n;
}
function kB(e, t, n, r) {
  const s = new Array(r), i = new T();
  new T(), new T(), new T();
  const o = new lt(), a = new ur(), c = new T(), h = {}, f = new Z(), d = [], p = [], g = [], B = [];
  for (let C = 0; C < r; C++) {
    let b;
    if (t.hasProperty("POSITION"))
      b = t.getProperty("POSITION", K.FLOAT, 3, C, i);
    else if (t.hasProperty("POSITION_QUANTIZED")) {
      b = t.getProperty("POSITION_QUANTIZED", K.UNSIGNED_SHORT, 3, C, i);
      const S = t.getGlobalProperty("QUANTIZED_VOLUME_OFFSET", K.FLOAT, 3);
      if (!S)
        throw new Error("i3dm parser: QUANTIZED_VOLUME_OFFSET must be defined for quantized positions.");
      const G = t.getGlobalProperty("QUANTIZED_VOLUME_SCALE", K.FLOAT, 3);
      if (!G)
        throw new Error("i3dm parser: QUANTIZED_VOLUME_SCALE must be defined for quantized positions.");
      const v = 65535;
      for (let P = 0; P < 3; P++)
        b[P] = b[P] / v * G[P] + S[P];
    }
    if (!b)
      throw new Error("i3dm: POSITION or POSITION_QUANTIZED must be defined for each instance.");
    if (i.copy(b), h.translation = i, e.normalUp = t.getProperty("NORMAL_UP", K.FLOAT, 3, C, d), e.normalRight = t.getProperty("NORMAL_RIGHT", K.FLOAT, 3, C, p), e.normalUp) {
      if (!e.normalRight)
        throw new Error("i3dm: Custom orientation requires both NORMAL_UP and NORMAL_RIGHT.");
      e.hasCustomOrientation = !0;
    } else {
      if (e.octNormalUp = t.getProperty("NORMAL_UP_OCT32P", K.UNSIGNED_SHORT, 2, C, d), e.octNormalRight = t.getProperty("NORMAL_RIGHT_OCT32P", K.UNSIGNED_SHORT, 2, C, p), e.octNormalUp)
        throw e.octNormalRight ? new Error("i3dm: oct-encoded orientation not implemented") : new Error("i3dm: oct-encoded orientation requires NORMAL_UP_OCT32P and NORMAL_RIGHT_OCT32P");
      e.eastNorthUp ? (q.WGS84.eastNorthUpToFixedFrame(i, f), f.getRotationMatrix3(o)) : o.identity();
    }
    a.fromMatrix3(o), h.rotation = a, c.set(1, 1, 1);
    const M = t.getProperty("SCALE", K.FLOAT, 1, C, g);
    Number.isFinite(M) && c.multiplyByScalar(M);
    const D = t.getProperty("SCALE_NON_UNIFORM", K.FLOAT, 3, C, d);
    D && c.scale(D), h.scale = c;
    let _ = t.getProperty("BATCH_ID", K.UNSIGNED_SHORT, 1, C, B);
    _ === void 0 && (_ = C);
    const x = new Z().fromQuaternion(h.rotation);
    f.identity(), f.translate(h.translation), f.multiplyRight(x), f.scale(h.scale);
    const L = f.clone();
    s[C] = {
      modelMatrix: L,
      batchId: _
    };
  }
  e.instances = s;
}
async function VB(e, t, n, r, s, i) {
  n = Mr(e, t, n);
  const o = new DataView(t);
  for (e.tilesLength = o.getUint32(n, !0), n += 4, e.tiles = []; e.tiles.length < e.tilesLength && (e.byteLength || 0) - n > 12; ) {
    const a = { shape: "tile3d" };
    e.tiles.push(a), n = await i(t, n, r, s, a);
  }
  return n;
}
async function jB(e, t, n, r) {
  var s, i;
  if (e.rotateYtoZ = !0, e.gltfUpAxis = (s = n == null ? void 0 : n["3d-tiles"]) != null && s.assetGltfUpAxis ? n["3d-tiles"].assetGltfUpAxis : "Y", (i = n == null ? void 0 : n["3d-tiles"]) != null && i.loadGLTF) {
    if (!r)
      return t.byteLength;
    const o = await Cn(t, pr, n, r);
    e.gltf = eu(o), e.gpuMemoryUsageInBytes = Hc(e.gltf);
  } else
    e.gltfArrayBuffer = t;
  return t.byteLength;
}
async function su(e, t = 0, n, r, s = { shape: "tile3d" }) {
  switch (s.byteOffset = t, s.type = $0(e, t), s.type) {
    case rn.COMPOSITE:
      return await VB(s, e, t, n, r, su);
    case rn.BATCHED_3D_MODEL:
      return await GB(s, e, t, n, r);
    case rn.GLTF:
      return await jB(s, e, n, r);
    case rn.INSTANCED_3D_MODEL:
      return await HB(s, e, t, n, r);
    case rn.POINT_CLOUD:
      return await Dp(s, e, t, n, r);
    default:
      throw new Error(`3DTileLoader: unknown type ${s.type}`);
  }
}
const KB = 1952609651, zB = 1;
async function WB(e, t, n) {
  if (new Uint32Array(e.slice(0, 4))[0] !== KB)
    throw new Error("Wrong subtree file magic number");
  if (new Uint32Array(e.slice(4, 8))[0] !== zB)
    throw new Error("Wrong subtree file verson, must be 1");
  const i = Ko(e.slice(8, 16)), o = new Uint8Array(e, 24, i), c = new TextDecoder("utf8").decode(o), h = JSON.parse(c), f = Ko(e.slice(16, 24));
  let d = new ArrayBuffer(0);
  if (f && (d = e.slice(24 + i)), await Qn(h, h.tileAvailability, d, n), Array.isArray(h.contentAvailability))
    for (const p of h.contentAvailability)
      await Qn(h, p, d, n);
  else
    await Qn(h, h.contentAvailability, d, n);
  return await Qn(h, h.childSubtreeAvailability, d, n), h;
}
async function Qn(e, t, n, r) {
  const s = Number.isFinite(t.bitstream) ? t.bitstream : t.bufferView;
  if (typeof s != "number")
    return;
  const i = e.bufferViews[s], o = e.buffers[i.buffer];
  if (!(r != null && r.baseUrl))
    throw new Error("Url is not provided");
  if (!r.fetch)
    throw new Error("fetch is not provided");
  if (o.uri) {
    const c = `${(r == null ? void 0 : r.baseUrl) || ""}/${o.uri}`, f = await (await r.fetch(c)).arrayBuffer();
    t.explicitBitstream = new Uint8Array(f, i.byteOffset, i.byteLength);
    return;
  }
  const a = e.buffers.slice(0, i.buffer).reduce((c, h) => c + h.byteLength, 0);
  t.explicitBitstream = new Uint8Array(n.slice(a, a + o.byteLength), i.byteOffset, i.byteLength);
}
function Ko(e) {
  const t = new DataView(e), n = t.getUint32(0, !0), r = t.getUint32(4, !0);
  return n + 2 ** 32 * r;
}
const iu = {
  dataType: null,
  batchType: null,
  id: "3d-tiles-subtree",
  name: "3D Tiles Subtree",
  module: "3d-tiles",
  version: xc,
  extensions: ["subtree"],
  mimeTypes: ["application/octet-stream"],
  tests: ["subtree"],
  parse: WB,
  options: {}
};
/**
 * @license
 * Copyright 2009 The Closure Library Authors
 * Copyright 2020 Daniel Wirtz / The long.js Authors.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * SPDX-License-Identifier: Apache-2.0
 */
var Ht = null;
try {
  Ht = new WebAssembly.Instance(
    new WebAssembly.Module(
      new Uint8Array([
        // \0asm
        0,
        97,
        115,
        109,
        // version 1
        1,
        0,
        0,
        0,
        // section "type"
        1,
        13,
        2,
        // 0, () => i32
        96,
        0,
        1,
        127,
        // 1, (i32, i32, i32, i32) => i32
        96,
        4,
        127,
        127,
        127,
        127,
        1,
        127,
        // section "function"
        3,
        7,
        6,
        // 0, type 0
        0,
        // 1, type 1
        1,
        // 2, type 1
        1,
        // 3, type 1
        1,
        // 4, type 1
        1,
        // 5, type 1
        1,
        // section "global"
        6,
        6,
        1,
        // 0, "high", mutable i32
        127,
        1,
        65,
        0,
        11,
        // section "export"
        7,
        50,
        6,
        // 0, "mul"
        3,
        109,
        117,
        108,
        0,
        1,
        // 1, "div_s"
        5,
        100,
        105,
        118,
        95,
        115,
        0,
        2,
        // 2, "div_u"
        5,
        100,
        105,
        118,
        95,
        117,
        0,
        3,
        // 3, "rem_s"
        5,
        114,
        101,
        109,
        95,
        115,
        0,
        4,
        // 4, "rem_u"
        5,
        114,
        101,
        109,
        95,
        117,
        0,
        5,
        // 5, "get_high"
        8,
        103,
        101,
        116,
        95,
        104,
        105,
        103,
        104,
        0,
        0,
        // section "code"
        10,
        191,
        1,
        6,
        // 0, "get_high"
        4,
        0,
        35,
        0,
        11,
        // 1, "mul"
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        126,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        // 2, "div_s"
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        127,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        // 3, "div_u"
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        128,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        // 4, "rem_s"
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        129,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11,
        // 5, "rem_u"
        36,
        1,
        1,
        126,
        32,
        0,
        173,
        32,
        1,
        173,
        66,
        32,
        134,
        132,
        32,
        2,
        173,
        32,
        3,
        173,
        66,
        32,
        134,
        132,
        130,
        34,
        4,
        66,
        32,
        135,
        167,
        36,
        0,
        32,
        4,
        167,
        11
      ])
    ),
    {}
  ).exports;
} catch {
}
function W(e, t, n) {
  this.low = e | 0, this.high = t | 0, this.unsigned = !!n;
}
W.prototype.__isLong__;
Object.defineProperty(W.prototype, "__isLong__", { value: !0 });
function bt(e) {
  return (e && e.__isLong__) === !0;
}
function zo(e) {
  var t = Math.clz32(e & -e);
  return e ? 31 - t : t;
}
W.isLong = bt;
var Wo = {}, Qo = {};
function Fe(e, t) {
  var n, r, s;
  return t ? (e >>>= 0, (s = 0 <= e && e < 256) && (r = Qo[e], r) ? r : (n = z(e, 0, !0), s && (Qo[e] = n), n)) : (e |= 0, (s = -128 <= e && e < 128) && (r = Wo[e], r) ? r : (n = z(e, e < 0 ? -1 : 0, !1), s && (Wo[e] = n), n));
}
W.fromInt = Fe;
function Jt(e, t) {
  if (isNaN(e)) return t ? he : Wt;
  if (t) {
    if (e < 0) return he;
    if (e >= ou) return uu;
  } else {
    if (e <= -Xo) return Ot;
    if (e + 1 >= Xo) return cu;
  }
  return e < 0 ? Jt(-e, t).neg() : z(
    e % Ye | 0,
    e / Ye | 0,
    t
  );
}
W.fromNumber = Jt;
function z(e, t, n) {
  return new W(e, t, n);
}
W.fromBits = z;
var gr = Math.pow;
function Ei(e, t, n) {
  if (e.length === 0) throw Error("empty string");
  if (typeof t == "number" ? (n = t, t = !1) : t = !!t, e === "NaN" || e === "Infinity" || e === "+Infinity" || e === "-Infinity")
    return t ? he : Wt;
  if (n = n || 10, n < 2 || 36 < n) throw RangeError("radix");
  var r;
  if ((r = e.indexOf("-")) > 0) throw Error("interior hyphen");
  if (r === 0)
    return Ei(e.substring(1), t, n).neg();
  for (var s = Jt(gr(n, 8)), i = Wt, o = 0; o < e.length; o += 8) {
    var a = Math.min(8, e.length - o), c = parseInt(e.substring(o, o + a), n);
    if (a < 8) {
      var h = Jt(gr(n, a));
      i = i.mul(h).add(Jt(c));
    } else
      i = i.mul(s), i = i.add(Jt(c));
  }
  return i.unsigned = t, i;
}
W.fromString = Ei;
function Vt(e, t) {
  return typeof e == "number" ? Jt(e, t) : typeof e == "string" ? Ei(e, t) : z(
    e.low,
    e.high,
    typeof t == "boolean" ? t : e.unsigned
  );
}
W.fromValue = Vt;
var $o = 65536, QB = 1 << 24, Ye = $o * $o, ou = Ye * Ye, Xo = ou / 2, qo = Fe(QB), Wt = Fe(0);
W.ZERO = Wt;
var he = Fe(0, !0);
W.UZERO = he;
var je = Fe(1);
W.ONE = je;
var au = Fe(1, !0);
W.UONE = au;
var Hs = Fe(-1);
W.NEG_ONE = Hs;
var cu = z(-1, 2147483647, !1);
W.MAX_VALUE = cu;
var uu = z(-1, -1, !0);
W.MAX_UNSIGNED_VALUE = uu;
var Ot = z(0, -2147483648, !1);
W.MIN_VALUE = Ot;
var F = W.prototype;
F.toInt = function() {
  return this.unsigned ? this.low >>> 0 : this.low;
};
F.toNumber = function() {
  return this.unsigned ? (this.high >>> 0) * Ye + (this.low >>> 0) : this.high * Ye + (this.low >>> 0);
};
F.toString = function(t) {
  if (t = t || 10, t < 2 || 36 < t) throw RangeError("radix");
  if (this.isZero()) return "0";
  if (this.isNegative())
    if (this.eq(Ot)) {
      var n = Jt(t), r = this.div(n), s = r.mul(n).sub(this);
      return r.toString(t) + s.toInt().toString(t);
    } else return "-" + this.neg().toString(t);
  for (var i = Jt(gr(t, 6), this.unsigned), o = this, a = ""; ; ) {
    var c = o.div(i), h = o.sub(c.mul(i)).toInt() >>> 0, f = h.toString(t);
    if (o = c, o.isZero()) return f + a;
    for (; f.length < 6; ) f = "0" + f;
    a = "" + f + a;
  }
};
F.getHighBits = function() {
  return this.high;
};
F.getHighBitsUnsigned = function() {
  return this.high >>> 0;
};
F.getLowBits = function() {
  return this.low;
};
F.getLowBitsUnsigned = function() {
  return this.low >>> 0;
};
F.getNumBitsAbs = function() {
  if (this.isNegative())
    return this.eq(Ot) ? 64 : this.neg().getNumBitsAbs();
  for (var t = this.high != 0 ? this.high : this.low, n = 31; n > 0 && !(t & 1 << n); n--) ;
  return this.high != 0 ? n + 33 : n + 1;
};
F.isSafeInteger = function() {
  var t = this.high >> 21;
  return t ? this.unsigned ? !1 : t === -1 && !(this.low === 0 && this.high === -2097152) : !0;
};
F.isZero = function() {
  return this.high === 0 && this.low === 0;
};
F.eqz = F.isZero;
F.isNegative = function() {
  return !this.unsigned && this.high < 0;
};
F.isPositive = function() {
  return this.unsigned || this.high >= 0;
};
F.isOdd = function() {
  return (this.low & 1) === 1;
};
F.isEven = function() {
  return (this.low & 1) === 0;
};
F.equals = function(t) {
  return bt(t) || (t = Vt(t)), this.unsigned !== t.unsigned && this.high >>> 31 === 1 && t.high >>> 31 === 1 ? !1 : this.high === t.high && this.low === t.low;
};
F.eq = F.equals;
F.notEquals = function(t) {
  return !this.eq(
    /* validates */
    t
  );
};
F.neq = F.notEquals;
F.ne = F.notEquals;
F.lessThan = function(t) {
  return this.comp(
    /* validates */
    t
  ) < 0;
};
F.lt = F.lessThan;
F.lessThanOrEqual = function(t) {
  return this.comp(
    /* validates */
    t
  ) <= 0;
};
F.lte = F.lessThanOrEqual;
F.le = F.lessThanOrEqual;
F.greaterThan = function(t) {
  return this.comp(
    /* validates */
    t
  ) > 0;
};
F.gt = F.greaterThan;
F.greaterThanOrEqual = function(t) {
  return this.comp(
    /* validates */
    t
  ) >= 0;
};
F.gte = F.greaterThanOrEqual;
F.ge = F.greaterThanOrEqual;
F.compare = function(t) {
  if (bt(t) || (t = Vt(t)), this.eq(t)) return 0;
  var n = this.isNegative(), r = t.isNegative();
  return n && !r ? -1 : !n && r ? 1 : this.unsigned ? t.high >>> 0 > this.high >>> 0 || t.high === this.high && t.low >>> 0 > this.low >>> 0 ? -1 : 1 : this.sub(t).isNegative() ? -1 : 1;
};
F.comp = F.compare;
F.negate = function() {
  return !this.unsigned && this.eq(Ot) ? Ot : this.not().add(je);
};
F.neg = F.negate;
F.add = function(t) {
  bt(t) || (t = Vt(t));
  var n = this.high >>> 16, r = this.high & 65535, s = this.low >>> 16, i = this.low & 65535, o = t.high >>> 16, a = t.high & 65535, c = t.low >>> 16, h = t.low & 65535, f = 0, d = 0, p = 0, g = 0;
  return g += i + h, p += g >>> 16, g &= 65535, p += s + c, d += p >>> 16, p &= 65535, d += r + a, f += d >>> 16, d &= 65535, f += n + o, f &= 65535, z(p << 16 | g, f << 16 | d, this.unsigned);
};
F.subtract = function(t) {
  return bt(t) || (t = Vt(t)), this.add(t.neg());
};
F.sub = F.subtract;
F.multiply = function(t) {
  if (this.isZero()) return this;
  if (bt(t) || (t = Vt(t)), Ht) {
    var n = Ht.mul(this.low, this.high, t.low, t.high);
    return z(n, Ht.get_high(), this.unsigned);
  }
  if (t.isZero()) return this.unsigned ? he : Wt;
  if (this.eq(Ot)) return t.isOdd() ? Ot : Wt;
  if (t.eq(Ot)) return this.isOdd() ? Ot : Wt;
  if (this.isNegative())
    return t.isNegative() ? this.neg().mul(t.neg()) : this.neg().mul(t).neg();
  if (t.isNegative()) return this.mul(t.neg()).neg();
  if (this.lt(qo) && t.lt(qo))
    return Jt(this.toNumber() * t.toNumber(), this.unsigned);
  var r = this.high >>> 16, s = this.high & 65535, i = this.low >>> 16, o = this.low & 65535, a = t.high >>> 16, c = t.high & 65535, h = t.low >>> 16, f = t.low & 65535, d = 0, p = 0, g = 0, B = 0;
  return B += o * f, g += B >>> 16, B &= 65535, g += i * f, p += g >>> 16, g &= 65535, g += o * h, p += g >>> 16, g &= 65535, p += s * f, d += p >>> 16, p &= 65535, p += i * h, d += p >>> 16, p &= 65535, p += o * c, d += p >>> 16, p &= 65535, d += r * f + s * h + i * c + o * a, d &= 65535, z(g << 16 | B, d << 16 | p, this.unsigned);
};
F.mul = F.multiply;
F.divide = function(t) {
  if (bt(t) || (t = Vt(t)), t.isZero()) throw Error("division by zero");
  if (Ht) {
    if (!this.unsigned && this.high === -2147483648 && t.low === -1 && t.high === -1)
      return this;
    var n = (this.unsigned ? Ht.div_u : Ht.div_s)(
      this.low,
      this.high,
      t.low,
      t.high
    );
    return z(n, Ht.get_high(), this.unsigned);
  }
  if (this.isZero()) return this.unsigned ? he : Wt;
  var r, s, i;
  if (this.unsigned) {
    if (t.unsigned || (t = t.toUnsigned()), t.gt(this)) return he;
    if (t.gt(this.shru(1)))
      return au;
    i = he;
  } else {
    if (this.eq(Ot)) {
      if (t.eq(je) || t.eq(Hs))
        return Ot;
      if (t.eq(Ot)) return je;
      var o = this.shr(1);
      return r = o.div(t).shl(1), r.eq(Wt) ? t.isNegative() ? je : Hs : (s = this.sub(t.mul(r)), i = r.add(s.div(t)), i);
    } else if (t.eq(Ot)) return this.unsigned ? he : Wt;
    if (this.isNegative())
      return t.isNegative() ? this.neg().div(t.neg()) : this.neg().div(t).neg();
    if (t.isNegative()) return this.div(t.neg()).neg();
    i = Wt;
  }
  for (s = this; s.gte(t); ) {
    r = Math.max(1, Math.floor(s.toNumber() / t.toNumber()));
    for (var a = Math.ceil(Math.log(r) / Math.LN2), c = a <= 48 ? 1 : gr(2, a - 48), h = Jt(r), f = h.mul(t); f.isNegative() || f.gt(s); )
      r -= c, h = Jt(r, this.unsigned), f = h.mul(t);
    h.isZero() && (h = je), i = i.add(h), s = s.sub(f);
  }
  return i;
};
F.div = F.divide;
F.modulo = function(t) {
  if (bt(t) || (t = Vt(t)), Ht) {
    var n = (this.unsigned ? Ht.rem_u : Ht.rem_s)(
      this.low,
      this.high,
      t.low,
      t.high
    );
    return z(n, Ht.get_high(), this.unsigned);
  }
  return this.sub(this.div(t).mul(t));
};
F.mod = F.modulo;
F.rem = F.modulo;
F.not = function() {
  return z(~this.low, ~this.high, this.unsigned);
};
F.countLeadingZeros = function() {
  return this.high ? Math.clz32(this.high) : Math.clz32(this.low) + 32;
};
F.clz = F.countLeadingZeros;
F.countTrailingZeros = function() {
  return this.low ? zo(this.low) : zo(this.high) + 32;
};
F.ctz = F.countTrailingZeros;
F.and = function(t) {
  return bt(t) || (t = Vt(t)), z(this.low & t.low, this.high & t.high, this.unsigned);
};
F.or = function(t) {
  return bt(t) || (t = Vt(t)), z(this.low | t.low, this.high | t.high, this.unsigned);
};
F.xor = function(t) {
  return bt(t) || (t = Vt(t)), z(this.low ^ t.low, this.high ^ t.high, this.unsigned);
};
F.shiftLeft = function(t) {
  return bt(t) && (t = t.toInt()), (t &= 63) === 0 ? this : t < 32 ? z(
    this.low << t,
    this.high << t | this.low >>> 32 - t,
    this.unsigned
  ) : z(0, this.low << t - 32, this.unsigned);
};
F.shl = F.shiftLeft;
F.shiftRight = function(t) {
  return bt(t) && (t = t.toInt()), (t &= 63) === 0 ? this : t < 32 ? z(
    this.low >>> t | this.high << 32 - t,
    this.high >> t,
    this.unsigned
  ) : z(
    this.high >> t - 32,
    this.high >= 0 ? 0 : -1,
    this.unsigned
  );
};
F.shr = F.shiftRight;
F.shiftRightUnsigned = function(t) {
  return bt(t) && (t = t.toInt()), (t &= 63) === 0 ? this : t < 32 ? z(
    this.low >>> t | this.high << 32 - t,
    this.high >>> t,
    this.unsigned
  ) : t === 32 ? z(this.high, 0, this.unsigned) : z(this.high >>> t - 32, 0, this.unsigned);
};
F.shru = F.shiftRightUnsigned;
F.shr_u = F.shiftRightUnsigned;
F.rotateLeft = function(t) {
  var n;
  return bt(t) && (t = t.toInt()), (t &= 63) === 0 ? this : t === 32 ? z(this.high, this.low, this.unsigned) : t < 32 ? (n = 32 - t, z(
    this.low << t | this.high >>> n,
    this.high << t | this.low >>> n,
    this.unsigned
  )) : (t -= 32, n = 32 - t, z(
    this.high << t | this.low >>> n,
    this.low << t | this.high >>> n,
    this.unsigned
  ));
};
F.rotl = F.rotateLeft;
F.rotateRight = function(t) {
  var n;
  return bt(t) && (t = t.toInt()), (t &= 63) === 0 ? this : t === 32 ? z(this.high, this.low, this.unsigned) : t < 32 ? (n = 32 - t, z(
    this.high << n | this.low >>> t,
    this.low << n | this.high >>> t,
    this.unsigned
  )) : (t -= 32, n = 32 - t, z(
    this.low << n | this.high >>> t,
    this.high << n | this.low >>> t,
    this.unsigned
  ));
};
F.rotr = F.rotateRight;
F.toSigned = function() {
  return this.unsigned ? z(this.low, this.high, !1) : this;
};
F.toUnsigned = function() {
  return this.unsigned ? this : z(this.low, this.high, !0);
};
F.toBytes = function(t) {
  return t ? this.toBytesLE() : this.toBytesBE();
};
F.toBytesLE = function() {
  var t = this.high, n = this.low;
  return [
    n & 255,
    n >>> 8 & 255,
    n >>> 16 & 255,
    n >>> 24,
    t & 255,
    t >>> 8 & 255,
    t >>> 16 & 255,
    t >>> 24
  ];
};
F.toBytesBE = function() {
  var t = this.high, n = this.low;
  return [
    t >>> 24,
    t >>> 16 & 255,
    t >>> 8 & 255,
    t & 255,
    n >>> 24,
    n >>> 16 & 255,
    n >>> 8 & 255,
    n & 255
  ];
};
W.fromBytes = function(t, n, r) {
  return r ? W.fromBytesLE(t, n) : W.fromBytesBE(t, n);
};
W.fromBytesLE = function(t, n) {
  return new W(
    t[0] | t[1] << 8 | t[2] << 16 | t[3] << 24,
    t[4] | t[5] << 8 | t[6] << 16 | t[7] << 24,
    n
  );
};
W.fromBytesBE = function(t, n) {
  return new W(
    t[4] << 24 | t[5] << 16 | t[6] << 8 | t[7],
    t[0] << 24 | t[1] << 16 | t[2] << 8 | t[3],
    n
  );
};
typeof BigInt == "function" && (W.fromBigInt = function(t, n) {
  var r = Number(BigInt.asIntN(32, t)), s = Number(BigInt.asIntN(32, t >> BigInt(32)));
  return z(r, s, n);
}, W.fromValue = function(t, n) {
  return typeof t == "bigint" ? W.fromBigInt(t, n) : Vt(t, n);
}, F.toBigInt = function() {
  var t = BigInt(this.low >>> 0), n = BigInt(this.unsigned ? this.high >>> 0 : this.high);
  return n << BigInt(32) | t;
});
const $B = 16;
function hu(e) {
  e === "X" && (e = "");
  const t = e.padEnd($B, "0");
  return W.fromString(t, !0, 16);
}
function XB(e) {
  if (e.isZero())
    return "X";
  let t = e.countTrailingZeros();
  const n = t % 4;
  t = (t - n) / 4;
  const r = t;
  t *= 4;
  const i = e.shiftRightUnsigned(t).toString(16).replace(/0+$/, "");
  return Array(17 - r - i.length).join("0") + i;
}
function qB(e, t) {
  const n = YB(e).shiftRightUnsigned(2);
  return e.add(W.fromNumber(2 * t + 1 - 4).multiply(n));
}
function YB(e) {
  return e.and(e.not().add(1));
}
const ZB = 3, t1 = 30, e1 = 2 * t1 + 1, Yo = 180 / Math.PI;
function n1(e) {
  if (e.length === 0)
    throw new Error(`Invalid Hilbert quad key ${e}`);
  const t = e.split("/"), n = parseInt(t[0], 10), r = t[1], s = r.length;
  let i = 0;
  const o = [0, 0];
  for (let a = s - 1; a >= 0; a--) {
    i = s - a;
    const c = r[a];
    let h = 0, f = 0;
    c === "1" ? f = 1 : c === "2" ? (h = 1, f = 1) : c === "3" && (h = 1);
    const d = Math.pow(2, i - 1);
    s1(d, o, h, f), o[0] += d * h, o[1] += d * f;
  }
  if (n % 2 === 1) {
    const a = o[0];
    o[0] = o[1], o[1] = a;
  }
  return { face: n, ij: o, level: i };
}
function r1(e) {
  if (e.isZero())
    return "";
  let t = e.toString(2);
  for (; t.length < ZB + e1; )
    t = "0" + t;
  const n = t.lastIndexOf("1"), r = t.substring(0, 3), s = t.substring(3, n), i = s.length / 2, o = W.fromString(r, !0, 2).toString(10);
  let a = "";
  if (i !== 0)
    for (a = W.fromString(s, !0, 2).toString(4); a.length < i; )
      a = "0" + a;
  return `${o}/${a}`;
}
function lu(e, t, n) {
  const r = 1 << t;
  return [(e[0] + n[0]) / r, (e[1] + n[1]) / r];
}
function Zo(e) {
  return e >= 0.5 ? 1 / 3 * (4 * e * e - 1) : 1 / 3 * (1 - 4 * (1 - e) * (1 - e));
}
function fu(e) {
  return [Zo(e[0]), Zo(e[1])];
}
function du(e, [t, n]) {
  switch (e) {
    case 0:
      return [1, t, n];
    case 1:
      return [-t, 1, n];
    case 2:
      return [-t, -n, 1];
    case 3:
      return [-1, -n, -t];
    case 4:
      return [n, -1, -t];
    case 5:
      return [n, t, -1];
    default:
      throw new Error("Invalid face");
  }
}
function mu([e, t, n]) {
  const r = Math.atan2(n, Math.sqrt(e * e + t * t));
  return [Math.atan2(t, e) * Yo, r * Yo];
}
function s1(e, t, n, r) {
  if (r === 0) {
    n === 1 && (t[0] = e - 1 - t[0], t[1] = e - 1 - t[1]);
    const s = t[0];
    t[0] = t[1], t[1] = s;
  }
}
function i1(e) {
  const t = lu(e.ij, e.level, [0.5, 0.5]), n = fu(t), r = du(e.face, n);
  return mu(r);
}
const o1 = 100;
function ta(e) {
  const { face: t, ij: n, level: r } = e, s = [
    [0, 0],
    [0, 1],
    [1, 1],
    [1, 0],
    [0, 0]
  ], i = Math.max(1, Math.ceil(o1 * Math.pow(2, -r))), o = new Float64Array(4 * i * 2 + 2);
  let a = 0, c = 0;
  for (let h = 0; h < 4; h++) {
    const f = s[h].slice(0), d = s[h + 1], p = (d[0] - f[0]) / i, g = (d[1] - f[1]) / i;
    for (let B = 0; B < i; B++) {
      f[0] += p, f[1] += g;
      const C = lu(n, r, f), b = fu(C), M = du(t, b), D = mu(M);
      Math.abs(D[1]) > 89.999 && (D[0] = c);
      const _ = D[0] - c;
      D[0] += _ > 180 ? -360 : _ < -180 ? 360 : 0, o[a++] = D[0], o[a++] = D[1], c = D[0];
    }
  }
  return o[a++] = o[0], o[a++] = o[1], o;
}
function Ci(e) {
  const t = a1(e);
  return n1(t);
}
function a1(e) {
  if (e.indexOf("/") > 0)
    return e;
  const t = hu(e);
  return r1(t);
}
function c1(e) {
  const t = Ci(e);
  return i1(t);
}
function u1(e) {
  let t;
  if (e.face === 2 || e.face === 5) {
    let n = null, r = 0;
    for (let s = 0; s < 4; s++) {
      const i = `${e.face}/${s}`, o = Ci(i), a = ta(o);
      (typeof n > "u" || n === null) && (n = new Float64Array(4 * a.length)), n.set(a, r), r += a.length;
    }
    t = ea(n);
  } else {
    const n = ta(e);
    t = ea(n);
  }
  return t;
}
function ea(e) {
  if (e.length % 2 !== 0)
    throw new Error("Invalid corners");
  const t = [], n = [];
  for (let r = 0; r < e.length; r += 2)
    t.push(e[r]), n.push(e[r + 1]);
  return t.sort((r, s) => r - s), n.sort((r, s) => r - s), {
    west: t[0],
    east: t[t.length - 1],
    north: n[n.length - 1],
    south: n[0]
  };
}
function h1(e, t) {
  const n = (t == null ? void 0 : t.minimumHeight) || 0, r = (t == null ? void 0 : t.maximumHeight) || 0, s = Ci(e), i = u1(s), o = i.west, a = i.south, c = i.east, h = i.north, f = [];
  return f.push(new T(o, h, n)), f.push(new T(c, h, n)), f.push(new T(c, a, n)), f.push(new T(o, a, n)), f.push(new T(o, h, r)), f.push(new T(c, h, r)), f.push(new T(c, a, r)), f.push(new T(o, a, r)), f;
}
function pu(e) {
  const t = e.token, n = {
    minimumHeight: e.minimumHeight,
    maximumHeight: e.maximumHeight
  }, r = h1(t, n), s = c1(t), i = s[0], o = s[1], a = q.WGS84.cartographicToCartesian([
    i,
    o,
    n.maximumHeight
  ]), c = new T(a[0], a[1], a[2]);
  r.push(c);
  const h = y0(r);
  return [...h.center, ...h.halfAxes];
}
const l1 = 4, f1 = 8, d1 = {
  QUADTREE: l1,
  OCTREE: f1
};
function m1(e, t, n) {
  if (e != null && e.box) {
    const r = hu(e.s2VolumeInfo.token), s = qB(r, t), i = XB(s), o = { ...e.s2VolumeInfo };
    switch (o.token = i, n) {
      case "OCTREE":
        const h = e.s2VolumeInfo, f = h.maximumHeight - h.minimumHeight, d = f / 2, p = h.minimumHeight + f / 2;
        h.minimumHeight = p - d, h.maximumHeight = p + d;
        break;
    }
    return {
      box: pu(o),
      s2VolumeInfo: o
    };
  }
}
async function gu(e) {
  const { subtree: t, subtreeData: n = {
    level: 0,
    x: 0,
    y: 0,
    z: 0
  }, parentData: r = {
    mortonIndex: 0,
    localLevel: -1,
    localX: 0,
    localY: 0,
    localZ: 0
  }, childIndex: s = 0, implicitOptions: i, loaderOptions: o, s2VolumeBox: a } = e, { subdivisionScheme: c, subtreeLevels: h, maximumLevel: f, contentUrlTemplate: d, subtreesUriTemplate: p, basePath: g } = i, B = { children: [], lodMetricValue: 0, contentUrl: "" };
  if (!f)
    return Ja.once(`Missing 'maximumLevel' or 'availableLevels' property. The subtree ${d} won't be loaded...`), B;
  const C = r.localLevel + 1, b = n.level + C;
  if (b > f)
    return B;
  const M = d1[c], D = Math.log2(M), _ = s & 1, x = s >> 1 & 1, L = s >> 2 & 1, S = Ce(r.localX, _, 1), G = Ce(r.localY, x, 1), v = Ce(r.localZ, L, 1), P = Ce(n.x, S, C), J = Ce(n.y, G, C), tt = Ce(n.z, v, C), it = Ce(r.mortonIndex, s, D), ft = C === h && gs(t.childSubtreeAvailability, it);
  let k, gt, Nt, Pt;
  if (ft) {
    const dt = `${g}/${p}`, X = Js(dt, b, P, J, tt);
    k = await Qe(X, iu, o), Pt = 0, gt = { level: b, x: P, y: J, z: tt }, Nt = { mortonIndex: 0, localLevel: 0, localX: 0, localY: 0, localZ: 0 };
  } else
    k = t, Pt = (M ** C - 1) / (M - 1) + it, gt = n, Nt = { mortonIndex: it, localLevel: C, localX: S, localY: G, localZ: v };
  if (!gs(k.tileAvailability, Pt))
    return B;
  gs(k.contentAvailability, Pt) && (B.contentUrl = Js(d, b, P, J, tt));
  for (let dt = 0; dt < M; dt++) {
    const X = m1(a, dt, c), at = await gu({
      subtree: k,
      subtreeData: gt,
      parentData: Nt,
      childIndex: dt,
      implicitOptions: i,
      loaderOptions: o,
      s2VolumeBox: X
    });
    (at.contentUrl || at.children.length) && B.children.push(at);
  }
  return B.contentUrl || B.children.length ? p1(B, { level: b, x: P, y: J, z: tt }, i, a) : B;
}
function gs(e, t) {
  let n;
  return Array.isArray(e) ? (n = e[0], e.length > 1 && Ja.once('Not supported extension "3DTILES_multiple_contents" has been detected')) : n = e, "constant" in n ? !!n.constant : n.explicitBitstream ? y1(t, n.explicitBitstream) : !1;
}
function p1(e, t, n, r) {
  const { basePath: s, refine: i, getRefine: o, lodMetricType: a, getTileType: c, rootLodMetricValue: h, rootBoundingVolume: f } = n, d = e.contentUrl && e.contentUrl.replace(`${s}/`, ""), p = h / 2 ** t.level, g = r != null && r.box ? { box: r.box } : f, B = g1(g, t, n.subdivisionScheme);
  return {
    children: e.children,
    contentUrl: e.contentUrl,
    content: { uri: d },
    id: e.contentUrl,
    refine: o(i),
    type: c(e),
    lodMetricType: a,
    lodMetricValue: p,
    geometricError: p,
    transform: e.transform,
    boundingVolume: B
  };
}
function g1(e, t, n) {
  if (e.region) {
    const { level: r, x: s, y: i, z: o } = t, [a, c, h, f, d, p] = e.region, g = 2 ** r, B = (h - a) / g, [C, b] = [a + B * s, a + B * (s + 1)], M = (f - c) / g, [D, _] = [c + M * i, c + M * (i + 1)];
    let x, L;
    if (n === "OCTREE") {
      const S = (p - d) / g;
      [x, L] = [
        d + S * o,
        d + S * (o + 1)
      ];
    } else
      [x, L] = [d, p];
    return {
      region: [C, D, b, _, x, L]
    };
  }
  if (e.box)
    return e;
  throw new Error(`Unsupported bounding volume type ${JSON.stringify(e)}`);
}
function Ce(e, t, n) {
  return (e << n) + t;
}
function Js(e, t, n, r, s) {
  const i = A1({ level: t, x: n, y: r, z: s });
  return e.replace(/{level}|{x}|{y}|{z}/gi, (o) => i[o]);
}
function A1(e) {
  const t = {};
  for (const n in e)
    t[`{${n}}`] = e[n];
  return t;
}
function y1(e, t) {
  const n = Math.floor(e / 8), r = e % 8;
  return (t[n] >> r & 1) === 1;
}
function Ti(e, t = "") {
  if (!t)
    return ue.EMPTY;
  const r = t.split("?")[0].split(".").pop();
  switch (r) {
    case "pnts":
      return ue.POINTCLOUD;
    case "i3dm":
    case "b3dm":
    case "glb":
    case "gltf":
      return ue.SCENEGRAPH;
    default:
      return r || ue.EMPTY;
  }
}
function wi(e) {
  switch (e) {
    case "REPLACE":
    case "replace":
      return Qt.REPLACE;
    case "ADD":
    case "add":
      return Qt.ADD;
    default:
      return e;
  }
}
function ks(e, t) {
  if (/^[a-z][0-9a-z+.-]*:/i.test(t)) {
    const r = new URL(e, `${t}/`);
    return decodeURI(r.toString());
  } else if (e.startsWith("/"))
    return e;
  return Pl(t, e);
}
function na(e, t) {
  var s;
  if (!e)
    return null;
  let n;
  if (e.content) {
    const i = e.content.uri || ((s = e.content) == null ? void 0 : s.url);
    typeof i < "u" && (n = ks(i, t));
  }
  return {
    ...e,
    id: n,
    contentUrl: n,
    lodMetricType: $e.GEOMETRIC_ERROR,
    lodMetricValue: e.geometricError,
    transformMatrix: e.transform,
    type: Ti(e, n),
    refine: wi(e.refine)
  };
}
async function B1(e, t, n) {
  let r = null;
  const s = sa(e.root);
  s && e.root ? r = await ra(e.root, e, t, s, n) : r = na(e.root, t);
  const i = [];
  for (i.push(r); i.length > 0; ) {
    const o = i.pop() || {}, a = o.children || [], c = [];
    for (const h of a) {
      const f = sa(h);
      let d;
      f ? d = await ra(h, e, t, f, n) : d = na(h, t), d && (c.push(d), i.push(d));
    }
    o.children = c;
  }
  return r;
}
async function ra(e, t, n, r, s) {
  var x, L, S;
  const { subdivisionScheme: i, maximumLevel: o, availableLevels: a, subtreeLevels: c, subtrees: { uri: h } } = r, f = Js(h, 0, 0, 0, 0), d = ks(f, n), p = await Qe(d, iu, s), g = (x = e.content) == null ? void 0 : x.uri, B = g ? ks(g, n) : "", C = (L = t == null ? void 0 : t.root) == null ? void 0 : L.refine, b = e.geometricError, M = (S = e.boundingVolume.extensions) == null ? void 0 : S["3DTILES_bounding_volume_S2"];
  if (M) {
    const v = { box: pu(M), s2VolumeInfo: M };
    e.boundingVolume = v;
  }
  const D = e.boundingVolume, _ = {
    contentUrlTemplate: B,
    subtreesUriTemplate: h,
    subdivisionScheme: i,
    subtreeLevels: c,
    maximumLevel: Number.isFinite(a) ? a - 1 : o,
    refine: C,
    basePath: n,
    lodMetricType: $e.GEOMETRIC_ERROR,
    rootLodMetricValue: b,
    rootBoundingVolume: D,
    getTileType: Ti,
    getRefine: wi
  };
  return await E1(e, n, p, _, s);
}
async function E1(e, t, n, r, s) {
  if (!e)
    return null;
  const { children: i, contentUrl: o } = await gu({
    subtree: n,
    implicitOptions: r,
    loaderOptions: s
  });
  let a, c = null;
  return o && (a = o, c = { uri: o.replace(`${t}/`, "") }), {
    ...e,
    id: a,
    contentUrl: a,
    lodMetricType: $e.GEOMETRIC_ERROR,
    lodMetricValue: e.geometricError,
    transformMatrix: e.transform,
    type: Ti(e, a),
    refine: wi(e.refine),
    content: c || e.content,
    children: i
  };
}
function sa(e) {
  var t;
  return ((t = e == null ? void 0 : e.extensions) == null ? void 0 : t["3DTILES_implicit_tiling"]) || (e == null ? void 0 : e.implicitTiling);
}
const dn = {
  dataType: null,
  batchType: null,
  id: "3d-tiles",
  name: "3D Tiles",
  module: "3d-tiles",
  version: xc,
  extensions: ["cmpt", "pnts", "b3dm", "i3dm"],
  mimeTypes: ["application/octet-stream"],
  tests: ["cmpt", "pnts", "b3dm", "i3dm"],
  parse: C1,
  options: {
    "3d-tiles": {
      loadGLTF: !0,
      decodeQuantizedPositions: !1,
      isTileset: "auto",
      assetGltfUpAxis: null
    }
  }
};
async function C1(e, t = {}, n) {
  const r = t["3d-tiles"] || {};
  let s;
  return r.isTileset === "auto" ? s = (n == null ? void 0 : n.url) && n.url.indexOf(".json") !== -1 : s = r.isTileset, s ? T1(e, t, n) : w1(e, t, n);
}
async function T1(e, t, n) {
  var c;
  const r = JSON.parse(new TextDecoder().decode(e)), s = (n == null ? void 0 : n.url) || "", i = b1(s), o = await B1(r, i, t || {});
  return {
    ...r,
    shape: "tileset3d",
    loader: dn,
    url: s,
    queryString: (n == null ? void 0 : n.queryString) || "",
    basePath: i,
    root: o || r.root,
    type: Rt.TILES3D,
    lodMetricType: $e.GEOMETRIC_ERROR,
    lodMetricValue: ((c = r.root) == null ? void 0 : c.geometricError) || 0
  };
}
async function w1(e, t, n) {
  const r = {
    content: {
      shape: "tile3d",
      featureIds: null
    }
  };
  return await su(e, 0, t, n, r.content), r.content;
}
function b1(e) {
  return ti(e);
}
const Au = "https://api.cesium.com/v1/assets";
async function _1(e, t) {
  if (!t) {
    const i = await I1(e);
    for (const o of i.items)
      o.type === "3DTILES" && (t = o.id);
  }
  const n = await x1(e, t), { type: r, url: s } = n;
  return $(r === "3DTILES" && s), n.headers = {
    Authorization: `Bearer ${n.accessToken}`
  }, n;
}
async function I1(e) {
  $(e);
  const t = Au, n = { Authorization: `Bearer ${e}` }, r = await pn(t, { headers: n });
  if (!r.ok)
    throw new Error(r.statusText);
  return await r.json();
}
async function x1(e, t) {
  $(e, t);
  const n = { Authorization: `Bearer ${e}` }, r = `${Au}/${t}`;
  let s = await pn(`${r}`, { headers: n });
  if (!s.ok)
    throw new Error(s.statusText);
  let i = await s.json();
  if (s = await pn(`${r}/endpoint`, { headers: n }), !s.ok)
    throw new Error(s.statusText);
  const o = await s.json();
  return i = {
    ...i,
    ...o
  }, i;
}
async function M1(e, t = {}) {
  t = t["cesium-ion"] || {};
  const { accessToken: n } = t;
  let r = t.assetId;
  if (!Number.isFinite(r)) {
    const s = e.match(/\/([0-9]+)\/tileset.json/);
    r = s && s[1];
  }
  return _1(n, r);
}
const yu = {
  ...dn,
  id: "cesium-ion",
  name: "Cesium Ion",
  // @ts-ignore
  preload: M1,
  parse: async (e, t, n) => (t = { ...t }, t["3d-tiles"] = t["cesium-ion"], t.loader = yu, dn.parse(e, t, n)),
  options: {
    "cesium-ion": {
      ...dn.options["3d-tiles"],
      accessToken: null
    }
  }
}, Vs = Number.MAX_SAFE_INTEGER;
var U;
(function(e) {
  e[e.BEGIN = 0] = "BEGIN", e[e.VALUE = 1] = "VALUE", e[e.OPEN_OBJECT = 2] = "OPEN_OBJECT", e[e.CLOSE_OBJECT = 3] = "CLOSE_OBJECT", e[e.OPEN_ARRAY = 4] = "OPEN_ARRAY", e[e.CLOSE_ARRAY = 5] = "CLOSE_ARRAY", e[e.TEXT_ESCAPE = 6] = "TEXT_ESCAPE", e[e.STRING = 7] = "STRING", e[e.BACKSLASH = 8] = "BACKSLASH", e[e.END = 9] = "END", e[e.OPEN_KEY = 10] = "OPEN_KEY", e[e.CLOSE_KEY = 11] = "CLOSE_KEY", e[e.TRUE = 12] = "TRUE", e[e.TRUE2 = 13] = "TRUE2", e[e.TRUE3 = 14] = "TRUE3", e[e.FALSE = 15] = "FALSE", e[e.FALSE2 = 16] = "FALSE2", e[e.FALSE3 = 17] = "FALSE3", e[e.FALSE4 = 18] = "FALSE4", e[e.NULL = 19] = "NULL", e[e.NULL2 = 20] = "NULL2", e[e.NULL3 = 21] = "NULL3", e[e.NUMBER_DECIMAL_POINT = 22] = "NUMBER_DECIMAL_POINT", e[e.NUMBER_DIGIT = 23] = "NUMBER_DIGIT";
})(U || (U = {}));
const N = {
  tab: 9,
  // \t
  lineFeed: 10,
  // \n
  carriageReturn: 13,
  // \r
  space: 32,
  // " "
  doubleQuote: 34,
  // "
  plus: 43,
  // +
  comma: 44,
  // ,
  minus: 45,
  // -
  period: 46,
  // .
  _0: 48,
  // 0
  _9: 57,
  // 9
  colon: 58,
  // :
  E: 69,
  // E
  openBracket: 91,
  // [
  backslash: 92,
  // \
  closeBracket: 93,
  // ]
  a: 97,
  // a
  b: 98,
  // b
  e: 101,
  // e
  f: 102,
  // f
  l: 108,
  // l
  n: 110,
  // n
  r: 114,
  // r
  s: 115,
  // s
  t: 116,
  // t
  u: 117,
  // u
  openBrace: 123,
  // {
  closeBrace: 125
  // }
}, ia = /[\\"\n]/g, oa = {
  onready: () => {
  },
  onopenobject: () => {
  },
  onkey: () => {
  },
  oncloseobject: () => {
  },
  onopenarray: () => {
  },
  onclosearray: () => {
  },
  onvalue: () => {
  },
  onerror: () => {
  },
  onend: () => {
  },
  onchunkparsed: () => {
  }
};
class R1 {
  constructor(t = {}) {
    y(this, "options", oa);
    y(this, "bufferCheckPosition", Vs);
    y(this, "q", "");
    y(this, "c", "");
    y(this, "p", "");
    y(this, "closed", !1);
    y(this, "closedRoot", !1);
    y(this, "sawRoot", !1);
    // tag = null;
    y(this, "error", null);
    y(this, "state", U.BEGIN);
    y(this, "stack", []);
    // mostly just for error reporting
    y(this, "position", 0);
    y(this, "column", 0);
    y(this, "line", 1);
    y(this, "slashed", !1);
    y(this, "unicodeI", 0);
    y(this, "unicodeS", null);
    y(this, "depth", 0);
    y(this, "textNode");
    y(this, "numberNode");
    this.options = { ...oa, ...t }, this.textNode = void 0, this.numberNode = "", this.emit("onready");
  }
  end() {
    return (this.state !== U.VALUE || this.depth !== 0) && this._error("Unexpected end"), this._closeValue(), this.c = "", this.closed = !0, this.emit("onend"), this;
  }
  resume() {
    return this.error = null, this;
  }
  close() {
    return this.write(null);
  }
  // protected
  emit(t, n) {
    var r, s;
    (s = (r = this.options)[t]) == null || s.call(r, n, this);
  }
  emitNode(t, n) {
    this._closeValue(), this.emit(t, n);
  }
  /* eslint-disable no-continue */
  // eslint-disable-next-line complexity, max-statements
  write(t) {
    if (this.error)
      throw this.error;
    if (this.closed)
      return this._error("Cannot write after close. Assign an onready handler.");
    if (t === null)
      return this.end();
    let n = 0, r = t.charCodeAt(0), s = this.p;
    for (; r && (s = r, this.c = r = t.charCodeAt(n++), s !== r ? this.p = s : s = this.p, !!r); )
      switch (this.position++, r === N.lineFeed ? (this.line++, this.column = 0) : this.column++, this.state) {
        case U.BEGIN:
          r === N.openBrace ? this.state = U.OPEN_OBJECT : r === N.openBracket ? this.state = U.OPEN_ARRAY : on(r) || this._error("Non-whitespace before {[.");
          continue;
        case U.OPEN_KEY:
        case U.OPEN_OBJECT:
          if (on(r))
            continue;
          if (this.state === U.OPEN_KEY)
            this.stack.push(U.CLOSE_KEY);
          else if (r === N.closeBrace) {
            this.emit("onopenobject"), this.depth++, this.emit("oncloseobject"), this.depth--, this.state = this.stack.pop() || U.VALUE;
            continue;
          } else
            this.stack.push(U.CLOSE_OBJECT);
          r === N.doubleQuote ? this.state = U.STRING : this._error('Malformed object key should start with "');
          continue;
        case U.CLOSE_KEY:
        case U.CLOSE_OBJECT:
          if (on(r))
            continue;
          r === N.colon ? (this.state === U.CLOSE_OBJECT ? (this.stack.push(U.CLOSE_OBJECT), this._closeValue("onopenobject"), this.depth++) : this._closeValue("onkey"), this.state = U.VALUE) : r === N.closeBrace ? (this.emitNode("oncloseobject"), this.depth--, this.state = this.stack.pop() || U.VALUE) : r === N.comma ? (this.state === U.CLOSE_OBJECT && this.stack.push(U.CLOSE_OBJECT), this._closeValue(), this.state = U.OPEN_KEY) : this._error("Bad object");
          continue;
        case U.OPEN_ARRAY:
        case U.VALUE:
          if (on(r))
            continue;
          if (this.state === U.OPEN_ARRAY)
            if (this.emit("onopenarray"), this.depth++, this.state = U.VALUE, r === N.closeBracket) {
              this.emit("onclosearray"), this.depth--, this.state = this.stack.pop() || U.VALUE;
              continue;
            } else
              this.stack.push(U.CLOSE_ARRAY);
          r === N.doubleQuote ? this.state = U.STRING : r === N.openBrace ? this.state = U.OPEN_OBJECT : r === N.openBracket ? this.state = U.OPEN_ARRAY : r === N.t ? this.state = U.TRUE : r === N.f ? this.state = U.FALSE : r === N.n ? this.state = U.NULL : r === N.minus ? this.numberNode += "-" : N._0 <= r && r <= N._9 ? (this.numberNode += String.fromCharCode(r), this.state = U.NUMBER_DIGIT) : this._error("Bad value");
          continue;
        case U.CLOSE_ARRAY:
          if (r === N.comma)
            this.stack.push(U.CLOSE_ARRAY), this._closeValue("onvalue"), this.state = U.VALUE;
          else if (r === N.closeBracket)
            this.emitNode("onclosearray"), this.depth--, this.state = this.stack.pop() || U.VALUE;
          else {
            if (on(r))
              continue;
            this._error("Bad array");
          }
          continue;
        case U.STRING:
          this.textNode === void 0 && (this.textNode = "");
          let i = n - 1, o = this.slashed, a = this.unicodeI;
          t: for (; ; ) {
            for (; a > 0; )
              if (this.unicodeS += String.fromCharCode(r), r = t.charCodeAt(n++), this.position++, a === 4 ? (this.textNode += String.fromCharCode(parseInt(this.unicodeS, 16)), a = 0, i = n - 1) : a++, !r)
                break t;
            if (r === N.doubleQuote && !o) {
              this.state = this.stack.pop() || U.VALUE, this.textNode += t.substring(i, n - 1), this.position += n - 1 - i;
              break;
            }
            if (r === N.backslash && !o && (o = !0, this.textNode += t.substring(i, n - 1), this.position += n - 1 - i, r = t.charCodeAt(n++), this.position++, !r))
              break;
            if (o) {
              if (o = !1, r === N.n ? this.textNode += `
` : r === N.r ? this.textNode += "\r" : r === N.t ? this.textNode += "	" : r === N.f ? this.textNode += "\f" : r === N.b ? this.textNode += "\b" : r === N.u ? (a = 1, this.unicodeS = "") : this.textNode += String.fromCharCode(r), r = t.charCodeAt(n++), this.position++, i = n - 1, r)
                continue;
              break;
            }
            ia.lastIndex = n;
            const c = ia.exec(t);
            if (c === null) {
              n = t.length + 1, this.textNode += t.substring(i, n - 1), this.position += n - 1 - i;
              break;
            }
            if (n = c.index + 1, r = t.charCodeAt(c.index), !r) {
              this.textNode += t.substring(i, n - 1), this.position += n - 1 - i;
              break;
            }
          }
          this.slashed = o, this.unicodeI = a;
          continue;
        case U.TRUE:
          r === N.r ? this.state = U.TRUE2 : this._error(`Invalid true started with t${r}`);
          continue;
        case U.TRUE2:
          r === N.u ? this.state = U.TRUE3 : this._error(`Invalid true started with tr${r}`);
          continue;
        case U.TRUE3:
          r === N.e ? (this.emit("onvalue", !0), this.state = this.stack.pop() || U.VALUE) : this._error(`Invalid true started with tru${r}`);
          continue;
        case U.FALSE:
          r === N.a ? this.state = U.FALSE2 : this._error(`Invalid false started with f${r}`);
          continue;
        case U.FALSE2:
          r === N.l ? this.state = U.FALSE3 : this._error(`Invalid false started with fa${r}`);
          continue;
        case U.FALSE3:
          r === N.s ? this.state = U.FALSE4 : this._error(`Invalid false started with fal${r}`);
          continue;
        case U.FALSE4:
          r === N.e ? (this.emit("onvalue", !1), this.state = this.stack.pop() || U.VALUE) : this._error(`Invalid false started with fals${r}`);
          continue;
        case U.NULL:
          r === N.u ? this.state = U.NULL2 : this._error(`Invalid null started with n${r}`);
          continue;
        case U.NULL2:
          r === N.l ? this.state = U.NULL3 : this._error(`Invalid null started with nu${r}`);
          continue;
        case U.NULL3:
          r === N.l ? (this.emit("onvalue", null), this.state = this.stack.pop() || U.VALUE) : this._error(`Invalid null started with nul${r}`);
          continue;
        case U.NUMBER_DECIMAL_POINT:
          r === N.period ? (this.numberNode += ".", this.state = U.NUMBER_DIGIT) : this._error("Leading zero not followed by .");
          continue;
        case U.NUMBER_DIGIT:
          N._0 <= r && r <= N._9 ? this.numberNode += String.fromCharCode(r) : r === N.period ? (this.numberNode.indexOf(".") !== -1 && this._error("Invalid number has two dots"), this.numberNode += ".") : r === N.e || r === N.E ? ((this.numberNode.indexOf("e") !== -1 || this.numberNode.indexOf("E") !== -1) && this._error("Invalid number has two exponential"), this.numberNode += "e") : r === N.plus || r === N.minus ? (s === N.e || s === N.E || this._error("Invalid symbol in number"), this.numberNode += String.fromCharCode(r)) : (this._closeNumber(), n--, this.state = this.stack.pop() || U.VALUE);
          continue;
        default:
          this._error(`Unknown state: ${this.state}`);
      }
    return this.position >= this.bufferCheckPosition && S1(this), this.emit("onchunkparsed"), this;
  }
  _closeValue(t = "onvalue") {
    this.textNode !== void 0 && this.emit(t, this.textNode), this.textNode = void 0;
  }
  _closeNumber() {
    this.numberNode && this.emit("onvalue", parseFloat(this.numberNode)), this.numberNode = "";
  }
  _error(t = "") {
    this._closeValue(), t += `
Line: ${this.line}
Column: ${this.column}
Char: ${this.c}`;
    const n = new Error(t);
    this.error = n, this.emit("onerror", n);
  }
}
function on(e) {
  return e === N.carriageReturn || e === N.lineFeed || e === N.space || e === N.tab;
}
function S1(e) {
  const t = Math.max(Vs, 10);
  let n = 0;
  for (const r of ["textNode", "numberNode"]) {
    const s = e[r] === void 0 ? 0 : e[r].length;
    if (s > t)
      switch (r) {
        case "text":
          break;
        default:
          e._error(`Max buffer length exceeded: ${r}`);
      }
    n = Math.max(n, s);
  }
  e.bufferCheckPosition = Vs - n + e.position;
}
class _e {
  constructor(t = null) {
    y(this, "path");
    if (this.path = ["$"], t instanceof _e) {
      this.path = [...t.path];
      return;
    }
    if (Array.isArray(t)) {
      this.path.push(...t);
      return;
    }
    if (typeof t == "string" && (this.path = t.split("."), this.path[0] !== "$"))
      throw new Error("JSONPaths must start with $");
  }
  clone() {
    return new _e(this);
  }
  toString() {
    return this.path.join(".");
  }
  push(t) {
    this.path.push(t);
  }
  pop() {
    return this.path.pop();
  }
  set(t) {
    this.path[this.path.length - 1] = t;
  }
  equals(t) {
    if (!this || !t || this.path.length !== t.path.length)
      return !1;
    for (let n = 0; n < this.path.length; ++n)
      if (this.path[n] !== t.path[n])
        return !1;
    return !0;
  }
  /**
   * Sets the value pointed at by path
   * TODO - handle root path
   * @param object
   * @param value
   */
  setFieldAtPath(t, n) {
    const r = [...this.path];
    r.shift();
    const s = r.pop();
    for (const i of r)
      t = t[i];
    t[s] = n;
  }
  /**
   * Gets the value pointed at by path
   * TODO - handle root path
   * @param object
   */
  getFieldAtPath(t) {
    const n = [...this.path];
    n.shift();
    const r = n.pop();
    for (const s of n)
      t = t[s];
    return t[r];
  }
}
class F1 {
  constructor(t) {
    y(this, "parser");
    y(this, "result");
    y(this, "previousStates", []);
    y(this, "currentState", Object.freeze({ container: [], key: null }));
    y(this, "jsonpath", new _e());
    this.reset(), this.parser = new R1({
      onready: () => {
        this.jsonpath = new _e(), this.previousStates.length = 0, this.currentState.container.length = 0;
      },
      onopenobject: (n) => {
        this._openObject({}), typeof n < "u" && this.parser.emit("onkey", n);
      },
      onkey: (n) => {
        this.jsonpath.set(n), this.currentState.key = n;
      },
      oncloseobject: () => {
        this._closeObject();
      },
      onopenarray: () => {
        this._openArray();
      },
      onclosearray: () => {
        this._closeArray();
      },
      onvalue: (n) => {
        this._pushOrSet(n);
      },
      onerror: (n) => {
        throw n;
      },
      onend: () => {
        this.result = this.currentState.container.pop();
      },
      ...t
    });
  }
  reset() {
    this.result = void 0, this.previousStates = [], this.currentState = Object.freeze({ container: [], key: null }), this.jsonpath = new _e();
  }
  write(t) {
    this.parser.write(t);
  }
  close() {
    this.parser.close();
  }
  // PRIVATE METHODS
  _pushOrSet(t) {
    const { container: n, key: r } = this.currentState;
    r !== null ? (n[r] = t, this.currentState.key = null) : n.push(t);
  }
  _openArray(t = []) {
    this.jsonpath.push(null), this._pushOrSet(t), this.previousStates.push(this.currentState), this.currentState = { container: t, isArray: !0, key: null };
  }
  _closeArray() {
    this.jsonpath.pop(), this.currentState = this.previousStates.pop();
  }
  _openObject(t = {}) {
    this.jsonpath.push(null), this._pushOrSet(t), this.previousStates.push(this.currentState), this.currentState = { container: t, isArray: !1, key: null };
  }
  _closeObject() {
    this.jsonpath.pop(), this.currentState = this.previousStates.pop();
  }
}
class O1 extends F1 {
  constructor(n = {}) {
    super({
      onopenarray: () => {
        if (!this.streamingArray && this._matchJSONPath()) {
          this.streamingJsonPath = this.getJsonPath().clone(), this.streamingArray = [], this._openArray(this.streamingArray);
          return;
        }
        this._openArray();
      },
      // Redefine onopenarray to inject value for top-level object
      onopenobject: (s) => {
        this.topLevelObject ? this._openObject({}) : (this.topLevelObject = {}, this._openObject(this.topLevelObject)), typeof s < "u" && this.parser.emit("onkey", s);
      }
    });
    y(this, "jsonPaths");
    y(this, "streamingJsonPath", null);
    y(this, "streamingArray", null);
    y(this, "topLevelObject", null);
    const r = n.jsonpaths || [];
    this.jsonPaths = r.map((s) => new _e(s));
  }
  /**
   * write REDEFINITION
   * - super.write() chunk to parser
   * - get the contents (so far) of "topmost-level" array as batch of rows
   * - clear top-level array
   * - return the batch of rows\
   */
  write(n) {
    super.write(n);
    let r = [];
    return this.streamingArray && (r = [...this.streamingArray], this.streamingArray.length = 0), r;
  }
  /**
   * Returns a partially formed result object
   * Useful for returning the "wrapper" object when array is not top level
   * e.g. GeoJSON
   */
  getPartialResult() {
    return this.topLevelObject;
  }
  getStreamingJsonPath() {
    return this.streamingJsonPath;
  }
  getStreamingJsonPathAsString() {
    return this.streamingJsonPath && this.streamingJsonPath.toString();
  }
  getJsonPath() {
    return this.jsonpath;
  }
  // PRIVATE METHODS
  /**
   * Checks is this.getJsonPath matches the jsonpaths provided in options
   */
  _matchJSONPath() {
    const n = this.getJsonPath();
    if (this.jsonPaths.length === 0)
      return !0;
    for (const r of this.jsonPaths)
      if (r.equals(n))
        return !0;
    return !1;
  }
}
async function* D1(e, t) {
  var d;
  const n = bl(e), { metadata: r } = t, { jsonpaths: s } = t.json || {};
  let i = !0;
  const o = null, a = new Is(o, t), c = new O1({ jsonpaths: s });
  for await (const p of n) {
    const g = c.write(p), B = g.length > 0 && c.getStreamingJsonPathAsString();
    g.length > 0 && i && (r && (yield {
      // Common fields
      shape: ((d = t == null ? void 0 : t.json) == null ? void 0 : d.shape) || "array-row-table",
      batchType: "partial-result",
      data: [],
      length: 0,
      bytesUsed: 0,
      // JSON additions
      container: c.getPartialResult(),
      jsonpath: B
    }), i = !1);
    for (const b of g) {
      a.addRow(b);
      const M = a.getFullBatch({ jsonpath: B });
      M && (yield M);
    }
    a.chunkComplete(p);
    const C = a.getFullBatch({ jsonpath: B });
    C && (yield C);
  }
  const h = c.getStreamingJsonPathAsString(), f = a.getFinalBatch({ jsonpath: h });
  f && (yield f), r && (yield {
    shape: "json",
    batchType: "final-result",
    container: c.getPartialResult(),
    jsonpath: c.getStreamingJsonPathAsString(),
    /** Data Just to avoid crashing? */
    data: [],
    length: 0
    // schema: null
  });
}
const Ar = {
  x: 0,
  y: 1,
  z: 2
};
function Bu(e, t = {}) {
  const { start: n = 0, end: r = e.length, plane: s = "xy" } = t, i = t.size || 2;
  let o = 0;
  const a = Ar[s[0]], c = Ar[s[1]];
  for (let h = n, f = r - i; h < r; h += i)
    o += (e[h + a] - e[f + a]) * (e[h + c] + e[f + c]), f = h;
  return o / 2;
}
function L1(e, t, n = 2, r, s = "xy") {
  const i = t && t.length, o = i ? t[0] * n : e.length;
  let a = Eu(e, 0, o, n, !0, r && r[0], s);
  const c = [];
  if (!a || a.next === a.prev)
    return c;
  let h, f, d, p, g, B, C;
  if (i && (a = v1(e, t, a, n, r, s)), e.length > 80 * n) {
    p = f = e[0], g = d = e[1];
    for (let b = n; b < o; b += n)
      B = e[b], C = e[b + 1], B < p && (p = B), C < g && (g = C), B > f && (f = B), C > d && (d = C);
    h = Math.max(f - p, d - g), h = h !== 0 ? 32767 / h : 0;
  }
  return An(a, c, n, p, g, h, 0), c;
}
function Eu(e, t, n, r, s, i, o) {
  let a, c;
  i === void 0 && (i = Bu(e, { start: t, end: n, size: r, plane: o }));
  let h = Ar[o[0]], f = Ar[o[1]];
  if (s === i < 0)
    for (a = t; a < n; a += r)
      c = aa(a, e[a + h], e[a + f], c);
  else
    for (a = n - r; a >= t; a -= r)
      c = aa(a, e[a + h], e[a + f], c);
  return c && Dr(c, c.next) && (Bn(c), c = c.next), c;
}
function xe(e, t) {
  if (!e)
    return e;
  t || (t = e);
  let n = e, r;
  do
    if (r = !1, !n.steiner && (Dr(n, n.next) || ot(n.prev, n, n.next) === 0)) {
      if (Bn(n), n = t = n.prev, n === n.next)
        break;
      r = !0;
    } else
      n = n.next;
  while (r || n !== t);
  return t;
}
function An(e, t, n, r, s, i, o) {
  if (!e)
    return;
  !o && i && j1(e, r, s, i);
  let a = e, c, h;
  for (; e.prev !== e.next; ) {
    if (c = e.prev, h = e.next, i ? N1(e, r, s, i) : U1(e)) {
      t.push(c.i / n | 0), t.push(e.i / n | 0), t.push(h.i / n | 0), Bn(e), e = h.next, a = h.next;
      continue;
    }
    if (e = h, e === a) {
      o ? o === 1 ? (e = P1(xe(e), t, n), An(e, t, n, r, s, i, 2)) : o === 2 && G1(e, t, n, r, s, i) : An(xe(e), t, n, r, s, i, 1);
      break;
    }
  }
}
function U1(e) {
  const t = e.prev, n = e, r = e.next;
  if (ot(t, n, r) >= 0)
    return !1;
  const s = t.x, i = n.x, o = r.x, a = t.y, c = n.y, h = r.y, f = s < i ? s < o ? s : o : i < o ? i : o, d = a < c ? a < h ? a : h : c < h ? c : h, p = s > i ? s > o ? s : o : i > o ? i : o, g = a > c ? a > h ? a : h : c > h ? c : h;
  let B = r.next;
  for (; B !== t; ) {
    if (B.x >= f && B.x <= p && B.y >= d && B.y <= g && Ke(s, a, i, c, o, h, B.x, B.y) && ot(B.prev, B, B.next) >= 0)
      return !1;
    B = B.next;
  }
  return !0;
}
function N1(e, t, n, r) {
  const s = e.prev, i = e, o = e.next;
  if (ot(s, i, o) >= 0)
    return !1;
  const a = s.x, c = i.x, h = o.x, f = s.y, d = i.y, p = o.y, g = a < c ? a < h ? a : h : c < h ? c : h, B = f < d ? f < p ? f : p : d < p ? d : p, C = a > c ? a > h ? a : h : c > h ? c : h, b = f > d ? f > p ? f : p : d > p ? d : p, M = js(g, B, t, n, r), D = js(C, b, t, n, r);
  let _ = e.prevZ, x = e.nextZ;
  for (; _ && _.z >= M && x && x.z <= D; ) {
    if (_.x >= g && _.x <= C && _.y >= B && _.y <= b && _ !== s && _ !== o && Ke(a, f, c, d, h, p, _.x, _.y) && ot(_.prev, _, _.next) >= 0 || (_ = _.prevZ, x.x >= g && x.x <= C && x.y >= B && x.y <= b && x !== s && x !== o && Ke(a, f, c, d, h, p, x.x, x.y) && ot(x.prev, x, x.next) >= 0))
      return !1;
    x = x.nextZ;
  }
  for (; _ && _.z >= M; ) {
    if (_.x >= g && _.x <= C && _.y >= B && _.y <= b && _ !== s && _ !== o && Ke(a, f, c, d, h, p, _.x, _.y) && ot(_.prev, _, _.next) >= 0)
      return !1;
    _ = _.prevZ;
  }
  for (; x && x.z <= D; ) {
    if (x.x >= g && x.x <= C && x.y >= B && x.y <= b && x !== s && x !== o && Ke(a, f, c, d, h, p, x.x, x.y) && ot(x.prev, x, x.next) >= 0)
      return !1;
    x = x.nextZ;
  }
  return !0;
}
function P1(e, t, n) {
  let r = e;
  do {
    const s = r.prev, i = r.next.next;
    !Dr(s, i) && Cu(s, r, r.next, i) && yn(s, i) && yn(i, s) && (t.push(s.i / n | 0), t.push(r.i / n | 0), t.push(i.i / n | 0), Bn(r), Bn(r.next), r = e = i), r = r.next;
  } while (r !== e);
  return xe(r);
}
function G1(e, t, n, r, s, i) {
  let o = e;
  do {
    let a = o.next.next;
    for (; a !== o.prev; ) {
      if (o.i !== a.i && W1(o, a)) {
        let c = Tu(o, a);
        o = xe(o, o.next), c = xe(c, c.next), An(o, t, n, r, s, i, 0), An(c, t, n, r, s, i, 0);
        return;
      }
      a = a.next;
    }
    o = o.next;
  } while (o !== e);
}
function v1(e, t, n, r, s, i) {
  const o = [];
  let a, c, h, f, d;
  for (a = 0, c = t.length; a < c; a++)
    h = t[a] * r, f = a < c - 1 ? t[a + 1] * r : e.length, d = Eu(e, h, f, r, !1, s && s[a + 1], i), d === d.next && (d.steiner = !0), o.push(z1(d));
  for (o.sort(H1), a = 0; a < o.length; a++)
    n = J1(o[a], n);
  return n;
}
function H1(e, t) {
  return e.x - t.x;
}
function J1(e, t) {
  const n = k1(e, t);
  if (!n)
    return t;
  const r = Tu(n, e);
  return xe(r, r.next), xe(n, n.next);
}
function k1(e, t) {
  let n = t;
  const r = e.x, s = e.y;
  let i = -1 / 0, o;
  do {
    if (s <= n.y && s >= n.next.y && n.next.y !== n.y) {
      const p = n.x + (s - n.y) * (n.next.x - n.x) / (n.next.y - n.y);
      if (p <= r && p > i && (i = p, o = n.x < n.next.x ? n : n.next, p === r))
        return o;
    }
    n = n.next;
  } while (n !== t);
  if (!o)
    return null;
  const a = o, c = o.x, h = o.y;
  let f = 1 / 0, d;
  n = o;
  do
    r >= n.x && n.x >= c && r !== n.x && Ke(s < h ? r : i, s, c, h, s < h ? i : r, s, n.x, n.y) && (d = Math.abs(s - n.y) / (r - n.x), yn(n, e) && (d < f || d === f && (n.x > o.x || n.x === o.x && V1(o, n))) && (o = n, f = d)), n = n.next;
  while (n !== a);
  return o;
}
function V1(e, t) {
  return ot(e.prev, e, t.prev) < 0 && ot(t.next, e, e.next) < 0;
}
function j1(e, t, n, r) {
  let s = e;
  do
    s.z === 0 && (s.z = js(s.x, s.y, t, n, r)), s.prevZ = s.prev, s.nextZ = s.next, s = s.next;
  while (s !== e);
  s.prevZ.nextZ = null, s.prevZ = null, K1(s);
}
function K1(e) {
  let t, n, r = 1, s, i, o, a, c, h;
  do {
    for (i = e, e = null, h = null, s = 0; i; ) {
      for (s++, a = i, o = 0, n = 0; n < r && (o++, a = a.nextZ, !!a); n++)
        ;
      for (c = r; o > 0 || c > 0 && a; )
        o !== 0 && (c === 0 || !a || i.z <= a.z) ? (t = i, i = i.nextZ, o--) : (t = a, a = a.nextZ, c--), h ? h.nextZ = t : e = t, t.prevZ = h, h = t;
      i = a;
    }
    h.nextZ = null, r *= 2;
  } while (s > 1);
  return e;
}
function js(e, t, n, r, s) {
  return e = (e - n) * s | 0, t = (t - r) * s | 0, e = (e | e << 8) & 16711935, e = (e | e << 4) & 252645135, e = (e | e << 2) & 858993459, e = (e | e << 1) & 1431655765, t = (t | t << 8) & 16711935, t = (t | t << 4) & 252645135, t = (t | t << 2) & 858993459, t = (t | t << 1) & 1431655765, e | t << 1;
}
function z1(e) {
  let t = e, n = e;
  do
    (t.x < n.x || t.x === n.x && t.y < n.y) && (n = t), t = t.next;
  while (t !== e);
  return n;
}
function Ke(e, t, n, r, s, i, o, a) {
  return (s - o) * (t - a) >= (e - o) * (i - a) && (e - o) * (r - a) >= (n - o) * (t - a) && (n - o) * (i - a) >= (s - o) * (r - a);
}
function W1(e, t) {
  return e.next.i !== t.i && e.prev.i !== t.i && !Q1(e, t) && // dones't intersect other edges
  (yn(e, t) && yn(t, e) && $1(e, t) && // locally visible
  (ot(e.prev, e, t.prev) || ot(e, t.prev, t)) || // does not create opposite-facing sectors
  Dr(e, t) && ot(e.prev, e, e.next) > 0 && ot(t.prev, t, t.next) > 0);
}
function ot(e, t, n) {
  return (t.y - e.y) * (n.x - t.x) - (t.x - e.x) * (n.y - t.y);
}
function Dr(e, t) {
  return e.x === t.x && e.y === t.y;
}
function Cu(e, t, n, r) {
  const s = Xn(ot(e, t, n)), i = Xn(ot(e, t, r)), o = Xn(ot(n, r, e)), a = Xn(ot(n, r, t));
  return !!(s !== i && o !== a || s === 0 && $n(e, n, t) || i === 0 && $n(e, r, t) || o === 0 && $n(n, e, r) || a === 0 && $n(n, t, r));
}
function $n(e, t, n) {
  return t.x <= Math.max(e.x, n.x) && t.x >= Math.min(e.x, n.x) && t.y <= Math.max(e.y, n.y) && t.y >= Math.min(e.y, n.y);
}
function Xn(e) {
  return e > 0 ? 1 : e < 0 ? -1 : 0;
}
function Q1(e, t) {
  let n = e;
  do {
    if (n.i !== e.i && n.next.i !== e.i && n.i !== t.i && n.next.i !== t.i && Cu(n, n.next, e, t))
      return !0;
    n = n.next;
  } while (n !== e);
  return !1;
}
function yn(e, t) {
  return ot(e.prev, e, e.next) < 0 ? ot(e, t, e.next) >= 0 && ot(e, e.prev, t) >= 0 : ot(e, t, e.prev) < 0 || ot(e, e.next, t) < 0;
}
function $1(e, t) {
  let n = e, r = !1;
  const s = (e.x + t.x) / 2, i = (e.y + t.y) / 2;
  do
    n.y > i != n.next.y > i && n.next.y !== n.y && s < (n.next.x - n.x) * (i - n.y) / (n.next.y - n.y) + n.x && (r = !r), n = n.next;
  while (n !== e);
  return r;
}
function Tu(e, t) {
  const n = new Ks(e.i, e.x, e.y), r = new Ks(t.i, t.x, t.y), s = e.next, i = t.prev;
  return e.next = t, t.prev = e, n.next = s, s.prev = n, r.next = n, n.prev = r, i.next = r, r.prev = i, r;
}
function aa(e, t, n, r) {
  const s = new Ks(e, t, n);
  return r ? (s.next = r.next, s.prev = r, r.next.prev = s, r.next = s) : (s.prev = s, s.next = s), s;
}
function Bn(e) {
  e.next.prev = e.prev, e.prev.next = e.next, e.prevZ && (e.prevZ.nextZ = e.nextZ), e.nextZ && (e.nextZ.prevZ = e.prevZ);
}
class Ks {
  constructor(t, n, r) {
    this.prev = null, this.next = null, this.z = 0, this.prevZ = null, this.nextZ = null, this.steiner = !1, this.i = t, this.x = n, this.y = r;
  }
}
function X1(e, t, n) {
  const r = q1(e), s = Object.keys(r).filter((i) => r[i] !== Array);
  return Y1(e, {
    propArrayTypes: r,
    ...t
  }, {
    numericPropKeys: n && n.numericPropKeys || s,
    PositionDataType: n ? n.PositionDataType : Float32Array,
    triangulate: n ? n.triangulate : !0
  });
}
function q1(e) {
  const t = {};
  for (const n of e)
    if (n.properties)
      for (const r in n.properties) {
        const s = n.properties[r];
        t[r] = sE(s, t[r]);
      }
  return t;
}
function Y1(e, t, n) {
  const { pointPositionsCount: r, pointFeaturesCount: s, linePositionsCount: i, linePathsCount: o, lineFeaturesCount: a, polygonPositionsCount: c, polygonObjectsCount: h, polygonRingsCount: f, polygonFeaturesCount: d, propArrayTypes: p, coordLength: g } = t, { numericPropKeys: B = [], PositionDataType: C = Float32Array, triangulate: b = !0 } = n, M = e[0] && "id" in e[0], D = e.length > 65535 ? Uint32Array : Uint16Array, _ = {
    type: "Point",
    positions: new C(r * g),
    globalFeatureIds: new D(r),
    featureIds: s > 65535 ? new Uint32Array(r) : new Uint16Array(r),
    numericProps: {},
    properties: [],
    fields: []
  }, x = {
    type: "LineString",
    pathIndices: i > 65535 ? new Uint32Array(o + 1) : new Uint16Array(o + 1),
    positions: new C(i * g),
    globalFeatureIds: new D(i),
    featureIds: a > 65535 ? new Uint32Array(i) : new Uint16Array(i),
    numericProps: {},
    properties: [],
    fields: []
  }, L = {
    type: "Polygon",
    polygonIndices: c > 65535 ? new Uint32Array(h + 1) : new Uint16Array(h + 1),
    primitivePolygonIndices: c > 65535 ? new Uint32Array(f + 1) : new Uint16Array(f + 1),
    positions: new C(c * g),
    globalFeatureIds: new D(c),
    featureIds: d > 65535 ? new Uint32Array(c) : new Uint16Array(c),
    numericProps: {},
    properties: [],
    fields: []
  };
  b && (L.triangles = []);
  for (const G of [_, x, L])
    for (const v of B) {
      const P = p[v];
      G.numericProps[v] = new P(G.positions.length / g);
    }
  x.pathIndices[o] = i, L.polygonIndices[h] = c, L.primitivePolygonIndices[f] = c;
  const S = {
    pointPosition: 0,
    pointFeature: 0,
    linePosition: 0,
    linePath: 0,
    lineFeature: 0,
    polygonPosition: 0,
    polygonObject: 0,
    polygonRing: 0,
    polygonFeature: 0,
    feature: 0
  };
  for (const G of e) {
    const v = G.geometry, P = G.properties || {};
    switch (v.type) {
      case "Point":
        Z1(v, _, S, g, P), _.properties.push(ys(P, B)), M && _.fields.push({ id: G.id }), S.pointFeature++;
        break;
      case "LineString":
        tE(v, x, S, g, P), x.properties.push(ys(P, B)), M && x.fields.push({ id: G.id }), S.lineFeature++;
        break;
      case "Polygon":
        eE(v, L, S, g, P), L.properties.push(ys(P, B)), M && L.fields.push({ id: G.id }), S.polygonFeature++;
        break;
      default:
        throw new Error("Invalid geometry type");
    }
    S.feature++;
  }
  return rE(_, x, L, g);
}
function Z1(e, t, n, r, s) {
  t.positions.set(e.data, n.pointPosition * r);
  const i = e.data.length / r;
  bi(t, s, n.pointPosition, i), t.globalFeatureIds.fill(n.feature, n.pointPosition, n.pointPosition + i), t.featureIds.fill(n.pointFeature, n.pointPosition, n.pointPosition + i), n.pointPosition += i;
}
function tE(e, t, n, r, s) {
  t.positions.set(e.data, n.linePosition * r);
  const i = e.data.length / r;
  bi(t, s, n.linePosition, i), t.globalFeatureIds.fill(n.feature, n.linePosition, n.linePosition + i), t.featureIds.fill(n.lineFeature, n.linePosition, n.linePosition + i);
  for (let o = 0, a = e.indices.length; o < a; ++o) {
    const c = e.indices[o], h = o === a - 1 ? e.data.length : e.indices[o + 1];
    t.pathIndices[n.linePath++] = n.linePosition, n.linePosition += (h - c) / r;
  }
}
function eE(e, t, n, r, s) {
  t.positions.set(e.data, n.polygonPosition * r);
  const i = e.data.length / r;
  bi(t, s, n.polygonPosition, i), t.globalFeatureIds.fill(n.feature, n.polygonPosition, n.polygonPosition + i), t.featureIds.fill(n.polygonFeature, n.polygonPosition, n.polygonPosition + i);
  for (let o = 0, a = e.indices.length; o < a; ++o) {
    const c = n.polygonPosition;
    t.polygonIndices[n.polygonObject++] = c;
    const h = e.areas[o], f = e.indices[o], d = e.indices[o + 1];
    for (let g = 0, B = f.length; g < B; ++g) {
      const C = f[g], b = g === B - 1 ? (
        // last line, so either read to:
        d === void 0 ? e.data.length : d[0]
      ) : f[g + 1];
      t.primitivePolygonIndices[n.polygonRing++] = n.polygonPosition, n.polygonPosition += (b - C) / r;
    }
    const p = n.polygonPosition;
    nE(t, h, f, { startPosition: c, endPosition: p, coordLength: r });
  }
}
function nE(e, t, n, { startPosition: r, endPosition: s, coordLength: i }) {
  if (!e.triangles)
    return;
  const o = r * i, a = s * i, c = e.positions.subarray(o, a), h = n[0], f = n.slice(1).map((p) => (p - h) / i), d = L1(c, f, i, t);
  for (let p = 0, g = d.length; p < g; ++p)
    e.triangles.push(r + d[p]);
}
function As(e, t) {
  const n = {};
  for (const r in e)
    n[r] = { value: e[r], size: t };
  return n;
}
function rE(e, t, n, r) {
  const s = {
    shape: "binary-feature-collection",
    points: {
      ...e,
      positions: { value: e.positions, size: r },
      globalFeatureIds: { value: e.globalFeatureIds, size: 1 },
      featureIds: { value: e.featureIds, size: 1 },
      numericProps: As(e.numericProps, 1)
    },
    lines: {
      ...t,
      positions: { value: t.positions, size: r },
      pathIndices: { value: t.pathIndices, size: 1 },
      globalFeatureIds: { value: t.globalFeatureIds, size: 1 },
      featureIds: { value: t.featureIds, size: 1 },
      numericProps: As(t.numericProps, 1)
    },
    polygons: {
      ...n,
      positions: { value: n.positions, size: r },
      polygonIndices: { value: n.polygonIndices, size: 1 },
      primitivePolygonIndices: { value: n.primitivePolygonIndices, size: 1 },
      globalFeatureIds: { value: n.globalFeatureIds, size: 1 },
      featureIds: { value: n.featureIds, size: 1 },
      numericProps: As(n.numericProps, 1)
    }
    // triangles not expected
  };
  return s.polygons && n.triangles && (s.polygons.triangles = { value: new Uint32Array(n.triangles), size: 1 }), s;
}
function bi(e, t, n, r) {
  for (const s in e.numericProps)
    if (s in t) {
      const i = t[s];
      e.numericProps[s].fill(i, n, n + r);
    }
}
function ys(e, t) {
  const n = {};
  for (const r in e)
    t.includes(r) || (n[r] = e[r]);
  return n;
}
function sE(e, t) {
  return t === Array || !Number.isFinite(e) ? Array : t === Float64Array || Math.fround(e) !== e ? Float64Array : Float32Array;
}
function iE(e) {
  let t = 0, n = 0, r = 0, s = 0, i = 0, o = 0, a = 0, c = 0, h = 0;
  const f = /* @__PURE__ */ new Set();
  for (const d of e) {
    const p = d.geometry;
    switch (p.type) {
      case "Point":
        n++, t++, f.add(p.coordinates.length);
        break;
      case "MultiPoint":
        n++, t += p.coordinates.length;
        for (const B of p.coordinates)
          f.add(B.length);
        break;
      case "LineString":
        i++, r += p.coordinates.length, s++;
        for (const B of p.coordinates)
          f.add(B.length);
        break;
      case "MultiLineString":
        i++;
        for (const B of p.coordinates) {
          r += B.length, s++;
          for (const C of B)
            f.add(C.length);
        }
        break;
      case "Polygon":
        h++, a++, c += p.coordinates.length;
        const g = p.coordinates.flat();
        o += g.length;
        for (const B of g)
          f.add(B.length);
        break;
      case "MultiPolygon":
        h++;
        for (const B of p.coordinates) {
          a++, c += B.length;
          const C = B.flat();
          o += C.length;
          for (const b of C)
            f.add(b.length);
        }
        break;
      default:
        throw new Error(`Unsupported geometry type: ${p.type}`);
    }
  }
  return {
    coordLength: f.size > 0 ? Math.max(...f) : 2,
    pointPositionsCount: t,
    pointFeaturesCount: n,
    linePositionsCount: r,
    linePathsCount: s,
    lineFeaturesCount: i,
    polygonPositionsCount: o,
    polygonObjectsCount: a,
    polygonRingsCount: c,
    polygonFeaturesCount: h
  };
}
function oE(e, t = { coordLength: 2, fixRingWinding: !0 }) {
  return e.map((n) => aE(n, t));
}
function ca(e, t, n, r) {
  n.push(t.length), t.push(...e);
  for (let s = e.length; s < r.coordLength; s++)
    t.push(0);
}
function zs(e, t, n, r) {
  n.push(t.length);
  for (const s of e) {
    t.push(...s);
    for (let i = s.length; i < r.coordLength; i++)
      t.push(0);
  }
}
function ua(e, t, n, r, s) {
  let i = 0;
  const o = [], a = [];
  for (const c of e) {
    const h = c.map((p) => p.slice(0, 2));
    let f = Bu(h.flat());
    const d = f < 0;
    s.fixRingWinding && (i === 0 && !d || i > 0 && d) && (c.reverse(), f = -f), o.push(f), zs(c, t, a, s), i++;
  }
  i > 0 && (r.push(o), n.push(a));
}
function aE(e, t) {
  const { geometry: n } = e;
  if (n.type === "GeometryCollection")
    throw new Error("GeometryCollection type not supported");
  const r = [], s = [];
  let i, o;
  switch (n.type) {
    case "Point":
      o = "Point", ca(n.coordinates, r, s, t);
      break;
    case "MultiPoint":
      o = "Point", n.coordinates.map((a) => ca(a, r, s, t));
      break;
    case "LineString":
      o = "LineString", zs(n.coordinates, r, s, t);
      break;
    case "MultiLineString":
      o = "LineString", n.coordinates.map((a) => zs(a, r, s, t));
      break;
    case "Polygon":
      o = "Polygon", i = [], ua(n.coordinates, r, s, i, t);
      break;
    case "MultiPolygon":
      o = "Polygon", i = [], n.coordinates.map((a) => ua(a, r, s, i, t));
      break;
    default:
      throw new Error(`Unknown type: ${o}`);
  }
  return { ...e, geometry: { type: o, indices: s, data: r, areas: i } };
}
function wu(e, t = { fixRingWinding: !0, triangulate: !0 }) {
  const n = iE(e), r = n.coordLength, { fixRingWinding: s } = t, i = oE(e, { coordLength: r, fixRingWinding: s });
  return X1(i, n, {
    numericPropKeys: t.numericPropKeys,
    PositionDataType: t.PositionDataType || Float32Array,
    triangulate: t.triangulate
  });
}
const cE = "4.3.3", uE = {
  dataType: null,
  batchType: null,
  name: "GeoJSON",
  id: "geojson",
  module: "geojson",
  version: cE,
  worker: !0,
  extensions: ["geojson"],
  mimeTypes: ["application/geo+json"],
  category: "geometry",
  text: !0,
  options: {
    geojson: {
      shape: "geojson-table"
    },
    json: {
      shape: "object-row-table",
      jsonpaths: ["$", "$.features"]
    },
    gis: {
      format: "geojson"
    }
  }
}, En = {
  ...uE,
  // @ts-expect-error
  parse: hE,
  // @ts-expect-error
  parseTextSync: bu,
  parseInBatches: lE
};
async function hE(e, t) {
  return bu(new TextDecoder().decode(e), t);
}
function bu(e, t) {
  t = { ...En.options, ...t }, t.geojson = { ...En.options.geojson, ...t.geojson }, t.gis = t.gis || {};
  let n;
  try {
    n = JSON.parse(e);
  } catch {
    n = {};
  }
  const r = {
    shape: "geojson-table",
    // TODO - deduce schema from geojson
    // TODO check that parsed data is of type FeatureCollection
    type: "FeatureCollection",
    features: (n == null ? void 0 : n.features) || []
  };
  switch (t.gis.format) {
    case "binary":
      return wu(r.features);
    default:
      return r;
  }
}
function lE(e, t) {
  t = { ...En.options, ...t }, t.json = { ...En.options.geojson, ...t.geojson };
  const n = D1(e, t);
  switch (t.gis.format) {
    case "binary":
      return fE(n);
    default:
      return n;
  }
}
async function* fE(e) {
  for await (const t of e)
    t.data = wu(t.data), yield t;
}
function _u(e) {
  const n = document.createElement("canvas");
  n.width = 64, n.height = 64;
  const r = n.getContext("2d");
  r.rect(0, 0, 64, 64);
  const s = r.createLinearGradient(0, 0, 64, 64);
  for (let o = 0; o < e.length; o++) {
    const a = e[o];
    s.addColorStop(a[0], "#" + a[1].getHexString());
  }
  r.fillStyle = s, r.fill();
  const i = new Nu(n);
  return i.needsUpdate = !0, i.minFilter = Pu, i.wrapS = Ii, i.wrapT = Ii, i.repeat.set(2, 2), i;
}
function ha(e) {
  e.updateMatrix(), e.updateMatrixWorld(), e.matrixWorldInverse.copy(e.matrixWorld).invert();
  const t = new ku();
  return t.setFromProjectionMatrix(new yt().multiplyMatrices(e.projectionMatrix, e.matrixWorldInverse)), t;
}
function dE(e) {
  const t = new qn(), n = new Vu(10, 5), r = new Tt(...e.projectPointOntoPlane([0, 0, 0])), s = new Tt(e.normal.x, e.normal.y, e.normal.z), i = new Tt().copy(r).add(s);
  n.lookAt(i), n.translate(r.x, r.y, r.z);
  const o = new Es({ color: 65535, side: pa }), a = new Cs(n, o), c = new ju(s, r, 5, 16776960);
  return t.add(c), t.add(a), t;
}
function la(e) {
  const { boundingVolume: t } = e;
  let n = 0;
  e.content && (n = Math.min(e.content.byteLength / 5e5, 1));
  const r = new O(n, 1, 0), s = new Gu(1, 1, 1), i = new yt();
  t.halfAxes ? i.copy(Iu(t.halfAxes)) : t.radius && s.scale(t.radius * 2, t.radius * 2, t.radius * 2), s.applyMatrix4(i);
  const o = new vu(s), a = new Hu(o, new Ju({ color: r }));
  return a.position.copy(new Tt(...t.center)), a;
}
function Iu(e) {
  const t = e;
  return new yt().fromArray([
    t[0] * 2,
    t[1] * 2,
    t[2] * 2,
    0,
    t[3] * 2,
    t[4] * 2,
    t[5] * 2,
    0,
    t[6] * 2,
    t[7] * 2,
    t[8] * 2,
    0,
    0,
    0,
    0,
    1
  ]);
}
function mE(e, t) {
  const s = 2 * Math.PI * 6378137 / 2, i = t * s / 180;
  let o = Math.log(Math.tan((90 + e) * Math.PI / 360)) / (Math.PI / 180);
  return o = o * s / 180, new ga(i, o);
}
function pE(e) {
  let t = 0;
  if ((e == null ? void 0 : e.userData.mimeType) == "image/ktx2" && e.mipmaps) {
    for (let n = 0; n < e.mipmaps.length; n++)
      t += e.mipmaps[n].data.byteLength;
    return t;
  } else if (e.image) {
    const { image: n } = e, r = 4;
    let s = [n.width, n.height];
    for (; s[0] > 1 || s[1] > 1; )
      t += s[0] * s[1] * r, s[0] = Math.max(Math.floor(s[0] / 2), 1), s[1] = Math.max(Math.floor(s[1] / 2), 1);
    return t += 1 * 1 * r, t;
  } else
    return;
}
function xu(e) {
  return Yu.estimateBytesUsed(e);
}
let Mt = null, zt = null, yr = null, sr = null;
const fa = {
  minHeight: 0,
  maxHeight: 300,
  samples: 4,
  sampleStep: 4,
  opacity: 0.5,
  blendingType: Qs
};
function gE(e, t, n, r = fa) {
  Mt && Mt.dispose(), zt || (zt = n);
  const s = { ...fa, ...r };
  Mt = new Ku(
    e.width * e.devicePixelRatio,
    e.height * e.devicePixelRatio
  ), Mt.texture.minFilter = xi, Mt.texture.magFilter = xi, Mt.stencilBuffer = !1, Mt.texture.format = zu, Mt.texture.type = Wu, zt.setPixelRatio(devicePixelRatio), zt.setSize(e.width, e.height), zt.setRenderTarget(Mt), yr = new Qu(), yr.overrideMaterial = BE, sr = t, ge.uniforms.tPosition.value = Mt.texture, ge.uniforms.minHeight.value = s.minHeight, ge.uniforms.maxHeight.value = s.maxHeight, ge.uniforms.samples.value = s.samples, ge.uniforms.sampleStep.value = s.sampleStep, ge.uniforms.opacity.value = s.opacity, ge.blending = s.blendingType;
}
function AE(e) {
  Mt.setSize(e.width * e.devicePixelRatio, e.height * e.devicePixelRatio), zt.setPixelRatio(devicePixelRatio), zt.setSize(e.width, e.height);
}
function yE(e) {
  if (zt) {
    const t = sr.parent;
    yr.add(sr), zt.setRenderTarget(Mt), zt.render(yr, e), t && t.add(sr), zt.setRenderTarget(null);
  }
}
const Br = (e) => e.toString(), BE = new Ws({
  vertexShader: Br`
        varying vec3 vPosition;
        void main() {
            vPosition =  (modelMatrix * vec4(position, 1.0)).xyz;
            gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
        }
    `,
  fragmentShader: Br`
        varying vec3 vPosition;
        void main() {
            gl_FragColor = vec4(vPosition, 1.0);
        }
    `,
  side: pa
}), EE = Br`
    #include <packing>

    varying vec2 vUv;
    varying vec3 vColor;
    uniform sampler2D tPosition;
    uniform float minHeight;
    uniform float maxHeight;
    uniform int samples;
    uniform float sampleStep;

    mat4 MVP;

    // Convert to normalized screen coordinates
    vec4 toNSC(const in vec4 v) {
        return vec4(0.5 * (v.xyz / v.w) + 0.5, v.w);
    }
    vec4 vertexDraping(
        const in sampler2D positionTex, // Position G-Buffer
        const in vec4 Vin // Vertex to drape
    ) {
        float texSize = float(textureSize(positionTex, 0).x);
        float pixelSize = 1.0 / texSize;
        vec2 stepSize = vec2(sampleStep/texSize);
        vec4 VinWorld = modelMatrix * Vin;

        vec4 lineStart = projectionMatrix * viewMatrix * vec4(VinWorld.x, minHeight, VinWorld.z, 1.0);
        vec4 lineEnd = projectionMatrix * viewMatrix * vec4(VinWorld.x, maxHeight, VinWorld.z, 1.0);

        vec4 Vout = VinWorld;

        // Binary search for line-terrain intersection
        float first = 0.0, last = 1.0;
        while(first <= last) {
            // Compute mid-point
            float mid = first + (last-first) / 2.0;
            // Compute texture coordinates along line
            vec4 texCoords = toNSC(mix(lineStart, lineEnd, mid));
            vec4 texSample = vec4(0.0); // Sample terrain
            for(int s = -samples; s < samples; s++) {
                for(int t = -samples; t < samples; t++) {
                    texSample += texture(positionTex,
                    texCoords.st + vec2(s,t) * stepSize);
                }
            }
            // Smooth samples obtain from G-Buffer
            texSample = texSample / (float(samples) * float(samples) * 4.0);
            float terrainHeight = texSample.y;
            Vout.y = terrainHeight;
           
            if((last-first) < pixelSize) { // Termination criteria
                return Vout;
            }
            // Perform intersection test
            float depthScene = toNSC(projectionMatrix * viewMatrix * Vout).y;
            if(depthScene >= texCoords.y) {
                first = mid;
            }
            else
                last = mid;
        }
        return Vout;
    }

    void main() {
        vColor = color;
        vUv = uv;
        MVP = projectionMatrix * modelViewMatrix;
        vec4 inputVertex = vec4(position, 1.0);
        vec4 outputVertex = vertexDraping(tPosition, inputVertex);
        vec4 finalPosition = projectionMatrix * viewMatrix * outputVertex;
        gl_Position = finalPosition;
    }
`, CE = Br`
    varying vec3 vColor;
    uniform float opacity;

    void main() {
        gl_FragColor = vec4(vColor, opacity);
    }
`, ge = new Ws({
  vertexShader: EE,
  fragmentShader: CE,
  uniforms: {
    tPosition: { value: null },
    minHeight: { value: 0 },
    maxHeight: { value: 300 },
    opacity: { value: 0.5 },
    samples: { value: 4 },
    sampleStep: { value: 4 }
  },
  vertexColors: !0,
  transparent: !0,
  depthTest: !1,
  blending: Qs
}), Mu = {
  // From chroma spectral http://gka.github.io/chroma.js/
  SPECTRAL: [
    [0, new O(0.3686, 0.3098, 0.6353)],
    [0.1, new O(0.1961, 0.5333, 0.7412)],
    [0.2, new O(0.4, 0.7608, 0.6471)],
    [0.3, new O(0.6706, 0.8667, 0.6431)],
    [0.4, new O(0.902, 0.9608, 0.5961)],
    [0.5, new O(1, 1, 0.749)],
    [0.6, new O(0.9961, 0.8784, 0.5451)],
    [0.7, new O(0.9922, 0.6824, 0.3804)],
    [0.8, new O(0.9569, 0.4275, 0.2627)],
    [0.9, new O(0.8353, 0.2431, 0.3098)],
    [1, new O(0.6196, 39e-4, 0.2588)]
  ],
  PLASMA: [
    [0, new O(0.241, 0.015, 0.61)],
    [0.1, new O(0.387, 1e-3, 0.654)],
    [0.2, new O(0.524, 0.025, 0.653)],
    [0.3, new O(0.651, 0.125, 0.596)],
    [0.4, new O(0.752, 0.227, 0.513)],
    [0.5, new O(0.837, 0.329, 0.431)],
    [0.6, new O(0.907, 0.435, 0.353)],
    [0.7, new O(0.963, 0.554, 0.272)],
    [0.8, new O(0.992, 0.681, 0.195)],
    [0.9, new O(0.987, 0.822, 0.144)],
    [1, new O(0.94, 0.975, 0.131)]
  ],
  YELLOW_GREEN: [
    [0, new O(0.1647, 0.2824, 0.3451)],
    [0.1, new O(0.1338, 0.3555, 0.4227)],
    [0.2, new O(0.061, 0.4319, 0.4864)],
    [0.3, new O(0, 0.5099, 0.5319)],
    [0.4, new O(0, 0.5881, 0.5569)],
    [0.5, new O(0.137, 0.665, 0.5614)],
    [0.6, new O(0.2906, 0.7395, 0.5477)],
    [0.7, new O(0.4453, 0.8099, 0.5201)],
    [0.8, new O(0.6102, 0.8748, 0.485)],
    [0.9, new O(0.7883, 0.9323, 0.4514)],
    [1, new O(0.9804, 0.9804, 0.4314)]
  ],
  VIRIDIS: [
    [0, new O(0.267, 5e-3, 0.329)],
    [0.1, new O(0.283, 0.141, 0.458)],
    [0.2, new O(0.254, 0.265, 0.53)],
    [0.3, new O(0.207, 0.372, 0.553)],
    [0.4, new O(0.164, 0.471, 0.558)],
    [0.5, new O(0.128, 0.567, 0.551)],
    [0.6, new O(0.135, 0.659, 0.518)],
    [0.7, new O(0.267, 0.749, 0.441)],
    [0.8, new O(0.478, 0.821, 0.318)],
    [0.9, new O(0.741, 0.873, 0.15)],
    [1, new O(0.993, 0.906, 0.144)]
  ],
  INFERNO: [
    [0, new O(0.077, 0.042, 0.206)],
    [0.1, new O(0.225, 0.036, 0.388)],
    [0.2, new O(0.373, 0.074, 0.432)],
    [0.3, new O(0.522, 0.128, 0.42)],
    [0.4, new O(0.665, 0.182, 0.37)],
    [0.5, new O(0.797, 0.255, 0.287)],
    [0.6, new O(0.902, 0.364, 0.184)],
    [0.7, new O(0.969, 0.516, 0.063)],
    [0.8, new O(0.988, 0.683, 0.072)],
    [0.9, new O(0.961, 0.859, 0.298)],
    [1, new O(0.988, 0.998, 0.645)]
  ],
  GRAYSCALE: [
    [0, new O(0, 0, 0)],
    [1, new O(1, 1, 1)]
  ],
  // 16 samples of the TURBU color scheme
  // values taken from: https://gist.github.com/mikhailov-work/ee72ba4191942acecc03fe6da94fc73f
  // original file licensed under Apache-2.0
  TURBO: [
    [0, new O(0.18995, 0.07176, 0.23217)],
    [0.07, new O(0.25107, 0.25237, 0.63374)],
    [0.13, new O(0.27628, 0.42118, 0.89123)],
    [0.2, new O(0.25862, 0.57958, 0.99876)],
    [0.27, new O(0.15844, 0.73551, 0.92305)],
    [0.33, new O(0.09267, 0.86554, 0.7623)],
    [0.4, new O(0.19659, 0.94901, 0.59466)],
    [0.47, new O(0.42778, 0.99419, 0.38575)],
    [0.53, new O(0.64362, 0.98999, 0.23356)],
    [0.6, new O(0.80473, 0.92452, 0.20459)],
    [0.67, new O(0.93301, 0.81236, 0.22667)],
    [0.73, new O(0.99314, 0.67408, 0.20348)],
    [0.8, new O(0.9836, 0.49291, 0.12849)],
    [0.87, new O(0.92105, 0.31489, 0.05475)],
    [0.93, new O(0.81608, 0.18462, 0.01809)],
    [1, new O(0.66449, 0.08436, 424e-5)]
  ],
  RAINBOW: [
    [0, new O(0.278, 0, 0.714)],
    [1 / 6, new O(0, 0, 1)],
    [2 / 6, new O(0, 1, 1)],
    [3 / 6, new O(0, 1, 0)],
    [4 / 6, new O(1, 1, 0)],
    [5 / 6, new O(1, 0.64, 0)],
    [1, new O(1, 0, 0)]
  ],
  CONTOUR: [
    [0, new O(0, 0, 0)],
    [0.03, new O(0, 0, 0)],
    [0.04, new O(1, 1, 1)],
    [1, new O(1, 1, 1)]
  ]
}, TE = `
  varying vec3 vColor;
  uniform float alpha;

  void main() {
    if (vColor == vec3(0.0, 0.0, 0.0)) {
      discard;
    } else {
      gl_FragColor = vec4( vColor, alpha);
    }
  }
`, wE = `
  varying vec3 vColor;
  uniform sampler2D gradient;
  uniform sampler2D grayscale;
  attribute float intensity;
  attribute float classification;
  uniform vec3 rootCenter;
  uniform vec3 rootNormal;
  uniform vec2 elevationRange;
  uniform int coloring;
  uniform bool hideGround;
  uniform float maxIntensity;
  uniform float intensityContrast;
  uniform float pointSize;

  #ifdef USE_COLOR
  vec3 getRGB() {
      vec3 rgb = color;
      return rgb;
  }
  #endif

  vec3 getElevation(){
    vec4 world = modelMatrix * vec4( position, 1.0 );
    float diff = abs(dot(rootNormal, (vec3(world) - rootCenter)));
    float w = max(diff - elevationRange.x,0.0) / max(elevationRange.y - elevationRange.x,1.0);
    vec3 cElevation = texture2D(gradient, vec2(w,1.0-w)).rgb;

    return cElevation;
  }

  vec3 getIntensity(){
    // TODO: real contrast enhancement. Check https://github.com/yuki-koyama/enhancer/blob/master/shaders/enhancer.fs
    float intmod = pow(intensity, intensityContrast);
    vec3 cIntensity = texture2D(grayscale, vec2(intmod / maxIntensity ,1.0-(intmod / maxIntensity))).rgb;
    return cIntensity;
  }

  vec3 getClassification(){
    float classNormalized = classification / 255.0;
    vec3 cClassification = texture2D(gradient, vec2(classNormalized * 5.0,1.0-classNormalized * 5.0)).rgb;
    return cClassification;
  }

  vec3 getColor(){
      vec3 color;
      if (hideGround && classification == 2.0) {
         return vec3(0.0, 0.0, 0.0);               
      }

      if (coloring == 1) {
        color = getIntensity();
      }
      else if (coloring == 2) {
        color = getClassification();
      } else if (coloring == 3) {
        color = getElevation();
      } 
      #ifdef USE_COLOR
      else if (coloring == 4) {
        color = getRGB();
      }
      #endif
      else {
        color = vec3(1.0, 1.0, 1.0);
      }
      return color;
  }

  void main() {
      vColor = getColor();

      gl_PointSize = pointSize;
      gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
  }
`;
var Ru = /* @__PURE__ */ ((e) => (e[e.Intensity = 1] = "Intensity", e[e.Classification = 2] = "Classification", e[e.Elevation = 3] = "Elevation", e[e.RGB = 4] = "RGB", e[e.White = 5] = "White", e))(Ru || {}), Er = /* @__PURE__ */ ((e) => (e[e.FlatTexture = 1] = "FlatTexture", e[e.ShadedTexture = 2] = "ShadedTexture", e[e.ShadedNoTexture = 3] = "ShadedNoTexture", e))(Er || {});
const bE = Mu.RAINBOW, _E = typeof document < "u" ? _u(bE) : null, IE = Mu.GRAYSCALE, xE = typeof document < "u" ? _u(IE) : null, ME = {
  throttleRequests: !0,
  maxRequests: 64,
  updateInterval: 0.1,
  maxConcurrency: 1,
  maximumScreenSpaceError: 16,
  memoryAdjustedScreenSpaceError: !0,
  maximumMemoryUsage: 400,
  memoryCacheOverflow: 128,
  viewDistanceScale: 1,
  skipLevelOfDetail: !1,
  resetTransform: !1,
  updateTransforms: !0,
  shading: Er.FlatTexture,
  transparent: !1,
  pointCloudColoring: Ru.White,
  pointSize: 1,
  worker: !0,
  wireframe: !1,
  debug: !1,
  gltfLoader: null,
  basisTranscoderPath: null,
  dracoDecoderPath: null,
  material: null,
  contentPostProcess: void 0,
  preloadTilesCount: null,
  collectAttributions: !1
};
class vE {
  /**
   * Loads a tileset of 3D Tiles according to the given {@link LoaderProps}
   * @public
   *
   * @param props - Properties for this load call {@link LoaderProps}.
   * @returns An object containing the 3D Model to be added to the scene
   * and a runtime engine to be updated every frame.
   */
  static async load(t) {
    const n = { ...ME, ...t.options }, { url: r } = t;
    let { viewport: s, renderer: i } = t;
    const o = n.updateInterval, a = 5, c = { ...n.loaderGLOptions };
    if (n.cesiumIONToken) {
      c["cesium-ion"] = {
        accessToken: n.cesiumIONToken
      };
      const R = await yu.preload(r, c);
      c.fetch = { headers: R.headers };
    }
    n.googleApiKey && (c.fetch = { headers: { "X-GOOG-API-KEY": n.googleApiKey } }, t.options.hasOwnProperty("collectAttributions") || (n.collectAttributions = !0)), t.loadingManager && t.loadingManager.itemStart(r);
    const h = await Qe(r, dn, {
      ...c
    }), f = {}, d = {}, p = [], g = new qn(), B = new qn();
    n.debug || (B.visible = !1);
    const C = {
      pointSize: { type: "f", value: n.pointSize },
      gradient: { type: "t", value: _E },
      grayscale: { type: "t", value: xE },
      rootCenter: { type: "vec3", value: new Tt() },
      rootNormal: { type: "vec3", value: new Tt() },
      coloring: { type: "i", value: n.pointCloudColoring },
      hideGround: { type: "b", value: !0 },
      elevationRange: { type: "vec2", value: new ga(0, 400) },
      maxIntensity: { type: "f", value: 1 },
      intensityContrast: { type: "f", value: 1 },
      alpha: { type: "f", value: 1 }
    }, b = new Ws({
      uniforms: C,
      vertexShader: wE,
      fragmentShader: TE,
      transparent: n.transparent,
      vertexColors: !0
    });
    let M, D, _;
    n.gltfLoader ? M = n.gltfLoader : (M = new Zu(), n.basisTranscoderPath && (D = new eh(), D.detectSupport(i ?? new $u()), D.setTranscoderPath(n.basisTranscoderPath + "/"), D.setWorkerLimit(1), M.setKTX2Loader(D)), n.dracoDecoderPath && (_ = new th(), _.setDecoderPath(n.dracoDecoderPath + "/"), _.setWorkerLimit(n.maxConcurrency), M.setDRACOLoader(_)));
    const x = new Es({ transparent: n.transparent }), L = {
      maximumMemoryUsage: n.maximumMemoryUsage,
      maximumScreenSpaceError: n.maximumScreenSpaceError,
      memoryAdjustedScreenSpaceError: n.memoryAdjustedScreenSpaceError,
      memoryCacheOverflow: n.memoryCacheOverflow,
      viewDistanceScale: n.viewDistanceScale,
      skipLevelOfDetail: n.skipLevelOfDetail,
      updateTransforms: n.updateTransforms,
      throttleRequests: n.throttleRequests,
      maxRequests: n.maxRequests,
      contentLoader: async (R) => {
        let H = null;
        switch (R.type) {
          case ue.POINTCLOUD: {
            H = SE(R, b, n, X);
            break;
          }
          case ue.SCENEGRAPH:
          case ue.MESH: {
            H = await RE(M, R, x, n, X);
            break;
          }
        }
        if (H && (H.visible = !1, f[R.id] = H, g.add(f[R.id]), n.debug)) {
          const nt = la(R);
          B.add(nt), d[R.id] = nt;
        }
      },
      onTileLoad: async (R) => {
        S && (n.resetTransform && !J && (R == null ? void 0 : R.depth) <= a && at(R), Nt = !0);
      },
      onTileUnload: (R) => {
        p.push(R);
      },
      onTileError: (R, H) => {
        console.warn("Tile error", R.id, H);
      },
      onTraversalComplete(R) {
        return n.collectAttributions && (tt = OE(R)), R;
      }
    }, S = new Q0(h, {
      ...L,
      loadOptions: {
        ...c,
        maxConcurrency: n.maxConcurrency,
        worker: n.worker,
        gltf: {
          loadImages: !1
        },
        "3d-tiles": {
          loadGLTF: !1
        }
      }
    }), G = new yt(), v = new yt(), P = new Tt();
    let J = !1, tt = "";
    if (S.root.boundingVolume ? (S.root.header.boundingVolume.region && console.warn(
      "Cannot apply a model matrix to bounding volumes of type region. Tileset stays in original geo-coordinates."
    ), v.setPosition(
      S.root.boundingVolume.center[0],
      S.root.boundingVolume.center[1],
      S.root.boundingVolume.center[2]
    )) : console.warn("Bounding volume not found, no transformations applied"), n.debug) {
      const R = la(S.root);
      B.add(R), d[S.root.id] = R;
    }
    let it = !1, ft = !1;
    C.rootCenter.value.copy(P), C.rootNormal.value.copy(new Tt(0, 0, 1).normalize()), S.stats.get("Loader concurrency").count = n.maxConcurrency, S.stats.get("Maximum mem usage").count = n.maximumMemoryUsage;
    let k = 0, gt = null, Nt = !0, Pt = null;
    const Oe = new Tt(1 / 0, 1 / 0, 1 / 0);
    let Xt = null;
    g.updateMatrixWorld(!0);
    const dt = new yt().copy(g.matrixWorld), X = new yt().copy(dt).invert();
    n.resetTransform && at(S.root), n.debug && (d[S.root.id].applyMatrix4(G), B.matrixWorld.copy(g.matrixWorld));
    function at(R) {
      if (!R.boundingVolume.halfAxes)
        return;
      const H = R.boundingVolume.halfAxes, nt = new yt().extractRotation(Iu(H)).premultiply(new yt().extractRotation(X));
      if (!new Nr().setFromRotationMatrix(nt).equals(new Nr())) {
        J = !0;
        const _t = new Tt(v.elements[12], v.elements[13], v.elements[14]);
        v.extractRotation(nt), v.setPosition(_t);
      }
      De();
    }
    function De() {
      G.copy(dt), n.resetTransform && G.multiply(new yt().copy(v).invert()), S.modelMatrix = new Z(G.toArray());
    }
    function Le(R, H, nt, At) {
      if (it || !At)
        return;
      Xt || (Xt = new lr({
        fov: At.fov / 180 * Math.PI,
        aspectRatio: At.aspect,
        near: At.near,
        far: At.far
      }).sseDenominator, n.debug && console.log("Updated sse denonimator:", Xt));
      const Ze = ha(At).planes.map((ct) => new Et(ct.normal.toArray(), ct.constant)), Mn = new Ft(Ze), ie = {
        camera: {
          position: Oe.toArray()
        },
        height: nt.height * nt.devicePixelRatio,
        frameNumber: R._frameNumber,
        sseDenominator: Xt,
        cullingVolume: Mn,
        viewport: {
          id: 0
        }
      };
      R._cache.reset(), R._traverser.traverse(R.root, ie, R.options);
      for (const ct of R.tiles)
        ct.selected ? H[ct.id] ? H[ct.id].visible = !0 : console.error("TILE SELECTED BUT NOT LOADED!!", ct.id) : H[ct.id] && (H[ct.id].visible = !1);
      for (; p.length > 0; ) {
        const ct = p.pop();
        H[ct.id] && ct.contentState == xt.UNLOADED && (g.remove(H[ct.id]), Bs(H[ct.id]), delete H[ct.id]), d[ct.id] && (Bs(d[ct.id]), B.remove(d[ct.id]), delete d[ct.id]);
      }
      const oe = R.stats.get("Tiles Loaded").count, Rn = R.stats.get("Tiles Loading").count;
      return t.onProgress && t.onProgress(oe, oe + Rn), t.loadingManager && !ft && Rn == 0 && (n.preloadTilesCount == null || oe >= n.preloadTilesCount) && (ft = !0, t.loadingManager.itemEnd(t.url)), ie;
    }
    function xn(R) {
      const H = new Tt(), nt = new Xu(), At = new Tt();
      R.decompose(H, nt, At), g.position.copy(H), g.quaternion.copy(nt), g.scale.copy(At), g.updateMatrix(), g.updateMatrixWorld(!0), dt.copy(g.matrixWorld), X.copy(dt).invert(), De();
    }
    return {
      model: g,
      runtime: {
        getTileset: () => S,
        getStats: () => S.stats,
        getDataAttributions: () => tt,
        showTiles: (R) => {
          B.visible = R;
        },
        setWireframe: (R) => {
          n.wireframe = R, g.traverse((H) => {
            H instanceof Cs && (H.material.wireframe = R);
          });
        },
        setDebug: (R) => {
          n.debug = R, B.visible = R;
        },
        setShading: (R) => {
          n.shading = R;
        },
        getTileBoxes: () => B,
        setViewDistanceScale: (R) => {
          S.options.viewDistanceScale = R, S._frameNumber++, Le(S, f, s, Pt);
        },
        setMaximumScreenSpaceError: (R) => {
          S.options.maximumScreenSpaceError = R, S._frameNumber++, Le(S, f, s, Pt);
        },
        setHideGround: (R) => {
          C.hideGround.value = R;
        },
        setPointCloudColoring: (R) => {
          C.coloring.value = R;
        },
        setElevationRange: (R) => {
          C.elevationRange.value.set(R[0], R[1]);
        },
        setMaxIntensity: (R) => {
          C.maxIntensity.value = R;
        },
        setIntensityContrast: (R) => {
          C.intensityContrast.value = R;
        },
        setPointAlpha: (R) => {
          C.alpha.value = R;
        },
        getLatLongHeightFromPosition: (R) => {
          const H = S.ellipsoid.cartesianToCartographic(
            new Tt().copy(R).applyMatrix4(new yt().copy(G).invert()).toArray()
          );
          return {
            lat: H[1],
            long: H[0],
            height: H[2]
          };
        },
        getPositionFromLatLongHeight: (R) => {
          const H = S.ellipsoid.cartographicToCartesian([R.long, R.lat, R.height]);
          return new Tt(...H).applyMatrix4(G);
        },
        orientToGeocoord: (R) => {
          const H = [R.long, R.lat, R.height], nt = S.ellipsoid.cartographicToCartesian(H), At = new yt().fromArray(
            S.ellipsoid.eastNorthUpToFixedFrame(nt)
          ), _t = new yt().makeRotationFromEuler(new Nr(Math.PI / 2, Math.PI / 2, 0)), Ze = new yt().copy(At).multiply(_t).invert();
          xn(Ze);
        },
        getWebMercatorCoord: (R) => mE(R.lat, R.long),
        getCameraFrustum: (R) => {
          const nt = ha(R).planes.map((_t) => new Et(_t.normal.toArray(), _t.constant)).map((_t) => dE(_t)), At = new qn();
          for (const _t of nt) At.add(_t);
          return At;
        },
        overlayGeoJSON: (R, H) => {
          if (R.applyMatrix4(G), R.updateMatrixWorld(), !i)
            throw new Error("GeoJSON draping requires a renderer reference via LoaderProps");
          return gE(s, g, i, H), R.material.dispose(), R.material = ge, R;
        },
        setViewport: (R) => {
          s = R, Xt = null, Nt = !0, Mt && AE(s);
        },
        setRenderer: (R) => {
          i = R;
        },
        update: function(R, H) {
          if (Pt = H, k += R, Mt && yE(H), S && k >= o) {
            if (!dt.equals(g.matrixWorld)) {
              k = 0, dt.copy(g.matrixWorld), n.updateTransforms && De();
              const nt = new Tt().setFromMatrixPosition(dt);
              C.rootCenter.value.copy(nt), C.rootNormal.value.copy(
                new Tt(0, 0, 1).applyMatrix4(dt).normalize()
              ), X.copy(dt).invert(), n.debug && (d[S.root.id].matrixWorld.copy(G), d[S.root.id].applyMatrix4(dt));
            }
            gt == null ? gt = new yt().copy(H.matrixWorld) : (Nt || FE(H, gt)) && (k = 0, Nt = !1, S._frameNumber++, H.getWorldPosition(Oe), gt.copy(H.matrixWorld), Le(S, f, s, H));
          }
        },
        dispose: function() {
          for (it = !0, S._destroy(); g.children.length > 0; ) {
            const R = g.children[0];
            Bs(R), g.remove(R);
          }
          for (; B.children.length > 0; ) {
            const R = B.children[0];
            B.remove(R), R.geometry.dispose(), R.material.dispose();
          }
          D && D.dispose(), _ && _.dispose();
        }
      }
    };
  }
  /**
   * Loads a tileset of 3D Tiles according to the given {@link GeoJSONLoaderProps}
   * Could be overlayed on geograpical 3D Tiles using {@link Runtime.overlayGeoJSON}
   * @public
   *
   * @param props - Properties for this load call {@link GeoJSONLoaderProps}.
   * @returns An object containing the 3D Model to be added to the scene
   */
  static async loadGeoJSON(t) {
    const { url: n, height: r, featureToColor: s } = t;
    return Qe(n, En, { worker: !1, gis: { format: "binary" } }).then((i) => {
      const o = i, a = new Aa(), c = o.polygons.positions.value.reduce(
        (d, p, g, B) => {
          if (g % 2 == 0) {
            const C = [p, B[g + 1], r ?? 0], b = q.WGS84.cartographicToCartesian(C);
            d.push(...b);
          }
          return d;
        },
        []
      );
      if (a.setAttribute("position", new ir(c, 3)), s) {
        const d = o.polygons.numericProps[s.feature].value.reduce((p, g, B, C) => {
          const b = s.colorMap(g);
          return p[B * 3] = b.r, p[B * 3 + 1] = b.g, p[B * 3 + 2] = b.b, p;
        }, []);
        a.setAttribute("color", new ir(d, 3));
      }
      a.setIndex(new ya(o.polygons.triangles.value, 1));
      const h = new Es({
        transparent: !0,
        vertexColors: !0,
        opacity: 0.5,
        blending: Qs
      });
      return new Cs(a, h);
    });
  }
}
async function RE(e, t, n, r, s) {
  return new Promise((i, o) => {
    const a = new yt().makeRotationAxis(new Tt(1, 0, 0), Math.PI / 2), c = t.content.gltfUpAxis !== "Z", h = new yt().fromArray(t.computedTransform).premultiply(s);
    c && h.multiply(a), t.content.byteLength || (t.content.byteLength = t.content.gltfArrayBuffer.byteLength), e.parse(
      t.content.gltfArrayBuffer,
      t.contentUrl ? t.contentUrl.substr(0, t.contentUrl.lastIndexOf("/") + 1) : null,
      (f) => {
        t.userData.asset = f.asset;
        const d = f.scenes[0];
        d.applyMatrix4(h), t.content.texturesByteLength = 0, t.content.geometriesByteLength = 0, d.traverse((p) => {
          if (p.type == "Mesh") {
            const g = p;
            t.content.geometriesByteLength += xu(g.geometry);
            const B = g.material, C = B.map;
            if (C) {
              const b = pE(C);
              b && (t.content.texturesByteLength += b);
            }
            r.material ? (g.material = r.material.clone(), B.dispose()) : r.shading == Er.FlatTexture && g.material.type !== "MeshBasicMaterial" && (g.material = n.clone(), B.dispose()), r.shading != Er.ShadedNoTexture ? g.material.type == "ShaderMaterial" ? g.material.uniforms.map = { value: C } : g.material.map = C : (C && C.dispose(), g.material.map = null), g.material.wireframe = r.wireframe, r.contentPostProcess && r.contentPostProcess(g);
          }
        }), t.content.gpuMemoryUsageInBytes = t.content.texturesByteLength + t.content.geometriesByteLength, i(d);
      },
      (f) => {
        o(new Error(`error parsing gltf in tile ${t.id}: ${f}`));
      }
    );
  });
}
function SE(e, t, n, r) {
  const s = {
    rtc_center: e.content.rtcCenter,
    // eslint-disable-line camelcase
    points: e.content.attributes.positions,
    intensities: e.content.attributes.intensity,
    classifications: e.content.attributes.classification,
    rgb: null,
    rgba: null
  }, { colors: i } = e.content.attributes;
  i && i.size === 3 && (s.rgb = i.value), i && i.size === 4 && (s.rgba = i.value);
  const o = new Aa();
  o.setAttribute("position", new ir(s.points, 3));
  const a = new yt().fromArray(e.computedTransform).premultiply(r);
  s.rgba ? o.setAttribute("color", new ir(s.rgba, 4)) : s.rgb && o.setAttribute("color", new Mi(s.rgb, 3, !0)), s.intensities && o.setAttribute(
    "intensity",
    // Handles both 16bit or 8bit intensity values
    new ya(s.intensities, 1, !0)
  ), s.classifications && o.setAttribute("classification", new Mi(s.classifications, 1, !1)), e.content.geometriesByteLength = xu(o), e.content.gpuMemoryUsageInBytes = e.content.geometriesByteLength;
  const c = new qu(o, n.material || t);
  if (s.rtc_center) {
    const h = s.rtc_center;
    a.multiply(new yt().makeTranslation(h[0], h[1], h[2]));
  }
  return c.applyMatrix4(a), n.contentPostProcess && n.contentPostProcess(c), c;
}
function da(e) {
  var t, n, r, s;
  (t = e == null ? void 0 : e.uniforms) != null && t.map ? (r = (n = e == null ? void 0 : e.uniforms) == null ? void 0 : n.map.value) == null || r.dispose() : e.map && ((s = e.map) == null || s.dispose()), e.dispose();
}
function Bs(e) {
  e.traverse((t) => {
    if (t.isMesh)
      if (t.geometry.dispose(), t.material.isMaterial)
        da(t.material);
      else
        for (const n of t.material)
          da(n);
  });
  for (let t = e.children.length - 1; t >= 0; t--) {
    const n = e.children[t];
    e.remove(n);
  }
}
function FE(e, t) {
  return !e.matrixWorld.equals(t);
}
function OE(e) {
  const t = /* @__PURE__ */ new Map();
  return e.forEach((s) => {
    var o, a;
    const i = (a = (o = s == null ? void 0 : s.userData) == null ? void 0 : o.asset) == null ? void 0 : a.copyright;
    i && i.split(/;/g).map((h) => h.trim()).forEach((h) => {
      h && t.set(h, (t.get(h) || 0) + 1);
    });
  }), Array.from(t).sort((s, i) => i[1] - s[1]).map(([s]) => s).join("; ");
}
export {
  vE as Loader3DTiles,
  Ru as PointCloudColoring,
  Er as Shading
};
